webpackJsonp([0],[
/* 0 */,
/* 1 */,
/* 2 */,
/* 3 */,
/* 4 */,
/* 5 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Icon__ = __webpack_require__(567);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Icon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__Icon__);


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__Icon___default.a);

/***/ }),
/* 6 */,
/* 7 */,
/* 8 */,
/* 9 */,
/* 10 */,
/* 11 */,
/* 12 */,
/* 13 */,
/* 14 */,
/* 15 */,
/* 16 */,
/* 17 */,
/* 18 */,
/* 19 */,
/* 20 */,
/* 21 */,
/* 22 */,
/* 23 */,
/* 24 */,
/* 25 */,
/* 26 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return getStyles; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return isValid; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return on; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return off; });
/* unused harmony export formatDate */

var getStyles = function getStyles(obj, unit) {
  var result = {};
  for (var key in obj) {
    if (obj[key]) {
      result[key] = obj[key] + (unit || '');
    }
  }
  return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(result).length > 0 ? result : null;
};

var isValid = function isValid(rule, val) {
  return rule.some(function (str) {
    return str === val;
  });
};

var on = function on(elem, type, fn) {
  elem.addEventListener(type, fn, false);
};

var off = function off(elem, type, fn) {
  elem.removeEventListener(type, fn, false);
};

var formatDate = function formatDate(date, fmt) {
  if (!(date instanceof Date)) {
    return '';
  }

  var o = {
    'M+': date.getMonth() + 1,
    'd+': date.getDate(),
    'h+': date.getHours(),
    'm+': date.getMinutes(),
    's+': date.getSeconds(),
    'q+': Math.floor((date.getMonth() + 3) / 3),
    'S': date.getMilliseconds() };
  if (/(y+)/.test(fmt)) fmt = fmt.replace(RegExp.$1, (date.getFullYear() + '').substr(4 - RegExp.$1.length));
  for (var k in o) {
    if (new RegExp('(' + k + ')').test(fmt)) fmt = fmt.replace(RegExp.$1, RegExp.$1.length === 1 ? o[k] : ('00' + o[k]).substr(('' + o[k]).length));
  }
  return fmt;
};

/***/ }),
/* 27 */,
/* 28 */,
/* 29 */,
/* 30 */,
/* 31 */,
/* 32 */,
/* 33 */,
/* 34 */,
/* 35 */,
/* 36 */,
/* 37 */,
/* 38 */,
/* 39 */,
/* 40 */,
/* 41 */,
/* 42 */,
/* 43 */,
/* 44 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(293)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(165),
  /* template */
  __webpack_require__(687),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 45 */,
/* 46 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return scrollToTop; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return scrollToElem; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return scrollTo; });



window.requestAnimationFrame = window.requestAnimationFrame || window.mozRequestAnimationFrame || window.webkitRequestAnimationFrame || window.msRequestAnimationFrame;

var Quad_easeIn = function Quad_easeIn(t, b, c, d) {
  return c * ((t = t / d - 1) * t * t + 1) + b;
};

var scrollTo = function scrollTo(end) {
  var time = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 500;
  var offset = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;

  end += offset;
  var scrollTop = window.pageYOffset || document.documentElement.scrollTop;

  if (scrollTop === end) {
    return false;
  }

  var b = scrollTop;
  var c = end - b;
  var d = time;
  var start = null;

  return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
    function step(timeStamp) {
      if (start === null) start = timeStamp;
      var progress = timeStamp - start;
      if (progress < time) {
        var st = Quad_easeIn(progress, b, c, d);
        document.body.scrollTop = st;
        document.documentElement.scrollTop = st;
        window.requestAnimationFrame(step);
      } else {
        document.body.scrollTop = end;
        document.documentElement.scrollTop = end;
        resolve(end);
      }
    }
    window.requestAnimationFrame(step);
  });
};

var scrollToTop = function scrollToTop(time) {
  return scrollTo(0, time);
};

var scrollToElem = function scrollToElem(elem, time, offset) {
  var top = elem.getBoundingClientRect().top + (window.pageYOffset || document.documentElement.scrollTop) - (document.documentElement.clientTop || 0);
  scrollTo(top, time, offset);
};



/***/ }),
/* 47 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__package_json__ = __webpack_require__(729);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__package_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__package_json__);


/* harmony default export */ __webpack_exports__["a"] = ({
  name: __WEBPACK_IMPORTED_MODULE_0__package_json___default.a.name,
  version: 'v' + __WEBPACK_IMPORTED_MODULE_0__package_json___default.a.version,
  links: {
    github: __WEBPACK_IMPORTED_MODULE_0__package_json___default.a.homepage
  },
  nav: [{
    name: 'Overview',
    cn_name: '概述',
    path: '/'
  }, {
    name: 'Standard',
    cn_name: '规范',
    path: '/Standard'
  }, {
    name: 'Color',
    cn_name: '色彩',
    path: '/Color'
  }, {
    name: 'Components',
    cn_name: '组件',
    path: '/Components',
    child: [{
      title: 'Base',
      components: [{
        name: 'Btn',
        cn_name: '按钮',
        path: '/Btn'
      }, {
        name: 'Icon',
        cn_name: '图标',
        path: '/Icon'
      }, {
        name: 'Spinner',
        cn_name: '加载动画',
        path: '/Spinner'
      }, {
        name: 'Loading',
        cn_name: '加载条',
        path: '/Loading'
      }, {
        name: 'SmoothScroll',
        cn_name: '平滑滚动',
        path: '/SmoothScroll'
      }, {
        name: 'BackTop',
        cn_name: '回到顶部',
        path: '/BackTop'
      }]
    }, {
      title: 'Data in',
      components: [{
        name: 'Switch',
        cn_name: '开关',
        path: '/Switch'
      }, {
        name: 'CheckBox',
        cn_name: '多选框',
        path: '/CheckBox'
      }, {
        name: 'Select',
        cn_name: '选择器',
        path: '/Select'
      }, {
        name: 'Input',
        cn_name: '输入栏',
        path: '/Input'
      }, {
        name: 'Radio',
        cn_name: '单选框',
        path: '/Radio'
      }, {
        name: 'Calendar',
        cn_name: '日历',
        path: '/Calendar'
      }]
    }, {
      title: 'Data out',
      components: [{
        name: 'Toast',
        cn_name: '提示',
        path: '/Toast'
      }, {
        name: 'Tab',
        cn_name: '标签栏',
        path: '/Tab'
      }, {
        name: 'Loadmore',
        cn_name: '加载更多',
        path: '/Loadmore'
      }, {
        name: 'Price',
        cn_name: '价格',
        path: '/Price'
      }, {
        name: 'Swipe',
        cn_name: '走马灯',
        path: '/Swipe'
      }, {
        name: 'Modal',
        cn_name: '弹出层',
        path: '/Modal'
      }, {
        name: 'Popover',
        cn_name: '弹出框',
        path: '/Popover'
      }]
    }]
  }]
});

/***/ }),
/* 48 */,
/* 49 */,
/* 50 */,
/* 51 */,
/* 52 */,
/* 53 */,
/* 54 */,
/* 55 */,
/* 56 */,
/* 57 */,
/* 58 */,
/* 59 */,
/* 60 */,
/* 61 */,
/* 62 */,
/* 63 */,
/* 64 */,
/* 65 */,
/* 66 */,
/* 67 */,
/* 68 */,
/* 69 */,
/* 70 */,
/* 71 */,
/* 72 */,
/* 73 */,
/* 74 */,
/* 75 */,
/* 76 */,
/* 77 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(297)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(137),
  /* template */
  __webpack_require__(691),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 78 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(289)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(138),
  /* template */
  __webpack_require__(682),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 79 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(298)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(151),
  /* template */
  __webpack_require__(692),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 80 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(283)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(154),
  /* template */
  __webpack_require__(676),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 81 */,
/* 82 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(724);



__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  mode: 'hash',
  routes: [{
    path: '/',
    component: __webpack_require__(613),
    children: [{
      path: '/',
      name: 'Overview',
      component: __webpack_require__(722)
    }, {
      path: '/Standard',
      name: 'Standard',
      component: __webpack_require__(723)
    }, {
      path: '/Color',
      name: 'Color',
      component: __webpack_require__(720)
    }, {
      path: '/Components',
      name: 'Components',
      component: __webpack_require__(721)
    }, {
      path: '/Components/Btn',
      name: 'Btn',
      component: __webpack_require__(700)
    }, {
      path: '/Components/Icon',
      name: 'Icon',
      component: __webpack_require__(704)
    }, {
      path: '/Components/Bar',
      name: 'Bar',
      component: __webpack_require__(699)
    }, {
      path: '/Components/Toast',
      name: 'Toast',
      component: __webpack_require__(719)
    }, {
      path: '/Components/Switch',
      name: 'Switch',
      component: __webpack_require__(716)
    }, {
      path: '/Components/Spinner',
      name: 'Spinner',
      component: __webpack_require__(714)
    }, {
      path: '/Components/Grid',
      name: 'Grid',
      component: __webpack_require__(703)
    }, {
      path: '/Components/Loading',
      name: 'Loading',
      component: __webpack_require__(706)
    }, {
      path: '/Components/Tabs',
      name: 'Tabs',
      component: __webpack_require__(718)
    }, {
      path: '/Components/CheckBox',
      name: 'CheckBox',
      component: __webpack_require__(702)
    }, {
      path: '/Components/Calendar',
      name: 'Calendar',
      component: __webpack_require__(701)
    }, {
      path: '/Components/Loadmore',
      name: 'Loadmore',
      component: __webpack_require__(707)
    }, {
      path: '/Components/Select',
      name: 'Select',
      component: __webpack_require__(712)
    }, {
      path: '/Components/Input',
      name: 'Input',
      component: __webpack_require__(705)
    }, {
      path: '/Components/Price',
      name: 'Price',
      component: __webpack_require__(710)
    }, {
      path: '/Components/Radio',
      name: 'Radio',
      component: __webpack_require__(711)
    }, {
      path: '/Components/Tab',
      name: 'Tab',
      component: __webpack_require__(717)
    }, {
      path: '/Components/Swipe',
      name: 'Swipe',
      component: __webpack_require__(715)
    }, {
      path: '/Components/Modal',
      name: 'Modal',
      component: __webpack_require__(708)
    }, {
      path: '/Components/SmoothScroll',
      name: 'SmoothScroll',
      component: __webpack_require__(713)
    }, {
      path: '/Components/BackTop',
      name: 'BackTop',
      component: __webpack_require__(698)
    }, {
      path: '/Components/Popover',
      name: 'Popover',
      component: __webpack_require__(709)
    }]
  }]
}));

/***/ }),
/* 83 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__BackTop__ = __webpack_require__(89);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__SmoothScroll__ = __webpack_require__(101);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Loading__ = __webpack_require__(93);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Spinner__ = __webpack_require__(102);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Btn__ = __webpack_require__(90);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Icon__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__vCalendar__ = __webpack_require__(107);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Radio__ = __webpack_require__(98);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Input__ = __webpack_require__(92);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__Select__ = __webpack_require__(100);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__CheckBox__ = __webpack_require__(91);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__Switch__ = __webpack_require__(104);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__Popover__ = __webpack_require__(96);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__Modal__ = __webpack_require__(95);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__Swipe__ = __webpack_require__(103);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__Tab__ = __webpack_require__(105);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__Price__ = __webpack_require__(97);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__Loadmore__ = __webpack_require__(94);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__Toast__ = __webpack_require__(106);
























var install = function install(Vue) {
  Vue.component(__WEBPACK_IMPORTED_MODULE_6__vCalendar__["a" /* default */].name, __WEBPACK_IMPORTED_MODULE_6__vCalendar__["a" /* default */]);

  Vue.component(__WEBPACK_IMPORTED_MODULE_0__BackTop__["a" /* default */].name, __WEBPACK_IMPORTED_MODULE_0__BackTop__["a" /* default */]);
  Vue.component(__WEBPACK_IMPORTED_MODULE_13__Modal__["a" /* default */].name, __WEBPACK_IMPORTED_MODULE_13__Modal__["a" /* default */]);
  Vue.component(__WEBPACK_IMPORTED_MODULE_14__Swipe__["a" /* Swipe */].name, __WEBPACK_IMPORTED_MODULE_14__Swipe__["a" /* Swipe */]);
  Vue.component(__WEBPACK_IMPORTED_MODULE_14__Swipe__["b" /* SwipeSlide */].name, __WEBPACK_IMPORTED_MODULE_14__Swipe__["b" /* SwipeSlide */]);
  Vue.component(__WEBPACK_IMPORTED_MODULE_15__Tab__["a" /* default */].name, __WEBPACK_IMPORTED_MODULE_15__Tab__["a" /* default */]);
  Vue.component(__WEBPACK_IMPORTED_MODULE_16__Price__["a" /* default */].name, __WEBPACK_IMPORTED_MODULE_16__Price__["a" /* default */]);
  Vue.component(__WEBPACK_IMPORTED_MODULE_7__Radio__["a" /* default */].name, __WEBPACK_IMPORTED_MODULE_7__Radio__["a" /* default */]);
  Vue.component(__WEBPACK_IMPORTED_MODULE_8__Input__["a" /* default */].name, __WEBPACK_IMPORTED_MODULE_8__Input__["a" /* default */]);
  Vue.component(__WEBPACK_IMPORTED_MODULE_17__Loadmore__["a" /* default */].name, __WEBPACK_IMPORTED_MODULE_17__Loadmore__["a" /* default */]);
  Vue.component(__WEBPACK_IMPORTED_MODULE_9__Select__["a" /* Select */].name, __WEBPACK_IMPORTED_MODULE_9__Select__["a" /* Select */]);
  Vue.component(__WEBPACK_IMPORTED_MODULE_9__Select__["b" /* SelectItem */].name, __WEBPACK_IMPORTED_MODULE_9__Select__["b" /* SelectItem */]);
  Vue.component(__WEBPACK_IMPORTED_MODULE_10__CheckBox__["a" /* default */].name, __WEBPACK_IMPORTED_MODULE_10__CheckBox__["a" /* default */]);
  Vue.component(__WEBPACK_IMPORTED_MODULE_3__Spinner__["a" /* default */].name, __WEBPACK_IMPORTED_MODULE_3__Spinner__["a" /* default */]);
  Vue.component(__WEBPACK_IMPORTED_MODULE_4__Btn__["a" /* default */].name, __WEBPACK_IMPORTED_MODULE_4__Btn__["a" /* default */]);
  Vue.component(__WEBPACK_IMPORTED_MODULE_5__Icon__["a" /* default */].name, __WEBPACK_IMPORTED_MODULE_5__Icon__["a" /* default */]);
  Vue.component(__WEBPACK_IMPORTED_MODULE_11__Switch__["a" /* default */].name, __WEBPACK_IMPORTED_MODULE_11__Switch__["a" /* default */]);

  Vue.use(__WEBPACK_IMPORTED_MODULE_12__Popover__["a" /* default */]);
  Vue.use(__WEBPACK_IMPORTED_MODULE_1__SmoothScroll__["a" /* default */]);
  Vue.use(__WEBPACK_IMPORTED_MODULE_6__vCalendar__["a" /* default */]);
  Vue.use(__WEBPACK_IMPORTED_MODULE_2__Loading__["a" /* default */]);
  Vue.use(__WEBPACK_IMPORTED_MODULE_18__Toast__["a" /* default */]);
};

if (typeof window !== 'undefined' && window.Vue) {
  install(window.Vue);
}

/* harmony default export */ __webpack_exports__["a"] = ({
  vCalendar: __WEBPACK_IMPORTED_MODULE_6__vCalendar__["a" /* default */],

  Popover: __WEBPACK_IMPORTED_MODULE_12__Popover__["a" /* default */],
  BackTop: __WEBPACK_IMPORTED_MODULE_0__BackTop__["a" /* default */],
  SmoothScroll: __WEBPACK_IMPORTED_MODULE_1__SmoothScroll__["a" /* default */],
  Modal: __WEBPACK_IMPORTED_MODULE_13__Modal__["a" /* default */],
  Swipe: __WEBPACK_IMPORTED_MODULE_14__Swipe__["a" /* Swipe */],
  Tab: __WEBPACK_IMPORTED_MODULE_15__Tab__["a" /* default */],
  Price: __WEBPACK_IMPORTED_MODULE_16__Price__["a" /* default */],
  Radio: __WEBPACK_IMPORTED_MODULE_7__Radio__["a" /* default */],
  Input: __WEBPACK_IMPORTED_MODULE_8__Input__["a" /* default */],
  Loadmore: __WEBPACK_IMPORTED_MODULE_17__Loadmore__["a" /* default */],
  Select: __WEBPACK_IMPORTED_MODULE_9__Select__["a" /* Select */],
  CheckBox: __WEBPACK_IMPORTED_MODULE_10__CheckBox__["a" /* default */],
  Loading: __WEBPACK_IMPORTED_MODULE_2__Loading__["a" /* default */],
  Spinner: __WEBPACK_IMPORTED_MODULE_3__Spinner__["a" /* default */],
  Btn: __WEBPACK_IMPORTED_MODULE_4__Btn__["a" /* default */],
  Icon: __WEBPACK_IMPORTED_MODULE_5__Icon__["a" /* default */],
  Toast: __WEBPACK_IMPORTED_MODULE_18__Toast__["a" /* default */],
  Switch: __WEBPACK_IMPORTED_MODULE_11__Switch__["a" /* default */],
  install: install
});

/***/ }),
/* 84 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 85 */,
/* 86 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(251)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(133),
  /* template */
  __webpack_require__(619),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 87 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(246)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(163),
  /* template */
  __webpack_require__(614),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 88 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(267)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(164),
  /* template */
  __webpack_require__(650),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 89 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__BackTop__ = __webpack_require__(564);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__BackTop___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__BackTop__);


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__BackTop___default.a);

/***/ }),
/* 90 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Btn__ = __webpack_require__(565);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Btn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__Btn__);


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__Btn___default.a);

/***/ }),
/* 91 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__CheckBox__ = __webpack_require__(566);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__CheckBox___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__CheckBox__);


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__CheckBox___default.a);

/***/ }),
/* 92 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Input__ = __webpack_require__(568);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Input___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__Input__);


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__Input___default.a);

/***/ }),
/* 93 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Loading__ = __webpack_require__(572);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Loading___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__Loading__);


var vm = void 0;

var install = function install(Vue) {
  var Component = Vue.extend(__WEBPACK_IMPORTED_MODULE_0__Loading___default.a);

  Vue.prototype.$loading = {
    start: function start() {
      if (vm) {
        vm.$destroy(true);
        vm = null;
      }

      var instance = new Component({
        data: {
          process: 0,
          status: 'loading'
        }
      });

      vm = instance.$mount();
      vm.start();
    },
    success: function success() {
      if (!vm) {
        return false;
      }

      vm.process = 100;
      vm.status = 'success';
    },
    error: function error() {
      if (!vm) {
        return false;
      }

      vm.process = 100;
      vm.status = 'error';
    }
  };
};

/* harmony default export */ __webpack_exports__["a"] = ({
  install: install,
  Loading: __WEBPACK_IMPORTED_MODULE_0__Loading___default.a
});

/***/ }),
/* 94 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Loadmore__ = __webpack_require__(573);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Loadmore___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__Loadmore__);


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__Loadmore___default.a);

/***/ }),
/* 95 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Modal__ = __webpack_require__(574);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__Modal__);


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__Modal___default.a);

/***/ }),
/* 96 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Popover__ = __webpack_require__(575);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Popover___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__Popover__);


var install = function install(Vue) {
  Vue.directive('popover', {
    bind: function bind(el, binding, vnode) {
      var $target = vnode.context.$refs[binding.arg];
      $target.$refs.reference = el;
    }
  });
  Vue.component(__WEBPACK_IMPORTED_MODULE_0__Popover___default.a.name, __WEBPACK_IMPORTED_MODULE_0__Popover___default.a);
};

/* harmony default export */ __webpack_exports__["a"] = ({
  install: install,
  Popover: __WEBPACK_IMPORTED_MODULE_0__Popover___default.a
});

/***/ }),
/* 97 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Price__ = __webpack_require__(576);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Price___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__Price__);


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__Price___default.a);

/***/ }),
/* 98 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Radio__ = __webpack_require__(577);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Radio___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__Radio__);


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__Radio___default.a);

/***/ }),
/* 99 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  bind: function bind(el, binding) {
    var clickHandler = function clickHandler(ev) {
      if (el.contains(ev.target)) {
        return false;
      }
      if (typeof binding.value === 'function') {
        binding.value();
      }
    };
    el.clickHandler = clickHandler;
    document.addEventListener('click', clickHandler);
  },
  unbind: function unbind(el) {
    document.removeEventListener('click', el.documentHandler);
  }
});

/***/ }),
/* 100 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Select__ = __webpack_require__(578);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__Select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__SelectItem__ = __webpack_require__(79);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__SelectItem___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__SelectItem__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__Select___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_1__SelectItem___default.a; });





/***/ }),
/* 101 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__SmoothScroll_js__ = __webpack_require__(46);


var install = function install(Vue) {
  Vue.prototype.$smoothScroll = function (target) {
    for (var _len = arguments.length, arg = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      arg[_key - 1] = arguments[_key];
    }

    if (target && target.nodeType === 1) {
      __WEBPACK_IMPORTED_MODULE_0__SmoothScroll_js__["a" /* scrollToElem */].apply(undefined, [target].concat(arg));
    } else {
      __WEBPACK_IMPORTED_MODULE_0__SmoothScroll_js__["b" /* scrollTo */].apply(undefined, [target || 0].concat(arg));
    }
  };
};

/* harmony default export */ __webpack_exports__["a"] = ({
  install: install
});

/***/ }),
/* 102 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Spinner__ = __webpack_require__(579);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Spinner___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__Spinner__);


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__Spinner___default.a);

/***/ }),
/* 103 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Swipe__ = __webpack_require__(580);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Swipe___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__Swipe__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__SwipeSlide__ = __webpack_require__(80);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__SwipeSlide___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__SwipeSlide__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__Swipe___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_1__SwipeSlide___default.a; });





/***/ }),
/* 104 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Switch__ = __webpack_require__(583);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Switch___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__Switch__);


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__Switch___default.a);

/***/ }),
/* 105 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Tab__ = __webpack_require__(584);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Tab___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__Tab__);


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__Tab___default.a);

/***/ }),
/* 106 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Toast__ = __webpack_require__(585);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Toast___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__Toast__);



var vm = void 0;

var install = function install(Vue) {
  var Component = Vue.extend(__WEBPACK_IMPORTED_MODULE_1__Toast___default.a);

  Vue.prototype.$toast = function (content, option) {
    var data = {
      content: content
    };

    if (vm) {
      vm.$destroy(true);
    }

    if (typeof option === 'string') {
      data.type = option;
    } else {
      __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(data, option);
    }

    var instance = new Component({
      data: data
    });

    vm = instance.$mount();
    vm.show = true;

    vm.$on('destroyed', function () {
      vm = null;
    });

    return vm;
  };
};

/* harmony default export */ __webpack_exports__["a"] = ({
  install: install,
  Toast: __WEBPACK_IMPORTED_MODULE_1__Toast___default.a
});

/***/ }),
/* 107 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Calendar__ = __webpack_require__(586);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Calendar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__Calendar__);


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__Calendar___default.a);

/***/ }),
/* 108 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App__ = __webpack_require__(86);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__App__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__router__ = __webpack_require__(82);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components__ = __webpack_require__(83);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__pages_components_demo__ = __webpack_require__(88);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__pages_components_demo___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__pages_components_demo__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__pages_components_demo_item__ = __webpack_require__(87);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__pages_components_demo_item___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__pages_components_demo_item__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__pages_components_v_code__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__pages_components_v_code___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__pages_components_v_code__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_clipboards__ = __webpack_require__(85);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_clipboards___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_vue_clipboards__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_github_markdown_css__ = __webpack_require__(84);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_github_markdown_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_github_markdown_css__);













__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].component(__WEBPACK_IMPORTED_MODULE_4__pages_components_demo___default.a.name, __WEBPACK_IMPORTED_MODULE_4__pages_components_demo___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].component(__WEBPACK_IMPORTED_MODULE_5__pages_components_demo_item___default.a.name, __WEBPACK_IMPORTED_MODULE_5__pages_components_demo_item___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].component(__WEBPACK_IMPORTED_MODULE_6__pages_components_v_code___default.a.name, __WEBPACK_IMPORTED_MODULE_6__pages_components_v_code___default.a);

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_7_vue_clipboards___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_3__components__["a" /* default */]);

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].config.productionTip = false;

new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]({
  el: '#app',
  router: __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */],
  template: '<App/>',
  components: { App: __WEBPACK_IMPORTED_MODULE_1__App___default.a }
});

/***/ }),
/* 109 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__pages_demo_Color_vue__ = __webpack_require__(594);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__pages_demo_Color_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__pages_demo_Color_vue__);




/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    color: __WEBPACK_IMPORTED_MODULE_0__pages_demo_Color_vue___default.a
  }
});

/***/ }),
/* 110 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__pages_demo_Btn_vue__ = __webpack_require__(591);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__pages_demo_Btn_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__pages_demo_Btn_vue__);




/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    test: __WEBPACK_IMPORTED_MODULE_0__pages_demo_Btn_vue___default.a
  }
});

/***/ }),
/* 111 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__pages_demo_Input_vue__ = __webpack_require__(598);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__pages_demo_Input_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__pages_demo_Input_vue__);




/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    test: __WEBPACK_IMPORTED_MODULE_0__pages_demo_Input_vue___default.a
  }
});

/***/ }),
/* 112 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__pages_demo_Radio_vue__ = __webpack_require__(604);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__pages_demo_Radio_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__pages_demo_Radio_vue__);




/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    test: __WEBPACK_IMPORTED_MODULE_0__pages_demo_Radio_vue___default.a
  }
});

/***/ }),
/* 113 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__pages_demo_Swipe_vue__ = __webpack_require__(608);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__pages_demo_Swipe_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__pages_demo_Swipe_vue__);




/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    test: __WEBPACK_IMPORTED_MODULE_0__pages_demo_Swipe_vue___default.a
  }
});

/***/ }),
/* 114 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__pages_demo_Tab_vue__ = __webpack_require__(610);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__pages_demo_Tab_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__pages_demo_Tab_vue__);




/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    test: __WEBPACK_IMPORTED_MODULE_0__pages_demo_Tab_vue___default.a
  }
});

/***/ }),
/* 115 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__pages_demo_SmoothScroll_vue__ = __webpack_require__(606);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__pages_demo_SmoothScroll_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__pages_demo_SmoothScroll_vue__);




/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    test: __WEBPACK_IMPORTED_MODULE_0__pages_demo_SmoothScroll_vue___default.a
  }
});

/***/ }),
/* 116 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__pages_demo_BackTop_vue__ = __webpack_require__(589);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__pages_demo_BackTop_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__pages_demo_BackTop_vue__);




/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    test: __WEBPACK_IMPORTED_MODULE_0__pages_demo_BackTop_vue___default.a
  }
});

/***/ }),
/* 117 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__pages_demo_Popover_vue__ = __webpack_require__(602);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__pages_demo_Popover_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__pages_demo_Popover_vue__);




/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    test: __WEBPACK_IMPORTED_MODULE_0__pages_demo_Popover_vue___default.a
  }
});

/***/ }),
/* 118 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__pages_demo_Switch_vue__ = __webpack_require__(609);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__pages_demo_Switch_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__pages_demo_Switch_vue__);




/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    test: __WEBPACK_IMPORTED_MODULE_0__pages_demo_Switch_vue___default.a
  }
});

/***/ }),
/* 119 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__pages_demo_Modal_vue__ = __webpack_require__(601);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__pages_demo_Modal_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__pages_demo_Modal_vue__);




/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    test: __WEBPACK_IMPORTED_MODULE_0__pages_demo_Modal_vue___default.a
  }
});

/***/ }),
/* 120 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__pages_demo_Bar_vue__ = __webpack_require__(590);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__pages_demo_Bar_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__pages_demo_Bar_vue__);




/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    test: __WEBPACK_IMPORTED_MODULE_0__pages_demo_Bar_vue___default.a
  }
});

/***/ }),
/* 121 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__pages_demo_Grid_vue__ = __webpack_require__(595);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__pages_demo_Grid_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__pages_demo_Grid_vue__);




/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    test: __WEBPACK_IMPORTED_MODULE_0__pages_demo_Grid_vue___default.a
  }
});

/***/ }),
/* 122 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__pages_demo_Calendar_vue__ = __webpack_require__(592);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__pages_demo_Calendar_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__pages_demo_Calendar_vue__);




/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    test: __WEBPACK_IMPORTED_MODULE_0__pages_demo_Calendar_vue___default.a
  }
});

/***/ }),
/* 123 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__pages_demo_Tabs_vue__ = __webpack_require__(611);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__pages_demo_Tabs_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__pages_demo_Tabs_vue__);




/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    test: __WEBPACK_IMPORTED_MODULE_0__pages_demo_Tabs_vue___default.a
  }
});

/***/ }),
/* 124 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__pages_demo_Toast_vue__ = __webpack_require__(612);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__pages_demo_Toast_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__pages_demo_Toast_vue__);




/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    test: __WEBPACK_IMPORTED_MODULE_0__pages_demo_Toast_vue___default.a
  }
});

/***/ }),
/* 125 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__pages_demo_Icon_vue__ = __webpack_require__(596);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__pages_demo_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__pages_demo_Icon_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__pages_demo_IconList_vue__ = __webpack_require__(597);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__pages_demo_IconList_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__pages_demo_IconList_vue__);





/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    test: __WEBPACK_IMPORTED_MODULE_0__pages_demo_Icon_vue___default.a,
    IconList: __WEBPACK_IMPORTED_MODULE_1__pages_demo_IconList_vue___default.a
  }
});

/***/ }),
/* 126 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__pages_demo_Spinner_vue__ = __webpack_require__(607);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__pages_demo_Spinner_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__pages_demo_Spinner_vue__);




/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    test: __WEBPACK_IMPORTED_MODULE_0__pages_demo_Spinner_vue___default.a
  }
});

/***/ }),
/* 127 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__pages_demo_CheckBox_vue__ = __webpack_require__(593);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__pages_demo_CheckBox_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__pages_demo_CheckBox_vue__);




/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    test: __WEBPACK_IMPORTED_MODULE_0__pages_demo_CheckBox_vue___default.a
  }
});

/***/ }),
/* 128 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__pages_demo_Loading_vue__ = __webpack_require__(599);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__pages_demo_Loading_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__pages_demo_Loading_vue__);




/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    test: __WEBPACK_IMPORTED_MODULE_0__pages_demo_Loading_vue___default.a
  }
});

/***/ }),
/* 129 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__pages_demo_Loadmore_vue__ = __webpack_require__(600);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__pages_demo_Loadmore_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__pages_demo_Loadmore_vue__);




/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    test: __WEBPACK_IMPORTED_MODULE_0__pages_demo_Loadmore_vue___default.a
  }
});

/***/ }),
/* 130 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__pages_demo_Select_vue__ = __webpack_require__(605);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__pages_demo_Select_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__pages_demo_Select_vue__);




/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    test: __WEBPACK_IMPORTED_MODULE_0__pages_demo_Select_vue___default.a
  }
});

/***/ }),
/* 131 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__pages_demo_Price_vue__ = __webpack_require__(603);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__pages_demo_Price_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__pages_demo_Price_vue__);




/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    test: __WEBPACK_IMPORTED_MODULE_0__pages_demo_Price_vue___default.a
  }
});

/***/ }),
/* 132 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__style_index_styl__ = __webpack_require__(242);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__style_index_styl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__style_index_styl__);




/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    var gap_xsm = __WEBPACK_IMPORTED_MODULE_0__style_index_styl___default.a.gap_xsm,
        gap_sm = __WEBPACK_IMPORTED_MODULE_0__style_index_styl___default.a.gap_sm,
        gap_md = __WEBPACK_IMPORTED_MODULE_0__style_index_styl___default.a.gap_md,
        gap_lg = __WEBPACK_IMPORTED_MODULE_0__style_index_styl___default.a.gap_lg,
        gap_xlg = __WEBPACK_IMPORTED_MODULE_0__style_index_styl___default.a.gap_xlg,
        size_sm = __WEBPACK_IMPORTED_MODULE_0__style_index_styl___default.a.size_sm,
        size_md = __WEBPACK_IMPORTED_MODULE_0__style_index_styl___default.a.size_md,
        size_lg = __WEBPACK_IMPORTED_MODULE_0__style_index_styl___default.a.size_lg,
        size_o_sm = __WEBPACK_IMPORTED_MODULE_0__style_index_styl___default.a.size_o_sm,
        size_o_md = __WEBPACK_IMPORTED_MODULE_0__style_index_styl___default.a.size_o_md,
        size_o_lg = __WEBPACK_IMPORTED_MODULE_0__style_index_styl___default.a.size_o_lg;

    return {
      gap: [gap_xsm, gap_sm, gap_md, gap_lg, gap_xlg],
      size: [size_sm, size_md, size_lg],
      size_o: [size_o_sm, size_o_md, size_o_lg]
    };
  }
});

/***/ }),
/* 133 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'app'
});

/***/ }),
/* 134 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__SmoothScroll_SmoothScroll__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__tools__ = __webpack_require__(26);





var prefixCls = 'hiui-backTop';

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'BackTop',
  props: {
    height: {
      default: 200,
      type: Number
    },
    time: {
      default: 500,
      type: Number
    },
    bottom: Number,
    right: Number
  },
  data: function data() {
    return {
      scrollTop: 0,
      show: false
    };
  },

  computed: {
    component_class: function component_class() {
      return [prefixCls];
    },
    component_style: function component_style() {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__tools__["d" /* getStyles */])({
        bottom: typeof this.bottom === 'number' && this.bottom + 'px',
        right: typeof this.right === 'number' && this.right + 'px'
      });
    }
  },
  watch: {
    scrollTop: function scrollTop(val) {
      if (val > this.height) {
        this.show = true;
      } else {
        this.show = false;
      }
    }
  },
  methods: {
    backTop: function backTop() {
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__SmoothScroll_SmoothScroll__["c" /* scrollToTop */])();
    },
    bindEvent: function bindEvent() {
      document.addEventListener('scroll', this.scroll, false);
    },
    unbindEvent: function unbindEvent() {
      document.removeEventListener('scroll', this.scroll, false);
    },
    scroll: function scroll() {
      this.scrollTop = window.pageYOffset || document.documentElement.scrollTop + document.body.scrollTop;
    }
  },
  mounted: function mounted() {
    this.bindEvent();
  },
  beforeDestroy: function beforeDestroy() {
    this.unbindEvent();
  }
});

/***/ }),
/* 135 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(5);





var prefixCls = 'hiui-btn';

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Btn',
  components: {
    Icon: __WEBPACK_IMPORTED_MODULE_1__Icon__["a" /* default */]
  },
  props: {
    size: {
      default: 'md',
      type: String
    },
    disabled: {
      default: false,
      type: Boolean
    },
    is_loading: {
      default: false,
      type: Boolean
    },
    loading_text: String,
    prefix: String,
    suffix: String
  },
  computed: {
    component_class: function component_class() {
      var _ref;

      return [prefixCls, (_ref = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, prefixCls + '-' + this.size, this.size), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, 'disabled', this.is_loading || this.disabled), _ref)];
    }
  },
  methods: {
    handleClick: function handleClick(e) {
      this.$emit('click', e);
    }
  }
});

/***/ }),
/* 136 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


var prefixCls = 'hiui-checkbox';

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'CheckBox',
  props: {
    size: {
      default: 'md',
      type: String
    },
    color: String,
    disabled: Boolean,
    value: {},
    checked: {
      type: Array,
      default: function _default() {
        return [];
      }
    }
  },
  model: {
    prop: 'checked',
    event: 'input'
  },
  data: function data() {
    return {
      cur_checked: []
    };
  },

  computed: {
    component_class: function component_class() {
      return [prefixCls, prefixCls + '-' + this.size, {
        disabled: this.disabled,
        active: this.is_active
      }];
    },

    is_active: function is_active() {
      var _this = this;

      return this.cur_checked.findIndex(function (item) {
        return _this.cur_value === item;
      }) !== -1;
    },
    cur_value: function cur_value() {
      return this.value == null ? this.$slots.default[0].text : this.value;
    }
  },
  watch: {
    checked: function checked(_checked) {
      this.cur_checked = [].concat(_checked);
    }
  },
  created: function created() {
    this.cur_checked = [].concat(this.checked);
  },
  methods: {
    triggerHandler: function triggerHandler(target) {
      if (this.disabled) return;
      var checked = this.cur_checked;
      var index = checked.findIndex(function (item) {
        return item === target;
      });
      if (index !== -1) checked.splice(index, 1);else checked.push(target);
      this.$emit('input', checked);
    }
  }
});

/***/ }),
/* 137 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty__);





var prefixCls = 'hiui-grid-col';

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Col',
  props: {
    span: [Number, String],
    offset: [Number, String],
    pull: [Number, String],
    push: [Number, String],
    xsm: [Number, String, Object],
    sm: [Number, String, Object],
    md: [Number, String, Object],
    lg: [Number, String, Object],
    xlg: [Number, String, Object]
  },
  data: function data() {
    return {
      gutter: 0
    };
  },

  computed: {
    component_class: function component_class() {
      var _ref,
          _this = this;

      var classList = ['' + prefixCls, (_ref = {}, __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, prefixCls + '-' + this.span, this.span), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, prefixCls + '-offset-' + this.offset, this.offset), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, prefixCls + '-push-' + this.push, this.push), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, prefixCls + '-pull-' + this.pull, this.pull), _ref)];

      var size_o = ['xsm', 'sm', 'md', 'lg', 'xlg'];
      size_o.forEach(function (size) {
        if (typeof _this[size] === 'number' || typeof _this[size] === 'string') {
          classList.push(prefixCls + '-' + size + '-' + _this[size]);
        } else if (__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof___default()(_this[size]) === 'object') {
          var props = _this[size];
          __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(props).forEach(function (prop) {
            classList.push(prop !== 'span' ? prefixCls + '-' + size + '-' + prop + '-' + props[prop] : prefixCls + '-' + size + '-' + props[prop]);
          });
        }
      });
      return classList;
    },
    styles: function styles() {
      return this.gutter ? {
        paddingLeft: this.gutter / 2 + 'px',
        paddingRight: this.gutter / 2 + 'px'
      } : {};
    }
  },
  mounted: function mounted() {
    this.gutter = this.$parent.gutter;
  }
});

/***/ }),
/* 138 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_from__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_from___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_from__);



var prefixCls = 'hiui-grid-row';

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Row',
  props: {
    gutter: {
      default: 0,
      type: Number
    }
  },
  computed: {
    component_class: function component_class() {
      return [prefixCls];
    },
    styles: function styles() {
      return this.gutter ? {
        marginLeft: this.gutter / -2 + 'px',
        marginRight: this.gutter / -2 + 'px'
      } : {};
    }
  },
  watch: {
    gutter: function gutter(val) {
      this.updateGutter(val);
    }
  },
  methods: {
    updateGutter: function updateGutter(val) {
      __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_from___default()(this.$children, function (vm) {
        if (vm && typeof vm.gutter === 'number') {
          vm.gutter = val;
        }
      });
    }
  }
});

/***/ }),
/* 139 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);



var prefixCls = 'hiui-icon';

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Icon',
  props: {
    size: Number,
    name: {
      type: String,
      required: true
    },
    color: {
      default: '',
      type: String
    },
    rotate: {
      default: false,
      type: Boolean
    }
  },
  data: function data() {
    return {};
  },

  computed: {
    component_class: function component_class() {
      return ['iconfont', prefixCls, 'icon-' + this.name, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()({}, prefixCls + '-rotate', this.rotate)];
    },
    size_style: function size_style() {
      return {
        fontSize: this.size ? this.size + 'px' : '',
        color: this.color || ''
      };
    }
  }
});

/***/ }),
/* 140 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


var prefixCls = 'hiui-input';

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Input',
  props: {
    value: {},
    size: { type: String, default: 'md' },
    color: String,
    label: [String, Number],
    placeholder: [String, Number],
    type: { type: String, default: 'text' },
    verify: [String, Array],
    reg: [RegExp, String],
    tip: String,
    with_border: { type: Boolean, default: true },
    format: Boolean,
    disabled: Boolean,
    readonly: Boolean,
    rows: Number,
    autosize: Boolean
  },
  components: {
    InputLabel: __webpack_require__(570),
    InputField: __webpack_require__(569),
    InputTip: __webpack_require__(571)
  },
  data: function data() {
    return {
      custom_tip: '',
      val: '',
      is_hover: false,
      is_focus: false,
      is_error: false,
      is_correct: false,
      is_edited: false,
      verify_result: false
    };
  },

  computed: {
    component_class: function component_class() {
      var is_error = this.is_error,
          is_focus = this.is_focus,
          disabled = this.disabled,
          is_animated = this.is_animated,
          size = this.size,
          type = this.type,
          with_border = this.with_border,
          label = this.label;

      return [prefixCls, prefixCls + '-' + size, { error: is_error, focus: is_focus, disabled: disabled, animated: is_animated, 'with-border': with_border, textarea: type === 'textarea', float: label != null }];
    },

    custom_style: function custom_style() {
      var color = this.color,
          is_hover = this.is_hover,
          is_focus = this.is_focus,
          with_border = this.with_border;

      if (!color || !with_border) return {};
      var rgb = color.indexOf('rgb') === -1 ? this.hexToRgb(color) : color.replace(/[^\d,]/g, '').split(',');
      var _boxshadow = is_focus ? '0 0 0 2px rgba(' + (rgb.r || rgb[0] || 0) + ',' + (rgb.g || rgb[1] || 0) + ',' + (rgb.b || rgb[2] || 0) + ',.2)' : undefined;
      var _color = is_hover || is_focus ? color : undefined;
      return {
        borderColor: _color,
        boxShadow: _boxshadow
      };
    },

    is_animated: function is_animated() {
      return this.label && !!(this.is_focus || this.value || this.value === 0);
    },

    no_verify: function no_verify() {
      return (!this.verify || this.verify && !this.verify.length) && !this.reg;
    },

    err_tip: function err_tip() {
      return this.custom_tip || this.tip;
    }
  },
  watch: {
    value: function value() {
      this.is_edited = true;
    }
  },
  created: function created() {
    this.registerEvents();
  },
  methods: {
    verifyHandler: function verifyHandler(verify_result) {
      var no_verify = this.no_verify;

      this.verify_result = verify_result;
      this.$emit('verify', no_verify || verify_result);
    },
    focusHandler: function focusHandler() {
      this.is_focus = true;
      this.is_error = false;
      this.is_correct = false;
      this.$emit('focus');
    },
    blurHandler: function blurHandler(is_edited) {
      this.is_focus = false;
      if (is_edited) {
        this.is_error = !this.no_verify && !this.verify_result || !!this.custom_tip;
        this.is_correct = !this.no_verify && this.verify_result && !this.custom_tip;
      }
      this.$emit('blur');
    },
    enterHandler: function enterHandler() {
      this.$emit('enter');
    },
    inputHandler: function inputHandler(val) {
      this.is_edited = true;
      this.is_correct = false;
      this.is_error = false;
      this.val = val;
      this.$emit('input', val);
    },
    registerEvents: function registerEvents() {
      var _this = this;

      var handler = function handler() {
        _this.verifyHandler(_this.verify_result);
        _this.blurHandler(true);
      };
      this.$root.$on('form-verify', handler);
      this.$on('form-verify', handler);
      this.$on('error', function (tip) {
        _this.custom_tip = tip;
        _this.is_error = true;
        _this.is_correct = false;
        _this.$emit('verify', false);
      });
      this.$on('correct', function () {
        _this.custom_tip = '';
        _this.is_error = false;
        _this.is_correct = true;
        _this.$emit('verify', true);
      });
      this.$on('clear', function () {
        _this.custom_tip = '';
        _this.is_error = false;
        _this.is_correct = false;
        _this.$emit('verify', false);
      });
    },
    hexToRgb: function hexToRgb(hex) {
      var shorthandRegex = /^#?([a-f\d])([a-f\d])([a-f\d])$/i;
      hex = hex.replace(shorthandRegex, function (m, r, g, b) {
        return r + r + g + g + b + b;
      });

      var result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
      return result ? {
        r: parseInt(result[1], 16),
        g: parseInt(result[2], 16),
        b: parseInt(result[3], 16)
      } : null;
    }
  }
});

/***/ }),
/* 141 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


var prefixCls = 'hiui-input-field';
var BASIC_VERIFY_REGEXP = {
  phone: /^\d{7,14}$/,
  password: /^(.){6,18}$/,
  email: /^[\w\d]+[\w\d-.]*@[\w\d-.]+\.[\w\d]{2,10}$/,
  empty: /.+/
};
/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'InputField',
  props: {
    value: [String, Number],
    type: {
      type: String,
      default: 'text'
    },
    placeholder: [String, Number],
    disabled: Boolean,
    readonly: Boolean,
    format: Boolean,
    autosize: Boolean,
    no_padding: Boolean,
    rows: { type: Number, default: 3 },
    verify: [String, Array],
    reg: [RegExp, String]
  },
  data: function data() {
    return {
      textarea_height: 0
    };
  },

  computed: {
    component_class: function component_class() {
      return [prefixCls, this.type, { 'no-padding': this.no_padding }];
    },

    textarea_style: function textarea_style() {
      return {
        height: this.textarea_height ? this.textarea_height + 'px' : undefined
      };
    },

    verify_result: function verify_result() {
      return this.verifyResult(this.value, this.reg, this.verify);
    }
  },
  watch: {
    verify_result: function verify_result() {
      this.$emit('verify', this.verify_result);
    },
    value: function value() {
      this.autosize && this.recomputeTextAreaHeight();
    }
  },
  created: function created() {
    this.$emit('verify', this.verify_result);
  },
  methods: {
    verifyResult: function verifyResult() {
      var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      var regs = arguments[1];
      var verify = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];

      value = value && typeof value.trim === 'function' && value.trim() || value;
      verify = [].concat(verify);

      if (this.reg) return new RegExp(this.reg).test(value);

      for (var i = 0, len = verify.length, reg; i < len; i++) {
        reg = BASIC_VERIFY_REGEXP[verify[i]];
        if (reg.test(value)) {
          if (verify[i] === 'empty') return !!value || value === 0;
          return true;
        } else {
          if (i === len - 1) {
            return false;
          }
        }
      }
      return false;
    },
    reformStr: function reformStr(str) {
      str = str + '';
      var result = str.trim();
      if (this.type === 'number') result = parseFloat(result);
      if (this.format) result = this.dealSpecialSymbol(result);
      return result;
    },
    dealSpecialSymbol: function dealSpecialSymbol(str) {
      var CHINESE_SYMBOL = '，。！？【】（）％＃＠＆１２３４５６７８９０';
      var REFORM_SYMBOL = ',.!?[]()%#@&1234567890';
      var TRANS_SYMBOL = { '.': true, '(': true, ')': true, '{': true, '}': true, '?': true };
      if (typeof str.normalize === 'function') str = str.normalize('NFKC');
      var arr = str.split('');
      var arr_deal = arr.map(function (item) {
        var idx = void 0;
        var condition = void 0;
        condition = TRANS_SYMBOL[item] ? '\\' + item : item;
        idx = CHINESE_SYMBOL.search(condition);
        return idx !== -1 ? REFORM_SYMBOL.charAt(idx) : item;
      });
      return arr_deal.join('');
    },
    recomputeTextAreaHeight: function recomputeTextAreaHeight() {
      var _this = this;

      this.$nextTick(function () {
        var hidden_textarea = _this.$refs.hidden_textarea;
        _this.textarea_height = hidden_textarea.scrollHeight;
      });
    }
  }
});

/***/ }),
/* 142 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


var prefixCls = 'hiui-input-label';
/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'InputLabel',
  props: {
    label: [String, Number]
  },
  data: function data() {
    return {};
  },
  computed: {
    component_class: function component_class() {
      return [prefixCls];
    }
  }
});

/***/ }),
/* 143 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Icon__ = __webpack_require__(5);




var prefixCls = 'hiui-input-tip';
var BASIC_VERIFY_TIP = {
  phone: '手机格式不正确',
  password: '密码长度为6~20位',
  email: '邮箱格式不正确',
  empty: '不能为空'
};
/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'InputTip',
  components: {
    Icon: __WEBPACK_IMPORTED_MODULE_0__Icon__["a" /* default */]
  },
  props: {
    tip: String,
    position: { type: String, default: 'middle' },
    verify: [String, Array],
    is_error: Boolean,
    is_correct: Boolean
  },
  computed: {
    component_class: function component_class() {
      return [prefixCls, this.position];
    },

    self_tip: function self_tip() {
      var verify = this.verify;

      return this.tip || BASIC_VERIFY_TIP[verify] || '输入格式不正确';
    }
  }
});

/***/ }),
/* 144 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Icon___ = __webpack_require__(5);




var prefixCls = 'hiui-loading';

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Loading',
  components: {
    Icon: __WEBPACK_IMPORTED_MODULE_0__Icon___["a" /* default */]
  },
  data: function data() {
    return {
      show: false,
      timer: null,
      status: 'loading',
      process: 0
    };
  },

  computed: {
    component_class: function component_class() {
      return [prefixCls, prefixCls + '-' + this.status];
    },
    component_style: function component_style() {
      return {
        width: this.process + '%'
      };
    }
  },
  watch: {
    process: function process(val) {
      var _this = this;

      if (val === 100) {
        setTimeout(function () {
          _this.show = false;
        }, 200);
      }
      return val;
    }
  },
  methods: {
    start: function start() {
      var _this2 = this;

      document.body.appendChild(this.$el);
      this.$nextTick(function () {
        _this2.show = true;
        _this2.startLoad();
      });
    },
    startLoad: function startLoad() {
      var _this3 = this;

      this.timer = setTimeout(function () {
        _this3.process += 5;
        if (_this3.process < 95) {
          _this3.startLoad();
        }
      }, 200);
    },
    destroy: function destroy() {
      this.$destroy(true);
    }
  },
  beforeDestroy: function beforeDestroy() {
    document.body.removeChild(this.$el);
  }
});

/***/ }),
/* 145 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Icon__ = __webpack_require__(5);




var prefixCls = 'hiui-loadmore';

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Loadmore',
  components: {
    Icon: __WEBPACK_IMPORTED_MODULE_0__Icon__["a" /* default */]
  },
  props: {
    offset: {
      default: 300,
      type: Number
    },
    interval: {
      default: 3,
      type: Number
    },
    done: {
      default: false,
      type: Boolean
    },
    real_time: {
      default: false,
      type: Boolean
    }
  },
  data: function data() {
    return {
      status: 'normal',
      error_msg: '加载失败',
      loadmore_scrollTop: 0,
      current_loaded: 0,
      scrollTop: 0
    };
  },

  computed: {
    component_class: function component_class() {
      return [prefixCls];
    },
    content_class: function content_class() {
      return [prefixCls + '-content'];
    },
    status_class: function status_class() {
      return [prefixCls + '-status'];
    }
  },
  watch: {
    scrollTop: function scrollTop(val) {
      this.real_time && this.getLoadmoreTop();
      if (!this.done && this.status === 'normal' && val >= this.loadmore_scrollTop) {
        this.loadmore();
      }
    }
  },
  methods: {
    init: function init() {
      this.bindEvent();
      this.getLoadmoreTop();
    },
    loadmore: function loadmore() {
      if (this.current_loaded >= this.interval) {
        this.current_loaded %= this.interval;
        this.status = 'loadmore';
        return false;
      }

      this.status = 'loading';
      this.$emit('load-method', this.next, this.error);
    },
    next: function next() {
      var _this = this;

      this.$nextTick(function () {
        _this.current_loaded += 1;
        _this.status = 'normal';
        _this.getLoadmoreTop();
      });
    },
    error: function error(msg) {
      this.error_msg = msg;
      this.status = 'error';
    },
    getLoadmoreTop: function getLoadmoreTop() {
      var content = this.$refs.content;


      if (!content) {
        return false;
      }

      this.loadmore_scrollTop = content.offsetHeight + this.getOffsetTop(content) - this.offset - document.documentElement.clientHeight;
    },
    getOffsetTop: function getOffsetTop(elem) {
      var clientTop;
      var scrollTop;
      var doc = document.documentElement;
      var body = document.body;
      var top = elem.getBoundingClientRect().top;

      clientTop = doc.clientTop || body.clientTop || 0;
      scrollTop = window.pageYOffset || doc.scrollTop;

      return top + scrollTop - clientTop;
    },
    bindEvent: function bindEvent() {
      document.addEventListener('scroll', this.scroll, false);
    },
    unbindEvent: function unbindEvent() {
      document.removeEventListener('scroll', this.scroll, false);
    },
    scroll: function scroll() {
      this.scrollTop = window.pageYOffset || document.documentElement.scrollTop + document.body.scrollTop;
    },
    reset: function reset() {
      this.current_loaded = 0;
      this.scrollTop = 0;
      this.status = 'normal';
      this.getLoadmoreTop();
    }
  },
  mounted: function mounted() {
    this.init();
  },
  beforeDestroy: function beforeDestroy() {
    this.unbindEvent();
  }
});

/***/ }),
/* 146 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__tools__ = __webpack_require__(26);




var prefixCls = 'hiui-modal';

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Modal',
  props: {
    show: false,
    type: {
      default: 'center',
      type: String,
      validator: function validator(val) {
        return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__tools__["a" /* isValid */])(['center', 'top', 'bottom', 'left', 'right'], val);
      }
    },
    render_type: {
      default: 'show',
      type: String,
      validator: function validator(val) {
        return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__tools__["a" /* isValid */])(['show', 'if'], val);
      }
    },
    use_close: {
      default: true,
      type: Boolean
    },
    use_mask: {
      default: true,
      type: Boolean
    },
    mask_close: {
      default: true,
      type: Boolean
    },
    prevent_scroll: {
      default: true,
      type: Boolean
    },
    use_shadow: {
      default: true,
      type: Boolean
    },
    overflow: String,
    border_radius: String,
    background_color: String,
    z_index: [Number, String]
  },
  model: {
    prop: 'show',
    event: 'switch'
  },
  data: function data() {
    return {
      modal_show: this.show,
      isExist: this.render_type === 'show' || this.show,
      transitionName: {
        center: 'hiui-modal-bounce-center',
        top: 'hiui-modal-slide-down',
        bottom: 'hiui-modal-slide-up',
        left: 'hiui-modal-slide-right',
        right: 'hiui-modal-slide-left'
      }
    };
  },

  watch: {
    show: function show(val) {
      var _this = this;

      this.isExist = true;
      this.$nextTick(function () {
        _this.modal_show = val;
      });

      if (this.prevent_scroll) {
        if (val) {
          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__tools__["b" /* on */])(document.documentElement, 'mousewheel', this.noScroll);
          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__tools__["b" /* on */])(document.documentElement, 'DOMMouseScroll', this.noScroll);
        } else {
          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__tools__["c" /* off */])(document.documentElement, 'mousewheel', this.noScroll);
          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__tools__["c" /* off */])(document.documentElement, 'DOMMouseScroll', this.noScroll);
        }
      }
    }
  },
  computed: {
    component_class: function component_class() {
      return [prefixCls + '-wrap'];
    },
    component_style: function component_style() {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__tools__["d" /* getStyles */])({
        zIndex: this.z_index
      });
    },
    container_class: function container_class() {
      var classNames = [prefixCls, prefixCls + '-' + this.type, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()({}, prefixCls + '-hasMask', this.use_mask)];
      return classNames;
    },
    body_class: function body_class() {
      var classNames = [prefixCls + '-body', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()({}, prefixCls + '-body-use_shadow', this.use_shadow)];
      return classNames;
    },
    body_style: function body_style() {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__tools__["d" /* getStyles */])({
        backgroundColor: this.background_color,
        borderRadius: this.border_radius,
        overflow: this.overflow
      });
    },
    icon_class: function icon_class() {
      return [prefixCls + '-close'];
    }
  },
  methods: {
    noScroll: function noScroll(e) {
      e.preventDefault();
    },
    closeModal: function closeModal(name) {
      if (name === 'mask' && !this.mask_close) {
        return false;
      }
      this.$emit('switch', false);
    },
    afterLeave: function afterLeave() {
      this.isExist = this.render_type === 'show';
    }
  },
  destroyed: function destroyed() {
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__tools__["c" /* off */])(document.documentElement, 'mousewheel', this.noScroll);
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__tools__["c" /* off */])(document.documentElement, 'DOMMouseScroll', this.noScroll);
  }
});

/***/ }),
/* 147 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__tools__ = __webpack_require__(26);






var prefixCls = 'hiui-popover';
var placementMap = {
  top: 'bottom',
  bottom: 'top',
  left: 'right',
  right: 'left'
};

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Popover',
  props: {
    placement: {
      default: 'top',
      type: String,
      validator: function validator(val) {
        return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__tools__["a" /* isValid */])(['top-left', 'top', 'top-right', 'bottom-left', 'bottom', 'bottom-right', 'left-top', 'left', 'left-bottom', 'right-top', 'right', 'right-bottom'], val);
      }
    },
    auto_reverse: {
      default: true,
      type: Boolean
    },
    offset: {
      default: 10,
      type: Number
    },
    trigger: {
      default: 'click',
      type: String,
      validator: function validator(val) {
        return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__tools__["a" /* isValid */])(['click', 'hover', 'focus', 'manual'], val);
      }
    },
    show_arrow: {
      default: true,
      type: Boolean
    },
    border_color: {
      default: true,
      type: [String, Boolean]
    },
    use_shadow: {
      default: true,
      type: [String, Boolean]
    },
    width: Number,
    z_index: Number,
    border_radius: Number
  },
  data: function data() {
    return {
      show: false,
      elem: null,
      popover_width: 0,
      popover_height: 0,
      offsetTop: 0,
      offsetLeft: 0,
      offsetWidth: 0,
      offsetHeight: 0,
      bounds: null,
      reference: null,
      timer: null,
      is_reverse: false,
      scrollTop: 0,
      scrollLeft: 0,
      transitionName: {
        top: 'hiui-popover-slide-down',
        bottom: 'hiui-popover-slide-up',
        left: 'hiui-popover-slide-right',
        right: 'hiui-popover-slide-left'
      }
    };
  },

  watch: {
    show: function show(val) {
      if (val) {
        document.body.appendChild(this.$refs.popover);
      }
      val ? this.$emit('show') : this.$emit('hide');
    },
    scrollTop: function scrollTop(val) {
      if (this.show && this.auto_reverse) {
        this.setReverse();
      }
    },
    scrollLeft: function scrollLeft(val) {
      if (this.show && this.auto_reverse) {
        this.setReverse();
      }
    }
  },
  computed: {
    position_type: function position_type() {
      return this.placement.split('-')[0];
    },
    reverse_type: function reverse_type() {
      return this.is_reverse ? placementMap[this.position_type] : this.position_type;
    },
    align_type: function align_type() {
      return this.placement.split('-')[1];
    },
    current_placement: function current_placement() {
      return this.reverse_type + (this.align_type ? '-' + this.align_type : '');
    },
    component_class: function component_class() {
      var _ref;

      return [prefixCls, (_ref = {}, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, prefixCls + '-' + this.current_placement, this.show_arrow), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, prefixCls + '-use_shadow', this.use_shadow), _ref)];
    },
    component_style: function component_style() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, this.component_border, this.component_width, this.position, this.align);
    },
    component_width: function component_width() {
      return {
        width: this.width ? this.width + 'px' : '',
        borderRadius: this.border_radius ? this.border_radius + 'px' : '',
        borderColor: this.border_color,
        zIndex: this.z_index
      };
    },
    component_border: function component_border() {
      return this.border_color === false ? {
        border: 'none'
      } : {};
    },
    position: function position() {
      var pos = {};

      switch (this.reverse_type) {
        case 'top':
          pos.top = this.offsetTop - this.popover_height - this.offset;
          break;
        case 'bottom':
          pos.top = this.offsetTop + this.offsetHeight + this.offset;
          break;
        case 'left':
          pos.left = this.offsetLeft - this.popover_width - this.offset;
          break;
        case 'right':
          pos.left = this.offsetLeft + this.offsetWidth + this.offset;
          break;
        default:
          break;
      }

      for (var key in pos) {
        pos[key] += 'px';
      }

      return pos;
    },
    align: function align() {
      var align = {};

      switch (this.align_type) {
        case 'left':
          align.left = this.offsetLeft;
          break;
        case 'right':
          align.left = this.offsetLeft - (this.popover_width - this.offsetWidth);
          break;
        case 'top':
          align.top = this.offsetTop;
          break;
        case 'bottom':
          align.top = this.offsetTop - (this.popover_height - this.offsetHeight);
          break;
        default:
          if (this.reverse_type === 'top' || this.reverse_type === 'bottom') {
            align.left = this.offsetLeft + (this.offsetWidth - this.popover_width) / 2;
          } else {
            align.top = this.offsetTop + (this.offsetHeight - this.popover_height) / 2;
          }
          break;
      }

      for (var key in align) {
        align[key] += 'px';
      }

      return align;
    }
  },
  methods: {
    setReverse: function setReverse() {
      var type = this.position_type;

      if (type === 'top' && this.scrollTop > this.offsetTop - this.popover_height - this.offset) {
        this.is_reverse = true;
        return false;
      }
      if (type === 'bottom' && this.scrollTop < this.offsetTop + this.offsetHeight + this.popover_height + this.offset - document.documentElement.clientHeight) {
        this.is_reverse = true;
        return false;
      }
      if (type === 'left' && this.scrollLeft > this.offsetLeft - this.popover_width - this.offset) {
        this.is_reverse = true;
        return false;
      }
      if (type === 'right' && this.scrollLeft < this.offsetLeft + this.offsetWidth + this.popover_width + this.offset - document.documentElement.clientWidth) {
        this.is_reverse = true;
        return false;
      }

      this.is_reverse = false;
    },
    open: function open() {
      if (this.timer) {
        clearTimeout(this.timer);
        this.timer = null;
        return false;
      }
      this.show = true;
      this.$nextTick(this.update);
    },
    close: function close() {
      var _this = this;

      this.timer = setTimeout(function () {
        _this.show = false;
        _this.timer = null;
      }, 150);
    },
    toggle: function toggle() {
      this.show ? this.close() : this.open();
    },
    update: function update() {
      this.getReferenceData();
      this.popover_width = this.$refs.popover.offsetWidth;
      this.popover_height = this.$refs.popover.offsetHeight;
      this.setReverse();
    },
    getReferenceData: function getReferenceData() {
      var offset = this.getOffset();
      this.offsetTop = offset.top;
      this.offsetLeft = offset.left;
      this.offsetWidth = this.reference.offsetWidth;
      this.offsetHeight = this.reference.offsetHeight;
    },
    getOffset: function getOffset() {
      var el = this.reference;
      var top = 0;
      var left = 0;

      while (el) {
        top += el.offsetTop;
        left += el.offsetLeft;
        el = el.offsetParent;
      }

      return {
        top: top,
        left: left
      };
    },
    handleDocumentClick: function handleDocumentClick(e) {
      if (!this.$refs.popover || !this.reference || this.$refs.popover.contains(e.target) || this.reference.contains(e.target)) {
        return false;
      }

      this.show = false;
    },
    getScroll: function getScroll() {
      this.scrollLeft = window.pageXOffset || document.documentElement.scrollLeft + document.body.scrollLeft;
      this.scrollTop = window.pageYOffset || document.documentElement.scrollTop + document.body.scrollTop;
    },
    afterLeave: function afterLeave() {
      document.body.removeChild(this.$refs.popover);
    }
  },
  mounted: function mounted() {
    var el = this.reference = this.$refs.reference;
    var popover = this.$refs.popover;

    if (!el && this.$slots.reference && this.$slots.reference[0]) {
      el = this.reference = this.$slots.reference[0].elm;
    }

    switch (this.trigger) {
      case 'hover':
        {
          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__tools__["b" /* on */])(el, 'mouseenter', this.open);
          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__tools__["b" /* on */])(el, 'mouseleave', this.close);
          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__tools__["b" /* on */])(popover, 'mouseenter', this.open);
          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__tools__["b" /* on */])(popover, 'mouseleave', this.close);
          break;
        }
      case 'click':
        {
          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__tools__["b" /* on */])(el, 'click', this.toggle);
          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__tools__["b" /* on */])(document, 'click', this.handleDocumentClick);
          break;
        }
      case 'focus':
        {
          if (el.nodeName === 'INPUT' || el.nodeName === 'TEXTAREA') {
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__tools__["b" /* on */])(el, 'focus', this.open);
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__tools__["b" /* on */])(el, 'blur', this.close);
          } else {
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__tools__["b" /* on */])(el, 'mousedown', this.open);
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__tools__["b" /* on */])(el, 'mouseup', this.close);
          }
          break;
        }
      default:
        {
          break;
        }
    }
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__tools__["b" /* on */])(document, 'scroll', this.getScroll);

    this.getScroll();
  },
  beforeDestroy: function beforeDestroy() {
    if (document.body.contains(this.$refs.popover)) {
      document.body.removeChild(this.$refs.popover);
    }
  },
  destroyed: function destroyed() {
    var el = this.reference;

    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__tools__["c" /* off */])(document, 'scroll', this.getScroll);
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__tools__["c" /* off */])(el, 'mouseenter', this.open);
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__tools__["c" /* off */])(el, 'mouseleave', this.close);
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__tools__["c" /* off */])(el, 'click', this.toggle);
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__tools__["c" /* off */])(document, 'click', this.handleDocumentClick);
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__tools__["c" /* off */])(el, 'focus', this.open);
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__tools__["c" /* off */])(el, 'blur', this.close);
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__tools__["c" /* off */])(el, 'mousedown', this.open);
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__tools__["c" /* off */])(el, 'mouseup', this.close);
  }
});

/***/ }),
/* 148 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);



var prefixCls = 'hiui-price';

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Price',
  props: {
    super: {
      type: Boolean,
      default: false
    },
    delete: {
      type: Boolean,
      default: false
    },
    color: {
      type: String,
      default: '#f02f45'
    },
    font_size: {
      type: Number,
      default: 24
    },
    no_shrink: {
      type: Boolean,
      default: false
    },
    symbol: {
      type: String,
      default: '￥'
    },
    suffix: [String, Number],
    text_size: Number
  },
  data: function data() {
    return {};
  },

  computed: {
    component_class: function component_class() {
      var _ref;

      return [prefixCls, (_ref = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, prefixCls + '-sup', this.super), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, prefixCls + '-delete', this.delete), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, prefixCls + '-noShrink', this.no_shrink), _ref)];
    },
    component_style: function component_style() {
      return {
        'color': this.color,
        'font-size': this.font_size + 'px',
        'line-height': this.font_size + 'px'
      };
    },
    suffix_style: function suffix_style() {
      return {
        'font-size': this.text_size + 'px'
      };
    }
  }
});

/***/ }),
/* 149 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


var prefixCls = 'hiui-radio';

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Radio',
  props: {
    value: {},
    checked: {},
    size: {
      default: 'md',
      type: String
    },
    color: String,
    reselect: Boolean,
    disabled: Boolean
  },
  model: {
    prop: 'checked',
    event: 'input'
  },
  data: function data() {
    return {
      cur_checked: ''
    };
  },

  computed: {
    component_class: function component_class() {
      var size = this.size,
          disabled = this.disabled,
          is_active = this.is_active;

      return [prefixCls, prefixCls + '-' + size, { disabled: disabled, active: is_active }];
    },

    is_active: function is_active() {
      var cur_value = this.cur_value,
          cur_checked = this.cur_checked;

      return cur_value === cur_checked;
    },
    active_style: function active_style() {
      return {
        backgroundColor: this.color
      };
    },
    cur_value: function cur_value() {
      return this.value == null ? this.$slots.default[0].text : this.value;
    }
  },
  watch: {
    checked: function checked(_checked) {
      this.cur_checked = _checked;
    }
  },
  created: function created() {
    this.cur_checked = this.checked;
  },
  methods: {
    triggerHandler: function triggerHandler(value) {
      this.cur_checked = this.reselect && this.cur_checked === value && this.cur_checked !== '' ? '' : value;
      this.$emit('input', this.cur_checked);
    }
  }
});

/***/ }),
/* 150 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__directive_clickothers_js__ = __webpack_require__(99);



var prefixCls = 'hiui-select';

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Select',
  directives: { clickothers: __WEBPACK_IMPORTED_MODULE_0__directive_clickothers_js__["a" /* default */] },
  props: {
    size: { default: 'md', type: String },
    color: String,
    data: Array,
    value: {},
    show_by: String,
    value_by: String,
    label: String,
    icon: String,
    default_first: Boolean,
    clear_invalid: Boolean,
    disabled: Boolean,
    float: Boolean
  },
  data: function data() {
    return {
      is_active: false,
      is_hover: false,
      is_error: false
    };
  },

  components: {
    'SelectItem': __webpack_require__(79)
  },
  computed: {
    component_class: function component_class() {
      var is_active = this.is_active,
          is_hover = this.is_hover,
          is_error = this.is_error,
          icon = this.icon,
          float = this.float,
          disabled = this.disabled,
          size = this.size;

      return [prefixCls, prefixCls + '-' + size, { active: is_active, hover: is_hover, error: is_error, 'has-icon': !!icon, float: float, disabled: disabled }];
    },

    custom_style: function custom_style() {
      var color = this.color,
          is_hover = this.is_hover,
          is_active = this.is_active;

      if (!color) return {};
      var rgb = color.indexOf('rgb') === -1 ? this.hexToRgb(color) : color.replace(/[^\d,]/g, '').split(',');
      var _boxshadow = is_active ? '0 0 0 2px rgba(' + (rgb.r || rgb[0] || 0) + ',' + (rgb.g || rgb[1] || 0) + ',' + (rgb.b || rgb[2] || 0) + ',.2)' : undefined;
      var _color = is_hover || is_active ? color : undefined;
      return {
        self: {
          borderColor: _color,
          boxShadow: _boxshadow
        },
        arrow: {
          borderColor: _color
        }
      };
    },
    show_val: function show_val() {
      var data = this.data,
          value = this.value,
          show_by = this.show_by,
          value_by = this.value_by;

      if (!data) return value;
      for (var i = 0, len = data.length, cur_val; i < len; i++) {
        cur_val = value_by ? data[i][value_by] : data[i];
        if (cur_val === value) return show_by ? data[i][show_by] : data[i];
      }
    },
    is_error_value: function is_error_value() {
      var value = this.value,
          value_by = this.value_by,
          data = this.data;

      if (!data) return false;
      return data.findIndex(function (item, index) {
        return value_by ? item[value_by] === value : value === item;
      }) === -1;
    }
  },
  watch: {
    is_active: function is_active(active) {
      this.$emit('active', active);
    },
    value: function value(_value) {
      this.dealErrorValue();
      _value && this.verfiy(_value);
    }
  },
  created: function created() {
    this.registerEvents();
    this.dealErrorValue();
    this.defaultFirst();
  },
  methods: {
    clickHandler: function clickHandler() {
      this.is_active = !this.is_active;
    },
    hoverHandler: function hoverHandler(hover) {
      this.is_hover = hover;
    },
    itemClick: function itemClick(item, index) {
      var value_by = this.value_by;

      var cur_val = value_by ? item[value_by] : item;
      this.$emit('input', cur_val, index);
      this.$emit('verify', true);
      this.$refs.tab_hack.focus();
      this.is_error = false;
      this.is_active = false;
    },
    clickOthers: function clickOthers() {
      this.is_active = false;
    },
    verfiy: function verfiy(value) {
      this.is_error = !value && value !== 0;
      this.$emit('verify', !this.is_error);
    },
    dealErrorValue: function dealErrorValue() {
      var is_error_value = this.is_error_value;

      if (!this.clear_invalid) return;

      if (is_error_value) {
        this.$emit('input', '');
        this.$emit('verify', false);
      }
    },
    defaultFirst: function defaultFirst() {
      var value_by = this.value_by,
          value = this.value,
          data = this.data,
          default_first = this.default_first,
          is_error_value = this.is_error_value;

      if (!default_first) return;
      var cur_value = is_error_value ? value_by ? data[0][value_by] : data[0] : value;
      this.$emit('input', cur_value, 0);
      this.$emit('verify', !!cur_value);
    },
    registerEvents: function registerEvents() {
      var _this = this;

      var handler = function handler() {
        _this.verfiy(_this.value);
      };
      this.$root.$on('form-verify', handler);
      this.$on('form-verify', handler);
      this.$on('close', function () {
        _this.is_active = false;
      });
    },
    hexToRgb: function hexToRgb(hex) {
      var shorthandRegex = /^#?([a-f\d])([a-f\d])([a-f\d])$/i;
      hex = hex.replace(shorthandRegex, function (m, r, g, b) {
        return r + r + g + g + b + b;
      });

      var result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
      return result ? {
        r: parseInt(result[1], 16),
        g: parseInt(result[2], 16),
        b: parseInt(result[3], 16)
      } : null;
    }
  }
});

/***/ }),
/* 151 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


var prefixCls = 'hiui-select-item';

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'SelectItem',
  props: {
    active: Boolean,
    color: String
  },
  data: function data() {
    return {};
  },

  computed: {
    component_class: function component_class() {
      return [prefixCls, { active: this.active }];
    },

    custom_style: function custom_style() {
      return {
        color: this.active ? this.color : undefined
      };
    }
  }
});

/***/ }),
/* 152 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon___ = __webpack_require__(5);





var prefixCls = 'hiui-spinner';

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Spinner',
  components: {
    Icon: __WEBPACK_IMPORTED_MODULE_1__Icon___["a" /* default */]
  },
  props: {
    size: Number,
    color: {
      default: '',
      type: String
    },
    wrap: {
      default: false,
      type: Boolean
    }
  },
  data: function data() {
    return {};
  },

  computed: {
    component_class: function component_class() {
      return [prefixCls, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()({}, prefixCls + '-wrap', this.wrap)];
    },
    styles: function styles() {
      return {
        width: this.size + 'px',
        height: this.size + 'px',
        color: '' + this.color
      };
    }
  }
});

/***/ }),
/* 153 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(194);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_swiper__ = __webpack_require__(534);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_swiper___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_swiper__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Icon__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_swiper_dist_css_swiper_min_css__ = __webpack_require__(245);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_swiper_dist_css_swiper_min_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_swiper_dist_css_swiper_min_css__);







var prefixCls = 'hiui-swipe';

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Swipe',
  props: {
    value: {},
    preview: { type: [Number, String], default: 1 },
    between: { type: Number, default: 0 },
    sliding_num: { type: Number, default: 1 },
    free: Boolean,
    coverflow: Boolean,
    loop: { type: Boolean, default: true },
    autoplay: [Boolean, Number],
    index: Boolean,
    index_trigger: { type: [String, Boolean], default: 'click' },
    trigger: { type: String, default: 'change' },
    arrow: { type: [String, Boolean], default: 'hover' },
    outer_arrow: { type: Boolean },
    arrow_offset: Number,
    index_x_offset: Number,
    index_y_offset: Number,
    update_by: {}
  },
  data: function data() {
    return {
      swiper: null,
      inited: false,
      is_hover: false,
      is_sliding: false
    };
  },

  components: {
    Icon: __WEBPACK_IMPORTED_MODULE_2__Icon__["a" /* default */],
    SwipeSlide: __webpack_require__(80),
    SwipeArrow: __webpack_require__(581),
    SwipeIndex: __webpack_require__(582)
  },
  computed: {
    component_class: function component_class() {
      return [prefixCls];
    },

    config: function config() {
      var _this = this;

      var preview = this.preview,
          between = this.between,
          sliding_num = this.sliding_num,
          free = this.free,
          loop = this.loop,
          autoplay = this.autoplay,
          value = this.value;

      var autoplay_speed = typeof autoplay === 'number' ? autoplay : autoplay ? 5000 : undefined;

      var config = {
        slidesPerView: preview,
        slidesPerGroup: sliding_num,
        spaceBetween: between,
        freeMode: free,
        loop: loop,
        initialSlide: value,
        autoplay: autoplay_speed,
        onTransitionEnd: function onTransitionEnd(swiper) {
          var inited = _this.inited,
              trigger = _this.trigger;

          if (!inited) return;
          if (trigger === 'progress') _this.is_sliding = false;
          _this.$emit('input', swiper.realIndex);
        }
      };

      var coverflow = this.coverflow ? {
        slideToClickedSlide: true,
        centeredSlides: true,
        effect: 'coverflow',
        coverflow: { rotate: 0, stretch: 0, depth: 100, modifier: 3, slideShadows: false }
      } : {};

      var progress = this.trigger === 'progress' ? {
        watchSlidesProgress: true,
        onProgress: function onProgress(swiper, progress) {
          _this.is_sliding = true;
          if (swiper.realIndex != null && swiper.realIndex !== _this.value) {
            _this.$emit('input', swiper.realIndex);
          }
        }
      } : {};
      config = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, config, coverflow, progress);
      return config;
    },
    slides_len: function slides_len() {
      if (!this.swiper) return 0;
      var len = this.swiper.slides.length;
      return this.loop ? len - this.preview * 2 : len;
    },
    arrow_disabled_status: function arrow_disabled_status() {
      var loop = this.loop,
          preview = this.preview,
          swiper = this.swiper,
          slides_len = this.slides_len;

      return {
        prev: !loop && swiper.activeIndex === 0,
        next: !loop && swiper.activeIndex === slides_len - preview
      };
    },
    reset: function reset() {
      var preview = this.preview,
          between = this.between,
          free = this.free,
          coverflow = this.coverflow,
          loop = this.loop,
          sliding_num = this.sliding_num,
          autoplay = this.autoplay;

      return { preview: preview, between: between, free: free, coverflow: coverflow, loop: loop, sliding_num: sliding_num, autoplay: autoplay };
    }
  },
  created: function created() {
    this.registerEvents();
  },
  mounted: function mounted() {
    this.init();
  },
  watch: {
    value: function value(index, old_index) {
      var swiper = this.swiper,
          trigger = this.trigger,
          autoplay = this.autoplay,
          is_sliding = this.is_sliding;

      if (!swiper || trigger === 'progress' && is_sliding) return;
      this.slideTo(index);
      this.swiper.startAutoplay();
    },
    update_by: {
      deep: true,
      handler: function handler() {
        var _this2 = this;

        this.$nextTick(function () {
          return _this2.update();
        });
      }
    },
    reset: function reset() {
      this.swiper.destroy(true, true);
      this.init();
    }
  },
  methods: {
    init: function init() {
      this.swiper = new __WEBPACK_IMPORTED_MODULE_1_swiper___default.a(this.$refs.swiper_container, this.config);
      this.inited = true;
    },
    update: function update() {
      this.swiper && this.swiper.update(true);
    },
    slideTo: function slideTo(target) {
      var loop = this.loop,
          preview = this.preview,
          slides_len = this.slides_len,
          swiper = this.swiper;

      var active = swiper.activeIndex;
      var len = swiper.slides.length;
      var speed = swiper.params.speed;
      if (loop) {
        var is_first = active === len - preview && target === 0;
        var is_last = active === preview - 1 && target === slides_len - 1;
        if (is_first || is_last) speed = 0;
        target += preview;
      }
      this.swiper.slideTo(target, speed);
    },
    registerEvents: function registerEvents() {
      var _this3 = this;

      this.$on('slide-to', function (index) {
        _this3.slideTo(index);
      });
      this.$on('slide-next', function (index) {
        var swiper = _this3.swiper;

        swiper.slideNext();
      });
      this.$on('slide-prev', function (index) {
        var swiper = _this3.swiper;

        swiper.slidePrev();
      });
    }
  }
});

/***/ }),
/* 154 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


var prefixCls = 'hiui-swipe-slide';

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'SwipeSlide',
  computed: {
    component_class: function component_class() {
      return [prefixCls, 'swiper-slide'];
    }
  }
});

/***/ }),
/* 155 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'swipeArrow',
  props: ['outer_arrow', 'arrow_offset', 'loop', 'preview', 'swiper', 'slides_len'],
  data: function data() {
    return {
      hover: [false, false]
    };
  },
  computed: {
    arrow_disabled_status: function arrow_disabled_status() {
      var loop = this.loop,
          preview = this.preview,
          swiper = this.swiper,
          slides_len = this.slides_len;

      return {
        left: !loop && swiper.activeIndex === 0,
        right: !loop && swiper.activeIndex === slides_len - preview
      };
    }
  }
});

/***/ }),
/* 156 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'swipeIndex',
  props: ['swiper', 'index_x_offset', 'index_y_offset', 'slides_len', 'index_trigger'],
  data: function data() {
    return {};
  },
  computed: {
    swipe_offset_style: function swipe_offset_style() {
      var _gap_xsm = 14;
      var index_x_offset = this.index_x_offset,
          index_y_offset = this.index_y_offset;

      return {
        'margin-left': index_x_offset + 'px',
        'bottom': _gap_xsm + index_y_offset + 'px'
      };
    }
  }
});

/***/ }),
/* 157 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


var prefixCls = 'hiui-switch';

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'vSwitch',
  props: {
    size: {
      default: 'md',
      type: String
    },
    value: {
      type: Boolean,
      required: true
    },
    disabled: {
      default: false,
      type: Boolean
    }
  },
  computed: {
    component_class: function component_class() {
      return [prefixCls, prefixCls + '-' + this.size, {
        'disabled': this.disabled,
        'checked': this.value
      }];
    },
    checked: {
      set: function set(val) {
        this.$emit('input', val);
      },
      get: function get() {
        return this.value;
      }
    }
  }
});

/***/ }),
/* 158 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_array_from__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_array_from___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_array_from__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Icon__ = __webpack_require__(5);







var prefixCls = 'hiui-tab';

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Tab',
  components: {
    Icon: __WEBPACK_IMPORTED_MODULE_3__Icon__["a" /* default */]
  },
  props: {
    value: {
      default: 0,
      type: Number
    },
    data: {
      default: [],
      type: Array
    },
    trigger: {
      default: 'click',
      type: String
    },
    type: {
      default: 'padding',
      type: String
    },
    font_size: Number,
    width: [Number, String],
    height: [Number, String],
    theme: String,
    activeStyle: Object,
    gap: Number
  },
  data: function data() {
    return {};
  },

  computed: {
    component_class: function component_class() {
      var _ref;

      return [prefixCls, (_ref = {}, __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, prefixCls + '-' + this.theme, this.theme), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, prefixCls + '-' + (this.type && this.type.split(':')[0]), this.type), _ref)];
    },
    item_class: function item_class() {
      return [prefixCls + '-item'];
    },
    item_style: function item_style() {
      var style = {};
      if (this.bar_type === 'fix_width') {
        var val = this.type.split(':')[1];

        if (val) {
          style.width = val;
        } else {
          style.width = 1 / this.data.length * 100 + '%';
        }
      }

      if (typeof this.font_size === 'number') {
        style.fontSize = this.font_size + 'px';
      }

      if (typeof this.gap === 'number') {
        if (this.bar_type === 'no_padding') {
          style.marginRight = this.gap + 'px';
        }
        if (this.bar_type === 'padding') {
          style.padding = '0 ' + this.gap / 2 + 'px';
        }
      }
      return style;
    },
    bar_type: function bar_type() {
      return this.type && this.type.split(':')[0];
    },
    tab_style: function tab_style() {
      var style = {};

      if (this.width) {
        style.width = this.width + (typeof this.width === 'number' ? 'px' : '');
      }
      if (this.height === 'auto') {
        style.height = 'auto';
        style.lineHeight = 'inherit';
      }
      if (typeof this.height === 'number') {
        style.height = this.height + 'px';
        style.lineHeight = this.height + 'px';
      }

      return style;
    },
    tab_data: function tab_data() {
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_array_from___default()(this.data, function (item) {
        return (typeof item === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(item)) === 'object' ? item : { name: item };
      });
    }
  },
  methods: {
    handleClick: function handleClick(i, title) {
      if (this.trigger !== 'click' || i === this.value) {
        return false;
      }

      this.$emit('input', i);
      this.$emit('change', i, title);
    },
    handleMouseEnter: function handleMouseEnter(i, title) {
      if (this.trigger !== 'hover' || i === this.value) {
        return false;
      }

      this.$emit('input', i);
      this.$emit('change', i, title);
    }
  }
});

/***/ }),
/* 159 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);



var prefixCls = 'hiui-toast';

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Toast',
  data: function data() {
    return {
      show: false,
      content: '',
      time: 2000,
      type: 'default',
      callback: null,
      iconType: {
        'default': 'info-circle',
        'primary': 'info-circle',
        'success': 'check-circle',
        'error': 'close-circle',
        'warning': 'exclamation-circle'
      },
      show_icon: {
        type: Boolean,
        default: true
      }
    };
  },

  computed: {
    component_class: function component_class() {
      var _ref;

      return [prefixCls, (_ref = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, prefixCls + '-' + this.type, this.type), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, prefixCls + '-show_icon', this.show_icon), _ref)];
    }
  },
  methods: {
    close: function close() {
      this.show = false;
    },
    afterLeave: function afterLeave() {
      this.$destroy(true);
    }
  },
  mounted: function mounted() {
    document.body.appendChild(this.$el);
    this.time && setTimeout(this.close, this.time);
  },
  beforeDestroy: function beforeDestroy() {
    var _this = this;

    document.body.removeChild(this.$el);
    this.callback && this.$nextTick(function () {
      _this.callback();
    });
  },
  destroyed: function destroyed() {
    this.$emit('destroyed');
  }
});

/***/ }),
/* 160 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Icon__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_purecss_build_base_min_css__ = __webpack_require__(243);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_purecss_build_base_min_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_purecss_build_base_min_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_purecss_build_grids_min_css__ = __webpack_require__(244);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_purecss_build_grids_min_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_purecss_build_grids_min_css__);






var prefixCls = 'hiui-vcalendar';

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'vCalendar',
  components: {
    Icon: __WEBPACK_IMPORTED_MODULE_0__Icon__["a" /* default */]
  },
  props: {
    n_months: {
      type: Number,
      default: 4
    },

    is_show: {
      type: Boolean,
      default: false
    },

    is_range: {
      type: Boolean,
      default: false
    },

    daterange: {
      type: Boolean,
      default: false
    },
    date_begin: {
      type: Array,
      default: Array
    },
    date_end: {
      type: Array,
      default: Array
    },

    is_today_disable: {
      type: Boolean,
      default: true
    },

    is_single_month: {
      type: Boolean,
      default: false
    },
    json_data: {
      type: Object,
      default: Object
    },
    init_select_day: {
      type: Array,
      default: Array
    },
    init_range_begin: {
      type: Array,
      default: Array
    },
    init_range_end: {
      type: Array,
      default: Array
    }
  },
  data: function data() {
    return {
      first_value: '',
      sec_value: '',
      cur_year: 0,
      cur_month: 0,
      today: 0,
      year: 0,
      month: 0,
      day: 0,
      total_days: [],
      select_day: [],
      days: [],
      rangeBegin: [],
      rangeEnd: [],
      formated_json_data: {},
      sep: '-',
      is_select_year: false,
      is_select_month: false,
      select_data: {
        cur_year: 0,
        cur_month: 0
      },
      week_days: ['日', '一', '二', '三', '四', '五', '六'],
      illegal: false
    };
  },
  computed: {
    component_class: function component_class() {
      return [prefixCls];
    },

    is_disable_prev: function is_disable_prev() {
      var self = this;
      if (self.daterange) {
        if (parseInt(self.cur_year) === parseInt(self.date_begin[0]) && parseInt(self.cur_month) + 1 === parseInt(self.date_begin[1])) {
          return true;
        } else {
          return false;
        }
      } else {
        return false;
      }
    },
    is_disable_next: function is_disable_next() {
      var self = this;
      if (self.daterange) {
        if (parseInt(self.cur_year) === parseInt(self.date_end[0]) && parseInt(self.cur_month) + 1 === parseInt(self.date_end[1])) {
          return true;
        } else {
          return false;
        }
      } else {
        return false;
      }
    },
    select_year_data: function select_year_data() {
      var result = [];
      var temp = [];
      var i = 1;
      var nowYear = new Date().getFullYear();
      for (var year = nowYear - 200; year <= nowYear + 200; year++) {
        temp.push({
          value: year,
          enable: this.daterange ? year >= this.date_begin[0] && year <= this.date_end[0] : true
        });
        if (i % 3 === 0) {
          result.push(temp);
          temp = [];
        }
        i++;
      }
      return result;
    },
    select_month_data: function select_month_data() {
      var result = [];
      var temp = [];
      var cur_date = '';
      var date_begin = [this.date_begin[0], this.date_begin[1], '01'].join('/');
      var date_end = [this.date_end[0], this.date_end[1], '01'].join('/');
      for (var month = 0, enable = false; month <= 11; month++) {
        cur_date = this.cur_year + '/' + (month + 1 < 10 ? '0' + (month + 1) : month + 1) + '/01';
        enable = this.daterange ? cur_date >= date_begin && cur_date <= date_end : true;
        temp.push({
          value: month + 1,
          enable: enable
        });
        if ((month + 1) % 3 === 0) {
          result.push(temp);
          temp = [];
        }
      }
      return result;
    }
  },
  mounted: function mounted() {
    var now = new Date();

    this.year = now.getFullYear();
    this.month = now.getMonth();
    this.day = now.getDate();
    if (this.range) {
      this.rangeBegin = Array;
      this.rangeEnd = Array;
    }
    this.today = Number(new Date(this.year, this.month, this.day));

    if (this.daterange) {
      this.cur_year = parseInt(this.date_begin[0]);
      this.cur_month = parseInt(this.date_begin[1]) - 1;
    } else {
      this.cur_year = this.year;
      this.cur_month = this.month;
    }

    if (this.init_select_day.length > 0) {
      this.select_day[0] = this.init_select_day[0];
      this.select_day[1] = this.init_select_day[1] - 1;
      this.select_day[2] = this.init_select_day[2];
    }

    if (this.init_range_begin.length > 0) {
      this.rangeBegin[0] = this.init_range_begin[0];
      this.rangeBegin[1] = this.init_range_begin[1] - 1;
      this.rangeBegin[2] = this.init_range_begin[2];
    }

    if (this.init_range_end.length > 0) {
      this.rangeEnd[0] = this.init_range_end[0];
      this.rangeEnd[1] = this.init_range_end[1] - 1;
      this.rangeEnd[2] = this.init_range_end[2];
    }
    this.render();
  },

  watch: {
    json_data: function json_data() {
      this.render();
    },
    cur_month: function cur_month(_cur_month) {
      this.select_data.cur_month = _cur_month;
    },
    cur_year: function cur_year(_cur_year) {
      this.select_data.cur_year = _cur_year;
    },
    date_begin: function date_begin() {
      if (this.daterange) {
        this.cur_year = parseInt(this.date_begin[0]);
        this.cur_month = parseInt(this.date_begin[1]) - 1;
        this.select_day = [];
      }
      this.render();
    },
    init_select_day: function init_select_day(_init_select_day) {
      if (isNaN(parseInt(_init_select_day[0])) || isNaN(parseInt(_init_select_day[1]))) return;
      this.cur_year = ~~_init_select_day[0];
      this.cur_month = ~~_init_select_day[1] - 1;

      if (this.init_select_day.length > 0) {
        this.select_day[0] = this.init_select_day[0];
        this.select_day[1] = this.init_select_day[1] - 1;
        this.select_day[2] = this.init_select_day[2];
      }
      this.render();
    },
    init_range_begin: function init_range_begin(_init_range_begin) {
      if (isNaN(parseInt(_init_range_begin[0])) || isNaN(parseInt(_init_range_begin[1]))) return;
      this.cur_year = ~~_init_range_begin[0];
      this.cur_month = ~~_init_range_begin[1] - 1;

      if (this.init_range_begin.length > 0) {
        this.rangeBegin[0] = this.init_range_begin[0];
        this.rangeBegin[1] = this.init_range_begin[1] - 1;
        this.rangeBegin[2] = this.init_range_begin[2];
      }
      this.render();
    },
    init_range_end: function init_range_end(_init_range_end) {
      if (isNaN(parseInt(_init_range_end[0])) || isNaN(parseInt(_init_range_end[1]))) return;
      this.cur_year = ~~_init_range_end[0];
      this.cur_month = ~~_init_range_end[1] - 1;

      if (this.init_range_end.length > 0) {
        this.rangeEnd[0] = this.init_range_end[0];
        this.rangeEnd[1] = this.init_range_end[1] - 1;
        this.rangeEnd[2] = this.init_range_end[2];
      }
      this.render();
    }
  },
  methods: {
    zero: function zero(n) {
      return n < 10 ? '0' + n : n;
    },

    render: function render() {
      var self = this;
      self.total_days = [];

      var format_json = !!self.json_data;
      if (format_json) {
        var new_json_data = {};
        for (var time in self.json_data) {
          var temp_date = new Date(parseInt(time));
          var temp_year = temp_date.getFullYear();
          var temp_month = temp_date.getMonth();
          var temp_day = temp_date.getDate();
          new_json_data[Number(new Date(temp_year, temp_month, temp_day))] = true;
        }
        self.formated_json_data = new_json_data;
      }

      if (!self.is_single_month) {
        if (!self.daterange) {
          var y = self.year;
          var m = self.month;
          for (var kds = 0; kds < self.n_months; kds++, m++) {
            if (m === 12) {
              m = 0;
              y = y + 1;
            }
            var fin_temp = {};
            fin_temp.arr = self.renderMonth(y, m);
            fin_temp.year = y;
            fin_temp.month = m + 1;
            self.total_days.push(fin_temp);
          }
        } else {
          var new_begin;
          var new_end;

          var b = Number(new Date(self.date_begin[0], self.date_begin[1], self.date_begin[2]));
          var e = Number(new Date(self.date_end[0], self.date_end[1], self.date_end[2]));

          if (b > e) {
            new_begin = self.date_end;
            new_end = self.date_begin;
            self.illegal = true;
          } else {
            new_begin = self.date_begin;
            new_end = self.date_end;
          }
          var r_y = ~~new_begin[0];
          var r_m = new_begin[1] - 1;
          var step;

          if (new_begin[0] === new_end[0] && new_begin[1] === new_end[1]) {
            step = 0;
          } else if (new_begin[0] === new_end[0] && new_begin[1] < new_end[1]) {
            step = ~~new_end[1] - ~~new_begin[1];
          } else if (new_begin[0] < new_end[0]) {
            step = 12 - ~~new_begin[1] + 12 * (~~new_end[0] - ~~new_begin[0] - 1) + ~~new_end[1];
          }

          for (var r_kds = 0; r_kds <= step; r_kds++, r_m++) {
            if (r_m === 12) {
              r_m = 0;
              r_y = r_y + 1;
            }
            var fin_temp_t = {};
            fin_temp_t.arr = self.renderMonth(r_y, r_m);
            fin_temp_t.year = r_y;
            fin_temp_t.month = r_m + 1;
            self.total_days.push(fin_temp_t);
          }
        }
      } else {
        if (self.daterange) {
          var bb = Number(new Date(self.date_begin[0], self.date_begin[1], self.date_begin[2]));
          var ee = Number(new Date(self.date_end[0], self.date_end[1], self.date_end[2]));

          if (bb > ee) {
            self.illegal = true;
          }
        }
        self.total_days = [];

        var fin_temp_s = {};
        fin_temp_s.arr = self.renderMonth(self.cur_year, self.cur_month);
        fin_temp_s.year = self.cur_year;
        fin_temp_s.month = self.cur_month + 1;
        self.total_days.push(fin_temp_s);
      }
    },

    select: function select(k1, k2, year, mon, e) {
      if (e !== undefined) e.stopPropagation();
      var self = this;

      if (self.is_range) {
        var select_days = [];

        for (var i = 0; i < self.total_days.length; i++) {
          if (self.total_days[i].year === year && self.total_days[i].month === mon) {
            select_days = self.total_days[i].arr;
            break;
          }
        }
        if (self.rangeBegin.length === 0 || self.rangeEndTemp !== 0) {
          self.rangeBegin = [year, mon - 1, select_days[k1][k2].day];
          self.rangeBeginTemp = self.rangeBegin;
          self.rangeEnd = [year, mon - 1, select_days[k1][k2].day];
          self.rangeEndTemp = 0;

          self.first_value = self.output(self.rangeBegin);
          self.sec_value = '';
        } else {
          self.rangeEnd = [year, mon - 1, select_days[k1][k2].day];
          if (+new Date(self.rangeEnd[0], self.rangeEnd[1], self.rangeEnd[2]) < +new Date(self.rangeBegin[0], self.rangeBegin[1], self.rangeBegin[2])) {
            self.rangeBegin = self.rangeEnd;
            self.first_value = self.output(self.rangeBegin);
          } else {
            self.rangeEndTemp = 1;

            self.sec_value = self.output(self.rangeEnd);
          }
        }

        self.total_days = [];
        self.render();
      } else {
        var select_days_s = [];

        for (var k = 0; k < self.total_days.length; k++) {
          if (self.total_days[k].year === year && self.total_days[k].month === mon) {
            select_days_s = self.total_days[k].arr;
            break;
          }
        }
        var d = select_days_s[k1][k2].day;
        self.select_day[0] = year;
        self.select_day[1] = mon - 1;
        self.select_day[2] = d;
        self.first_value = self.output(self.select_day);
        self.render();
      }

      self.$emit('get-first-value', self.first_value);
      self.$emit('get-sec-value', self.sec_value);
    },

    output: function output(args) {
      var self = this;
      return args[0] + self.sep + self.zero(args[1] + 1) + self.sep + self.zero(args[2]);
    },

    preMonth: function preMonth() {
      var self = this;
      if (parseInt(self.cur_month) === 0) {
        self.cur_month = 11;
        self.cur_year = parseInt(self.cur_year) - 1;
      } else {
        self.cur_month = parseInt(self.cur_month) - 1;
      }
      self.render();
    },

    nextMonth: function nextMonth() {
      var self = this;
      if (parseInt(self.cur_month) === 11) {
        self.cur_month = 0;
        self.cur_year = parseInt(self.cur_year) + 1;
      } else {
        self.cur_month = parseInt(self.cur_month) + 1;
      }
      self.render();
    },
    renderMonth: function renderMonth(y, m) {
      var self = this;
      var firstDayOfMonth = new Date(y, m, 1).getDay();
      var lastDateOfMonth = new Date(y, m + 1, 0).getDate();
      var lastDayOfLastMonth = new Date(y, m, 0).getDate();
      var i;
      var line = 0;
      var temp = [];
      for (i = 1; i <= lastDateOfMonth; i++) {
        var dow = new Date(y, m, i).getDay();

        if (dow === 0) {
          temp[line] = [];
        } else if (i === 1) {
          temp[line] = [];
          var k_first = lastDayOfLastMonth - firstDayOfMonth + 1;
          for (var j = 0; j < firstDayOfMonth; j++) {
            temp[line].push({ day: k_first, nodisplay: true });
            k_first++;
          }
        }

        var thisDay = new Date(y, m, i).getDay();

        var thisTime = Number(new Date(y, m, i));

        if (self.is_range) {
          var options;
          if (self.illegal) {
            options = { day: i, disable: true };
          } else {
            options = { day: i };
          }
          if (self.rangeBegin.length > 0) {
            var beginTime = Number(new Date(self.rangeBegin[0], self.rangeBegin[1], self.rangeBegin[2]));
            var endTime = Number(new Date(self.rangeEnd[0], self.rangeEnd[1], self.rangeEnd[2]));
            if (beginTime <= thisTime && endTime >= thisTime && !self.formated_json_data[thisTime]) {
              options.select = true;
            }
            if (beginTime === thisTime) {
              options.range_begin = true;
            } else if (endTime === thisTime) {
              options.range_end = true;
            }
          }
          if (self.daterange) {
            var r_b_m = Number(new Date(self.date_begin[0], self.date_begin[1] - 1, self.date_begin[2]));
            var r_e_m = Number(new Date(self.date_end[0], self.date_end[1] - 1, self.date_end[2]));
            if (thisTime < r_b_m || thisTime > r_e_m) {
              options.disable = true;
            }
          }

          if (self.is_today_disable) {
            if (thisTime < self.today) {
              options.disable = true;
            }
          }

          if (thisDay === 0 || thisDay === 6) {
            options.weekend = true;
          }

          var json = !!self.formated_json_data;
          if (json && !self.illegal) {
            if (self.formated_json_data[thisTime]) {
              options.disable = true;
            }
          }
          temp[line].push(options);
        } else {
          var options_s;
          if (self.illegal) {
            options_s = { day: i, disable: true };
          } else {
            options_s = { day: i };
          }
          var thisTime_s = Number(new Date(y, m, i));
          var selectTime_s = Number(new Date(self.select_day[0], self.select_day[1], self.select_day[2]));
          if (self.daterange) {
            var r_b_s = Number(new Date(self.date_begin[0], self.date_begin[1] - 1, self.date_begin[2]));
            var r_e_s = Number(new Date(self.date_end[0], self.date_end[1] - 1, self.date_end[2]));
            if (thisTime_s < r_b_s || thisTime_s > r_e_s) {
              options_s.disable = true;
            }
          }

          if (self.is_today_disable) {
            if (thisTime_s < self.today) {
              options_s.disable = true;
            }
          }
          if (thisDay === 0 || thisDay === 6) {
            options_s.weekend = true;
          }
          if (thisTime_s === selectTime_s) {
            options_s.select = true;
          }

          var json_s = !!self.formated_json_data;
          if (json_s && !self.illegal) {
            if (self.formated_json_data[thisTime_s]) {
              options_s.disable = true;
            }
          }
          temp[line].push(options_s);
        }

        if (dow === 6) {
          line++;
        } else if (i === lastDateOfMonth) {
          var k_last = 1;
          for (dow; dow < 6; dow++) {
            temp[line].push({ day: k_last, nodisplay: true });
            k_last++;
          }
        }
      }
      return temp;
    },
    selectYear: function selectYear(year) {
      this.cur_year = year;
      this.render();
      this.is_select_year = false;
    },
    selectMonth: function selectMonth(month) {
      this.cur_month = month - 1;
      this.render();
      this.is_select_month = false;
    },
    scrollToTheYear: function scrollToTheYear() {
      var _this = this;

      setTimeout(function () {
        _this.$refs.select_year.scrollTop = Math.round((_this.cur_year - _this.select_year_data[0][0].value - 1) / 3) * 55 - 65;
      }, 50);
    }
  }
});

/***/ }),
/* 161 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__config__ = __webpack_require__(47);




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Header',
  data: function data() {
    return {
      config: __WEBPACK_IMPORTED_MODULE_0__config__["a" /* default */]
    };
  }
});

/***/ }),
/* 162 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__config_js__ = __webpack_require__(47);




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Nav',
  data: function data() {
    return {
      data: __WEBPACK_IMPORTED_MODULE_0__config_js__["a" /* default */].nav
    };
  },

  methods: {}
});

/***/ }),
/* 163 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_highlight_js__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_highlight_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_highlight_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_markdown_it__ = __webpack_require__(483);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_markdown_it___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_markdown_it__);





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'demo-item',
  components: {
    vCode: __webpack_require__(44)
  },
  props: {
    lang: {
      default: 'html',
      type: String
    },
    name: String,
    description: String,
    code: String
  },
  data: function data() {
    return {
      show_code: false
    };
  },

  computed: {
    descr: function descr() {
      var md = new __WEBPACK_IMPORTED_MODULE_1_markdown_it___default.a();
      return md.render(this.description);
    }
  },
  mounted: function mounted() {
    __WEBPACK_IMPORTED_MODULE_0_highlight_js___default.a.highlightBlock(this.$refs.description);
  }
});

/***/ }),
/* 164 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'demo',
  components: {
    Row: __webpack_require__(78),
    vCol: __webpack_require__(77)
  },
  props: {
    title: {
      default: '',
      type: String
    },
    is_horizontal_center: {
      default: false,
      type: Boolean
    },
    is_vertical_center: {
      default: false,
      type: Boolean
    }
  },
  data: function data() {
    return {
      cur: 'left'
    };
  }
});

/***/ }),
/* 165 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_highlight_js__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_highlight_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_highlight_js__);




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'v-code',
  props: ['code', 'lang'],
  mounted: function mounted() {
    __WEBPACK_IMPORTED_MODULE_0_highlight_js___default.a.highlightBlock(this.$refs.code);
  }
});

/***/ }),
/* 166 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      default_value: false,
      rocket: 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEAAAABACAYAAACqaXHeAAAEOElEQVR4Xu2a3VHcMBCAvYY3mAEqyPEGSA9QAVBBSAWBCkIqCFSQSwWQCkIqCFQAmZGANy4VhMz43uA2sxmbMcay1/rzXDg/3q1s7aeVdrW7kLzyB165/skMwMwCeiQghNhPkmRba33Q1zR62wKkPACckOKIeNoXhF4ArK+v783NzX0rr/pkMvlyfX19GNsSogMYDAbLi4uLd0mSLNcou6uUOo8JIToAKeWPJEl2DEreZ1m2OhqN7mNBiAqgvO9NCiLiV601HY5RnmgAWkz/mbKIuKW1vopBIBoAKeVRkiSfmEqdK6V2mbJOYlEAdFn9QptYVhAFgBDiEAA+d1mqWGdBLAB3ADDoAoBksyxbCe0RggOoC3q4IBDxo9Z6yJW3kQsOQAhxCgDvbSaHiFda6y2bsdwxwQFIKX8boj7WHB8eHlZvb29HLGELoaAAhBCbAHBpMa+nIYh4oLU+dXlH09igADr6/tp5IuJ3rfXetAKgi812w+Qv8v+MMog40lqvTisANEz8OMuyYeHi8kCJrsK1kWLIcyDYFmjY/8Yrr5SSbol0W3z2PD4+vru5uTkLYQUhATxlfErhbetNz+A2j5VSdJfw/gQDUHcAcuL7OssJeRAGA1C3kkop1veklNWz40IpZUqiOFkFa0I2X5BSvvAAnNg+PxApeCo/90qpFZt5tI0JCeBFBMgJakxZI671tClc/T8kgBcukHz6eDzeMt3waPUXFhYu626O/wWAnP5ZlmUHVQi56VOdoDbqCxULRLWAkvndUzEkTdN/vn0ymewBACVC61LlxbAgKfO+AHTdqiQ/AxCiaDKzABtb5IypCWY4w4wynBjC5gNTYwHT6Aapvrdksyp1Y6YRQFsyhM0GEX9prTun1TkfCLYFhBBnAPCWMwmGzFRehrrUAhsZhKwSBbOAjY2NYZqmHxir2yoSsnskCAAhxEke2rYqxxUI1UfkHUAI5QtIISB4BRBS+VAQvAHgtL9wzb1NjpNYaXtH8b8XAGtra4P5+XkqgTVdZ7lz4sh5a6byAsClAszRtk7Gl2t0BpCvPvX9RX98ZImcAdi0v/gi5aOBwgcASmJu+lKqy3t8NFA4ATDk8Lvo4CzrmidwAmAqZpa0+oOIRwBATY9PRU+63QHAm7L21d+oIJqm6TIAUI9Q07XaKVfoBKDJ99MpPR6PD4v0d35WXBV5vWrGqLjv51B3imJoXisYmvqMXGMCJwCmDhDOpMqlM0T8qbVuPEcaYDtVjkMAYJlkBQCrDcYAoVcAzxoaOCtf7PuK9bCVqIHAAm46bV0t4AlA18is0kDZSYlK5NlpbBWEE4DCDdrk7MoutGvCMx9LvYNLvbpBoimEIBc3tOnlo7whvcOmDS7fCvuujRNOFpAD2LdRnsbmLi+xLXkRBNtve70OO4dzPb7A2QJ6nLuXT88AeME4xS/5Cza6SV/42HnJAAAAAElFTkSuQmCC',
      code: '\n<BackTop></BackTop>\n        ',
      rocket_code: '\n<BackTop :height="100" :bottom="100">\n  <img :src="rocket" width="50" height="50" alt="backTop">\n</BackTop>\n        '
    };
  }
});

/***/ }),
/* 167 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      no_padding_code: "\n<!-- use_padding: false -->\n<Bar>\n  <Btn>Button</Btn>\n</Bar>\n        ",
      have_padding_code: "\n<!-- use_padding: true -->\n<Bar :use_padding=\"true\">\n  <Btn>Button</Btn>\n  <Btn>Button</Btn>\n  <Btn>Button</Btn>\n</Bar>\n        "
    };
  }
});

/***/ }),
/* 168 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      size_code: "\n<Btn :size=\"'sm'\">Btn sm</Btn>\n<Btn :size=\"'md'\">Btn md</Btn>\n<Btn :size=\"'lg'\">Btn lg</Btn>\n        ",
      status_code: "\n<Btn :disabled=\"true\">Disabled</Btn>\n<Btn :is_loading=\"true\" loading_text=\"Loading..\">Btn</Btn>\n        ",
      icon_code: "\n<Btn :prefix=\"'arrowleft'\">Left</Btn>\n<Btn :prefix=\"'arrowright'\">Right</Btn>\n<Btn :suffix=\"'arrowup'\">Up</Btn>\n<Btn :suffix=\"'arrowdown'\">Down</Btn>\n        ",
      style_code: "\n<Btn :class=\"'solid-btn'\" :prefix=\"'rollback'\">Back</Btn>\n<Btn :class=\"'star-btn'\" :prefix=\"'star'\">Star</Btn>\n<Btn :class=\"'cir-btn'\" :prefix=\"'search'\"></Btn>\n<Btn :class=\"'fixed-width-btn'\" :suffix=\"'shoppingcart'\" :size=\"'lg'\">\u8D2D\u4E70</Btn>\n\n<style lang=\"stylus\">\n.solid-btn {\n  border: none;\n  border-radius: 0;\n  color: _white;\n  background-color: _blue;\n}\n.solid-btn:hover {\n  background-color: lighten(_blue, 10%);\n}\n.solid-btn:active {\n  background-color: darken(_blue, 10%);\n}\n\n.star-btn:hover {\n  color: _yellow;\n  border-color: _yellow;\n}\n.star-btn:active {\n  box-shadow: none;\n  color: darken(_yellow, 20%);\n  border-color: darken(_yellow, 20%);\n}\n\n.cir-btn {\n  border-radius: 50%;\n  padding: 0;\n  width: _size_md;\n}\n\n.fixed-width-btn {\n  width: 150px;\n  color: _white;\n  border: none;\n  background-color: _red;\n  border-radius: 0;\n}\n.fixed-width-btn:hover {\n  background-color: lighten(_red, 10%);\n}\n.fixed-width-btn:active {\n  background-color: darken(_red, 10%);\n}\n</style>\n        "
    };
  }
});

/***/ }),
/* 169 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      demo_single_date: '',
      demo_from_date: '',
      demo_ret_date: '',
      single_date: '\n<vCalendar :is_show="true"\n           :is_range="false"\n           :is_single_month="true"\n           :is_today_disable="true"\n           @get-first-value="date = arguments[0]"></vCalendar>\n        ',
      double_date: '\n<vCalendar :is_show="true"\n           :is_range="true"\n           :is_single_month="true"\n           :is_today_disable="true"\n           @get-first-value="demo_from_date = arguments[0]"\n           @get-sec-value="demo_ret_date = arguments[0]"></vCalendar>\n'
    };
  }
});

/***/ }),
/* 170 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      test: [],
      test_value: [],
      test_disable: [],
      test_color: [],
      code: "\n<CheckBox v-model=\"test\" :size=\"'sm'\">\u5C0F</CheckBox>\n<CheckBox v-model=\"test\" :size=\"'md'\">\u4E2D\u7B49</CheckBox>\n<CheckBox v-model=\"test\" :size=\"'lg'\">\u5927</CheckBox>\n        ",
      value_code: "\n<CheckBox v-model=\"test_value\" :value=\"'small'\" :size=\"'sm'\">\u5C0F</CheckBox>\n<CheckBox v-model=\"test_value\" :value=\"'normal'\" :size=\"'md'\">\u4E2D\u7B49</CheckBox>\n<CheckBox v-model=\"test_value\" :value=\"'large'\" :size=\"'lg'\">\u5927</CheckBox>\n        ",
      disable_code: "\n<CheckBox v-model=\"test_disable\">\u6B63\u5E38</CheckBox>\n<CheckBox v-model=\"test_disable\" :disabled=\"true\">\u7981\u7528</CheckBox>\n        ",
      color_code: "\n<CheckBox v-model=\"test_color\">\u6B63\u5E38</CheckBox>\n<CheckBox v-model=\"test_color\" :color=\"'rgb(0, 160,' 233)\">\u84DD\u8272</CheckBox>\n        "
    };
  }
});

/***/ }),
/* 171 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    type: {
      default: 'blue',
      type: String
    }
  },
  data: function data() {
    return {
      data: {
        blue: {
          name: '蓝色',
          colors: ['_blue', '_blue_light', '_blue_deep']
        },
        red: {
          name: '红色',
          colors: ['_red', '_red_light', '_red_deep']
        },
        green: {
          name: '绿色',
          colors: ['_green', '_green_light', '_green_deep']
        },
        yellow: {
          name: '黄色',
          colors: ['_yellow', '_yellow_light', '_yellow_deep']
        },
        neutrals: {
          name: '中性色',
          colors: ['_grey', '_grey_light', '_grey_lighter', '_grey_deep', '_grey_deeper', '_black']
        },
        vi: {
          name: 'Vi',
          colors: ['_vi_red', '_vi_yellow', '_vi_cyan']
        }
      }
    };
  }
});

/***/ }),
/* 172 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      code: "\n<Row>\n  <Col :span=\"12\"> col-12 </Col>\n  <Col :span=\"12\"> col-12 </Col>\n</Row>\n\n<Row>\n  <Col :span=\"6\"> col-6 </Col>\n  <Col :span=\"6\"> col-6 </Col>\n  <Col :span=\"6\"> col-6 </Col>\n  <Col :span=\"6\"> col-6 </Col>\n</Row>\n\n<Row>\n  <Col :span=\"8\"> col-8 </Col>\n  <Col :span=\"8\"> col-8 </Col>\n  <Col :span=\"8\"> col-8 </Col>\n</Row>\n        ",
      gutter_code: "\n<Row :gutter=\"20\">\n  <Col :span=\"6\">\n    <div class=\"gutter-box\">col-6</div>\n  </Col>\n  <Col :span=\"6\">\n    <div class=\"gutter-box\">col-6</div>\n  </Col>\n  <Col :span=\"6\">\n    <div class=\"gutter-box\">col-6</div>\n  </Col>\n  <Col :span=\"6\">\n    <div class=\"gutter-box\">col-6</div>\n  </Col>\n</Row>\n        ",
      offset_code: "\n<Row>\n  <Col :span=\"8\"> col-8 </Col>\n  <Col :span=\"8\" :offset=\"8\"> col-8 offset-8 </Col>\n</Row>\n\n<Row>\n  <Col :span=\"6\" :offset=\"6\"> col-6 offset-6 </Col>\n  <Col :span=\"6\" :offset=\"6\"> col-6 offset-6 </Col>\n</Row>\n\n<Row>\n  <Col :span=\"12\" :offset=\"6\"> col-12 offset-6 </Col>\n</Row>\n        ",
      sort_code: "\n<Row>\n  <Col :span=\"18\" :push=\"6\"> col-18 push-6 </Col>\n  <Col :span=\"6\" :pull=\"18\"> col-6 pull-18 </Col>\n</Row>\n        ",
      responsive_code: "\n<Row>\n  <Col :xsm=\"0\" :sm=\"4\" :md=\"6\" :lg=\"8\" :xlg=\"6\" >Col</Col>\n  <Col :xsm=\"24\" :sm=\"16\" :md=\"12\" :lg=\"8\" :xlg=\"{ span: 6, offset: 3 }\" >Col</Col>\n  <Col :xsm=\"0\" :sm=\"4\" :md=\"6\" :lg=\"8\" :xlg=\"{ span: 6, offset: 3 }\" >Col</Col>\n</Row>\n        "
    };
  }
});

/***/ }),
/* 173 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
        data: function data() {
                return {
                        name_code: "\n<Icon :name=\"'heart'\"></Icon>\n<Icon :name=\"'star'\"></Icon>\n<Icon :name=\"'tag'\"></Icon>\n        ",
                        size_code: "\n<Icon :size=\"16\" :name=\"'enviroment'\"></Icon>\n<Icon :size=\"24\" :name=\"'enviroment'\"></Icon>\n<Icon :size=\"32\" :name=\"'enviroment'\"></Icon>\n        ",
                        color_code: "\n<Icon :color=\"'red'\" :name=\"'search'\"></Icon>\n<Icon :color=\"'#00a0e9'\" :name=\"'search'\"></Icon>\n<Icon :color=\"'rgba(33, 66, 99, 0.6)'\" :name=\"'search'\"></Icon>\n        ",
                        rotate_code: "\n<Icon :rotate=\"true\" :name=\"'loading'\"></Icon>\n        "
                };
        }
});

/***/ }),
/* 174 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    Row: __webpack_require__(78),
    vCol: __webpack_require__(77)
  },
  data: function data() {
    return {
      timer: null,
      index: null,
      icons: ['pay-circle-o', 'pay-circle', 'tag-o', 'tag', 'check-square-o', 'check-square', 'calendar', 'unlock', 'lock', 'download', 'upload', 'loading', 'message', 'heart-o', 'heart', 'delete', 'dislike', 'like', 'scan', 'appstore', 'appstore-o', 'export', 'enviroment-o', 'enviroment', 'cloud-o', 'tags-o', 'tags', 'qrcode', 'phone', 'picture', 'setting', 'search', 'solution', 'team', 'totop', 'user', 'shoppingcart', 'file', 'filter', 'star-o', 'star', 'home', 'link', 'logout', 'question-circle-o', 'question-circle', 'ellipsis', 'swapright', 'swapleft', 'swap', 'clock-circle-o', 'clock-circle', 'bars', 'creditcard', 'close', 'check', 'check-circle-o', 'check-circle', 'close-circle-o', 'close-circle', 'exclamation-circle-o', 'exclamation-circle', 'info-circle-o', 'info-circle', 'plus', 'plus-circle', 'plus-circle-o', 'minus', 'arrowleft', 'arrowright', 'arrowup', 'arrowdown', 'doubleleft', 'doubleright', 'reload', 'retweet', 'rollback', 'down-circle', 'up-circle', 'left-circle', 'right-circle', 'caretup', 'caretdown', 'caretleft', 'caretright', 'right', 'left', 'down', 'up', 'mail', 'mail-circle', 'weixin', 'weixin-circle', 'sina', 'sina-circle', 'qq', 'qq-circle', 'sort', 'view', 'color', 'bold', 'time', 'checkbox-multiple-blank', 'drag', 'code', 'qrcode', 'mobilephone', 'order-list', 'edit', 'pencil', 'first-page', 'last-page']
    };
  },

  methods: {
    clickHandle: function clickHandle(num) {
      var _this = this;

      this.index = num;
      if (this.timer) {
        clearTimeout(this.timer);
      }
      this.timer = setTimeout(function () {
        _this.timer = null;
        _this.index = null;
      }, 1000);
    }
  }
});

/***/ }),
/* 175 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
        data: function data() {
                return {
                        size_test: '',
                        label_test: '',
                        status_test: '',
                        verify_test: '',
                        verify1_test: '',
                        verify2_test: '',
                        color_test: '',
                        textarea_test: '',
                        verify_result: false,
                        verify1_result: false,
                        verify2_result: false,
                        verify3_result: false,
                        code: '\n<Input :size="\'sm\'" v-model="test"></Input>\n<Input :size="\'md\'" v-model="test"></Input>\n<Input :size="\'lg\'" v-model="test"></Input>\n        ',
                        label_code: '\n// \u53EA\u8981\u5B58\u5728label\uFF0C\u90FD\u4F1A\u9ED8\u8BA4\u4F7F\u7528\u6D6E\u52A8\u52A8\u753B\u3002\n<Input :label="\'\u6211\u662F\u6D6E\u52A8\u6807\u9898\'" v-model="label_test"></Input>\n<Input :placeholder="\'\u6211\u662F\u63D0\u793A\'" v-model="label_test"></Input>\n        ',
                        color_code: '\n<Input :placeholder="\'\u9ED8\u8BA4\'" v-model="status_test"></Input>\n<Input :placeholder="\'\u7EFF\u8272\'" color="#4fae9B" v-model="color_test"></Input>\n<Input :placeholder="\'\u84DD\u8272\'" color="rgb(0, 160, 233)" v-model="color_test"></Input>\n        ',
                        disabled_code: '\n<Input :placeholder="\'\u6B63\u5E38\u4F7F\u7528\'" v-model="status_test"></Input>\n<Input :placeholder="\'\u6211\u88AB\u7981\u7528\u4E86\'" :disabled="true" v-model="status_test"></Input>\n        ',
                        verify_code: '\n// \u66F4\u591A\u9A8C\u8BC1\u7EC6\u8282\uFF0C\u53C2\u7167API\n<Input :placeholder="\'\u9A8C\u8BC1\u624B\u673A\u53F7(\u6570\u5B577~14\u4F4D)\'" verify="phone" @verify="verify_result = arguments[0]"></Input>\n<p>\u624B\u673A\u53F7\u9A8C\u8BC1\u7ED3\u679C: {{ verify_result }}</p>\n<Input :placeholder="\'\u9A8C\u8BC1\u624B\u673A\u53F7/\u90AE\u7BB1\'" :verify="[\'phone\', \'email\']" @verify="verify3_result = arguments[0]"></Input>\n<p>\u624B\u673A\u53F7/\u90AE\u7BB1\u9A8C\u8BC1\u679C: {{ verify3_result }}</p>\n<Input :placeholder="\'\u8F93\u5165 \u54C8\u54C8\'" :reg="/\u54C8\u54C8/" tip="\u4E0D\u5F00\u5FC3" @verify="verify1_result = arguments[0]"></Input>\n<p>\u81EA\u5B9A\u4E49\u9A8C\u8BC11\u7ED3\u679C\uFF1A{{verify1_result}}</p>\n<Input :placeholder="\'\u81EA\u5B9A\u4E49\u9A8C\u8BC12\'" :ref="\'verify_input\'" @verify="verify2_result = arguments[0]"></Input>\n<p>\n  <Btn @click="$refs.verify_input.$emit(verify2_result ? \'error\' : \'correct\', \'\u81EA\u5B9A\u4E49\u7684\u9519\u8BEF\u4FE1\u606F\u554A\')">{{ verify2_result ? \'\u62A5\u9519\' : \'\u6B63\u786E\' }}</Btn>\n  <Btn @click="$refs.verify_input.$emit(\'clear\')">\u6E05\u9664(\u9A8C\u8BC1\u7ED3\u679C\u8FD8\u539F\u4E3Afalse)</Btn>\n</p>\n<p>\u81EA\u5B9A\u4E49\u9A8C\u8BC11\u7ED3\u679C\uFF1A{{verify2_result}}</p>\n        ',
                        textarea_code: '\n<Input v-model="textarea_test"></Input>\n<Input v-model="textarea_test" :placeholder="\'\u9ED8\u8BA43\u884C\u9AD8\'" type="textarea"></Input>\n<Input v-model="textarea_test" type="textarea" :placeholder="\'\u5185\u5BB9\u6491\u5F00\u9AD8\u5EA6\'" :autosize="true"></Input>\n        '
                };
        }
});

/***/ }),
/* 176 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      size_code: "\n<Btn @click=\"$loading.start()\">Start</Btn>\n<Btn @click=\"$loading.success()\">Success</Btn>\n<Btn @click=\"$loading.error()\">Error</Btn>\n        "
    };
  }
});

/***/ }),
/* 177 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);



/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      cur: 1,
      total: 10,
      show: [false, false, false],
      count: 5,
      timer: null,
      list: [],
      code: '\n<Loadmore v-if="show" @load-method="getNextPage" :done="cur >= total">\n  <div v-for="item in list" class="block">\n    {{ item }}\n  </div>\n</Loadmore>\n\n//...\ngetNextPage (next, err) {\n  this.cur++\n\n  this.getList()\n  .then(next)\n  .catch((err_msg) => err(err_msg))\n}\n        ',
      slot_code: '\n<Loadmore v-if="show" :interval="4" :offset="0" @load-method="getNextPage" :done="cur >= total">\n  <div v-for="item in list" class="block">\n    {{ item }}\n  </div>\n  <template slot="loading">\n    <Icon name="heart" color="rgb(255, 66, 66)" class="float-icon"></Icon>\n    Loading more...\n  </template>\n  <template slot="loadmore" scope="props">\n    <Btn @click="props.loadmore" class="blue-btn">\u70B9\u51FB\u52A0\u8F7D\u66F4\u591A</Btn>\n  </template>\n  <template slot="error" scope="props">\n    <Btn @click="props.loadmore" class="error-btn">\u51FA\u9519\u5566\uFF0C\u91CD\u65B0\u52A0\u8F7D</Btn>\n  </template>\n</Loadmore>\n\n//...\ngetNextPage (next, err) {\n  this.cur++\n\n  this.getList()\n  .then(next)\n  .catch((err_msg) => err(err_msg))\n}\n        '
    };
  },

  methods: {
    setShow: function setShow(index) {
      this.cur = 1;
      this.list = [];
      clearTimeout(this.timer);
      this.getList(0);

      this.show = this.show.map(function (bool, i) {
        return i === index && !bool;
      });
    },
    getNextPage: function getNextPage(next, err) {
      this.cur++;

      this.getList().then(next).catch(function (err_msg) {
        return err(err_msg);
      });
    },
    getList: function getList() {
      var _this = this;

      var time = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1000;

      return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        _this.timer = setTimeout(function () {
          if (_this.cur > 1 && _this.show.indexOf(true) === 2) {
            _this.cur--;
            return reject('加载失败');
          }
          var data = new Array(_this.count).fill(_this.cur);
          _this.list = _this.list.concat(data);

          resolve();
        }, time);
      });
    }
  }
});

/***/ }),
/* 178 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      show: false,
      top_show: false,
      bottom_show: false,
      left_show: false,
      right_show: false,
      mask_cloe_show: false,
      mask_show: false,
      prevent_show: false,
      code: "\n<Modal v-model=\"show\">\n  <h1>Title</h1>\n  <p>This is a test txt.</p>\n</Modal>\n\n<Modal :type=\"'top'\" v-model=\"top_show\">\n  <h1>Title</h1>\n  <p>This is a test txt.</p>\n</Modal>\n\n<Modal :type=\"'bottom'\" v-model=\"bottom_show\">\n  <h1>Title</h1>\n  <p>This is a test txt.</p>\n</Modal>\n\n<Modal :type=\"'left'\" v-model=\"left_show\">\n  <h1>Title</h1>\n  <p>This is a test txt.</p>\n</Modal>\n\n<Modal :type=\"'right'\" v-model=\"right_show\">\n  <h1>Title</h1>\n  <p>This is a test txt.</p>\n</Modal>\n        ",
      mask_close_code: "\n<Modal :mask_close=\"false\" v-model=\"mask_cloe_show\">\n  <h1>Title</h1>\n  <p>This is a test txt.</p>\n</Modal>\n        ",
      mask_show_code: "\n<Modal :use_mask=\"false\" v-model=\"mask_show\">\n  <h1>Title</h1>\n  <p>This is a test txt.</p>\n</Modal>\n        ",
      prevent_code: "\n<Modal :prevent_scroll=\"false\" v-model=\"prevent_show\">\n  <h1>Title</h1>\n  <p>This is a test txt.</p>\n</Modal>\n        "
    };
  }
});

/***/ }),
/* 179 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      show: true,
      val: '',
      code: '\n<Popover :placement="\'top-left\'">\n  <content></content>\n  <Btn slot="reference">\u4E0A\u5DE6</Btn>\n</Popover>\n\n<Popover :placement="\'top\'">\n  <content></content>\n  <Btn slot="reference">\u4E0A\u4E2D</Btn>\n</Popover>\n\n<Popover :placement="\'top-right\'">\n  <content></content>\n  <Btn slot="reference">\u4E0A\u53F3</Btn>\n</Popover>\n\n<Popover :placement="\'left-top\'">\n  <content></content>\n  <Btn slot="reference">\u5DE6\u4E0A</Btn>\n</Popover>\n\n<Popover :placement="\'left\'">\n  <content></content>\n  <Btn slot="reference">\u5DE6\u4E2D</Btn>\n</Popover>\n\n<Popover :placement="\'left-bottom\'">\n  <content></content>\n  <Btn slot="reference">\u5DE6\u4E0B</Btn>\n</Popover>\n\n<Popover :placement="\'right-top\'">\n  <content></content>\n  <Btn slot="reference">\u53F3\u4E0A</Btn>\n</Popover>\n\n<Popover :placement="\'right\'">\n  <content></content>\n  <Btn slot="reference">\u53F3\u4E2D</Btn>\n</Popover>\n\n<Popover :placement="\'right-bottom\'">\n  <content></content>\n  <Btn slot="reference">\u53F3\u4E0B</Btn>\n</Popover>\n\n<Popover :placement="\'bottom-left\'">\n  <content></content>\n  <Btn slot="reference">\u4E0B\u5DE6</Btn>\n</Popover>\n\n<Popover :placement="\'bottom\'">\n  <content></content>\n  <Btn slot="reference">\u4E0B\u4E2D</Btn>\n</Popover>\n\n<Popover :placement="\'bottom-right\'">\n  <content></content>\n  <Btn slot="reference">\u4E0B\u53F3</Btn>\n</Popover>\n        ',
      trigger_code: '\n<Popover>\n  <content></content>\n  <Btn slot="reference">Click</Btn>\n</Popover>\n\n<Popover trigger="hover">\n  <content></content>\n  <Btn slot="reference">Hover</Btn>\n</Popover>\n\n<Popover trigger="focus">\n  <content></content>\n  <Btn slot="reference">Focus</Btn>\n</Popover>\n\n<Popover trigger="manual" ref="manual_popover">\n  <content></content>\n  <Btn slot="reference" @click="$refs.manual_popover.toggle()">Manual</Btn>\n</Popover>\n\n        ',
      directive_code: '\n<Popover ref="popover">\n  <content></content>\n</Popover>\n<Btn v-popover:popover>Click</Btn>\n        ',
      event_code: '\n<Popover ref="popover" @show="$toast(\'Show\')" @hide="$toast(\'hide\')">\n  <content></content>\n  <Btn slot="reference">Click</Btn>\n</Popover>\n        '
    };
  }
});

/***/ }),
/* 180 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
        data: function data() {
                return {
                        code: "\n<Price>24</Price>\n<Price :font_size=\"36\">36</Price>\n<Price :font_size=\"48\">48</Price>\n        ",
                        color_code: "\n<Price>99</Price>\n<Price :color=\"'#00a0e9'\">998</Price>\n<Price :color=\"'rgba(99, 99, 99, 1)'\">9998</Price>\n        ",
                        super_code: "\n<Price :super=\"true\">24</Price>\n<Price :super=\"true\" :font_size=\"36\">36</Price>\n<Price :super=\"true\" :font_size=\"48\">48</Price>\n        ",
                        delete_code: "\n<Price :delete=\"true\">24</Price>\n<Price :delete=\"true\" :font_size=\"36\">36</Price>\n<Price :delete=\"true\" :font_size=\"48\">48</Price>\n        ",
                        suffix_code: "\n<Price suffix=\"\u8D77\">24</Price>\n<Price suffix=\"\u8D77\" :font_size=\"36\">36</Price>\n<Price suffix=\"\u8D77\" :font_size=\"48\">48</Price>\n        "
                };
        }
});

/***/ }),
/* 181 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
        data: function data() {
                return {
                        test: '',
                        value_test: 0,
                        status_test: '',
                        color_test: '',
                        reselect_test: '',
                        code: '\n<Radio v-model="test" :size="\'sm\'">\u5355\u9009\u6309\u94AE</Radio>\n<Radio v-model="test" :size="\'md\'">\u5355\u9009\u6309\u94AE2</Radio>\n<Radio v-model="test" :size="\'lg\'">\u5355\u9009\u6309\u94AE3</Radio>\n<p class="radio-result">\u5DF2\u9009\u4E2D\uFF1A{{ test }}</p>\n        ',
                        value_code: '\n<Radio :value="1" v-model="value_test">\u5355\u9009\u6309\u94AE</Radio>\n<Radio :value="2" v-model="value_test">\u5355\u9009\u6309\u94AE2</Radio>\n<Radio :value="3" v-model="value_test">\u5355\u9009\u6309\u94AE3</Radio>\n<p class="radio-result">\u5DF2\u9009\u4E2D\uFF1A{{ value_test }}</p>\n        ',
                        status_code: '\n<Radio v-model="status_test">\u5355\u9009\u6309\u94AE</Radio>\n<Radio :disabled="true" v-model="status_test">\u5DF2\u7981\u7528</Radio>\n<p class="radio-result">\u5DF2\u9009\u4E2D\uFF1A{{ status_test }}</p>\n        ',
                        color_code: '\n<Radio v-model="color_test">\u5355\u9009\u6309\u94AE</Radio>\n<Radio :color="\'rgb(0, 160, 233)\'" v-model="color_test">\u5355\u9009\u6309\u94AE2(\u84DD\u8272)</Radio>\n<p class="radio-result">\u5DF2\u9009\u4E2D\uFF1A{{ color_test }}</p>\n        ',
                        reselect_code: '\n<Radio v-model="reselect_test" :reselect="true">\u5355\u9009\u6309\u94AE</Radio>\n<Radio v-model="reselect_test" :reselect="true">\u5355\u9009\u6309\u94AE2</Radio>\n<p class="radio-result">\u5DF2\u9009\u4E2D\uFF1A{{ reselect_test }}</p>\n        '
                };
        }
});

/***/ }),
/* 182 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      test: '',
      float_test: '',
      color_test: '',
      disabled_test: '',
      custom_test: '',
      code: '\n<Select :data="[2,3,4]" v-model="test" :size="\'sm\'"></Select>\n<Select :data="[2,3,4]" v-model="test" :size="\'md\'"></Select>\n<Select :data="[2,3,4]" v-model="test" :size="\'lg\'"></Select>\n        ',
      float_code: '\n<Select :data="[2,3,4]" :float="true" :label="\'\u6211\u662F\u6807\u9898\'" v-model="float_test"></Select>\n<Select :data="[2,3,4]" v-model="float_test"></Select>\n        ',
      disabled_code: '\n<Select :data="[2,3,4]" :disabled="true"></Select>\n<Select :data="[2,3,4]" v-model="disabled_test"></Select>\n        ',
      color_code: '\n<Select :data="[2,3,4]" v-model="color_test"></Select>\n<Select :data="[2,3,4]" :color="\'#4fae9B\'" v-model="color_test"></Select>\n<Select :data="[2,3,4]" :color="\'rgb(0, 160, 233)\'" v-model="color_test"></Select>\n        ',
      custom_code: '\n// \u9009\u62E9\u56681 \u65E0\u89E6\u53D1close\u4E8B\u4EF6\n<Select v-model="custom_test">\n  <p class="custom-option" v-for="n in 4" @click="custom_test = \'\u81EA\u5B9A\u4E49\u9009\u9879\' + n">\u81EA\u5B9A\u4E49\u9009\u9879 {{ n }}</p>\n</Select>\n\n// \u9009\u62E9\u56682 \u89E6\u53D1close\u4E8B\u4EF6\n<Select :ref="\'select\'" v-model="custom_test">\n  <p class="custom-option" v-for="n in 4" @click="custom_test = \'\u81EA\u5B9A\u4E49\u9009\u9879\' + n, $refs.select.$emit(\'close\')">\u81EA\u5B9A\u4E49\u9009\u9879 {{ n }}</p>\n</Select>\n\n<Btn @click.native="$refs.select.$emit(\'form-verify\')">\u9A8C\u8BC1\u9009\u62E9\u56681</Btn>\n<Btn @click.native="$root.$emit(\'form-verify\')">\u9A8C\u8BC1\u6240\u6709\u9009\u62E9\u5668</Btn>\n         '
    };
  }
});

/***/ }),
/* 183 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      code: "\n<Btn @click.native=\"$smoothScroll(300)\">\u6EDA\u52A8\u5230\u8DDD\u79BB\u9876\u90E8300\u7684\u4F4D\u7F6E</Btn>\n        ",
      ele_code: "\n<Btn @click.native=\"$smoothScroll($refs.target)\">\u6EDA\u52A8\u5230\u76EE\u6807\u5143\u7D20</Btn>\n<Btn @click.native=\"$smoothScroll($refs.target, 1000, -100)\">\u504F\u79FB100px</Btn>\n        ",
      top_code: "\n<Btn @click.native=\"$smoothScroll()\">\u6EDA\u52A8\u9876\u90E8</Btn>\n<Btn @click.native=\"$smoothScroll(0, 200)\">200ms\u6EDA\u5230\u9876\u90E8</Btn>\n        "
    };
  }
});

/***/ }),
/* 184 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      code: "\n<Spinner></Spinner>\n        ",
      size_code: "\n<Spinner></Spinner>\n<Spinner :size=\"36\"></Spinner>\n<Spinner :size=\"48\"></Spinner>\n<Spinner :size=\"60\"></Spinner>\n        ",
      color_code: "\n<Spinner :color=\"'pink'\"></Spinner>\n<Spinner :color=\"'#87db83'\"></Spinner>\n<Spinner :color=\"'rgba(255, 66, 66, 1)'\"></Spinner>\n        ",
      wrap_code: "\n<article class=\"article\">\n  <h3>Article Title</h3>\n  <p>This is a test text</p>\n  <Spinner :wrap=\"true\">\n    Loading...\n  </Spinner>\n</article>\n        "
    };
  }
});

/***/ }),
/* 185 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      test: false,
      index: 2,
      trigger_index: 0,
      code: "\n<Swipe>\n  <SwipeSlide v-for=\"(n, index) in 5\" :key=\"index\">\n    <div class=\"content\"> {{ index}} </div>\n  </SwipeSlide>\n</Swipe>\n<Swipe :loop=\"false\">\n  <SwipeSlide v-for=\"(n, index) in 5\" :key=\"index\">\n    <div class=\"content\"> {{ index}} </div>\n  </SwipeSlide>\n</Swipe>\n        ",
      index_code: "\n<p>\u5F53\u524D\u4E0B\u6807\u662F {{ index }}</p>\n<Swipe v-model=\"index\">\n  <SwipeSlide v-for=\"(n, index) in 5\" :key=\"index\">\n    <div class=\"content\"> {{index}} </div>\n  </SwipeSlide>\n</Swipe>\n<br>\n<p>\u5F53\u524D\u4E0B\u6807\u662F {{ trigger_index }}</p>\n<Swipe v-model=\"trigger_index\" :trigger=\"'progress'\">\n  <SwipeSlide v-for=\"(n, index) in 5\" :key=\"index\">\n    <div class=\"content\"> {{index}} <p>\u6ED1\u52A8\u8FC7\u7A0B\u4E2D\u6539\u53D8index</p></div>\n  </SwipeSlide>\n</Swipe>\n<Swipe :index=\"true\">\n  <SwipeSlide v-for=\"(n, index) in 5\" :key=\"index\">\n    <div class=\"content\"> {{index}} <p>\u663E\u793Aindex</p></div>\n  </SwipeSlide>\n</Swipe>\n<Swipe :index=\"true\" :index_trigger=\"'hover'\">\n  <SwipeSlide v-for=\"(n, index) in 5\" :key=\"index\">\n    <div class=\"content\"> {{index}} <p>index hover\u89E6\u53D1\u6ED1\u52A8</p></div>\n  </SwipeSlide>\n</Swipe>\n<Swipe :index=\"true\" :index_x_offset=\"15\" :index_y_offset=\"-10\">\n  <SwipeSlide v-for=\"(n, index) in 5\" :key=\"index\">\n    <div class=\"content\"> {{ index}} <p>\u8C03\u6574\u4E0B\u6807\u504F\u5DEE</p></div>\n  </SwipeSlide>\n</Swipe>\n        ",
      arrow_code: "\n<Swipe>\n  <SwipeSlide v-for=\"(n, index) in 5\" :key=\"index\">\n    <div class=\"content\"> {{index}} <p>\u9ED8\u8BA4hover\u663E\u793A\u5DE6\u53F3\u7BAD\u5934</p> </div>\n  </SwipeSlide>\n</Swipe>\n<Swipe :arrow=\"true\">\n  <SwipeSlide v-for=\"(n, index) in 5\" :key=\"index\">\n    <div class=\"content\"> {{index}} <p>\u603B\u662F\u663E\u793A\u7BAD\u5934</p> </div>\n  </SwipeSlide>\n</Swipe>\n<Swipe :arrow=\"false\">\n  <SwipeSlide v-for=\"(n, index) in 5\" :key=\"index\">\n    <div class=\"content\"> {{index}} <p>\u65E0\u7BAD\u5934</p> </div>\n  </SwipeSlide>\n</Swipe>\n<Swipe :arrow=\"true\" :outer_arrow=\"true\">\n  <SwipeSlide v-for=\"(n, index) in 5\" :key=\"index\">\n    <div class=\"content\"> {{ index}} <p>\u5916\u90E8\u7BAD\u5934</p> </div>\n  </SwipeSlide>\n</Swipe>\n<Swipe :arrow=\"true\" :outer_arrow=\"true\" :arrow_offset=\"-15\">\n  <SwipeSlide v-for=\"(n, index) in 5\" :key=\"index\">\n    <div class=\"content\"> {{ index}} <p>\u8C03\u6574\u7BAD\u5934\u504F\u5DEE</p> </div>\n  </SwipeSlide>\n</Swipe>\n        ",
      sliding_code: "\n<p>\u540C\u65F6\u5C55\u793A\u591A\u4E2ASlide</p>\n<Swipe :preview=\"2\" :between=\"12\">\n  <SwipeSlide v-for=\"(n, index) in 5\" :key=\"index\">\n    <div class=\"content\"> {{index}} </div>\n  </SwipeSlide>\n</Swipe>\n<Swipe :preview=\"3\" :between=\"12\">\n  <SwipeSlide v-for=\"(n, index) in 5\" :key=\"index\">\n    <div class=\"content\"> {{index}} </div>\n  </SwipeSlide>\n</Swipe>\n<p>\u591A\u4E2ASlide\u540C\u65F6\u6ED1\u52A8</p>\n<Swipe :preview=\"2\" :between=\"12\" :sliding_num=\"2\">\n  <SwipeSlide v-for=\"(n, index) in 6\" :key=\"index\">\n    <div class=\"content\"> {{index}} </div>\n  </SwipeSlide>\n</Swipe>\n        ",
      coverflow_code: "\n<Swipe :coverflow=\"true\">\n  <SwipeSlide v-for=\"(n, index) in 5\" :key=\"index\">\n    <div class=\"content\"> {{index}} </div>\n  </SwipeSlide>\n</Swipe>\n<Swipe :coverflow=\"true\" :preview=\"2\">\n  <SwipeSlide v-for=\"(n, index) in 5\" :key=\"index\">\n    <div class=\"content\"> {{index}} </div>\n  </SwipeSlide>\n</Swipe>\n<Swipe :coverflow=\"true\" :preview=\"3\">\n  <SwipeSlide v-for=\"(n, index) in 5\" :key=\"index\">\n    <div class=\"content\"> {{index}} </div>\n  </SwipeSlide>\n</Swipe>\n        ",
      free_code: "\n<Swipe>\n  <SwipeSlide v-for=\"(n, index) in 5\" :key=\"index\">\n    <div class=\"content\"> {{index}} </div>\n  </SwipeSlide>\n</Swipe>\n<Swipe :free=\"true\">\n  <SwipeSlide v-for=\"(n, index) in 5\" :key=\"index\">\n    <div class=\"content\"> {{index}} </div>\n  </SwipeSlide>\n</Swipe>\n        ",
      event_code: "\n<Swipe ref=\"swiper\">\n  <SwipeSlide v-for=\"(n, index) in 5\" :key=\"index\">\n    <div class=\"content\"> {{ index}} </div>\n  </SwipeSlide>\n</Swipe>\n<Btn @click.native=\"$refs.swiper.$emit('slide-prev')\">\u524D\u4E00\u4E2A</Btn>\n<Btn @click.native=\"$refs.swiper.$emit('slide-next')\">\u540E\u4E00\u4E2A</Btn>\n<Btn @click.native=\"$refs.swiper.$emit('slide-to', 1)\">\u5230\u7B2C\u4E8C\u4E2A</Btn>\n        "
    };
  }
});

/***/ }),
/* 186 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      code: "\n<vSwitch :size=\"'sm'\" v-model=\"val\"></vSwitch>\n<vSwitch :size=\"'md'\" v-model=\"val\"></vSwitch>\n<vSwitch :size=\"'lg'\" v-model=\"val\"></vSwitch>\n        ",
      color_code: "\n<vSwitch :class=\"'green'\" v-model=\"val\"></vSwitch>\n\n<style lang=\"stylus\">\n.green {\n  background-color: _red;\n}\n\n.green.checked {\n  background-color: _green;\n}\n</style>\n        ",
      status_code: "\n<vSwitch v-model=\"val\"></vSwitch>\n<vSwitch v-model=\"val\" disabled></vSwitch>\n        ",
      val: false
    };
  }
});

/***/ }),
/* 187 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      default_index: 0,
      type_index: 0,
      theme_index: 0,
      trigger_index: 0,
      icon_index: 0,
      style_index: 0,
      code: "\n<Tab :data=\"['\u6807\u7B7E\u4E00', '\u6807\u7B7E\u4E8C', '\u6807\u7B7E\u4E09']\" v-model=\"default_index\"></Tab>\n        ",
      type_code: "\n<Tab :data=\"['\u6807\u7B7E\u4E00', '\u6807\u7B7E\u4E8C', '\u6807\u7B7E\u4E09']\" v-model=\"type_index\" :type=\"'no_padding'\"></Tab>\n<Tab :data=\"['\u6807\u7B7E\u4E00', '\u6807\u7B7E\u4E8C', '\u6807\u7B7E\u4E09']\" v-model=\"type_index\" :type=\"'fix_width'\"></Tab>\n<Tab :data=\"['\u6807\u7B7E\u4E00', '\u6807\u7B7E\u4E8C', '\u6807\u7B7E\u4E09']\" v-model=\"type_index\" :type=\"'fix_width:25%'\"></Tab>\n        ",
      theme_code: "\n<Tab :data=\"['\u6807\u7B7E\u4E00', '\u6807\u7B7E\u4E8C', '\u6807\u7B7E\u4E09']\" v-model=\"theme_index\"></Tab>\n<Tab :data=\"['\u6807\u7B7E\u4E00', '\u6807\u7B7E\u4E8C', '\u6807\u7B7E\u4E09']\" v-model=\"theme_index\" :theme=\"'card'\"></Tab>\n<Tab :data=\"['\u6807\u7B7E\u4E00', '\u6807\u7B7E\u4E8C', '\u6807\u7B7E\u4E09']\" v-model=\"theme_index\" :theme=\"'ticket'\" :type=\"'fix_width'\"></Tab>\n        ",
      trigger_code: "\n<Tab :data=\"['\u6807\u7B7E\u4E00', '\u6807\u7B7E\u4E8C', '\u6807\u7B7E\u4E09']\" v-model=\"trigger_index\" trigger=\"hover\"></Tab>\n        ",
      icon_code: "\n<Tab :data=\"['Home', 'Cart', 'User']\" v-model=\"icon_index\"></Tab>\n<Tab\n  :data=\"[{\n    name: 'Home',\n    icon: 'home'\n  }, {\n    name: 'Cart',\n    icon: 'shoppingcart'\n  }, {\n    name: 'User',\n    icon: 'user'\n  }]\" v-model=\"style_index\"></Tab>\n<Tab\n  :data=\"[{\n    name: 'Home',\n    suffix_icon: 'home'\n  }, {\n    name: 'Cart',\n    suffix_icon: 'shoppingcart'\n  }, {\n    name: 'User',\n    suffix_icon: 'user'\n  }]\" v-model=\"icon_index\"></Tab>\n        ",
      style_code: "\n<Tab :data=\"['\u6807\u7B7E\u4E00', '\u6807\u7B7E\u4E8C', '\u6807\u7B7E\u4E09']\" v-model=\"style_index\" :active-style=\"{ color: '#f02f45', borderBottomColor: '#f02f45' }\"></Tab>\n        "
    };
  }
});

/***/ }),
/* 188 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      code: "\n<Tabs>\n  <TabPane :label=\"'\u6807\u7B7E\u4E00'\">\u7B2C\u4E00\u4E2A\u6807\u7B7E\u5185\u5BB9</TabPane>\n  <TabPane :label=\"'\u6807\u7B7E\u4E8C'\">\u7B2C\u4E8C\u4E2A\u6807\u7B7E\u5185\u5BB9</TabPane>\n  <TabPane :label=\"'\u6807\u7B7E\u4E09'\">\u7B2C\u4E09\u4E2A\u6807\u7B7E\u5185\u5BB9</TabPane>\n</Tabs>\n        ",
      type_code: "\n<Tabs :type=\"'no_padding'\">\n  <TabPane :label=\"'\u6807\u7B7E\u4E00'\">\u4E0D\u4F7F\u7528padding\u7684\u6807\u7B7E1</TabPane>\n  <TabPane :label=\"'\u6807\u7B7E\u4E8C'\">\u4E0D\u4F7F\u7528padding\u7684\u6807\u7B7E2</TabPane>\n  <TabPane :label=\"'\u6807\u7B7E\u4E09'\">\u4E0D\u4F7F\u7528padding\u7684\u6807\u7B7E3</TabPane>\n</Tabs>\n\n<Tabs :type=\"'fix_width'\">\n  <TabPane :label=\"'\u6807\u7B7E\u4E00'\">\u5E73\u5206\u5BBD\u5EA6\u7684\u6807\u7B7E1</TabPane>\n  <TabPane :label=\"'\u6807\u7B7E\u4E8C'\">\u5E73\u5206\u5BBD\u5EA6\u7684\u6807\u7B7E2</TabPane>\n  <TabPane :label=\"'\u6807\u7B7E\u4E09'\">\u5E73\u5206\u5BBD\u5EA6\u7684\u6807\u7B7E3</TabPane>\n</Tabs>\n\n<Tabs :type=\"'fix_width:20%'\">\n  <TabPane :label=\"'\u6807\u7B7E\u4E00'\">\u56FA\u5B9A\u5BBD\u5EA6\u4E3A20%\u7684\u6807\u7B7E1</TabPane>\n  <TabPane :label=\"'\u6807\u7B7E\u4E8C'\">\u56FA\u5B9A\u5BBD\u5EA6\u4E3A20%\u7684\u6807\u7B7E2</TabPane>\n  <TabPane :label=\"'\u6807\u7B7E\u4E09'\">\u56FA\u5B9A\u5BBD\u5EA6\u4E3A20%\u7684\u6807\u7B7E3</TabPane>\n</Tabs>\n        ",
      icon_code: "\n<Tabs>\n  <TabPane :label=\"'Home'\" :icon=\"'home'\">\u7B2C\u4E00\u4E2A\u6807\u7B7E\u5185\u5BB9</TabPane>\n  <TabPane :label=\"'Cart'\" :icon=\"'shoppingcart'\">\u7B2C\u4E8C\u4E2A\u6807\u7B7E\u5185\u5BB9</TabPane>\n  <TabPane :label=\"'User'\" :icon=\"'user'\">\u7B2C\u4E09\u4E2A\u6807\u7B7E\u5185\u5BB9</TabPane>\n  <TabPane :label=\"'Setting'\" :icon=\"'setting'\">\u7B2C\u56DB\u4E2A\u6807\u7B7E\u5185\u5BB9</TabPane>\n</Tabs>\n        ",
      style_code: "\n<Tabs :type=\"'no_padding'\" :active-style=\"{ color: '#f02f45', borderBottomColor: '#f02f45' }\">\n  <TabPane :label=\"'\u673A\u9152\u81EA\u7531\u884C'\">\u673A\u9152\u81EA\u7531\u884C</TabPane>\n  <TabPane :label=\"'\u5F53\u5730\u73A9\u4E50'\">\u5F53\u5730\u73A9\u4E50</TabPane>\n  <TabPane :label=\"'\u51FA\u884C\u5FC5\u5907'\">\u51FA\u884C\u5FC5\u5907</TabPane>\n</Tabs>\n        ",
      type_descr: "\n`no_padding` \u4E0D\u4F7F\u7528padding\u7684\u6807\u7B7E\n\n`fix_width`  \u5E73\u5206\u5BBD\u5EA6\u7684\u6807\u7B7E\n\n`fix_width:String`  \u56FA\u5B9A\u5BBD\u5EA6\u7684\u6807\u7B7E\n        "
    };
  }
});

/***/ }),
/* 189 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      size_code: "\n<Btn @click=\"$toast(nowDate)\">Toast</Btn>\n        ",
      type_code: "\n<Btn @click=\"$toast(nowDate, 'default')\">Default</Btn>\n<Btn @click=\"$toast(nowDate, 'primary')\">Primary</Btn>\n<Btn @click=\"$toast(nowDate, 'success')\">Success</Btn>\n<Btn @click=\"$toast(nowDate, 'warning')\">Warning</Btn>\n<Btn @click=\"$toast(nowDate, 'error')\">Error</Btn>\n        ",
      time_code: "\n<Btn @click=\"$toast('\u4E00\u79D2\u540E\u6D88\u5931', { time: 1000 })\">\u5EF6\u8FDF\u4E00\u79D2</Btn>\n<Btn @click=\"control\">\u624B\u52A8\u63A7\u5236</Btn>\n\n//...\ncontrol () {\n  if (this.vm) {\n    this.vm.show = false\n    this.vm = null\n    return false\n  }\n  this.vm = this.$toast(this.nowDate, { time: 0 })\n}\n        ",
      callback_code: "\n<Btn @click=\"$toast(nowDate, { callback: () => $toast('Callback\uFF01') })\">\u56DE\u8C03\u51FD\u6570</Btn>\n        ",
      timer: null,
      vm: null,
      nowDate: new Date().toLocaleString()
    };
  },

  methods: {
    control: function control() {
      if (this.vm) {
        this.vm.show = false;
        this.vm = null;
        return false;
      }
      this.vm = this.$toast(this.nowDate, { time: 0 });
    }
  },
  mounted: function mounted() {
    var _this = this;

    this.timer = setInterval(function () {
      _this.nowDate = new Date().toLocaleString();
    }, 1000);
  },
  beforeDestroy: function beforeDestroy() {
    clearInterval(this.timer);
  }
});

/***/ }),
/* 190 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'home',
  components: {
    vHeader: __webpack_require__(587),
    vNav: __webpack_require__(588)
  },
  data: function data() {
    return {
      phone5_size: [320, 568],
      phone6_size: [375, 667]
    };
  },

  computed: {
    preview_size: function preview_size() {
      return document.documentElement.clientHeight < this.phone6_size[1] + 120 ? this.phone5_size : this.phone6_size;
    }
  }
});

/***/ }),
/* 191 */,
/* 192 */,
/* 193 */,
/* 194 */,
/* 195 */,
/* 196 */,
/* 197 */,
/* 198 */,
/* 199 */,
/* 200 */,
/* 201 */,
/* 202 */,
/* 203 */,
/* 204 */,
/* 205 */,
/* 206 */,
/* 207 */,
/* 208 */,
/* 209 */,
/* 210 */,
/* 211 */,
/* 212 */,
/* 213 */,
/* 214 */,
/* 215 */,
/* 216 */,
/* 217 */,
/* 218 */,
/* 219 */,
/* 220 */,
/* 221 */,
/* 222 */,
/* 223 */,
/* 224 */,
/* 225 */,
/* 226 */,
/* 227 */,
/* 228 */,
/* 229 */,
/* 230 */,
/* 231 */,
/* 232 */,
/* 233 */,
/* 234 */,
/* 235 */,
/* 236 */,
/* 237 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(238)();
// imports


// module
exports.push([module.i, ".grid-concept-demo{margin-bottom:10px;background-image:linear-gradient(90deg,#f5f5f5 4.16666667%,#eee 0,#eee 8.33333333%,#f5f5f5 0,#f5f5f5 12.5%,#eee 0,#eee 16.66666667%,#f5f5f5 0,#f5f5f5 20.83333333%,#eee 0,#eee 25%,#f5f5f5 0,#f5f5f5 29.16666667%,#eee 0,#eee 33.33333333%,#f5f5f5 0,#f5f5f5 37.5%,#eee 0,#eee 41.66666667%,#f5f5f5 0,#f5f5f5 45.83333333%,#eee 0,#eee 50%,#f5f5f5 0,#f5f5f5 54.16666667%,#eee 0,#eee 58.33333333%,#f5f5f5 0,#f5f5f5 62.5%,#eee 0,#eee 66.66666667%,#f5f5f5 0,#f5f5f5 70.83333333%,#eee 0,#eee 75%,#f5f5f5 0,#f5f5f5 79.16666667%,#eee 0,#eee 83.33333333%,#f5f5f5 0,#f5f5f5 87.5%,#eee 0,#eee 91.66666667%,#f5f5f5 0,#f5f5f5 95.83333333%,#eee 0)}.grid-concept-demo .hiui-grid-col{height:60px;line-height:60px;background-color:rgba(0,160,233,.5);text-align:center;color:#fff}", ""]);

// exports


/***/ }),
/* 238 */,
/* 239 */,
/* 240 */,
/* 241 */
/***/ (function(module, exports) {

module.exports = {
	"Aacute": "Á",
	"aacute": "á",
	"Abreve": "Ă",
	"abreve": "ă",
	"ac": "∾",
	"acd": "∿",
	"acE": "∾̳",
	"Acirc": "Â",
	"acirc": "â",
	"acute": "´",
	"Acy": "А",
	"acy": "а",
	"AElig": "Æ",
	"aelig": "æ",
	"af": "⁡",
	"Afr": "𝔄",
	"afr": "𝔞",
	"Agrave": "À",
	"agrave": "à",
	"alefsym": "ℵ",
	"aleph": "ℵ",
	"Alpha": "Α",
	"alpha": "α",
	"Amacr": "Ā",
	"amacr": "ā",
	"amalg": "⨿",
	"amp": "&",
	"AMP": "&",
	"andand": "⩕",
	"And": "⩓",
	"and": "∧",
	"andd": "⩜",
	"andslope": "⩘",
	"andv": "⩚",
	"ang": "∠",
	"ange": "⦤",
	"angle": "∠",
	"angmsdaa": "⦨",
	"angmsdab": "⦩",
	"angmsdac": "⦪",
	"angmsdad": "⦫",
	"angmsdae": "⦬",
	"angmsdaf": "⦭",
	"angmsdag": "⦮",
	"angmsdah": "⦯",
	"angmsd": "∡",
	"angrt": "∟",
	"angrtvb": "⊾",
	"angrtvbd": "⦝",
	"angsph": "∢",
	"angst": "Å",
	"angzarr": "⍼",
	"Aogon": "Ą",
	"aogon": "ą",
	"Aopf": "𝔸",
	"aopf": "𝕒",
	"apacir": "⩯",
	"ap": "≈",
	"apE": "⩰",
	"ape": "≊",
	"apid": "≋",
	"apos": "'",
	"ApplyFunction": "⁡",
	"approx": "≈",
	"approxeq": "≊",
	"Aring": "Å",
	"aring": "å",
	"Ascr": "𝒜",
	"ascr": "𝒶",
	"Assign": "≔",
	"ast": "*",
	"asymp": "≈",
	"asympeq": "≍",
	"Atilde": "Ã",
	"atilde": "ã",
	"Auml": "Ä",
	"auml": "ä",
	"awconint": "∳",
	"awint": "⨑",
	"backcong": "≌",
	"backepsilon": "϶",
	"backprime": "‵",
	"backsim": "∽",
	"backsimeq": "⋍",
	"Backslash": "∖",
	"Barv": "⫧",
	"barvee": "⊽",
	"barwed": "⌅",
	"Barwed": "⌆",
	"barwedge": "⌅",
	"bbrk": "⎵",
	"bbrktbrk": "⎶",
	"bcong": "≌",
	"Bcy": "Б",
	"bcy": "б",
	"bdquo": "„",
	"becaus": "∵",
	"because": "∵",
	"Because": "∵",
	"bemptyv": "⦰",
	"bepsi": "϶",
	"bernou": "ℬ",
	"Bernoullis": "ℬ",
	"Beta": "Β",
	"beta": "β",
	"beth": "ℶ",
	"between": "≬",
	"Bfr": "𝔅",
	"bfr": "𝔟",
	"bigcap": "⋂",
	"bigcirc": "◯",
	"bigcup": "⋃",
	"bigodot": "⨀",
	"bigoplus": "⨁",
	"bigotimes": "⨂",
	"bigsqcup": "⨆",
	"bigstar": "★",
	"bigtriangledown": "▽",
	"bigtriangleup": "△",
	"biguplus": "⨄",
	"bigvee": "⋁",
	"bigwedge": "⋀",
	"bkarow": "⤍",
	"blacklozenge": "⧫",
	"blacksquare": "▪",
	"blacktriangle": "▴",
	"blacktriangledown": "▾",
	"blacktriangleleft": "◂",
	"blacktriangleright": "▸",
	"blank": "␣",
	"blk12": "▒",
	"blk14": "░",
	"blk34": "▓",
	"block": "█",
	"bne": "=⃥",
	"bnequiv": "≡⃥",
	"bNot": "⫭",
	"bnot": "⌐",
	"Bopf": "𝔹",
	"bopf": "𝕓",
	"bot": "⊥",
	"bottom": "⊥",
	"bowtie": "⋈",
	"boxbox": "⧉",
	"boxdl": "┐",
	"boxdL": "╕",
	"boxDl": "╖",
	"boxDL": "╗",
	"boxdr": "┌",
	"boxdR": "╒",
	"boxDr": "╓",
	"boxDR": "╔",
	"boxh": "─",
	"boxH": "═",
	"boxhd": "┬",
	"boxHd": "╤",
	"boxhD": "╥",
	"boxHD": "╦",
	"boxhu": "┴",
	"boxHu": "╧",
	"boxhU": "╨",
	"boxHU": "╩",
	"boxminus": "⊟",
	"boxplus": "⊞",
	"boxtimes": "⊠",
	"boxul": "┘",
	"boxuL": "╛",
	"boxUl": "╜",
	"boxUL": "╝",
	"boxur": "└",
	"boxuR": "╘",
	"boxUr": "╙",
	"boxUR": "╚",
	"boxv": "│",
	"boxV": "║",
	"boxvh": "┼",
	"boxvH": "╪",
	"boxVh": "╫",
	"boxVH": "╬",
	"boxvl": "┤",
	"boxvL": "╡",
	"boxVl": "╢",
	"boxVL": "╣",
	"boxvr": "├",
	"boxvR": "╞",
	"boxVr": "╟",
	"boxVR": "╠",
	"bprime": "‵",
	"breve": "˘",
	"Breve": "˘",
	"brvbar": "¦",
	"bscr": "𝒷",
	"Bscr": "ℬ",
	"bsemi": "⁏",
	"bsim": "∽",
	"bsime": "⋍",
	"bsolb": "⧅",
	"bsol": "\\",
	"bsolhsub": "⟈",
	"bull": "•",
	"bullet": "•",
	"bump": "≎",
	"bumpE": "⪮",
	"bumpe": "≏",
	"Bumpeq": "≎",
	"bumpeq": "≏",
	"Cacute": "Ć",
	"cacute": "ć",
	"capand": "⩄",
	"capbrcup": "⩉",
	"capcap": "⩋",
	"cap": "∩",
	"Cap": "⋒",
	"capcup": "⩇",
	"capdot": "⩀",
	"CapitalDifferentialD": "ⅅ",
	"caps": "∩︀",
	"caret": "⁁",
	"caron": "ˇ",
	"Cayleys": "ℭ",
	"ccaps": "⩍",
	"Ccaron": "Č",
	"ccaron": "č",
	"Ccedil": "Ç",
	"ccedil": "ç",
	"Ccirc": "Ĉ",
	"ccirc": "ĉ",
	"Cconint": "∰",
	"ccups": "⩌",
	"ccupssm": "⩐",
	"Cdot": "Ċ",
	"cdot": "ċ",
	"cedil": "¸",
	"Cedilla": "¸",
	"cemptyv": "⦲",
	"cent": "¢",
	"centerdot": "·",
	"CenterDot": "·",
	"cfr": "𝔠",
	"Cfr": "ℭ",
	"CHcy": "Ч",
	"chcy": "ч",
	"check": "✓",
	"checkmark": "✓",
	"Chi": "Χ",
	"chi": "χ",
	"circ": "ˆ",
	"circeq": "≗",
	"circlearrowleft": "↺",
	"circlearrowright": "↻",
	"circledast": "⊛",
	"circledcirc": "⊚",
	"circleddash": "⊝",
	"CircleDot": "⊙",
	"circledR": "®",
	"circledS": "Ⓢ",
	"CircleMinus": "⊖",
	"CirclePlus": "⊕",
	"CircleTimes": "⊗",
	"cir": "○",
	"cirE": "⧃",
	"cire": "≗",
	"cirfnint": "⨐",
	"cirmid": "⫯",
	"cirscir": "⧂",
	"ClockwiseContourIntegral": "∲",
	"CloseCurlyDoubleQuote": "”",
	"CloseCurlyQuote": "’",
	"clubs": "♣",
	"clubsuit": "♣",
	"colon": ":",
	"Colon": "∷",
	"Colone": "⩴",
	"colone": "≔",
	"coloneq": "≔",
	"comma": ",",
	"commat": "@",
	"comp": "∁",
	"compfn": "∘",
	"complement": "∁",
	"complexes": "ℂ",
	"cong": "≅",
	"congdot": "⩭",
	"Congruent": "≡",
	"conint": "∮",
	"Conint": "∯",
	"ContourIntegral": "∮",
	"copf": "𝕔",
	"Copf": "ℂ",
	"coprod": "∐",
	"Coproduct": "∐",
	"copy": "©",
	"COPY": "©",
	"copysr": "℗",
	"CounterClockwiseContourIntegral": "∳",
	"crarr": "↵",
	"cross": "✗",
	"Cross": "⨯",
	"Cscr": "𝒞",
	"cscr": "𝒸",
	"csub": "⫏",
	"csube": "⫑",
	"csup": "⫐",
	"csupe": "⫒",
	"ctdot": "⋯",
	"cudarrl": "⤸",
	"cudarrr": "⤵",
	"cuepr": "⋞",
	"cuesc": "⋟",
	"cularr": "↶",
	"cularrp": "⤽",
	"cupbrcap": "⩈",
	"cupcap": "⩆",
	"CupCap": "≍",
	"cup": "∪",
	"Cup": "⋓",
	"cupcup": "⩊",
	"cupdot": "⊍",
	"cupor": "⩅",
	"cups": "∪︀",
	"curarr": "↷",
	"curarrm": "⤼",
	"curlyeqprec": "⋞",
	"curlyeqsucc": "⋟",
	"curlyvee": "⋎",
	"curlywedge": "⋏",
	"curren": "¤",
	"curvearrowleft": "↶",
	"curvearrowright": "↷",
	"cuvee": "⋎",
	"cuwed": "⋏",
	"cwconint": "∲",
	"cwint": "∱",
	"cylcty": "⌭",
	"dagger": "†",
	"Dagger": "‡",
	"daleth": "ℸ",
	"darr": "↓",
	"Darr": "↡",
	"dArr": "⇓",
	"dash": "‐",
	"Dashv": "⫤",
	"dashv": "⊣",
	"dbkarow": "⤏",
	"dblac": "˝",
	"Dcaron": "Ď",
	"dcaron": "ď",
	"Dcy": "Д",
	"dcy": "д",
	"ddagger": "‡",
	"ddarr": "⇊",
	"DD": "ⅅ",
	"dd": "ⅆ",
	"DDotrahd": "⤑",
	"ddotseq": "⩷",
	"deg": "°",
	"Del": "∇",
	"Delta": "Δ",
	"delta": "δ",
	"demptyv": "⦱",
	"dfisht": "⥿",
	"Dfr": "𝔇",
	"dfr": "𝔡",
	"dHar": "⥥",
	"dharl": "⇃",
	"dharr": "⇂",
	"DiacriticalAcute": "´",
	"DiacriticalDot": "˙",
	"DiacriticalDoubleAcute": "˝",
	"DiacriticalGrave": "`",
	"DiacriticalTilde": "˜",
	"diam": "⋄",
	"diamond": "⋄",
	"Diamond": "⋄",
	"diamondsuit": "♦",
	"diams": "♦",
	"die": "¨",
	"DifferentialD": "ⅆ",
	"digamma": "ϝ",
	"disin": "⋲",
	"div": "÷",
	"divide": "÷",
	"divideontimes": "⋇",
	"divonx": "⋇",
	"DJcy": "Ђ",
	"djcy": "ђ",
	"dlcorn": "⌞",
	"dlcrop": "⌍",
	"dollar": "$",
	"Dopf": "𝔻",
	"dopf": "𝕕",
	"Dot": "¨",
	"dot": "˙",
	"DotDot": "⃜",
	"doteq": "≐",
	"doteqdot": "≑",
	"DotEqual": "≐",
	"dotminus": "∸",
	"dotplus": "∔",
	"dotsquare": "⊡",
	"doublebarwedge": "⌆",
	"DoubleContourIntegral": "∯",
	"DoubleDot": "¨",
	"DoubleDownArrow": "⇓",
	"DoubleLeftArrow": "⇐",
	"DoubleLeftRightArrow": "⇔",
	"DoubleLeftTee": "⫤",
	"DoubleLongLeftArrow": "⟸",
	"DoubleLongLeftRightArrow": "⟺",
	"DoubleLongRightArrow": "⟹",
	"DoubleRightArrow": "⇒",
	"DoubleRightTee": "⊨",
	"DoubleUpArrow": "⇑",
	"DoubleUpDownArrow": "⇕",
	"DoubleVerticalBar": "∥",
	"DownArrowBar": "⤓",
	"downarrow": "↓",
	"DownArrow": "↓",
	"Downarrow": "⇓",
	"DownArrowUpArrow": "⇵",
	"DownBreve": "̑",
	"downdownarrows": "⇊",
	"downharpoonleft": "⇃",
	"downharpoonright": "⇂",
	"DownLeftRightVector": "⥐",
	"DownLeftTeeVector": "⥞",
	"DownLeftVectorBar": "⥖",
	"DownLeftVector": "↽",
	"DownRightTeeVector": "⥟",
	"DownRightVectorBar": "⥗",
	"DownRightVector": "⇁",
	"DownTeeArrow": "↧",
	"DownTee": "⊤",
	"drbkarow": "⤐",
	"drcorn": "⌟",
	"drcrop": "⌌",
	"Dscr": "𝒟",
	"dscr": "𝒹",
	"DScy": "Ѕ",
	"dscy": "ѕ",
	"dsol": "⧶",
	"Dstrok": "Đ",
	"dstrok": "đ",
	"dtdot": "⋱",
	"dtri": "▿",
	"dtrif": "▾",
	"duarr": "⇵",
	"duhar": "⥯",
	"dwangle": "⦦",
	"DZcy": "Џ",
	"dzcy": "џ",
	"dzigrarr": "⟿",
	"Eacute": "É",
	"eacute": "é",
	"easter": "⩮",
	"Ecaron": "Ě",
	"ecaron": "ě",
	"Ecirc": "Ê",
	"ecirc": "ê",
	"ecir": "≖",
	"ecolon": "≕",
	"Ecy": "Э",
	"ecy": "э",
	"eDDot": "⩷",
	"Edot": "Ė",
	"edot": "ė",
	"eDot": "≑",
	"ee": "ⅇ",
	"efDot": "≒",
	"Efr": "𝔈",
	"efr": "𝔢",
	"eg": "⪚",
	"Egrave": "È",
	"egrave": "è",
	"egs": "⪖",
	"egsdot": "⪘",
	"el": "⪙",
	"Element": "∈",
	"elinters": "⏧",
	"ell": "ℓ",
	"els": "⪕",
	"elsdot": "⪗",
	"Emacr": "Ē",
	"emacr": "ē",
	"empty": "∅",
	"emptyset": "∅",
	"EmptySmallSquare": "◻",
	"emptyv": "∅",
	"EmptyVerySmallSquare": "▫",
	"emsp13": " ",
	"emsp14": " ",
	"emsp": " ",
	"ENG": "Ŋ",
	"eng": "ŋ",
	"ensp": " ",
	"Eogon": "Ę",
	"eogon": "ę",
	"Eopf": "𝔼",
	"eopf": "𝕖",
	"epar": "⋕",
	"eparsl": "⧣",
	"eplus": "⩱",
	"epsi": "ε",
	"Epsilon": "Ε",
	"epsilon": "ε",
	"epsiv": "ϵ",
	"eqcirc": "≖",
	"eqcolon": "≕",
	"eqsim": "≂",
	"eqslantgtr": "⪖",
	"eqslantless": "⪕",
	"Equal": "⩵",
	"equals": "=",
	"EqualTilde": "≂",
	"equest": "≟",
	"Equilibrium": "⇌",
	"equiv": "≡",
	"equivDD": "⩸",
	"eqvparsl": "⧥",
	"erarr": "⥱",
	"erDot": "≓",
	"escr": "ℯ",
	"Escr": "ℰ",
	"esdot": "≐",
	"Esim": "⩳",
	"esim": "≂",
	"Eta": "Η",
	"eta": "η",
	"ETH": "Ð",
	"eth": "ð",
	"Euml": "Ë",
	"euml": "ë",
	"euro": "€",
	"excl": "!",
	"exist": "∃",
	"Exists": "∃",
	"expectation": "ℰ",
	"exponentiale": "ⅇ",
	"ExponentialE": "ⅇ",
	"fallingdotseq": "≒",
	"Fcy": "Ф",
	"fcy": "ф",
	"female": "♀",
	"ffilig": "ﬃ",
	"fflig": "ﬀ",
	"ffllig": "ﬄ",
	"Ffr": "𝔉",
	"ffr": "𝔣",
	"filig": "ﬁ",
	"FilledSmallSquare": "◼",
	"FilledVerySmallSquare": "▪",
	"fjlig": "fj",
	"flat": "♭",
	"fllig": "ﬂ",
	"fltns": "▱",
	"fnof": "ƒ",
	"Fopf": "𝔽",
	"fopf": "𝕗",
	"forall": "∀",
	"ForAll": "∀",
	"fork": "⋔",
	"forkv": "⫙",
	"Fouriertrf": "ℱ",
	"fpartint": "⨍",
	"frac12": "½",
	"frac13": "⅓",
	"frac14": "¼",
	"frac15": "⅕",
	"frac16": "⅙",
	"frac18": "⅛",
	"frac23": "⅔",
	"frac25": "⅖",
	"frac34": "¾",
	"frac35": "⅗",
	"frac38": "⅜",
	"frac45": "⅘",
	"frac56": "⅚",
	"frac58": "⅝",
	"frac78": "⅞",
	"frasl": "⁄",
	"frown": "⌢",
	"fscr": "𝒻",
	"Fscr": "ℱ",
	"gacute": "ǵ",
	"Gamma": "Γ",
	"gamma": "γ",
	"Gammad": "Ϝ",
	"gammad": "ϝ",
	"gap": "⪆",
	"Gbreve": "Ğ",
	"gbreve": "ğ",
	"Gcedil": "Ģ",
	"Gcirc": "Ĝ",
	"gcirc": "ĝ",
	"Gcy": "Г",
	"gcy": "г",
	"Gdot": "Ġ",
	"gdot": "ġ",
	"ge": "≥",
	"gE": "≧",
	"gEl": "⪌",
	"gel": "⋛",
	"geq": "≥",
	"geqq": "≧",
	"geqslant": "⩾",
	"gescc": "⪩",
	"ges": "⩾",
	"gesdot": "⪀",
	"gesdoto": "⪂",
	"gesdotol": "⪄",
	"gesl": "⋛︀",
	"gesles": "⪔",
	"Gfr": "𝔊",
	"gfr": "𝔤",
	"gg": "≫",
	"Gg": "⋙",
	"ggg": "⋙",
	"gimel": "ℷ",
	"GJcy": "Ѓ",
	"gjcy": "ѓ",
	"gla": "⪥",
	"gl": "≷",
	"glE": "⪒",
	"glj": "⪤",
	"gnap": "⪊",
	"gnapprox": "⪊",
	"gne": "⪈",
	"gnE": "≩",
	"gneq": "⪈",
	"gneqq": "≩",
	"gnsim": "⋧",
	"Gopf": "𝔾",
	"gopf": "𝕘",
	"grave": "`",
	"GreaterEqual": "≥",
	"GreaterEqualLess": "⋛",
	"GreaterFullEqual": "≧",
	"GreaterGreater": "⪢",
	"GreaterLess": "≷",
	"GreaterSlantEqual": "⩾",
	"GreaterTilde": "≳",
	"Gscr": "𝒢",
	"gscr": "ℊ",
	"gsim": "≳",
	"gsime": "⪎",
	"gsiml": "⪐",
	"gtcc": "⪧",
	"gtcir": "⩺",
	"gt": ">",
	"GT": ">",
	"Gt": "≫",
	"gtdot": "⋗",
	"gtlPar": "⦕",
	"gtquest": "⩼",
	"gtrapprox": "⪆",
	"gtrarr": "⥸",
	"gtrdot": "⋗",
	"gtreqless": "⋛",
	"gtreqqless": "⪌",
	"gtrless": "≷",
	"gtrsim": "≳",
	"gvertneqq": "≩︀",
	"gvnE": "≩︀",
	"Hacek": "ˇ",
	"hairsp": " ",
	"half": "½",
	"hamilt": "ℋ",
	"HARDcy": "Ъ",
	"hardcy": "ъ",
	"harrcir": "⥈",
	"harr": "↔",
	"hArr": "⇔",
	"harrw": "↭",
	"Hat": "^",
	"hbar": "ℏ",
	"Hcirc": "Ĥ",
	"hcirc": "ĥ",
	"hearts": "♥",
	"heartsuit": "♥",
	"hellip": "…",
	"hercon": "⊹",
	"hfr": "𝔥",
	"Hfr": "ℌ",
	"HilbertSpace": "ℋ",
	"hksearow": "⤥",
	"hkswarow": "⤦",
	"hoarr": "⇿",
	"homtht": "∻",
	"hookleftarrow": "↩",
	"hookrightarrow": "↪",
	"hopf": "𝕙",
	"Hopf": "ℍ",
	"horbar": "―",
	"HorizontalLine": "─",
	"hscr": "𝒽",
	"Hscr": "ℋ",
	"hslash": "ℏ",
	"Hstrok": "Ħ",
	"hstrok": "ħ",
	"HumpDownHump": "≎",
	"HumpEqual": "≏",
	"hybull": "⁃",
	"hyphen": "‐",
	"Iacute": "Í",
	"iacute": "í",
	"ic": "⁣",
	"Icirc": "Î",
	"icirc": "î",
	"Icy": "И",
	"icy": "и",
	"Idot": "İ",
	"IEcy": "Е",
	"iecy": "е",
	"iexcl": "¡",
	"iff": "⇔",
	"ifr": "𝔦",
	"Ifr": "ℑ",
	"Igrave": "Ì",
	"igrave": "ì",
	"ii": "ⅈ",
	"iiiint": "⨌",
	"iiint": "∭",
	"iinfin": "⧜",
	"iiota": "℩",
	"IJlig": "Ĳ",
	"ijlig": "ĳ",
	"Imacr": "Ī",
	"imacr": "ī",
	"image": "ℑ",
	"ImaginaryI": "ⅈ",
	"imagline": "ℐ",
	"imagpart": "ℑ",
	"imath": "ı",
	"Im": "ℑ",
	"imof": "⊷",
	"imped": "Ƶ",
	"Implies": "⇒",
	"incare": "℅",
	"in": "∈",
	"infin": "∞",
	"infintie": "⧝",
	"inodot": "ı",
	"intcal": "⊺",
	"int": "∫",
	"Int": "∬",
	"integers": "ℤ",
	"Integral": "∫",
	"intercal": "⊺",
	"Intersection": "⋂",
	"intlarhk": "⨗",
	"intprod": "⨼",
	"InvisibleComma": "⁣",
	"InvisibleTimes": "⁢",
	"IOcy": "Ё",
	"iocy": "ё",
	"Iogon": "Į",
	"iogon": "į",
	"Iopf": "𝕀",
	"iopf": "𝕚",
	"Iota": "Ι",
	"iota": "ι",
	"iprod": "⨼",
	"iquest": "¿",
	"iscr": "𝒾",
	"Iscr": "ℐ",
	"isin": "∈",
	"isindot": "⋵",
	"isinE": "⋹",
	"isins": "⋴",
	"isinsv": "⋳",
	"isinv": "∈",
	"it": "⁢",
	"Itilde": "Ĩ",
	"itilde": "ĩ",
	"Iukcy": "І",
	"iukcy": "і",
	"Iuml": "Ï",
	"iuml": "ï",
	"Jcirc": "Ĵ",
	"jcirc": "ĵ",
	"Jcy": "Й",
	"jcy": "й",
	"Jfr": "𝔍",
	"jfr": "𝔧",
	"jmath": "ȷ",
	"Jopf": "𝕁",
	"jopf": "𝕛",
	"Jscr": "𝒥",
	"jscr": "𝒿",
	"Jsercy": "Ј",
	"jsercy": "ј",
	"Jukcy": "Є",
	"jukcy": "є",
	"Kappa": "Κ",
	"kappa": "κ",
	"kappav": "ϰ",
	"Kcedil": "Ķ",
	"kcedil": "ķ",
	"Kcy": "К",
	"kcy": "к",
	"Kfr": "𝔎",
	"kfr": "𝔨",
	"kgreen": "ĸ",
	"KHcy": "Х",
	"khcy": "х",
	"KJcy": "Ќ",
	"kjcy": "ќ",
	"Kopf": "𝕂",
	"kopf": "𝕜",
	"Kscr": "𝒦",
	"kscr": "𝓀",
	"lAarr": "⇚",
	"Lacute": "Ĺ",
	"lacute": "ĺ",
	"laemptyv": "⦴",
	"lagran": "ℒ",
	"Lambda": "Λ",
	"lambda": "λ",
	"lang": "⟨",
	"Lang": "⟪",
	"langd": "⦑",
	"langle": "⟨",
	"lap": "⪅",
	"Laplacetrf": "ℒ",
	"laquo": "«",
	"larrb": "⇤",
	"larrbfs": "⤟",
	"larr": "←",
	"Larr": "↞",
	"lArr": "⇐",
	"larrfs": "⤝",
	"larrhk": "↩",
	"larrlp": "↫",
	"larrpl": "⤹",
	"larrsim": "⥳",
	"larrtl": "↢",
	"latail": "⤙",
	"lAtail": "⤛",
	"lat": "⪫",
	"late": "⪭",
	"lates": "⪭︀",
	"lbarr": "⤌",
	"lBarr": "⤎",
	"lbbrk": "❲",
	"lbrace": "{",
	"lbrack": "[",
	"lbrke": "⦋",
	"lbrksld": "⦏",
	"lbrkslu": "⦍",
	"Lcaron": "Ľ",
	"lcaron": "ľ",
	"Lcedil": "Ļ",
	"lcedil": "ļ",
	"lceil": "⌈",
	"lcub": "{",
	"Lcy": "Л",
	"lcy": "л",
	"ldca": "⤶",
	"ldquo": "“",
	"ldquor": "„",
	"ldrdhar": "⥧",
	"ldrushar": "⥋",
	"ldsh": "↲",
	"le": "≤",
	"lE": "≦",
	"LeftAngleBracket": "⟨",
	"LeftArrowBar": "⇤",
	"leftarrow": "←",
	"LeftArrow": "←",
	"Leftarrow": "⇐",
	"LeftArrowRightArrow": "⇆",
	"leftarrowtail": "↢",
	"LeftCeiling": "⌈",
	"LeftDoubleBracket": "⟦",
	"LeftDownTeeVector": "⥡",
	"LeftDownVectorBar": "⥙",
	"LeftDownVector": "⇃",
	"LeftFloor": "⌊",
	"leftharpoondown": "↽",
	"leftharpoonup": "↼",
	"leftleftarrows": "⇇",
	"leftrightarrow": "↔",
	"LeftRightArrow": "↔",
	"Leftrightarrow": "⇔",
	"leftrightarrows": "⇆",
	"leftrightharpoons": "⇋",
	"leftrightsquigarrow": "↭",
	"LeftRightVector": "⥎",
	"LeftTeeArrow": "↤",
	"LeftTee": "⊣",
	"LeftTeeVector": "⥚",
	"leftthreetimes": "⋋",
	"LeftTriangleBar": "⧏",
	"LeftTriangle": "⊲",
	"LeftTriangleEqual": "⊴",
	"LeftUpDownVector": "⥑",
	"LeftUpTeeVector": "⥠",
	"LeftUpVectorBar": "⥘",
	"LeftUpVector": "↿",
	"LeftVectorBar": "⥒",
	"LeftVector": "↼",
	"lEg": "⪋",
	"leg": "⋚",
	"leq": "≤",
	"leqq": "≦",
	"leqslant": "⩽",
	"lescc": "⪨",
	"les": "⩽",
	"lesdot": "⩿",
	"lesdoto": "⪁",
	"lesdotor": "⪃",
	"lesg": "⋚︀",
	"lesges": "⪓",
	"lessapprox": "⪅",
	"lessdot": "⋖",
	"lesseqgtr": "⋚",
	"lesseqqgtr": "⪋",
	"LessEqualGreater": "⋚",
	"LessFullEqual": "≦",
	"LessGreater": "≶",
	"lessgtr": "≶",
	"LessLess": "⪡",
	"lesssim": "≲",
	"LessSlantEqual": "⩽",
	"LessTilde": "≲",
	"lfisht": "⥼",
	"lfloor": "⌊",
	"Lfr": "𝔏",
	"lfr": "𝔩",
	"lg": "≶",
	"lgE": "⪑",
	"lHar": "⥢",
	"lhard": "↽",
	"lharu": "↼",
	"lharul": "⥪",
	"lhblk": "▄",
	"LJcy": "Љ",
	"ljcy": "љ",
	"llarr": "⇇",
	"ll": "≪",
	"Ll": "⋘",
	"llcorner": "⌞",
	"Lleftarrow": "⇚",
	"llhard": "⥫",
	"lltri": "◺",
	"Lmidot": "Ŀ",
	"lmidot": "ŀ",
	"lmoustache": "⎰",
	"lmoust": "⎰",
	"lnap": "⪉",
	"lnapprox": "⪉",
	"lne": "⪇",
	"lnE": "≨",
	"lneq": "⪇",
	"lneqq": "≨",
	"lnsim": "⋦",
	"loang": "⟬",
	"loarr": "⇽",
	"lobrk": "⟦",
	"longleftarrow": "⟵",
	"LongLeftArrow": "⟵",
	"Longleftarrow": "⟸",
	"longleftrightarrow": "⟷",
	"LongLeftRightArrow": "⟷",
	"Longleftrightarrow": "⟺",
	"longmapsto": "⟼",
	"longrightarrow": "⟶",
	"LongRightArrow": "⟶",
	"Longrightarrow": "⟹",
	"looparrowleft": "↫",
	"looparrowright": "↬",
	"lopar": "⦅",
	"Lopf": "𝕃",
	"lopf": "𝕝",
	"loplus": "⨭",
	"lotimes": "⨴",
	"lowast": "∗",
	"lowbar": "_",
	"LowerLeftArrow": "↙",
	"LowerRightArrow": "↘",
	"loz": "◊",
	"lozenge": "◊",
	"lozf": "⧫",
	"lpar": "(",
	"lparlt": "⦓",
	"lrarr": "⇆",
	"lrcorner": "⌟",
	"lrhar": "⇋",
	"lrhard": "⥭",
	"lrm": "‎",
	"lrtri": "⊿",
	"lsaquo": "‹",
	"lscr": "𝓁",
	"Lscr": "ℒ",
	"lsh": "↰",
	"Lsh": "↰",
	"lsim": "≲",
	"lsime": "⪍",
	"lsimg": "⪏",
	"lsqb": "[",
	"lsquo": "‘",
	"lsquor": "‚",
	"Lstrok": "Ł",
	"lstrok": "ł",
	"ltcc": "⪦",
	"ltcir": "⩹",
	"lt": "<",
	"LT": "<",
	"Lt": "≪",
	"ltdot": "⋖",
	"lthree": "⋋",
	"ltimes": "⋉",
	"ltlarr": "⥶",
	"ltquest": "⩻",
	"ltri": "◃",
	"ltrie": "⊴",
	"ltrif": "◂",
	"ltrPar": "⦖",
	"lurdshar": "⥊",
	"luruhar": "⥦",
	"lvertneqq": "≨︀",
	"lvnE": "≨︀",
	"macr": "¯",
	"male": "♂",
	"malt": "✠",
	"maltese": "✠",
	"Map": "⤅",
	"map": "↦",
	"mapsto": "↦",
	"mapstodown": "↧",
	"mapstoleft": "↤",
	"mapstoup": "↥",
	"marker": "▮",
	"mcomma": "⨩",
	"Mcy": "М",
	"mcy": "м",
	"mdash": "—",
	"mDDot": "∺",
	"measuredangle": "∡",
	"MediumSpace": " ",
	"Mellintrf": "ℳ",
	"Mfr": "𝔐",
	"mfr": "𝔪",
	"mho": "℧",
	"micro": "µ",
	"midast": "*",
	"midcir": "⫰",
	"mid": "∣",
	"middot": "·",
	"minusb": "⊟",
	"minus": "−",
	"minusd": "∸",
	"minusdu": "⨪",
	"MinusPlus": "∓",
	"mlcp": "⫛",
	"mldr": "…",
	"mnplus": "∓",
	"models": "⊧",
	"Mopf": "𝕄",
	"mopf": "𝕞",
	"mp": "∓",
	"mscr": "𝓂",
	"Mscr": "ℳ",
	"mstpos": "∾",
	"Mu": "Μ",
	"mu": "μ",
	"multimap": "⊸",
	"mumap": "⊸",
	"nabla": "∇",
	"Nacute": "Ń",
	"nacute": "ń",
	"nang": "∠⃒",
	"nap": "≉",
	"napE": "⩰̸",
	"napid": "≋̸",
	"napos": "ŉ",
	"napprox": "≉",
	"natural": "♮",
	"naturals": "ℕ",
	"natur": "♮",
	"nbsp": " ",
	"nbump": "≎̸",
	"nbumpe": "≏̸",
	"ncap": "⩃",
	"Ncaron": "Ň",
	"ncaron": "ň",
	"Ncedil": "Ņ",
	"ncedil": "ņ",
	"ncong": "≇",
	"ncongdot": "⩭̸",
	"ncup": "⩂",
	"Ncy": "Н",
	"ncy": "н",
	"ndash": "–",
	"nearhk": "⤤",
	"nearr": "↗",
	"neArr": "⇗",
	"nearrow": "↗",
	"ne": "≠",
	"nedot": "≐̸",
	"NegativeMediumSpace": "​",
	"NegativeThickSpace": "​",
	"NegativeThinSpace": "​",
	"NegativeVeryThinSpace": "​",
	"nequiv": "≢",
	"nesear": "⤨",
	"nesim": "≂̸",
	"NestedGreaterGreater": "≫",
	"NestedLessLess": "≪",
	"NewLine": "\n",
	"nexist": "∄",
	"nexists": "∄",
	"Nfr": "𝔑",
	"nfr": "𝔫",
	"ngE": "≧̸",
	"nge": "≱",
	"ngeq": "≱",
	"ngeqq": "≧̸",
	"ngeqslant": "⩾̸",
	"nges": "⩾̸",
	"nGg": "⋙̸",
	"ngsim": "≵",
	"nGt": "≫⃒",
	"ngt": "≯",
	"ngtr": "≯",
	"nGtv": "≫̸",
	"nharr": "↮",
	"nhArr": "⇎",
	"nhpar": "⫲",
	"ni": "∋",
	"nis": "⋼",
	"nisd": "⋺",
	"niv": "∋",
	"NJcy": "Њ",
	"njcy": "њ",
	"nlarr": "↚",
	"nlArr": "⇍",
	"nldr": "‥",
	"nlE": "≦̸",
	"nle": "≰",
	"nleftarrow": "↚",
	"nLeftarrow": "⇍",
	"nleftrightarrow": "↮",
	"nLeftrightarrow": "⇎",
	"nleq": "≰",
	"nleqq": "≦̸",
	"nleqslant": "⩽̸",
	"nles": "⩽̸",
	"nless": "≮",
	"nLl": "⋘̸",
	"nlsim": "≴",
	"nLt": "≪⃒",
	"nlt": "≮",
	"nltri": "⋪",
	"nltrie": "⋬",
	"nLtv": "≪̸",
	"nmid": "∤",
	"NoBreak": "⁠",
	"NonBreakingSpace": " ",
	"nopf": "𝕟",
	"Nopf": "ℕ",
	"Not": "⫬",
	"not": "¬",
	"NotCongruent": "≢",
	"NotCupCap": "≭",
	"NotDoubleVerticalBar": "∦",
	"NotElement": "∉",
	"NotEqual": "≠",
	"NotEqualTilde": "≂̸",
	"NotExists": "∄",
	"NotGreater": "≯",
	"NotGreaterEqual": "≱",
	"NotGreaterFullEqual": "≧̸",
	"NotGreaterGreater": "≫̸",
	"NotGreaterLess": "≹",
	"NotGreaterSlantEqual": "⩾̸",
	"NotGreaterTilde": "≵",
	"NotHumpDownHump": "≎̸",
	"NotHumpEqual": "≏̸",
	"notin": "∉",
	"notindot": "⋵̸",
	"notinE": "⋹̸",
	"notinva": "∉",
	"notinvb": "⋷",
	"notinvc": "⋶",
	"NotLeftTriangleBar": "⧏̸",
	"NotLeftTriangle": "⋪",
	"NotLeftTriangleEqual": "⋬",
	"NotLess": "≮",
	"NotLessEqual": "≰",
	"NotLessGreater": "≸",
	"NotLessLess": "≪̸",
	"NotLessSlantEqual": "⩽̸",
	"NotLessTilde": "≴",
	"NotNestedGreaterGreater": "⪢̸",
	"NotNestedLessLess": "⪡̸",
	"notni": "∌",
	"notniva": "∌",
	"notnivb": "⋾",
	"notnivc": "⋽",
	"NotPrecedes": "⊀",
	"NotPrecedesEqual": "⪯̸",
	"NotPrecedesSlantEqual": "⋠",
	"NotReverseElement": "∌",
	"NotRightTriangleBar": "⧐̸",
	"NotRightTriangle": "⋫",
	"NotRightTriangleEqual": "⋭",
	"NotSquareSubset": "⊏̸",
	"NotSquareSubsetEqual": "⋢",
	"NotSquareSuperset": "⊐̸",
	"NotSquareSupersetEqual": "⋣",
	"NotSubset": "⊂⃒",
	"NotSubsetEqual": "⊈",
	"NotSucceeds": "⊁",
	"NotSucceedsEqual": "⪰̸",
	"NotSucceedsSlantEqual": "⋡",
	"NotSucceedsTilde": "≿̸",
	"NotSuperset": "⊃⃒",
	"NotSupersetEqual": "⊉",
	"NotTilde": "≁",
	"NotTildeEqual": "≄",
	"NotTildeFullEqual": "≇",
	"NotTildeTilde": "≉",
	"NotVerticalBar": "∤",
	"nparallel": "∦",
	"npar": "∦",
	"nparsl": "⫽⃥",
	"npart": "∂̸",
	"npolint": "⨔",
	"npr": "⊀",
	"nprcue": "⋠",
	"nprec": "⊀",
	"npreceq": "⪯̸",
	"npre": "⪯̸",
	"nrarrc": "⤳̸",
	"nrarr": "↛",
	"nrArr": "⇏",
	"nrarrw": "↝̸",
	"nrightarrow": "↛",
	"nRightarrow": "⇏",
	"nrtri": "⋫",
	"nrtrie": "⋭",
	"nsc": "⊁",
	"nsccue": "⋡",
	"nsce": "⪰̸",
	"Nscr": "𝒩",
	"nscr": "𝓃",
	"nshortmid": "∤",
	"nshortparallel": "∦",
	"nsim": "≁",
	"nsime": "≄",
	"nsimeq": "≄",
	"nsmid": "∤",
	"nspar": "∦",
	"nsqsube": "⋢",
	"nsqsupe": "⋣",
	"nsub": "⊄",
	"nsubE": "⫅̸",
	"nsube": "⊈",
	"nsubset": "⊂⃒",
	"nsubseteq": "⊈",
	"nsubseteqq": "⫅̸",
	"nsucc": "⊁",
	"nsucceq": "⪰̸",
	"nsup": "⊅",
	"nsupE": "⫆̸",
	"nsupe": "⊉",
	"nsupset": "⊃⃒",
	"nsupseteq": "⊉",
	"nsupseteqq": "⫆̸",
	"ntgl": "≹",
	"Ntilde": "Ñ",
	"ntilde": "ñ",
	"ntlg": "≸",
	"ntriangleleft": "⋪",
	"ntrianglelefteq": "⋬",
	"ntriangleright": "⋫",
	"ntrianglerighteq": "⋭",
	"Nu": "Ν",
	"nu": "ν",
	"num": "#",
	"numero": "№",
	"numsp": " ",
	"nvap": "≍⃒",
	"nvdash": "⊬",
	"nvDash": "⊭",
	"nVdash": "⊮",
	"nVDash": "⊯",
	"nvge": "≥⃒",
	"nvgt": ">⃒",
	"nvHarr": "⤄",
	"nvinfin": "⧞",
	"nvlArr": "⤂",
	"nvle": "≤⃒",
	"nvlt": "<⃒",
	"nvltrie": "⊴⃒",
	"nvrArr": "⤃",
	"nvrtrie": "⊵⃒",
	"nvsim": "∼⃒",
	"nwarhk": "⤣",
	"nwarr": "↖",
	"nwArr": "⇖",
	"nwarrow": "↖",
	"nwnear": "⤧",
	"Oacute": "Ó",
	"oacute": "ó",
	"oast": "⊛",
	"Ocirc": "Ô",
	"ocirc": "ô",
	"ocir": "⊚",
	"Ocy": "О",
	"ocy": "о",
	"odash": "⊝",
	"Odblac": "Ő",
	"odblac": "ő",
	"odiv": "⨸",
	"odot": "⊙",
	"odsold": "⦼",
	"OElig": "Œ",
	"oelig": "œ",
	"ofcir": "⦿",
	"Ofr": "𝔒",
	"ofr": "𝔬",
	"ogon": "˛",
	"Ograve": "Ò",
	"ograve": "ò",
	"ogt": "⧁",
	"ohbar": "⦵",
	"ohm": "Ω",
	"oint": "∮",
	"olarr": "↺",
	"olcir": "⦾",
	"olcross": "⦻",
	"oline": "‾",
	"olt": "⧀",
	"Omacr": "Ō",
	"omacr": "ō",
	"Omega": "Ω",
	"omega": "ω",
	"Omicron": "Ο",
	"omicron": "ο",
	"omid": "⦶",
	"ominus": "⊖",
	"Oopf": "𝕆",
	"oopf": "𝕠",
	"opar": "⦷",
	"OpenCurlyDoubleQuote": "“",
	"OpenCurlyQuote": "‘",
	"operp": "⦹",
	"oplus": "⊕",
	"orarr": "↻",
	"Or": "⩔",
	"or": "∨",
	"ord": "⩝",
	"order": "ℴ",
	"orderof": "ℴ",
	"ordf": "ª",
	"ordm": "º",
	"origof": "⊶",
	"oror": "⩖",
	"orslope": "⩗",
	"orv": "⩛",
	"oS": "Ⓢ",
	"Oscr": "𝒪",
	"oscr": "ℴ",
	"Oslash": "Ø",
	"oslash": "ø",
	"osol": "⊘",
	"Otilde": "Õ",
	"otilde": "õ",
	"otimesas": "⨶",
	"Otimes": "⨷",
	"otimes": "⊗",
	"Ouml": "Ö",
	"ouml": "ö",
	"ovbar": "⌽",
	"OverBar": "‾",
	"OverBrace": "⏞",
	"OverBracket": "⎴",
	"OverParenthesis": "⏜",
	"para": "¶",
	"parallel": "∥",
	"par": "∥",
	"parsim": "⫳",
	"parsl": "⫽",
	"part": "∂",
	"PartialD": "∂",
	"Pcy": "П",
	"pcy": "п",
	"percnt": "%",
	"period": ".",
	"permil": "‰",
	"perp": "⊥",
	"pertenk": "‱",
	"Pfr": "𝔓",
	"pfr": "𝔭",
	"Phi": "Φ",
	"phi": "φ",
	"phiv": "ϕ",
	"phmmat": "ℳ",
	"phone": "☎",
	"Pi": "Π",
	"pi": "π",
	"pitchfork": "⋔",
	"piv": "ϖ",
	"planck": "ℏ",
	"planckh": "ℎ",
	"plankv": "ℏ",
	"plusacir": "⨣",
	"plusb": "⊞",
	"pluscir": "⨢",
	"plus": "+",
	"plusdo": "∔",
	"plusdu": "⨥",
	"pluse": "⩲",
	"PlusMinus": "±",
	"plusmn": "±",
	"plussim": "⨦",
	"plustwo": "⨧",
	"pm": "±",
	"Poincareplane": "ℌ",
	"pointint": "⨕",
	"popf": "𝕡",
	"Popf": "ℙ",
	"pound": "£",
	"prap": "⪷",
	"Pr": "⪻",
	"pr": "≺",
	"prcue": "≼",
	"precapprox": "⪷",
	"prec": "≺",
	"preccurlyeq": "≼",
	"Precedes": "≺",
	"PrecedesEqual": "⪯",
	"PrecedesSlantEqual": "≼",
	"PrecedesTilde": "≾",
	"preceq": "⪯",
	"precnapprox": "⪹",
	"precneqq": "⪵",
	"precnsim": "⋨",
	"pre": "⪯",
	"prE": "⪳",
	"precsim": "≾",
	"prime": "′",
	"Prime": "″",
	"primes": "ℙ",
	"prnap": "⪹",
	"prnE": "⪵",
	"prnsim": "⋨",
	"prod": "∏",
	"Product": "∏",
	"profalar": "⌮",
	"profline": "⌒",
	"profsurf": "⌓",
	"prop": "∝",
	"Proportional": "∝",
	"Proportion": "∷",
	"propto": "∝",
	"prsim": "≾",
	"prurel": "⊰",
	"Pscr": "𝒫",
	"pscr": "𝓅",
	"Psi": "Ψ",
	"psi": "ψ",
	"puncsp": " ",
	"Qfr": "𝔔",
	"qfr": "𝔮",
	"qint": "⨌",
	"qopf": "𝕢",
	"Qopf": "ℚ",
	"qprime": "⁗",
	"Qscr": "𝒬",
	"qscr": "𝓆",
	"quaternions": "ℍ",
	"quatint": "⨖",
	"quest": "?",
	"questeq": "≟",
	"quot": "\"",
	"QUOT": "\"",
	"rAarr": "⇛",
	"race": "∽̱",
	"Racute": "Ŕ",
	"racute": "ŕ",
	"radic": "√",
	"raemptyv": "⦳",
	"rang": "⟩",
	"Rang": "⟫",
	"rangd": "⦒",
	"range": "⦥",
	"rangle": "⟩",
	"raquo": "»",
	"rarrap": "⥵",
	"rarrb": "⇥",
	"rarrbfs": "⤠",
	"rarrc": "⤳",
	"rarr": "→",
	"Rarr": "↠",
	"rArr": "⇒",
	"rarrfs": "⤞",
	"rarrhk": "↪",
	"rarrlp": "↬",
	"rarrpl": "⥅",
	"rarrsim": "⥴",
	"Rarrtl": "⤖",
	"rarrtl": "↣",
	"rarrw": "↝",
	"ratail": "⤚",
	"rAtail": "⤜",
	"ratio": "∶",
	"rationals": "ℚ",
	"rbarr": "⤍",
	"rBarr": "⤏",
	"RBarr": "⤐",
	"rbbrk": "❳",
	"rbrace": "}",
	"rbrack": "]",
	"rbrke": "⦌",
	"rbrksld": "⦎",
	"rbrkslu": "⦐",
	"Rcaron": "Ř",
	"rcaron": "ř",
	"Rcedil": "Ŗ",
	"rcedil": "ŗ",
	"rceil": "⌉",
	"rcub": "}",
	"Rcy": "Р",
	"rcy": "р",
	"rdca": "⤷",
	"rdldhar": "⥩",
	"rdquo": "”",
	"rdquor": "”",
	"rdsh": "↳",
	"real": "ℜ",
	"realine": "ℛ",
	"realpart": "ℜ",
	"reals": "ℝ",
	"Re": "ℜ",
	"rect": "▭",
	"reg": "®",
	"REG": "®",
	"ReverseElement": "∋",
	"ReverseEquilibrium": "⇋",
	"ReverseUpEquilibrium": "⥯",
	"rfisht": "⥽",
	"rfloor": "⌋",
	"rfr": "𝔯",
	"Rfr": "ℜ",
	"rHar": "⥤",
	"rhard": "⇁",
	"rharu": "⇀",
	"rharul": "⥬",
	"Rho": "Ρ",
	"rho": "ρ",
	"rhov": "ϱ",
	"RightAngleBracket": "⟩",
	"RightArrowBar": "⇥",
	"rightarrow": "→",
	"RightArrow": "→",
	"Rightarrow": "⇒",
	"RightArrowLeftArrow": "⇄",
	"rightarrowtail": "↣",
	"RightCeiling": "⌉",
	"RightDoubleBracket": "⟧",
	"RightDownTeeVector": "⥝",
	"RightDownVectorBar": "⥕",
	"RightDownVector": "⇂",
	"RightFloor": "⌋",
	"rightharpoondown": "⇁",
	"rightharpoonup": "⇀",
	"rightleftarrows": "⇄",
	"rightleftharpoons": "⇌",
	"rightrightarrows": "⇉",
	"rightsquigarrow": "↝",
	"RightTeeArrow": "↦",
	"RightTee": "⊢",
	"RightTeeVector": "⥛",
	"rightthreetimes": "⋌",
	"RightTriangleBar": "⧐",
	"RightTriangle": "⊳",
	"RightTriangleEqual": "⊵",
	"RightUpDownVector": "⥏",
	"RightUpTeeVector": "⥜",
	"RightUpVectorBar": "⥔",
	"RightUpVector": "↾",
	"RightVectorBar": "⥓",
	"RightVector": "⇀",
	"ring": "˚",
	"risingdotseq": "≓",
	"rlarr": "⇄",
	"rlhar": "⇌",
	"rlm": "‏",
	"rmoustache": "⎱",
	"rmoust": "⎱",
	"rnmid": "⫮",
	"roang": "⟭",
	"roarr": "⇾",
	"robrk": "⟧",
	"ropar": "⦆",
	"ropf": "𝕣",
	"Ropf": "ℝ",
	"roplus": "⨮",
	"rotimes": "⨵",
	"RoundImplies": "⥰",
	"rpar": ")",
	"rpargt": "⦔",
	"rppolint": "⨒",
	"rrarr": "⇉",
	"Rrightarrow": "⇛",
	"rsaquo": "›",
	"rscr": "𝓇",
	"Rscr": "ℛ",
	"rsh": "↱",
	"Rsh": "↱",
	"rsqb": "]",
	"rsquo": "’",
	"rsquor": "’",
	"rthree": "⋌",
	"rtimes": "⋊",
	"rtri": "▹",
	"rtrie": "⊵",
	"rtrif": "▸",
	"rtriltri": "⧎",
	"RuleDelayed": "⧴",
	"ruluhar": "⥨",
	"rx": "℞",
	"Sacute": "Ś",
	"sacute": "ś",
	"sbquo": "‚",
	"scap": "⪸",
	"Scaron": "Š",
	"scaron": "š",
	"Sc": "⪼",
	"sc": "≻",
	"sccue": "≽",
	"sce": "⪰",
	"scE": "⪴",
	"Scedil": "Ş",
	"scedil": "ş",
	"Scirc": "Ŝ",
	"scirc": "ŝ",
	"scnap": "⪺",
	"scnE": "⪶",
	"scnsim": "⋩",
	"scpolint": "⨓",
	"scsim": "≿",
	"Scy": "С",
	"scy": "с",
	"sdotb": "⊡",
	"sdot": "⋅",
	"sdote": "⩦",
	"searhk": "⤥",
	"searr": "↘",
	"seArr": "⇘",
	"searrow": "↘",
	"sect": "§",
	"semi": ";",
	"seswar": "⤩",
	"setminus": "∖",
	"setmn": "∖",
	"sext": "✶",
	"Sfr": "𝔖",
	"sfr": "𝔰",
	"sfrown": "⌢",
	"sharp": "♯",
	"SHCHcy": "Щ",
	"shchcy": "щ",
	"SHcy": "Ш",
	"shcy": "ш",
	"ShortDownArrow": "↓",
	"ShortLeftArrow": "←",
	"shortmid": "∣",
	"shortparallel": "∥",
	"ShortRightArrow": "→",
	"ShortUpArrow": "↑",
	"shy": "­",
	"Sigma": "Σ",
	"sigma": "σ",
	"sigmaf": "ς",
	"sigmav": "ς",
	"sim": "∼",
	"simdot": "⩪",
	"sime": "≃",
	"simeq": "≃",
	"simg": "⪞",
	"simgE": "⪠",
	"siml": "⪝",
	"simlE": "⪟",
	"simne": "≆",
	"simplus": "⨤",
	"simrarr": "⥲",
	"slarr": "←",
	"SmallCircle": "∘",
	"smallsetminus": "∖",
	"smashp": "⨳",
	"smeparsl": "⧤",
	"smid": "∣",
	"smile": "⌣",
	"smt": "⪪",
	"smte": "⪬",
	"smtes": "⪬︀",
	"SOFTcy": "Ь",
	"softcy": "ь",
	"solbar": "⌿",
	"solb": "⧄",
	"sol": "/",
	"Sopf": "𝕊",
	"sopf": "𝕤",
	"spades": "♠",
	"spadesuit": "♠",
	"spar": "∥",
	"sqcap": "⊓",
	"sqcaps": "⊓︀",
	"sqcup": "⊔",
	"sqcups": "⊔︀",
	"Sqrt": "√",
	"sqsub": "⊏",
	"sqsube": "⊑",
	"sqsubset": "⊏",
	"sqsubseteq": "⊑",
	"sqsup": "⊐",
	"sqsupe": "⊒",
	"sqsupset": "⊐",
	"sqsupseteq": "⊒",
	"square": "□",
	"Square": "□",
	"SquareIntersection": "⊓",
	"SquareSubset": "⊏",
	"SquareSubsetEqual": "⊑",
	"SquareSuperset": "⊐",
	"SquareSupersetEqual": "⊒",
	"SquareUnion": "⊔",
	"squarf": "▪",
	"squ": "□",
	"squf": "▪",
	"srarr": "→",
	"Sscr": "𝒮",
	"sscr": "𝓈",
	"ssetmn": "∖",
	"ssmile": "⌣",
	"sstarf": "⋆",
	"Star": "⋆",
	"star": "☆",
	"starf": "★",
	"straightepsilon": "ϵ",
	"straightphi": "ϕ",
	"strns": "¯",
	"sub": "⊂",
	"Sub": "⋐",
	"subdot": "⪽",
	"subE": "⫅",
	"sube": "⊆",
	"subedot": "⫃",
	"submult": "⫁",
	"subnE": "⫋",
	"subne": "⊊",
	"subplus": "⪿",
	"subrarr": "⥹",
	"subset": "⊂",
	"Subset": "⋐",
	"subseteq": "⊆",
	"subseteqq": "⫅",
	"SubsetEqual": "⊆",
	"subsetneq": "⊊",
	"subsetneqq": "⫋",
	"subsim": "⫇",
	"subsub": "⫕",
	"subsup": "⫓",
	"succapprox": "⪸",
	"succ": "≻",
	"succcurlyeq": "≽",
	"Succeeds": "≻",
	"SucceedsEqual": "⪰",
	"SucceedsSlantEqual": "≽",
	"SucceedsTilde": "≿",
	"succeq": "⪰",
	"succnapprox": "⪺",
	"succneqq": "⪶",
	"succnsim": "⋩",
	"succsim": "≿",
	"SuchThat": "∋",
	"sum": "∑",
	"Sum": "∑",
	"sung": "♪",
	"sup1": "¹",
	"sup2": "²",
	"sup3": "³",
	"sup": "⊃",
	"Sup": "⋑",
	"supdot": "⪾",
	"supdsub": "⫘",
	"supE": "⫆",
	"supe": "⊇",
	"supedot": "⫄",
	"Superset": "⊃",
	"SupersetEqual": "⊇",
	"suphsol": "⟉",
	"suphsub": "⫗",
	"suplarr": "⥻",
	"supmult": "⫂",
	"supnE": "⫌",
	"supne": "⊋",
	"supplus": "⫀",
	"supset": "⊃",
	"Supset": "⋑",
	"supseteq": "⊇",
	"supseteqq": "⫆",
	"supsetneq": "⊋",
	"supsetneqq": "⫌",
	"supsim": "⫈",
	"supsub": "⫔",
	"supsup": "⫖",
	"swarhk": "⤦",
	"swarr": "↙",
	"swArr": "⇙",
	"swarrow": "↙",
	"swnwar": "⤪",
	"szlig": "ß",
	"Tab": "\t",
	"target": "⌖",
	"Tau": "Τ",
	"tau": "τ",
	"tbrk": "⎴",
	"Tcaron": "Ť",
	"tcaron": "ť",
	"Tcedil": "Ţ",
	"tcedil": "ţ",
	"Tcy": "Т",
	"tcy": "т",
	"tdot": "⃛",
	"telrec": "⌕",
	"Tfr": "𝔗",
	"tfr": "𝔱",
	"there4": "∴",
	"therefore": "∴",
	"Therefore": "∴",
	"Theta": "Θ",
	"theta": "θ",
	"thetasym": "ϑ",
	"thetav": "ϑ",
	"thickapprox": "≈",
	"thicksim": "∼",
	"ThickSpace": "  ",
	"ThinSpace": " ",
	"thinsp": " ",
	"thkap": "≈",
	"thksim": "∼",
	"THORN": "Þ",
	"thorn": "þ",
	"tilde": "˜",
	"Tilde": "∼",
	"TildeEqual": "≃",
	"TildeFullEqual": "≅",
	"TildeTilde": "≈",
	"timesbar": "⨱",
	"timesb": "⊠",
	"times": "×",
	"timesd": "⨰",
	"tint": "∭",
	"toea": "⤨",
	"topbot": "⌶",
	"topcir": "⫱",
	"top": "⊤",
	"Topf": "𝕋",
	"topf": "𝕥",
	"topfork": "⫚",
	"tosa": "⤩",
	"tprime": "‴",
	"trade": "™",
	"TRADE": "™",
	"triangle": "▵",
	"triangledown": "▿",
	"triangleleft": "◃",
	"trianglelefteq": "⊴",
	"triangleq": "≜",
	"triangleright": "▹",
	"trianglerighteq": "⊵",
	"tridot": "◬",
	"trie": "≜",
	"triminus": "⨺",
	"TripleDot": "⃛",
	"triplus": "⨹",
	"trisb": "⧍",
	"tritime": "⨻",
	"trpezium": "⏢",
	"Tscr": "𝒯",
	"tscr": "𝓉",
	"TScy": "Ц",
	"tscy": "ц",
	"TSHcy": "Ћ",
	"tshcy": "ћ",
	"Tstrok": "Ŧ",
	"tstrok": "ŧ",
	"twixt": "≬",
	"twoheadleftarrow": "↞",
	"twoheadrightarrow": "↠",
	"Uacute": "Ú",
	"uacute": "ú",
	"uarr": "↑",
	"Uarr": "↟",
	"uArr": "⇑",
	"Uarrocir": "⥉",
	"Ubrcy": "Ў",
	"ubrcy": "ў",
	"Ubreve": "Ŭ",
	"ubreve": "ŭ",
	"Ucirc": "Û",
	"ucirc": "û",
	"Ucy": "У",
	"ucy": "у",
	"udarr": "⇅",
	"Udblac": "Ű",
	"udblac": "ű",
	"udhar": "⥮",
	"ufisht": "⥾",
	"Ufr": "𝔘",
	"ufr": "𝔲",
	"Ugrave": "Ù",
	"ugrave": "ù",
	"uHar": "⥣",
	"uharl": "↿",
	"uharr": "↾",
	"uhblk": "▀",
	"ulcorn": "⌜",
	"ulcorner": "⌜",
	"ulcrop": "⌏",
	"ultri": "◸",
	"Umacr": "Ū",
	"umacr": "ū",
	"uml": "¨",
	"UnderBar": "_",
	"UnderBrace": "⏟",
	"UnderBracket": "⎵",
	"UnderParenthesis": "⏝",
	"Union": "⋃",
	"UnionPlus": "⊎",
	"Uogon": "Ų",
	"uogon": "ų",
	"Uopf": "𝕌",
	"uopf": "𝕦",
	"UpArrowBar": "⤒",
	"uparrow": "↑",
	"UpArrow": "↑",
	"Uparrow": "⇑",
	"UpArrowDownArrow": "⇅",
	"updownarrow": "↕",
	"UpDownArrow": "↕",
	"Updownarrow": "⇕",
	"UpEquilibrium": "⥮",
	"upharpoonleft": "↿",
	"upharpoonright": "↾",
	"uplus": "⊎",
	"UpperLeftArrow": "↖",
	"UpperRightArrow": "↗",
	"upsi": "υ",
	"Upsi": "ϒ",
	"upsih": "ϒ",
	"Upsilon": "Υ",
	"upsilon": "υ",
	"UpTeeArrow": "↥",
	"UpTee": "⊥",
	"upuparrows": "⇈",
	"urcorn": "⌝",
	"urcorner": "⌝",
	"urcrop": "⌎",
	"Uring": "Ů",
	"uring": "ů",
	"urtri": "◹",
	"Uscr": "𝒰",
	"uscr": "𝓊",
	"utdot": "⋰",
	"Utilde": "Ũ",
	"utilde": "ũ",
	"utri": "▵",
	"utrif": "▴",
	"uuarr": "⇈",
	"Uuml": "Ü",
	"uuml": "ü",
	"uwangle": "⦧",
	"vangrt": "⦜",
	"varepsilon": "ϵ",
	"varkappa": "ϰ",
	"varnothing": "∅",
	"varphi": "ϕ",
	"varpi": "ϖ",
	"varpropto": "∝",
	"varr": "↕",
	"vArr": "⇕",
	"varrho": "ϱ",
	"varsigma": "ς",
	"varsubsetneq": "⊊︀",
	"varsubsetneqq": "⫋︀",
	"varsupsetneq": "⊋︀",
	"varsupsetneqq": "⫌︀",
	"vartheta": "ϑ",
	"vartriangleleft": "⊲",
	"vartriangleright": "⊳",
	"vBar": "⫨",
	"Vbar": "⫫",
	"vBarv": "⫩",
	"Vcy": "В",
	"vcy": "в",
	"vdash": "⊢",
	"vDash": "⊨",
	"Vdash": "⊩",
	"VDash": "⊫",
	"Vdashl": "⫦",
	"veebar": "⊻",
	"vee": "∨",
	"Vee": "⋁",
	"veeeq": "≚",
	"vellip": "⋮",
	"verbar": "|",
	"Verbar": "‖",
	"vert": "|",
	"Vert": "‖",
	"VerticalBar": "∣",
	"VerticalLine": "|",
	"VerticalSeparator": "❘",
	"VerticalTilde": "≀",
	"VeryThinSpace": " ",
	"Vfr": "𝔙",
	"vfr": "𝔳",
	"vltri": "⊲",
	"vnsub": "⊂⃒",
	"vnsup": "⊃⃒",
	"Vopf": "𝕍",
	"vopf": "𝕧",
	"vprop": "∝",
	"vrtri": "⊳",
	"Vscr": "𝒱",
	"vscr": "𝓋",
	"vsubnE": "⫋︀",
	"vsubne": "⊊︀",
	"vsupnE": "⫌︀",
	"vsupne": "⊋︀",
	"Vvdash": "⊪",
	"vzigzag": "⦚",
	"Wcirc": "Ŵ",
	"wcirc": "ŵ",
	"wedbar": "⩟",
	"wedge": "∧",
	"Wedge": "⋀",
	"wedgeq": "≙",
	"weierp": "℘",
	"Wfr": "𝔚",
	"wfr": "𝔴",
	"Wopf": "𝕎",
	"wopf": "𝕨",
	"wp": "℘",
	"wr": "≀",
	"wreath": "≀",
	"Wscr": "𝒲",
	"wscr": "𝓌",
	"xcap": "⋂",
	"xcirc": "◯",
	"xcup": "⋃",
	"xdtri": "▽",
	"Xfr": "𝔛",
	"xfr": "𝔵",
	"xharr": "⟷",
	"xhArr": "⟺",
	"Xi": "Ξ",
	"xi": "ξ",
	"xlarr": "⟵",
	"xlArr": "⟸",
	"xmap": "⟼",
	"xnis": "⋻",
	"xodot": "⨀",
	"Xopf": "𝕏",
	"xopf": "𝕩",
	"xoplus": "⨁",
	"xotime": "⨂",
	"xrarr": "⟶",
	"xrArr": "⟹",
	"Xscr": "𝒳",
	"xscr": "𝓍",
	"xsqcup": "⨆",
	"xuplus": "⨄",
	"xutri": "△",
	"xvee": "⋁",
	"xwedge": "⋀",
	"Yacute": "Ý",
	"yacute": "ý",
	"YAcy": "Я",
	"yacy": "я",
	"Ycirc": "Ŷ",
	"ycirc": "ŷ",
	"Ycy": "Ы",
	"ycy": "ы",
	"yen": "¥",
	"Yfr": "𝔜",
	"yfr": "𝔶",
	"YIcy": "Ї",
	"yicy": "ї",
	"Yopf": "𝕐",
	"yopf": "𝕪",
	"Yscr": "𝒴",
	"yscr": "𝓎",
	"YUcy": "Ю",
	"yucy": "ю",
	"yuml": "ÿ",
	"Yuml": "Ÿ",
	"Zacute": "Ź",
	"zacute": "ź",
	"Zcaron": "Ž",
	"zcaron": "ž",
	"Zcy": "З",
	"zcy": "з",
	"Zdot": "Ż",
	"zdot": "ż",
	"zeetrf": "ℨ",
	"ZeroWidthSpace": "​",
	"Zeta": "Ζ",
	"zeta": "ζ",
	"zfr": "𝔷",
	"Zfr": "ℨ",
	"ZHcy": "Ж",
	"zhcy": "ж",
	"zigrarr": "⇝",
	"zopf": "𝕫",
	"Zopf": "ℤ",
	"Zscr": "𝒵",
	"zscr": "𝓏",
	"zwj": "‍",
	"zwnj": "‌"
};

/***/ }),
/* 242 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"gap_xsm":"14px","gap_sm":"20px","gap_md":"30px","gap_lg":"44px","gap_xlg":"62px","size_o_sm":"28px","size_o_md":"40px","size_o_lg":"56px","size_sm":"24px","size_md":"34px","size_lg":"44px","border_radius":"3px"};

/***/ }),
/* 243 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 244 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 245 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 246 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"gap_xsm":"14px","gap_sm":"20px","gap_md":"30px","gap_lg":"44px","gap_xlg":"62px","size_o_sm":"28px","size_o_md":"40px","size_o_lg":"56px","size_sm":"24px","size_md":"34px","size_lg":"44px","border_radius":"3px"};

/***/ }),
/* 247 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"gap_xsm":"14px","gap_sm":"20px","gap_md":"30px","gap_lg":"44px","gap_xlg":"62px","size_o_sm":"28px","size_o_md":"40px","size_o_lg":"56px","size_sm":"24px","size_md":"34px","size_lg":"44px","border_radius":"3px"};

/***/ }),
/* 248 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 249 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"gap_xsm":"14px","gap_sm":"20px","gap_md":"30px","gap_lg":"44px","gap_xlg":"62px","size_o_sm":"28px","size_o_md":"40px","size_o_lg":"56px","size_sm":"24px","size_md":"34px","size_lg":"44px","border_radius":"3px"};

/***/ }),
/* 250 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 251 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 252 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"gap_xsm":"14px","gap_sm":"20px","gap_md":"30px","gap_lg":"44px","gap_xlg":"62px","size_o_sm":"28px","size_o_md":"40px","size_o_lg":"56px","size_sm":"24px","size_md":"34px","size_lg":"44px","border_radius":"3px"};

/***/ }),
/* 253 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 254 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 255 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"gap_xsm":"14px","gap_sm":"20px","gap_md":"30px","gap_lg":"44px","gap_xlg":"62px","size_o_sm":"28px","size_o_md":"40px","size_o_lg":"56px","size_sm":"24px","size_md":"34px","size_lg":"44px","border_radius":"3px"};

/***/ }),
/* 256 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"gap_xsm":"14px","gap_sm":"20px","gap_md":"30px","gap_lg":"44px","gap_xlg":"62px","size_o_sm":"28px","size_o_md":"40px","size_o_lg":"56px","size_sm":"24px","size_md":"34px","size_lg":"44px","border_radius":"3px"};

/***/ }),
/* 257 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"gap_xsm":"14px","gap_sm":"20px","gap_md":"30px","gap_lg":"44px","gap_xlg":"62px","size_o_sm":"28px","size_o_md":"40px","size_o_lg":"56px","size_sm":"24px","size_md":"34px","size_lg":"44px","border_radius":"3px"};

/***/ }),
/* 258 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"gap_xsm":"14px","gap_sm":"20px","gap_md":"30px","gap_lg":"44px","gap_xlg":"62px","size_o_sm":"28px","size_o_md":"40px","size_o_lg":"56px","size_sm":"24px","size_md":"34px","size_lg":"44px","border_radius":"3px"};

/***/ }),
/* 259 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"gap_xsm":"14px","gap_sm":"20px","gap_md":"30px","gap_lg":"44px","gap_xlg":"62px","size_o_sm":"28px","size_o_md":"40px","size_o_lg":"56px","size_sm":"24px","size_md":"34px","size_lg":"44px","border_radius":"3px"};

/***/ }),
/* 260 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"gap_xsm":"14px","gap_sm":"20px","gap_md":"30px","gap_lg":"44px","gap_xlg":"62px","size_o_sm":"28px","size_o_md":"40px","size_o_lg":"56px","size_sm":"24px","size_md":"34px","size_lg":"44px","border_radius":"3px"};

/***/ }),
/* 261 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 262 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 263 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 264 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 265 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"gap_xsm":"14px","gap_sm":"20px","gap_md":"30px","gap_lg":"44px","gap_xlg":"62px","size_o_sm":"28px","size_o_md":"40px","size_o_lg":"56px","size_sm":"24px","size_md":"34px","size_lg":"44px","border_radius":"3px"};

/***/ }),
/* 266 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 267 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"gap_xsm":"14px","gap_sm":"20px","gap_md":"30px","gap_lg":"44px","gap_xlg":"62px","size_o_sm":"28px","size_o_md":"40px","size_o_lg":"56px","size_sm":"24px","size_md":"34px","size_lg":"44px","border_radius":"3px"};

/***/ }),
/* 268 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"gap_xsm":"14px","gap_sm":"20px","gap_md":"30px","gap_lg":"44px","gap_xlg":"62px","size_o_sm":"28px","size_o_md":"40px","size_o_lg":"56px","size_sm":"24px","size_md":"34px","size_lg":"44px","border_radius":"3px"};

/***/ }),
/* 269 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"gap_xsm":"14px","gap_sm":"20px","gap_md":"30px","gap_lg":"44px","gap_xlg":"62px","size_o_sm":"28px","size_o_md":"40px","size_o_lg":"56px","size_sm":"24px","size_md":"34px","size_lg":"44px","border_radius":"3px"};

/***/ }),
/* 270 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 271 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"gap_xsm":"14px","gap_sm":"20px","gap_md":"30px","gap_lg":"44px","gap_xlg":"62px","size_o_sm":"28px","size_o_md":"40px","size_o_lg":"56px","size_sm":"24px","size_md":"34px","size_lg":"44px","border_radius":"3px"};

/***/ }),
/* 272 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 273 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 274 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 275 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 276 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"gap_xsm":"14px","gap_sm":"20px","gap_md":"30px","gap_lg":"44px","gap_xlg":"62px","size_o_sm":"28px","size_o_md":"40px","size_o_lg":"56px","size_sm":"24px","size_md":"34px","size_lg":"44px","border_radius":"3px"};

/***/ }),
/* 277 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"gap_xsm":"14px","gap_sm":"20px","gap_md":"30px","gap_lg":"44px","gap_xlg":"62px","size_o_sm":"28px","size_o_md":"40px","size_o_lg":"56px","size_sm":"24px","size_md":"34px","size_lg":"44px","border_radius":"3px"};

/***/ }),
/* 278 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 279 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"gap_xsm":"14px","gap_sm":"20px","gap_md":"30px","gap_lg":"44px","gap_xlg":"62px","size_o_sm":"28px","size_o_md":"40px","size_o_lg":"56px","size_sm":"24px","size_md":"34px","size_lg":"44px","border_radius":"3px"};

/***/ }),
/* 280 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 281 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 282 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 283 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 284 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"gap_xsm":"14px","gap_sm":"20px","gap_md":"30px","gap_lg":"44px","gap_xlg":"62px","size_o_sm":"28px","size_o_md":"40px","size_o_lg":"56px","size_sm":"24px","size_md":"34px","size_lg":"44px","border_radius":"3px"};

/***/ }),
/* 285 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 286 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"gap_xsm":"14px","gap_sm":"20px","gap_md":"30px","gap_lg":"44px","gap_xlg":"62px","size_o_sm":"28px","size_o_md":"40px","size_o_lg":"56px","size_sm":"24px","size_md":"34px","size_lg":"44px","border_radius":"3px"};

/***/ }),
/* 287 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"gap_xsm":"14px","gap_sm":"20px","gap_md":"30px","gap_lg":"44px","gap_xlg":"62px","size_o_sm":"28px","size_o_md":"40px","size_o_lg":"56px","size_sm":"24px","size_md":"34px","size_lg":"44px","border_radius":"3px"};

/***/ }),
/* 288 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"gap_xsm":"14px","gap_sm":"20px","gap_md":"30px","gap_lg":"44px","gap_xlg":"62px","size_o_sm":"28px","size_o_md":"40px","size_o_lg":"56px","size_sm":"24px","size_md":"34px","size_lg":"44px","border_radius":"3px"};

/***/ }),
/* 289 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"gap_xsm":"14px","gap_sm":"20px","gap_md":"30px","gap_lg":"44px","gap_xlg":"62px","size_o_sm":"28px","size_o_md":"40px","size_o_lg":"56px","size_sm":"24px","size_md":"34px","size_lg":"44px","border_radius":"3px"};

/***/ }),
/* 290 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 291 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 292 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"gap_xsm":"14px","gap_sm":"20px","gap_md":"30px","gap_lg":"44px","gap_xlg":"62px","size_o_sm":"28px","size_o_md":"40px","size_o_lg":"56px","size_sm":"24px","size_md":"34px","size_lg":"44px","border_radius":"3px"};

/***/ }),
/* 293 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 294 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 295 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 296 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 297 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"gap_xsm":"14px","gap_sm":"20px","gap_md":"30px","gap_lg":"44px","gap_xlg":"62px","size_o_sm":"28px","size_o_md":"40px","size_o_lg":"56px","size_sm":"24px","size_md":"34px","size_lg":"44px","border_radius":"3px"};

/***/ }),
/* 298 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"gap_xsm":"14px","gap_sm":"20px","gap_md":"30px","gap_lg":"44px","gap_xlg":"62px","size_o_sm":"28px","size_o_md":"40px","size_o_lg":"56px","size_sm":"24px","size_md":"34px","size_lg":"44px","border_radius":"3px"};

/***/ }),
/* 299 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 300 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"gap_xsm":"14px","gap_sm":"20px","gap_md":"30px","gap_lg":"44px","gap_xlg":"62px","size_o_sm":"28px","size_o_md":"40px","size_o_lg":"56px","size_sm":"24px","size_md":"34px","size_lg":"44px","border_radius":"3px"};

/***/ }),
/* 301 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"gap_xsm":"14px","gap_sm":"20px","gap_md":"30px","gap_lg":"44px","gap_xlg":"62px","size_o_sm":"28px","size_o_md":"40px","size_o_lg":"56px","size_sm":"24px","size_md":"34px","size_lg":"44px","border_radius":"3px"};

/***/ }),
/* 302 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"gap_xsm":"14px","gap_sm":"20px","gap_md":"30px","gap_lg":"44px","gap_xlg":"62px","size_o_sm":"28px","size_o_md":"40px","size_o_lg":"56px","size_sm":"24px","size_md":"34px","size_lg":"44px","border_radius":"3px"};

/***/ }),
/* 303 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"gap_xsm":"14px","gap_sm":"20px","gap_md":"30px","gap_lg":"44px","gap_xlg":"62px","size_o_sm":"28px","size_o_md":"40px","size_o_lg":"56px","size_sm":"24px","size_md":"34px","size_lg":"44px","border_radius":"3px"};

/***/ }),
/* 304 */,
/* 305 */,
/* 306 */,
/* 307 */,
/* 308 */,
/* 309 */,
/* 310 */,
/* 311 */,
/* 312 */,
/* 313 */,
/* 314 */,
/* 315 */,
/* 316 */,
/* 317 */,
/* 318 */,
/* 319 */,
/* 320 */,
/* 321 */,
/* 322 */,
/* 323 */,
/* 324 */,
/* 325 */,
/* 326 */,
/* 327 */,
/* 328 */,
/* 329 */,
/* 330 */,
/* 331 */,
/* 332 */,
/* 333 */,
/* 334 */,
/* 335 */,
/* 336 */,
/* 337 */,
/* 338 */,
/* 339 */,
/* 340 */,
/* 341 */,
/* 342 */,
/* 343 */,
/* 344 */,
/* 345 */,
/* 346 */,
/* 347 */,
/* 348 */,
/* 349 */,
/* 350 */,
/* 351 */,
/* 352 */,
/* 353 */,
/* 354 */,
/* 355 */,
/* 356 */,
/* 357 */,
/* 358 */,
/* 359 */,
/* 360 */,
/* 361 */,
/* 362 */,
/* 363 */,
/* 364 */,
/* 365 */,
/* 366 */,
/* 367 */,
/* 368 */,
/* 369 */,
/* 370 */,
/* 371 */,
/* 372 */,
/* 373 */,
/* 374 */,
/* 375 */,
/* 376 */,
/* 377 */,
/* 378 */,
/* 379 */,
/* 380 */,
/* 381 */,
/* 382 */,
/* 383 */,
/* 384 */,
/* 385 */,
/* 386 */,
/* 387 */,
/* 388 */,
/* 389 */,
/* 390 */,
/* 391 */,
/* 392 */,
/* 393 */,
/* 394 */,
/* 395 */,
/* 396 */,
/* 397 */,
/* 398 */,
/* 399 */,
/* 400 */,
/* 401 */,
/* 402 */,
/* 403 */,
/* 404 */,
/* 405 */,
/* 406 */,
/* 407 */,
/* 408 */,
/* 409 */,
/* 410 */,
/* 411 */,
/* 412 */,
/* 413 */,
/* 414 */,
/* 415 */,
/* 416 */,
/* 417 */,
/* 418 */,
/* 419 */,
/* 420 */,
/* 421 */,
/* 422 */,
/* 423 */,
/* 424 */,
/* 425 */,
/* 426 */,
/* 427 */,
/* 428 */,
/* 429 */,
/* 430 */,
/* 431 */,
/* 432 */,
/* 433 */,
/* 434 */,
/* 435 */,
/* 436 */,
/* 437 */,
/* 438 */,
/* 439 */,
/* 440 */,
/* 441 */,
/* 442 */,
/* 443 */,
/* 444 */,
/* 445 */,
/* 446 */,
/* 447 */,
/* 448 */,
/* 449 */,
/* 450 */,
/* 451 */,
/* 452 */,
/* 453 */,
/* 454 */,
/* 455 */,
/* 456 */,
/* 457 */,
/* 458 */,
/* 459 */,
/* 460 */,
/* 461 */,
/* 462 */,
/* 463 */,
/* 464 */,
/* 465 */,
/* 466 */,
/* 467 */,
/* 468 */,
/* 469 */,
/* 470 */,
/* 471 */,
/* 472 */,
/* 473 */,
/* 474 */,
/* 475 */,
/* 476 */,
/* 477 */,
/* 478 */,
/* 479 */,
/* 480 */,
/* 481 */,
/* 482 */,
/* 483 */,
/* 484 */,
/* 485 */,
/* 486 */,
/* 487 */,
/* 488 */,
/* 489 */,
/* 490 */,
/* 491 */,
/* 492 */,
/* 493 */,
/* 494 */,
/* 495 */,
/* 496 */,
/* 497 */,
/* 498 */,
/* 499 */,
/* 500 */,
/* 501 */,
/* 502 */,
/* 503 */,
/* 504 */,
/* 505 */,
/* 506 */,
/* 507 */,
/* 508 */,
/* 509 */,
/* 510 */,
/* 511 */,
/* 512 */,
/* 513 */,
/* 514 */,
/* 515 */,
/* 516 */,
/* 517 */,
/* 518 */,
/* 519 */,
/* 520 */,
/* 521 */,
/* 522 */,
/* 523 */,
/* 524 */,
/* 525 */,
/* 526 */,
/* 527 */,
/* 528 */,
/* 529 */,
/* 530 */,
/* 531 */,
/* 532 */,
/* 533 */,
/* 534 */,
/* 535 */,
/* 536 */,
/* 537 */,
/* 538 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(109),
  /* template */
  __webpack_require__(684),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 539 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  null,
  /* template */
  __webpack_require__(671),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 540 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(110),
  /* template */
  __webpack_require__(641),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 541 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(111),
  /* template */
  __webpack_require__(645),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 542 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(112),
  /* template */
  __webpack_require__(646),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 543 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(113),
  /* template */
  __webpack_require__(647),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 544 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(114),
  /* template */
  __webpack_require__(648),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 545 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(115),
  /* template */
  __webpack_require__(649),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 546 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(116),
  /* template */
  __webpack_require__(651),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 547 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(117),
  /* template */
  __webpack_require__(652),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 548 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(118),
  /* template */
  __webpack_require__(640),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 549 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  null,
  /* template */
  __webpack_require__(653),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 550 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(119),
  /* template */
  __webpack_require__(654),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 551 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(120),
  /* template */
  __webpack_require__(655),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 552 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(725)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(121),
  /* template */
  __webpack_require__(656),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 553 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(122),
  /* template */
  __webpack_require__(657),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 554 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(123),
  /* template */
  __webpack_require__(658),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 555 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(124),
  /* template */
  __webpack_require__(659),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 556 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(125),
  /* template */
  __webpack_require__(639),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 557 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(126),
  /* template */
  __webpack_require__(638),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 558 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(127),
  /* template */
  __webpack_require__(637),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 559 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(128),
  /* template */
  __webpack_require__(636),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 560 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(129),
  /* template */
  __webpack_require__(635),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 561 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(130),
  /* template */
  __webpack_require__(634),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 562 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(131),
  /* template */
  __webpack_require__(633),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 563 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(132),
  /* template */
  __webpack_require__(643),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 564 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(256)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(134),
  /* template */
  __webpack_require__(624),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 565 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(303)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(135),
  /* template */
  __webpack_require__(697),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 566 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(288)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(136),
  /* template */
  __webpack_require__(681),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 567 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(249)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(139),
  /* template */
  __webpack_require__(617),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 568 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(279)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(140),
  /* template */
  __webpack_require__(672),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 569 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(271)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(141),
  /* template */
  __webpack_require__(663),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 570 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(259)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(142),
  /* template */
  __webpack_require__(627),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 571 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(284)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(143),
  /* template */
  __webpack_require__(677),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 572 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(302)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(144),
  /* template */
  __webpack_require__(696),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 573 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(265)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(145),
  /* template */
  __webpack_require__(642),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 574 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(287)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(146),
  /* template */
  __webpack_require__(680),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 575 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(255)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(147),
  /* template */
  __webpack_require__(623),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 576 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(252)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(148),
  /* template */
  __webpack_require__(620),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 577 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(276)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(149),
  /* template */
  __webpack_require__(668),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 578 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(300)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(150),
  /* template */
  __webpack_require__(694),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 579 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(247)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(152),
  /* template */
  __webpack_require__(615),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 580 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(277)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(153),
  /* template */
  __webpack_require__(669),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 581 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(299)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(155),
  /* template */
  __webpack_require__(693),
  /* scopeId */
  "data-v-d39bcbde",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 582 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(296)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(156),
  /* template */
  __webpack_require__(690),
  /* scopeId */
  "data-v-b9917b4c",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 583 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(301)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(157),
  /* template */
  __webpack_require__(695),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 584 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(286)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(158),
  /* template */
  __webpack_require__(679),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 585 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(258)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(159),
  /* template */
  __webpack_require__(626),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 586 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(292)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(160),
  /* template */
  __webpack_require__(686),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 587 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(257)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(161),
  /* template */
  __webpack_require__(625),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 588 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(260)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(162),
  /* template */
  __webpack_require__(628),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 589 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(261)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(166),
  /* template */
  __webpack_require__(629),
  /* scopeId */
  "data-v-2fd6ab4a",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 590 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(295)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(167),
  /* template */
  __webpack_require__(689),
  /* scopeId */
  "data-v-a8b77022",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 591 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(278)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(168),
  /* template */
  __webpack_require__(670),
  /* scopeId */
  "data-v-68500490",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 592 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(254)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(169),
  /* template */
  __webpack_require__(622),
  /* scopeId */
  "data-v-20a99e92",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 593 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(264)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(170),
  /* template */
  __webpack_require__(632),
  /* scopeId */
  "data-v-36608c77",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 594 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(281)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(171),
  /* template */
  __webpack_require__(674),
  /* scopeId */
  "data-v-71179b82",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 595 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(266)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(172),
  /* template */
  __webpack_require__(644),
  /* scopeId */
  "data-v-4711289a",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 596 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(250)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(173),
  /* template */
  __webpack_require__(618),
  /* scopeId */
  "data-v-0820084d",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 597 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(263)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(174),
  /* template */
  __webpack_require__(631),
  /* scopeId */
  "data-v-316888ea",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 598 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(290)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(175),
  /* template */
  __webpack_require__(683),
  /* scopeId */
  "data-v-91c061b4",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 599 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(291)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(176),
  /* template */
  __webpack_require__(685),
  /* scopeId */
  "data-v-9c7022d0",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 600 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(282)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(177),
  /* template */
  __webpack_require__(675),
  /* scopeId */
  "data-v-714c7a0f",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 601 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(269)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(178),
  /* template */
  __webpack_require__(661),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 602 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(275)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(179),
  /* template */
  __webpack_require__(667),
  /* scopeId */
  "data-v-660ae0fe",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 603 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(270)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(180),
  /* template */
  __webpack_require__(662),
  /* scopeId */
  "data-v-5aa55db6",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 604 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(253)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(181),
  /* template */
  __webpack_require__(621),
  /* scopeId */
  "data-v-178d0ad7",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 605 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(285)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(182),
  /* template */
  __webpack_require__(678),
  /* scopeId */
  "data-v-7a1f8850",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 606 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(262)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(183),
  /* template */
  __webpack_require__(630),
  /* scopeId */
  "data-v-312a7cef",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 607 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(274)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(184),
  /* template */
  __webpack_require__(666),
  /* scopeId */
  "data-v-630008f5",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 608 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(294)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(185),
  /* template */
  __webpack_require__(688),
  /* scopeId */
  "data-v-a5e102d4",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 609 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(280)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(186),
  /* template */
  __webpack_require__(673),
  /* scopeId */
  "data-v-6fbfa2f0",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 610 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(273)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(187),
  /* template */
  __webpack_require__(665),
  /* scopeId */
  "data-v-62f2fa71",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 611 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(248)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(188),
  /* template */
  __webpack_require__(616),
  /* scopeId */
  "data-v-01d0165c",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 612 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(272)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(189),
  /* template */
  __webpack_require__(664),
  /* scopeId */
  "data-v-610a9703",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 613 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(268)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(190),
  /* template */
  __webpack_require__(660),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 614 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "demo-item"
  }, [_c('div', {
    staticClass: "demo-item-container"
  }, [_vm._t("default")], 2), _vm._v(" "), _c('span', {
    staticClass: "demo-item-title",
    attrs: {
      "data-title": _vm.name
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "demo-description"
  }, [_c('span', {
    ref: "description",
    domProps: {
      "innerHTML": _vm._s(_vm.descr)
    }
  }), _vm._v(" "), _c('Icon', {
    class: ['show-code-btn', {
      open: _vm.show_code
    }],
    attrs: {
      "name": "caretdown"
    },
    nativeOn: {
      "click": function($event) {
        _vm.show_code = !_vm.show_code
      }
    }
  })], 1), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "slide"
    }
  }, [_c('v-code', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.show_code),
      expression: "show_code"
    }],
    attrs: {
      "lang": _vm.lang,
      "code": _vm.code
    }
  })], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 615 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: _vm.component_class
  }, [(_vm.wrap) ? _c('div', {
    staticClass: "hiui-spinner-content"
  }, [_c('Icon', {
    attrs: {
      "name": "loading",
      "rotate": true,
      "color": _vm.color,
      "size": _vm.size
    }
  }), _vm._v(" "), _vm._t("default")], 2) : _c('Icon', {
    attrs: {
      "name": "loading",
      "rotate": true,
      "color": _vm.color,
      "size": _vm.size
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 616 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('demo', {
    staticClass: "tabs-demo",
    attrs: {
      "title": "Tabs"
    }
  }, [_c('demo-item', {
    attrs: {
      "name": "default",
      "description": "默认",
      "code": _vm.code
    },
    slot: "left"
  }, [_c('Tabs', [_c('TabPane', {
    attrs: {
      "label": '标签一'
    }
  }, [_vm._v("第一个标签内容")]), _vm._v(" "), _c('TabPane', {
    attrs: {
      "label": '标签二'
    }
  }, [_vm._v("第二个标签内容")]), _vm._v(" "), _c('TabPane', {
    attrs: {
      "label": '标签三'
    }
  }, [_vm._v("第三个标签内容")])], 1)], 1), _vm._v(" "), _c('demo-item', {
    staticClass: "type-group",
    attrs: {
      "name": "type",
      "description": _vm.type_descr,
      "code": _vm.type_code
    },
    slot: "right"
  }, [_c('Tabs', {
    attrs: {
      "type": 'no_padding'
    }
  }, [_c('TabPane', {
    attrs: {
      "label": '标签一'
    }
  }, [_vm._v("不使用padding的标签1")]), _vm._v(" "), _c('TabPane', {
    attrs: {
      "label": '标签二'
    }
  }, [_vm._v("不使用padding的标签2")]), _vm._v(" "), _c('TabPane', {
    attrs: {
      "label": '标签三'
    }
  }, [_vm._v("不使用padding的标签3")])], 1), _vm._v(" "), _c('Tabs', {
    attrs: {
      "type": 'fix_width'
    }
  }, [_c('TabPane', {
    attrs: {
      "label": '标签一'
    }
  }, [_vm._v("平分宽度的标签1")]), _vm._v(" "), _c('TabPane', {
    attrs: {
      "label": '标签二'
    }
  }, [_vm._v("平分宽度的标签2")]), _vm._v(" "), _c('TabPane', {
    attrs: {
      "label": '标签三'
    }
  }, [_vm._v("平分宽度的标签3")])], 1), _vm._v(" "), _c('Tabs', {
    attrs: {
      "type": 'fix_width:20%'
    }
  }, [_c('TabPane', {
    attrs: {
      "label": '标签一'
    }
  }, [_vm._v("固定宽度为20%的标签1")]), _vm._v(" "), _c('TabPane', {
    attrs: {
      "label": '标签二'
    }
  }, [_vm._v("固定宽度为20%的标签2")]), _vm._v(" "), _c('TabPane', {
    attrs: {
      "label": '标签三'
    }
  }, [_vm._v("固定宽度为20%的标签3")])], 1)], 1), _vm._v(" "), _c('demo-item', {
    attrs: {
      "name": "icon",
      "description": "图标",
      "code": _vm.icon_code
    },
    slot: "left"
  }, [_c('Tabs', [_c('TabPane', {
    attrs: {
      "label": 'Home',
      "icon": 'home'
    }
  }, [_vm._v("第一个标签内容")]), _vm._v(" "), _c('TabPane', {
    attrs: {
      "label": 'Cart',
      "icon": 'shoppingcart'
    }
  }, [_vm._v("第二个标签内容")]), _vm._v(" "), _c('TabPane', {
    attrs: {
      "label": 'User',
      "icon": 'user'
    }
  }, [_vm._v("第三个标签内容")])], 1)], 1), _vm._v(" "), _c('demo-item', {
    attrs: {
      "name": "activeStyle",
      "description": "选中样式",
      "code": _vm.style_code
    },
    slot: "left"
  }, [_c('Tabs', {
    attrs: {
      "type": 'no_padding',
      "active-style": {
        color: '#f02f45',
        borderBottomColor: '#f02f45'
      }
    }
  }, [_c('TabPane', {
    attrs: {
      "label": '机酒自由行'
    }
  }, [_vm._v("机酒自由行")]), _vm._v(" "), _c('TabPane', {
    attrs: {
      "label": '当地玩乐'
    }
  }, [_vm._v("当地玩乐")]), _vm._v(" "), _c('TabPane', {
    attrs: {
      "label": '出行必备'
    }
  }, [_vm._v("出行必备")])], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 617 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('i', {
    class: _vm.component_class,
    style: (_vm.size_style)
  })
},staticRenderFns: []}

/***/ }),
/* 618 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('demo', {
    staticClass: "icon-demo",
    attrs: {
      "title": "Icon"
    }
  }, [_c('demo-item', {
    attrs: {
      "name": "name",
      "description": "图标类型",
      "code": _vm.name_code
    },
    slot: "left"
  }, [_c('Icon', {
    attrs: {
      "name": 'heart'
    }
  }), _vm._v(" "), _c('Icon', {
    attrs: {
      "name": 'star'
    }
  }), _vm._v(" "), _c('Icon', {
    attrs: {
      "name": 'tag'
    }
  })], 1), _vm._v(" "), _c('demo-item', {
    attrs: {
      "name": "size",
      "description": "图标大小",
      "code": _vm.size_code
    },
    slot: "right"
  }, [_c('Icon', {
    attrs: {
      "size": 16,
      "name": 'enviroment'
    }
  }), _vm._v(" "), _c('Icon', {
    attrs: {
      "size": 24,
      "name": 'enviroment'
    }
  }), _vm._v(" "), _c('Icon', {
    attrs: {
      "size": 32,
      "name": 'enviroment'
    }
  })], 1), _vm._v(" "), _c('demo-item', {
    attrs: {
      "name": "color",
      "description": "图标颜色",
      "code": _vm.color_code
    },
    slot: "left"
  }, [_c('Icon', {
    attrs: {
      "color": 'red',
      "name": 'search'
    }
  }), _vm._v(" "), _c('Icon', {
    attrs: {
      "color": '#00a0e9',
      "name": 'search'
    }
  }), _vm._v(" "), _c('Icon', {
    attrs: {
      "color": 'rgba(33, 66, 99, 0.6)',
      "name": 'search'
    }
  })], 1), _vm._v(" "), _c('demo-item', {
    attrs: {
      "name": "rotate",
      "description": "旋转",
      "code": _vm.rotate_code
    },
    slot: "right"
  }, [_c('Icon', {
    attrs: {
      "rotate": true,
      "name": 'loading'
    }
  })], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 619 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('router-view')], 1)
},staticRenderFns: []}

/***/ }),
/* 620 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    class: _vm.component_class,
    style: (_vm.component_style)
  }, [_c('small', {
    style: (_vm.suffix_style)
  }, [_vm._v(_vm._s(_vm.symbol))]), _c('em', [_vm._t("default")], 2), (_vm.suffix) ? _c('small', {
    staticClass: "hiui-price-suffix",
    style: (_vm.suffix_style)
  }, [_vm._v(_vm._s(_vm.suffix))]) : _vm._e()])
},staticRenderFns: []}

/***/ }),
/* 621 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('demo', {
    staticClass: "radio-demo",
    attrs: {
      "title": "Radio"
    }
  }, [_c('demo-item', {
    attrs: {
      "name": "size",
      "description": "大小",
      "code": _vm.code
    },
    slot: "left"
  }, [_c('Radio', {
    attrs: {
      "size": 'sm'
    },
    model: {
      value: (_vm.test),
      callback: function($$v) {
        _vm.test = $$v
      },
      expression: "test"
    }
  }, [_vm._v("单选按钮")]), _vm._v(" "), _c('Radio', {
    attrs: {
      "size": 'md'
    },
    model: {
      value: (_vm.test),
      callback: function($$v) {
        _vm.test = $$v
      },
      expression: "test"
    }
  }, [_vm._v("单选按钮2")]), _vm._v(" "), _c('Radio', {
    attrs: {
      "size": 'lg'
    },
    model: {
      value: (_vm.test),
      callback: function($$v) {
        _vm.test = $$v
      },
      expression: "test"
    }
  }, [_vm._v("单选按钮3")]), _vm._v(" "), _c('p', {
    staticClass: "radio-result"
  }, [_vm._v("已选中：" + _vm._s(_vm.test))])], 1), _vm._v(" "), _c('demo-item', {
    attrs: {
      "name": "value",
      "description": "指定值",
      "code": _vm.value_code
    },
    slot: "right"
  }, [_c('Radio', {
    attrs: {
      "value": 0
    },
    model: {
      value: (_vm.value_test),
      callback: function($$v) {
        _vm.value_test = $$v
      },
      expression: "value_test"
    }
  }, [_vm._v("单选按钮")]), _vm._v(" "), _c('Radio', {
    attrs: {
      "value": 1
    },
    model: {
      value: (_vm.value_test),
      callback: function($$v) {
        _vm.value_test = $$v
      },
      expression: "value_test"
    }
  }, [_vm._v("单选按钮2")]), _vm._v(" "), _c('Radio', {
    attrs: {
      "value": 2
    },
    model: {
      value: (_vm.value_test),
      callback: function($$v) {
        _vm.value_test = $$v
      },
      expression: "value_test"
    }
  }, [_vm._v("单选按钮3")]), _vm._v(" "), _c('p', {
    staticClass: "radio-result"
  }, [_vm._v("已选中：" + _vm._s(_vm.value_test))])], 1), _vm._v(" "), _c('demo-item', {
    attrs: {
      "name": "status",
      "description": "状态",
      "code": _vm.status_code
    },
    slot: "left"
  }, [_c('Radio', {
    model: {
      value: (_vm.status_test),
      callback: function($$v) {
        _vm.status_test = $$v
      },
      expression: "status_test"
    }
  }, [_vm._v("单选按钮")]), _vm._v(" "), _c('Radio', {
    attrs: {
      "disabled": true
    },
    model: {
      value: (_vm.status_test),
      callback: function($$v) {
        _vm.status_test = $$v
      },
      expression: "status_test"
    }
  }, [_vm._v("已禁用")]), _vm._v(" "), _c('p', {
    staticClass: "radio-result"
  }, [_vm._v("已选中：" + _vm._s(_vm.status_test))])], 1), _vm._v(" "), _c('demo-item', {
    attrs: {
      "name": "color",
      "description": "颜色",
      "code": _vm.color_code
    },
    slot: "right"
  }, [_c('Radio', {
    model: {
      value: (_vm.color_test),
      callback: function($$v) {
        _vm.color_test = $$v
      },
      expression: "color_test"
    }
  }, [_vm._v("单选按钮")]), _vm._v(" "), _c('Radio', {
    attrs: {
      "color": 'rgb(0, 160, 233)'
    },
    model: {
      value: (_vm.color_test),
      callback: function($$v) {
        _vm.color_test = $$v
      },
      expression: "color_test"
    }
  }, [_vm._v("单选按钮2(蓝色)")]), _vm._v(" "), _c('p', {
    staticClass: "radio-result"
  }, [_vm._v("已选中：" + _vm._s(_vm.color_test))])], 1), _vm._v(" "), _c('demo-item', {
    attrs: {
      "name": "reselect",
      "description": "重选(选中状态再次点击则取消)",
      "code": _vm.reselect_code
    },
    slot: "left"
  }, [_c('Radio', {
    attrs: {
      "reselect": true
    },
    model: {
      value: (_vm.reselect_test),
      callback: function($$v) {
        _vm.reselect_test = $$v
      },
      expression: "reselect_test"
    }
  }, [_vm._v("单选按钮")]), _vm._v(" "), _c('Radio', {
    attrs: {
      "reselect": true
    },
    model: {
      value: (_vm.reselect_test),
      callback: function($$v) {
        _vm.reselect_test = $$v
      },
      expression: "reselect_test"
    }
  }, [_vm._v("单选按钮2")]), _vm._v(" "), _c('p', {
    staticClass: "radio-result"
  }, [_vm._v("已选中：" + _vm._s(_vm.reselect_test))])], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 622 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('demo', {
    staticClass: "icon-demo",
    attrs: {
      "title": "Icon"
    }
  }, [_c('demo-item', {
    attrs: {
      "name": "singleDate",
      "description": "单日期选择",
      "code": _vm.single_date,
      "lang": "js"
    }
  }, [_c('div', [_vm._v("日期: " + _vm._s(_vm.demo_single_date))]), _vm._v(" "), _c('div', {
    staticClass: "calendar-warp"
  }, [_c('vCalendar', {
    attrs: {
      "is_show": true,
      "is_range": false,
      "is_single_month": true,
      "is_today_disable": true
    },
    on: {
      "get-first-value": function($event) {
        _vm.demo_single_date = arguments[0]
      }
    }
  })], 1)]), _vm._v(" "), _c('demo-item', {
    attrs: {
      "name": "doubleDate",
      "description": "双日期选择",
      "code": _vm.double_date,
      "lang": "js"
    }
  }, [_c('div', [_vm._v("起止日期:  " + _vm._s(_vm.demo_from_date) + " "), _c('Icon', {
    attrs: {
      "name": "arrowright"
    }
  }), _vm._v(" " + _vm._s(_vm.demo_ret_date))], 1), _vm._v(" "), _c('div', {
    staticClass: "calendar-warp"
  }, [_c('vCalendar', {
    attrs: {
      "is_show": true,
      "is_range": true,
      "is_single_month": true,
      "is_today_disable": true
    },
    on: {
      "get-first-value": function($event) {
        _vm.demo_from_date = arguments[0]
      },
      "get-sec-value": function($event) {
        _vm.demo_ret_date = arguments[0]
      }
    }
  })], 1)])], 1)
},staticRenderFns: []}

/***/ }),
/* 623 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', [_c('transition', {
    attrs: {
      "name": _vm.transitionName[_vm.reverse_type]
    },
    on: {
      "after-leave": _vm.afterLeave
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.show),
      expression: "show"
    }],
    ref: "popover",
    class: _vm.component_class,
    style: (_vm.component_style)
  }, [_vm._t("default")], 2)]), _vm._v(" "), _vm._t("reference")], 2)
},staticRenderFns: []}

/***/ }),
/* 624 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [(_vm.show) ? _c('div', {
    class: _vm.component_class,
    style: (_vm.component_style),
    on: {
      "click": _vm.backTop
    }
  }, [_vm._t("default", [_c('Icon', {
    attrs: {
      "name": "up"
    }
  })])], 2) : _vm._e()])
},staticRenderFns: []}

/***/ }),
/* 625 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('header', {
    staticClass: "header"
  }, [_c('h3', {
    staticClass: "logo"
  }, [_vm._v("\n    " + _vm._s(_vm.config.name) + "\n    "), _c('small', [_vm._v(_vm._s(_vm.config.version))])]), _vm._v(" "), _c('ul', {
    staticClass: "menu"
  }, _vm._l((_vm.config.links), function(val, key) {
    return _c('li', [_c('a', {
      attrs: {
        "href": val
      }
    }, [_vm._v(_vm._s(key))])])
  }))])
},staticRenderFns: []}

/***/ }),
/* 626 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "hiui_fade"
    },
    on: {
      "after-leave": _vm.afterLeave
    }
  }, [(_vm.show) ? _c('div', {
    class: _vm.component_class
  }, [(_vm.show_icon) ? _c('Icon', {
    attrs: {
      "name": _vm.iconType[_vm.type],
      "size": 16
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "hiui-toast-content"
  }, [_vm._v(_vm._s(_vm.content))])], 1) : _vm._e()])
},staticRenderFns: []}

/***/ }),
/* 627 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.label) ? _c('span', {
    class: _vm.component_class
  }, [_vm._v(_vm._s(_vm.label))]) : _vm._e()
},staticRenderFns: []}

/***/ }),
/* 628 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('nav', {
    staticClass: "nav"
  }, [_c('ul', [_vm._l((_vm.data), function(obj) {
    return [_c('router-link', {
      staticClass: "link-li",
      attrs: {
        "exact": true,
        "to": obj.path,
        "tag": "li"
      }
    }, [_vm._v("\n        " + _vm._s(obj.name) + "\n        "), _c('small', [_vm._v(_vm._s(obj.cn_name))])]), _vm._v(" "), _vm._l((obj.child), function(child_obj) {
      return (obj.child) ? _c('div', {
        staticClass: "nav-child-wrap"
      }, [_c('div', {
        staticClass: "nav-child-title"
      }, [_vm._v(_vm._s(child_obj.title))]), _vm._v(" "), _vm._l((child_obj.components), function(component_obj, i) {
        return _c('router-link', {
          key: i,
          staticClass: "nav-child link-li",
          attrs: {
            "exact": true,
            "to": obj.path + component_obj.path,
            "tag": "li"
          }
        }, [_vm._v("\n          " + _vm._s(component_obj.name) + "\n          "), _c('small', [_vm._v(_vm._s(component_obj.cn_name))])])
      })], 2) : _vm._e()
    })]
  })], 2)])
},staticRenderFns: []}

/***/ }),
/* 629 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('demo', {
    staticClass: "backTop-demo",
    attrs: {
      "title": "BackTop"
    }
  }, [_c('demo-item', {
    attrs: {
      "name": "default",
      "description": "默认",
      "code": _vm.code
    }
  }, [_c('p', [_vm._v("向下滚动300px，即可显示默认的BackTop组件")]), _vm._v(" "), _c('BackTop')], 1), _vm._v(" "), _c('demo-item', {
    attrs: {
      "name": "default",
      "description": "默认",
      "code": _vm.rocket_code
    }
  }, [_c('p', [_vm._v("向下滚动100px，即可自定义配置的BackTop组件")]), _vm._v(" "), _c('BackTop', {
    attrs: {
      "height": 100,
      "bottom": 100
    }
  }, [_c('img', {
    attrs: {
      "src": _vm.rocket,
      "width": "50",
      "height": "50",
      "alt": "backTop"
    }
  })])], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 630 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('demo', {
    staticClass: "icon-demo",
    attrs: {
      "title": "Icon"
    }
  }, [_c('demo-item', {
    attrs: {
      "name": "default",
      "description": "滚动到具体位置",
      "code": _vm.code
    }
  }, [_c('Btn', {
    nativeOn: {
      "click": function($event) {
        _vm.$smoothScroll(300)
      }
    }
  }, [_vm._v("滚动到距离顶部300的位置")])], 1), _vm._v(" "), _c('demo-item', {
    attrs: {
      "name": "default",
      "description": "滚动到目标元素",
      "code": _vm.ele_code
    }
  }, [_c('div', {
    ref: "target"
  }, [_vm._v("# Target")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('Btn', {
    nativeOn: {
      "click": function($event) {
        _vm.$smoothScroll(_vm.$refs.target)
      }
    }
  }, [_vm._v("滚动到目标元素")]), _vm._v(" "), _c('Btn', {
    nativeOn: {
      "click": function($event) {
        _vm.$smoothScroll(_vm.$refs.target, 1000, -100)
      }
    }
  }, [_vm._v("偏移100px")])], 1), _vm._v(" "), _c('demo-item', {
    attrs: {
      "name": "default",
      "description": "滚动到顶部",
      "code": _vm.top_code
    }
  }, [_c('Btn', {
    nativeOn: {
      "click": function($event) {
        _vm.$smoothScroll()
      }
    }
  }, [_vm._v("滚动顶部")]), _vm._v(" "), _c('Btn', {
    nativeOn: {
      "click": function($event) {
        _vm.$smoothScroll(0, 200)
      }
    }
  }, [_vm._v("200ms滚到顶部")])], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 631 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('Row', {
    attrs: {
      "gutter": 10
    }
  }, [_vm._l((_vm.icons), function(type, i) {
    return [_c('vCol', {
      attrs: {
        "xlg": 3,
        "lg": 4,
        "md": 6,
        "sm": 8
      }
    }, [_c('div', {
      directives: [{
        name: "clipboard",
        rawName: "v-clipboard:copy",
        value: (("<Icon name=\"" + type + "\"></Icon>")),
        expression: "`<Icon name=\"${type}\"></Icon>`",
        arg: "copy"
      }],
      staticClass: "icon-item",
      on: {
        "click": function($event) {
          _vm.clickHandle(i)
        }
      }
    }, [_c('Icon', {
      attrs: {
        "size": 26,
        "name": type
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "icon-name",
      on: {
        "click": function($event) {
          $event.stopPropagation();
          void 0
        }
      }
    }, [_vm._v(_vm._s(type))]), _vm._v(" "), _c('transition', {
      attrs: {
        "name": "fade"
      }
    }, [(_vm.index === i) ? _c('div', {
      staticClass: "copy_success"
    }, [_vm._v("\n            Copy Success!\n          ")]) : _vm._e()])], 1)])]
  })], 2)
},staticRenderFns: []}

/***/ }),
/* 632 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('demo', {
    staticClass: "checkbox-demo",
    attrs: {
      "title": "Checkbox"
    }
  }, [_c('demo-item', {
    attrs: {
      "name": "size",
      "description": "大小",
      "code": _vm.code
    },
    slot: "left"
  }, [_c('CheckBox', {
    attrs: {
      "size": 'sm'
    },
    model: {
      value: (_vm.test),
      callback: function($$v) {
        _vm.test = $$v
      },
      expression: "test"
    }
  }, [_vm._v("小")]), _vm._v(" "), _c('CheckBox', {
    attrs: {
      "size": 'md'
    },
    model: {
      value: (_vm.test),
      callback: function($$v) {
        _vm.test = $$v
      },
      expression: "test"
    }
  }, [_vm._v("中等")]), _vm._v(" "), _c('CheckBox', {
    attrs: {
      "size": 'lg'
    },
    model: {
      value: (_vm.test),
      callback: function($$v) {
        _vm.test = $$v
      },
      expression: "test"
    }
  }, [_vm._v("大")]), _vm._v(" "), _c('p', {
    staticClass: "result"
  }, [_vm._v(_vm._s(JSON.stringify(_vm.test)))])], 1), _vm._v(" "), _c('demo-item', {
    attrs: {
      "name": "value",
      "description": "指定值",
      "code": _vm.value_code
    },
    slot: "right"
  }, [_c('CheckBox', {
    attrs: {
      "value": 'small'
    },
    model: {
      value: (_vm.test_value),
      callback: function($$v) {
        _vm.test_value = $$v
      },
      expression: "test_value"
    }
  }, [_vm._v("小")]), _vm._v(" "), _c('CheckBox', {
    attrs: {
      "value": 'normal'
    },
    model: {
      value: (_vm.test_value),
      callback: function($$v) {
        _vm.test_value = $$v
      },
      expression: "test_value"
    }
  }, [_vm._v("中等")]), _vm._v(" "), _c('CheckBox', {
    attrs: {
      "value": 'large'
    },
    model: {
      value: (_vm.test_value),
      callback: function($$v) {
        _vm.test_value = $$v
      },
      expression: "test_value"
    }
  }, [_vm._v("大")]), _vm._v(" "), _c('p', {
    staticClass: "result"
  }, [_vm._v(_vm._s(JSON.stringify(_vm.test_value)))])], 1), _vm._v(" "), _c('demo-item', {
    attrs: {
      "name": "status",
      "description": "状态",
      "code": _vm.disable_code
    },
    slot: "left"
  }, [_c('CheckBox', {
    model: {
      value: (_vm.test_disable),
      callback: function($$v) {
        _vm.test_disable = $$v
      },
      expression: "test_disable"
    }
  }, [_vm._v("正常")]), _vm._v(" "), _c('CheckBox', {
    attrs: {
      "disabled": true
    },
    model: {
      value: (_vm.test_disable),
      callback: function($$v) {
        _vm.test_disable = $$v
      },
      expression: "test_disable"
    }
  }, [_vm._v("禁用")]), _vm._v(" "), _c('p', {
    staticClass: "result"
  }, [_vm._v(_vm._s(JSON.stringify(_vm.test_disable)))])], 1), _vm._v(" "), _c('demo-item', {
    attrs: {
      "name": "color",
      "description": "颜色",
      "code": _vm.color_code
    },
    slot: "right"
  }, [_c('CheckBox', {
    model: {
      value: (_vm.test_color),
      callback: function($$v) {
        _vm.test_color = $$v
      },
      expression: "test_color"
    }
  }, [_vm._v("正常")]), _vm._v(" "), _c('CheckBox', {
    attrs: {
      "color": 'rgb(0, 160, 233)'
    },
    model: {
      value: (_vm.test_color),
      callback: function($$v) {
        _vm.test_color = $$v
      },
      expression: "test_color"
    }
  }, [_vm._v("蓝色")]), _vm._v(" "), _c('p', {
    staticClass: "result"
  }, [_vm._v(_vm._s(JSON.stringify(_vm.test_color)))])], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 633 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('h1', [_vm._v("Price")]), _vm._v(" "), _c('blockquote', [_c('p', [_vm._v("价格")])]), _vm._v(" "), _c('h2', [_vm._v("代码示例")]), _vm._v(" "), _c('p', [_c('test')], 1), _vm._v(" "), _c('h2', [_vm._v("API")]), _vm._v(" "), _vm._m(0)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('table', [_c('thead', [_c('tr', [_c('th', [_vm._v("参数")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "text-align": "left"
    }
  }, [_vm._v("说明")]), _vm._v(" "), _c('th', [_vm._v("类型")]), _vm._v(" "), _c('th', [_vm._v("默认值")])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_vm._v("color")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "text-align": "left"
    }
  }, [_vm._v("颜色")]), _vm._v(" "), _c('td', [_c('code', [_vm._v("String")])]), _vm._v(" "), _c('td', [_c('code', [_vm._v("#f02f45")])])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("font_size")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "text-align": "left"
    }
  }, [_vm._v("字号大小")]), _vm._v(" "), _c('td', [_c('code', [_vm._v("Number")])]), _vm._v(" "), _c('td', [_c('code', [_vm._v("24")])])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("super")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "text-align": "left"
    }
  }, [_vm._v("价格符号是否对其文本的上标")]), _vm._v(" "), _c('td', [_c('code', [_vm._v("Boolean")])]), _vm._v(" "), _c('td', [_c('code', [_vm._v("false")])])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("delete")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "text-align": "left"
    }
  }, [_vm._v("是否为"), _c('code', [_vm._v("Del")]), _vm._v("样式")]), _vm._v(" "), _c('td', [_c('code', [_vm._v("Boolean")])]), _vm._v(" "), _c('td', [_c('code', [_vm._v("false")])])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("suffix")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "text-align": "left"
    }
  }, [_vm._v("后缀文本")]), _vm._v(" "), _c('td', [_c('code', [_vm._v("String/Number")])]), _vm._v(" "), _c('td', [_vm._v("-")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("text_size")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "text-align": "left"
    }
  }, [_vm._v("文本和符号大小")]), _vm._v(" "), _c('td', [_c('code', [_vm._v("Number")])]), _vm._v(" "), _c('td', [_vm._v("-")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("no_shrink")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "text-align": "left"
    }
  }, [_vm._v("文本和符号价格符号不缩小")]), _vm._v(" "), _c('td', [_c('code', [_vm._v("Boolean")])]), _vm._v(" "), _c('td', [_c('code', [_vm._v("false")])])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("symbol")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "text-align": "left"
    }
  }, [_vm._v("价格符号")]), _vm._v(" "), _c('td', [_c('code', [_vm._v("String")])]), _vm._v(" "), _c('td', [_c('code', [_vm._v("￥")])])])])])
}]}

/***/ }),
/* 634 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('h1', [_vm._v("Select")]), _vm._v(" "), _c('blockquote', [_c('p', [_vm._v("选择器")])]), _vm._v(" "), _c('h2', [_vm._v("代码示例")]), _vm._v(" "), _c('p', [_c('test')], 1), _vm._v(" "), _c('h2', [_vm._v("API")]), _vm._v(" "), _c('h3', [_vm._v("Select")]), _vm._v(" "), _vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('h3', [_vm._v("SelectItem")]), _vm._v(" "), _vm._m(2)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('table', [_c('thead', [_c('tr', [_c('th', [_vm._v("参数")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "text-align": "left"
    }
  }, [_vm._v("说明")]), _vm._v(" "), _c('th', [_vm._v("类型")]), _vm._v(" "), _c('th', [_vm._v("默认值")])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_vm._v("value")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "text-align": "left"
    }
  }, [_vm._v("选择器当前选中的数据，请使用"), _c('code', [_vm._v("v-model")]), _vm._v("获取及设置")]), _vm._v(" "), _c('td', [_vm._v("-")]), _vm._v(" "), _c('td', [_vm._v("-")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("size")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "text-align": "left"
    }
  }, [_vm._v("选择器尺寸，可选值 "), _c('code', [_vm._v("sm")]), _vm._v("/"), _c('code', [_vm._v("md")]), _vm._v("/"), _c('code', [_vm._v("lg")])]), _vm._v(" "), _c('td', [_c('code', [_vm._v("String")])]), _vm._v(" "), _c('td', [_c('code', [_vm._v("md")])])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("color")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "text-align": "left"
    }
  }, [_vm._v("选择器聚焦时的颜色, 支持两种格式"), _c('code', [_vm._v("#f00")]), _vm._v("/"), _c('code', [_vm._v("rgb(255,255,255)")])]), _vm._v(" "), _c('td', [_c('code', [_vm._v("String")])]), _vm._v(" "), _c('td', [_vm._v("-")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("label")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "text-align": "left"
    }
  }, [_vm._v("标题")]), _vm._v(" "), _c('td', [_c('code', [_vm._v("String")])]), _vm._v(" "), _c('td', [_c('code', [_vm._v("请选择")]), _vm._v("/"), _c('code', [_vm._v("已选择")])])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("data")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "text-align": "left"
    }
  }, [_vm._v("选择器数据")]), _vm._v(" "), _c('td', [_c('code', [_vm._v("Array")])]), _vm._v(" "), _c('td', [_vm._v("-")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("show_by")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "text-align": "left"
    }
  }, [_vm._v("指定选项展示的值, 默认展示data[index]")]), _vm._v(" "), _c('td', [_c('code', [_vm._v("String")])]), _vm._v(" "), _c('td', [_vm._v("-")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("value_by")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "text-align": "left"
    }
  }, [_vm._v("指定选项返回的值, 默认返回data[index]")]), _vm._v(" "), _c('td', [_c('code', [_vm._v("String")])]), _vm._v(" "), _c('td', [_vm._v("-")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("float")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "text-align": "left"
    }
  }, [_vm._v("标题是否浮动")]), _vm._v(" "), _c('td', [_c('code', [_vm._v("Boolean")])]), _vm._v(" "), _c('td', [_c('code', [_vm._v("false")])])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("disabled")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "text-align": "left"
    }
  }, [_vm._v("是否禁用")]), _vm._v(" "), _c('td', [_c('code', [_vm._v("Boolean")])]), _vm._v(" "), _c('td', [_c('code', [_vm._v("false")])])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("default_first")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "text-align": "left"
    }
  }, [_vm._v("是否默认选中第一个选项")]), _vm._v(" "), _c('td', [_c('code', [_vm._v("Boolean")])]), _vm._v(" "), _c('td', [_c('code', [_vm._v("false")])])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("clear_invalid")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "text-align": "left"
    }
  }, [_vm._v("是否自动清空无效值, 如果value并未存在data数据中")]), _vm._v(" "), _c('td', [_c('code', [_vm._v("Boolean")])]), _vm._v(" "), _c('td', [_c('code', [_vm._v("false")])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('table', [_c('thead', [_c('tr', [_c('th', [_vm._v("事件")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "text-align": "left"
    }
  }, [_vm._v("说明")]), _vm._v(" "), _c('th', [_vm._v("类型")]), _vm._v(" "), _c('th', [_vm._v("使用")]), _vm._v(" "), _c('th', [_vm._v("结果")])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_vm._v("close")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "text-align": "left"
    }
  }, [_vm._v("关掉当前Select选择器")]), _vm._v(" "), _c('td', [_vm._v("触发事件")]), _vm._v(" "), _c('td', [_c('code', [_vm._v("component.$emit('close')")])]), _vm._v(" "), _c('td', [_vm._v("-")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("form-verify")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "text-align": "left"
    }
  }, [_vm._v("验证当前选择器是否选中")]), _vm._v(" "), _c('td', [_vm._v("触发事件")]), _vm._v(" "), _c('td', [_c('code', [_vm._v("component.$emit('form-verify')")]), _vm._v("/"), _c('code', [_vm._v("this.$root.$emit('form-verify')")])]), _vm._v(" "), _c('td', [_vm._v("-")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('table', [_c('thead', [_c('tr', [_c('th', [_vm._v("参数")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "text-align": "left"
    }
  }, [_vm._v("说明")]), _vm._v(" "), _c('th', [_vm._v("类型")]), _vm._v(" "), _c('th', [_vm._v("默认值")])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_vm._v("active")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "text-align": "left"
    }
  }, [_vm._v("选中状态")]), _vm._v(" "), _c('td', [_c('code', [_vm._v("Boolean")])]), _vm._v(" "), _c('td', [_c('code', [_vm._v("false")])])])])])
}]}

/***/ }),
/* 635 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('h1', [_vm._v("Loadmore")]), _vm._v(" "), _c('blockquote', [_c('p', [_vm._v("加载更多")])]), _vm._v(" "), _c('h2', [_vm._v("代码示例")]), _vm._v(" "), _c('p', [_vm._v("以下示例，模拟异步加载的时间为 1 秒")]), _vm._v(" "), _c('p', [_c('test')], 1), _vm._v(" "), _c('h2', [_vm._v("API")]), _vm._v(" "), _vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _vm._m(2), _vm._v(" "), _c('h2', [_vm._v("Slot")]), _vm._v(" "), _vm._m(3), _vm._v(" "), _vm._m(4), _vm._v(" "), _c('p', [_vm._v("e.g.")]), _vm._v(" "), _vm._m(5)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('table', [_c('thead', [_c('tr', [_c('th', [_vm._v("参数")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "text-align": "left"
    }
  }, [_vm._v("说明")]), _vm._v(" "), _c('th', [_vm._v("类型")]), _vm._v(" "), _c('th', [_vm._v("默认值")])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_vm._v("done")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "text-align": "left"
    }
  }, [_vm._v("是否已经全部加载完毕")]), _vm._v(" "), _c('td', [_c('code', [_vm._v("Boolean")])]), _vm._v(" "), _c('td', [_c('code', [_vm._v("false")])])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("interval")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "text-align": "left"
    }
  }, [_vm._v("手动点击加载出现间隔")]), _vm._v(" "), _c('td', [_c('code', [_vm._v("Number")])]), _vm._v(" "), _c('td', [_c('code', [_vm._v("3")])])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("offset")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "text-align": "left"
    }
  }, [_vm._v("距离到容器底部"), _c('code', [_vm._v("300px")]), _vm._v("时加载")]), _vm._v(" "), _c('td', [_c('code', [_vm._v("Number")])]), _vm._v(" "), _c('td', [_c('code', [_vm._v("300")])])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("real_time")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "text-align": "left"
    }
  }, [_vm._v("是否每次滚动都监听容器高度")]), _vm._v(" "), _c('td', [_c('code', [_vm._v("Boolean")])]), _vm._v(" "), _c('td', [_c('code', [_vm._v("false")])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('table', [_c('thead', [_c('tr', [_c('th', [_vm._v("事件")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "text-align": "left"
    }
  }, [_vm._v("说明")]), _vm._v(" "), _c('th', [_vm._v("回调参数")])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_vm._v("load-method")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "text-align": "left"
    }
  }, [_vm._v("加载时调用方法")]), _vm._v(" "), _c('td', [_c('code', [_vm._v("[next <Function:异步加载完毕后调用>, err: <Function:加载出错时调用>]")])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('table', [_c('thead', [_c('tr', [_c('th', [_vm._v("方法")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "text-align": "left"
    }
  }, [_vm._v("说明")])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_vm._v("reset")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "text-align": "left"
    }
  }, [_vm._v("重置组件状态")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('table', [_c('thead', [_c('tr', [_c('th', [_vm._v("名字")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "text-align": "left"
    }
  }, [_vm._v("说明")])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_vm._v("loading")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "text-align": "left"
    }
  }, [_vm._v("加载中的内容")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("loadmore")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "text-align": "left"
    }
  }, [_vm._v("手动加载更多的内容")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("error")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "text-align": "left"
    }
  }, [_vm._v("出错时的内容")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('a', {
    attrs: {
      "href": "https://vuefe.cn/v2/guide/components.html#%E4%BD%9C%E7%94%A8%E5%9F%9F%E6%8F%92%E6%A7%BD"
    }
  }, [_vm._v("#")]), _vm._v(" 使用 具有特殊属性 "), _c('code', [_vm._v("scope")]), _vm._v(" 的 "), _c('code', [_vm._v("<template>")]), _vm._v(" 元素做插槽时，可在作用域中调用 "), _c('code', [_vm._v("loadmore")]), _vm._v(" 方法去继续加载.")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('pre', [_c('code', {
    staticClass: "language-html"
  }, [_c('span', {
    staticClass: "hljs-tag"
  }, [_vm._v("<"), _c('span', {
    staticClass: "hljs-name"
  }, [_vm._v("template")]), _vm._v(" "), _c('span', {
    staticClass: "hljs-attr"
  }, [_vm._v("slot")]), _vm._v("="), _c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("\"loadmore\"")]), _vm._v(" "), _c('span', {
    staticClass: "hljs-attr"
  }, [_vm._v("scope")]), _vm._v("="), _c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("\"props\"")]), _vm._v(">")]), _vm._v("\n  "), _c('span', {
    staticClass: "hljs-tag"
  }, [_vm._v("<"), _c('span', {
    staticClass: "hljs-name"
  }, [_vm._v("Btn")]), _vm._v(" "), _c('span', {
    staticClass: "hljs-attr"
  }, [_vm._v("@click")]), _vm._v("="), _c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("\"props.loadmore\"")]), _vm._v(" "), _c('span', {
    staticClass: "hljs-attr"
  }, [_vm._v("class")]), _vm._v("="), _c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("\"blue-btn\"")]), _vm._v(">")]), _vm._v("点击加载更多"), _c('span', {
    staticClass: "hljs-tag"
  }, [_vm._v("</"), _c('span', {
    staticClass: "hljs-name"
  }, [_vm._v("Btn")]), _vm._v(">")]), _vm._v("\n"), _c('span', {
    staticClass: "hljs-tag"
  }, [_vm._v("</"), _c('span', {
    staticClass: "hljs-name"
  }, [_vm._v("template")]), _vm._v(">")]), _vm._v("\n")])])
}]}

/***/ }),
/* 636 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('h1', [_vm._v("Loading")]), _vm._v(" "), _c('blockquote', [_c('p', [_vm._v("加载条")])]), _vm._v(" "), _c('h2', [_vm._v("代码示例")]), _vm._v(" "), _c('p', [_c('test')], 1), _vm._v(" "), _c('h2', [_vm._v("API")]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('h2', [_vm._v("Params")]), _vm._v(" "), _vm._m(1)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('pre', [_c('code', {
    staticClass: "language-js"
  }, [_c('span', {
    staticClass: "hljs-keyword"
  }, [_vm._v("this")]), _vm._v(".$loading.start()\n"), _c('span', {
    staticClass: "hljs-keyword"
  }, [_vm._v("this")]), _vm._v(".$loading.success()\n"), _c('span', {
    staticClass: "hljs-keyword"
  }, [_vm._v("this")]), _vm._v(".$loading.error()\n")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('table', [_c('thead', [_c('tr', [_c('th', [_vm._v("参数")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "text-align": "left"
    }
  }, [_vm._v("说明")]), _vm._v(" "), _c('th', [_vm._v("类型")]), _vm._v(" "), _c('th', [_vm._v("默认值")])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_vm._v("name")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "text-align": "left"
    }
  }, [_vm._v("description")]), _vm._v(" "), _c('td', [_c('code', [_vm._v("String")])]), _vm._v(" "), _c('td', [_vm._v("-")])])])])
}]}

/***/ }),
/* 637 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('h1', [_vm._v("CheckBox")]), _vm._v(" "), _c('blockquote', [_c('p', [_vm._v("多选框")])]), _vm._v(" "), _c('h2', [_vm._v("代码示例")]), _vm._v(" "), _c('p', [_c('test')], 1), _vm._v(" "), _c('h2', [_vm._v("API")]), _vm._v(" "), _vm._m(0)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('table', [_c('thead', [_c('tr', [_c('th', [_vm._v("参数")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "text-align": "left"
    }
  }, [_vm._v("说明")]), _vm._v(" "), _c('th', [_vm._v("类型")]), _vm._v(" "), _c('th', [_vm._v("默认值")])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_vm._v("checked")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "text-align": "left"
    }
  }, [_vm._v("多选框当前选中的数据，请使用"), _c('code', [_vm._v("v-model")]), _vm._v("获取及设置")]), _vm._v(" "), _c('td', [_vm._v("-")]), _vm._v(" "), _c('td', [_vm._v("-")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("value")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "text-align": "left"
    }
  }, [_vm._v("多选框值")]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [_c('code', [_vm._v("slot内容")])])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("size")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "text-align": "left"
    }
  }, [_vm._v("多选框尺寸，可选值 "), _c('code', [_vm._v("sm")]), _vm._v("/"), _c('code', [_vm._v("md")]), _vm._v("/"), _c('code', [_vm._v("lg")])]), _vm._v(" "), _c('td', [_c('code', [_vm._v("String")])]), _vm._v(" "), _c('td', [_c('code', [_vm._v("md")])])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("color")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "text-align": "left"
    }
  }, [_vm._v("多选框颜色")]), _vm._v(" "), _c('td', [_c('code', [_vm._v("String")])]), _vm._v(" "), _c('td', [_c('code', [_vm._v("#f02f45")])])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("disabled")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "text-align": "left"
    }
  }, [_vm._v("是否禁用")]), _vm._v(" "), _c('td', [_c('code', [_vm._v("Boolean")])]), _vm._v(" "), _c('td', [_c('code', [_vm._v("false")])])])])])
}]}

/***/ }),
/* 638 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('h1', [_vm._v("Spinner")]), _vm._v(" "), _c('blockquote', [_c('p', [_vm._v("加载动画")])]), _vm._v(" "), _c('h2', [_vm._v("代码示例")]), _vm._v(" "), _c('p', [_c('test')], 1), _vm._v(" "), _c('h2', [_vm._v("API")]), _vm._v(" "), _vm._m(0)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('table', [_c('thead', [_c('tr', [_c('th', [_vm._v("参数")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "text-align": "left"
    }
  }, [_vm._v("说明")]), _vm._v(" "), _c('th', [_vm._v("类型")]), _vm._v(" "), _c('th', [_vm._v("默认值")])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_vm._v("size")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "text-align": "left"
    }
  }, [_vm._v("尺寸")]), _vm._v(" "), _c('td', [_c('code', [_vm._v("Number")])]), _vm._v(" "), _c('td', [_c('code', [_vm._v("24")])])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("color")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "text-align": "left"
    }
  }, [_vm._v("颜色")]), _vm._v(" "), _c('td', [_c('code', [_vm._v("String")])]), _vm._v(" "), _c('td', [_vm._v("-")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("wrap")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "text-align": "left"
    }
  }, [_vm._v("是否覆盖整个容器")]), _vm._v(" "), _c('td', [_c('code', [_vm._v("Boolean")])]), _vm._v(" "), _c('td', [_c('code', [_vm._v("false")])])])])])
}]}

/***/ }),
/* 639 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('h1', [_vm._v("Icon")]), _vm._v(" "), _c('blockquote', [_c('p', [_vm._v("图标")])]), _vm._v(" "), _c('h2', [_vm._v("代码示例")]), _vm._v(" "), _c('p', [_c('test')], 1), _vm._v(" "), _c('h2', [_vm._v("API")]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('h2', [_vm._v("图标列表")]), _vm._v(" "), _c('blockquote', [_c('p', [_vm._v("点击图标复制代码")])]), _vm._v(" "), _c('p', [_c('IconList')], 1)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('table', [_c('thead', [_c('tr', [_c('th', [_vm._v("参数")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "text-align": "left"
    }
  }, [_vm._v("说明")]), _vm._v(" "), _c('th', [_vm._v("类型")]), _vm._v(" "), _c('th', [_vm._v("默认值")])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_vm._v("name")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "text-align": "left"
    }
  }, [_vm._v("图标类型")]), _vm._v(" "), _c('td', [_c('code', [_vm._v("String")])]), _vm._v(" "), _c('td', [_vm._v("-")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("size")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "text-align": "left"
    }
  }, [_vm._v("图标尺寸")]), _vm._v(" "), _c('td', [_c('code', [_vm._v("Number")])]), _vm._v(" "), _c('td', [_vm._v("-")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("color")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "text-align": "left"
    }
  }, [_vm._v("图标颜色")]), _vm._v(" "), _c('td', [_c('code', [_vm._v("String")])]), _vm._v(" "), _c('td', [_vm._v("-")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("rotate")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "text-align": "left"
    }
  }, [_vm._v("是否旋转")]), _vm._v(" "), _c('td', [_c('code', [_vm._v("Boolean")])]), _vm._v(" "), _c('td', [_c('code', [_vm._v("false")])])])])])
}]}

/***/ }),
/* 640 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('h1', [_vm._v("Switch")]), _vm._v(" "), _c('blockquote', [_c('p', [_vm._v("开关")])]), _vm._v(" "), _c('h2', [_vm._v("代码示例")]), _vm._v(" "), _c('p', [_c('test')], 1), _vm._v(" "), _c('h2', [_vm._v("API")]), _vm._v(" "), _vm._m(0)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('table', [_c('thead', [_c('tr', [_c('th', [_vm._v("参数")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "text-align": "left"
    }
  }, [_vm._v("说明")]), _vm._v(" "), _c('th', [_vm._v("类型")]), _vm._v(" "), _c('th', [_vm._v("默认值")])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_vm._v("Size")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "text-align": "left"
    }
  }, [_vm._v("尺寸，可选值 "), _c('code', [_vm._v("lg")]), _vm._v("/"), _c('code', [_vm._v("md")]), _vm._v("/"), _c('code', [_vm._v("sm")])]), _vm._v(" "), _c('td', [_c('code', [_vm._v("String")])]), _vm._v(" "), _c('td', [_c('code', [_vm._v("md")])])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("value")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "text-align": "left"
    }
  }, [_vm._v("绑定值，请使用"), _c('code', [_vm._v("v-model")]), _vm._v("获取及设置")]), _vm._v(" "), _c('td', [_c('code', [_vm._v("Boolean")])]), _vm._v(" "), _c('td', [_vm._v("-")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("disabled")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "text-align": "left"
    }
  }, [_vm._v("是否禁用")]), _vm._v(" "), _c('td', [_c('code', [_vm._v("Boolean")])]), _vm._v(" "), _c('td', [_c('code', [_vm._v("false")])])])])])
}]}

/***/ }),
/* 641 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('h1', [_vm._v("Btn")]), _vm._v(" "), _c('blockquote', [_c('p', [_vm._v("按钮组件")])]), _vm._v(" "), _c('h2', [_vm._v("代码示例")]), _vm._v(" "), _c('p', [_c('test')], 1), _vm._v(" "), _c('h2', [_vm._v("API")]), _vm._v(" "), _vm._m(0)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('table', [_c('thead', [_c('tr', [_c('th', [_vm._v("参数")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "text-align": "left"
    }
  }, [_vm._v("说明")]), _vm._v(" "), _c('th', [_vm._v("类型")]), _vm._v(" "), _c('th', [_vm._v("默认值")])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_vm._v("size")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "text-align": "left"
    }
  }, [_vm._v("按钮尺寸，可选值 "), _c('code', [_vm._v("sm")]), _vm._v("/"), _c('code', [_vm._v("md")]), _vm._v("/"), _c('code', [_vm._v("lg")])]), _vm._v(" "), _c('td', [_c('code', [_vm._v("String")])]), _vm._v(" "), _c('td', [_c('code', [_vm._v("md")])])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("disabled")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "text-align": "left"
    }
  }, [_vm._v("是否禁用")]), _vm._v(" "), _c('td', [_c('code', [_vm._v("Boolean")])]), _vm._v(" "), _c('td', [_c('code', [_vm._v("false")])])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("is_loading")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "text-align": "left"
    }
  }, [_vm._v("是否加载中")]), _vm._v(" "), _c('td', [_c('code', [_vm._v("Boolean")])]), _vm._v(" "), _c('td', [_c('code', [_vm._v("false")])])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("loading_text")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "text-align": "left"
    }
  }, [_vm._v("加载时的文本")]), _vm._v(" "), _c('td', [_c('code', [_vm._v("String")])]), _vm._v(" "), _c('td', [_vm._v("-")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("prefix")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "text-align": "left"
    }
  }, [_vm._v("前置图标")]), _vm._v(" "), _c('td', [_c('code', [_vm._v("String")])]), _vm._v(" "), _c('td', [_vm._v("-")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("suffix")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "text-align": "left"
    }
  }, [_vm._v("后置图标")]), _vm._v(" "), _c('td', [_c('code', [_vm._v("String")])]), _vm._v(" "), _c('td', [_vm._v("-")])])])])
}]}

/***/ }),
/* 642 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: _vm.component_class
  }, [_c('div', {
    ref: "content",
    class: _vm.content_class
  }, [_vm._t("default", null, {
    loadmore: _vm.loadmore
  })], 2), _vm._v(" "), _c('div', {
    class: _vm.status_class
  }, [(_vm.status === 'loading') ? _vm._t("loading", [_c('div', [_c('Icon', {
    attrs: {
      "name": "loading",
      "rotate": true
    }
  }), _vm._v("\n        加载中....\n      ")], 1)], {
    loadmore: _vm.loadmore
  }) : _vm._e(), _vm._v(" "), (_vm.status === 'loadmore') ? _vm._t("loadmore", [_c('Btn', {
    nativeOn: {
      "click": function($event) {
        _vm.loadmore($event)
      }
    }
  }, [_vm._v("点击加载更多")])], {
    loadmore: _vm.loadmore
  }) : _vm._e(), _vm._v(" "), (_vm.status === 'error') ? _vm._t("error", [_c('Btn', {
    nativeOn: {
      "click": function($event) {
        _vm.loadmore($event)
      }
    }
  }, [_vm._v(_vm._s(_vm.error_msg) + " 点击重试")])], {
    loadmore: _vm.loadmore
  }) : _vm._e()], 2)])
},staticRenderFns: []}

/***/ }),
/* 643 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('h1', [_vm._v("Standard")]), _vm._v(" "), _c('blockquote', [_c('p', [_vm._v("一些基础的规范")])]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('h2', [_vm._v("Span")]), _vm._v(" "), _c('blockquote', [_c('p', [_vm._v("元素间的距离")])]), _vm._v(" "), _c('p', [_c('v-code', {
    attrs: {
      "code": _vm.gap.join(' ')
    }
  })], 1), _vm._v(" "), _c('p', [_vm._v("基本的 xsm sm md lg xlg 五档间距，UI组件和公共业务组件强制要求，具体页面设计建议遵从。")]), _vm._v(" "), _c('h2', [_vm._v("Size")]), _vm._v(" "), _c('blockquote', [_c('p', [_vm._v("基础尺寸，一般用于规范元素的高度，比如一个按钮的size。")])]), _vm._v(" "), _c('h3', [_vm._v("outer")]), _vm._v(" "), _c('p', [_c('v-code', {
    attrs: {
      "code": _vm.size_o.join(' ')
    }
  })], 1), _vm._v(" "), _c('h3', [_vm._v("inner")]), _vm._v(" "), _c('p', [_c('v-code', {
    attrs: {
      "code": _vm.size.join(' ')
    }
  })], 1), _vm._v(" "), _c('p', [_vm._v("outer用于Bar组件，inner用于Btn form等组件。")])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("尺寸相关变量在 "), _c('code', [_vm._v("/src/style/themes/size/index.styl")]), _vm._v(" 文件中修改")])
}]}

/***/ }),
/* 644 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('demo', {
    attrs: {
      "title": "Grid"
    }
  }, [_c('demo-item', {
    staticClass: "grid-demo",
    attrs: {
      "name": "default",
      "description": "基础栅格",
      "code": _vm.code
    }
  }, [_c('Row', [_c('Col', {
    attrs: {
      "span": 12
    }
  }, [_vm._v(" col-12 ")]), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 12
    }
  }, [_vm._v(" col-12 ")])], 1), _vm._v(" "), _c('Row', [_c('Col', {
    attrs: {
      "span": 6
    }
  }, [_vm._v(" col-6 ")]), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 6
    }
  }, [_vm._v(" col-6 ")]), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 6
    }
  }, [_vm._v(" col-6 ")]), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 6
    }
  }, [_vm._v(" col-6 ")])], 1), _vm._v(" "), _c('Row', [_c('Col', {
    attrs: {
      "span": 8
    }
  }, [_vm._v(" col-8 ")]), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 8
    }
  }, [_vm._v(" col-8 ")]), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 8
    }
  }, [_vm._v(" col-8 ")])], 1)], 1), _vm._v(" "), _c('demo-item', {
    staticClass: "grid-gutter-demo",
    attrs: {
      "name": "gutter",
      "description": "间隔",
      "code": _vm.gutter_code
    }
  }, [_c('Row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('Col', {
    attrs: {
      "span": 6
    }
  }, [_c('div', {
    staticClass: "gutter-box"
  }, [_vm._v("col-6")])]), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 6
    }
  }, [_c('div', {
    staticClass: "gutter-box"
  }, [_vm._v("col-6")])]), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 6
    }
  }, [_c('div', {
    staticClass: "gutter-box"
  }, [_vm._v("col-6")])]), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 6
    }
  }, [_c('div', {
    staticClass: "gutter-box"
  }, [_vm._v("col-6")])])], 1)], 1), _vm._v(" "), _c('demo-item', {
    staticClass: "grid-demo",
    attrs: {
      "name": "offset",
      "description": "区块偏移",
      "code": _vm.offset_code
    }
  }, [_c('Row', [_c('Col', {
    attrs: {
      "span": 8
    }
  }, [_vm._v(" col-8 ")]), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 8,
      "offset": 8
    }
  }, [_vm._v(" col-8 offset-8 ")])], 1), _vm._v(" "), _c('Row', [_c('Col', {
    attrs: {
      "span": 6,
      "offset": 6
    }
  }, [_vm._v(" col-6 offset-6 ")]), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 6,
      "offset": 6
    }
  }, [_vm._v(" col-6 offset-6 ")])], 1), _vm._v(" "), _c('Row', [_c('Col', {
    attrs: {
      "span": 12,
      "offset": 6
    }
  }, [_vm._v(" col-12 offset-6 ")])], 1)], 1), _vm._v(" "), _c('demo-item', {
    staticClass: "grid-demo",
    attrs: {
      "name": "pull & push",
      "description": "区块排序",
      "code": _vm.sort_code
    }
  }, [_c('Row', [_c('Col', {
    attrs: {
      "span": 18,
      "push": 6
    }
  }, [_vm._v(" col-18 push-6 ")]), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 6,
      "pull": 18
    }
  }, [_vm._v(" col-6 pull-18 ")])], 1)], 1), _vm._v(" "), _c('demo-item', {
    staticClass: "grid-demo",
    attrs: {
      "name": "responsive",
      "description": "响应式",
      "code": _vm.responsive_code
    }
  }, [_c('Row', [_c('Col', {
    attrs: {
      "xsm": 0,
      "sm": 4,
      "md": 6,
      "lg": 8,
      "xlg": 6
    }
  }, [_vm._v("Col")]), _vm._v(" "), _c('Col', {
    attrs: {
      "xsm": 24,
      "sm": 16,
      "md": 12,
      "lg": 8,
      "xlg": {
        span: 6,
        offset: 3
      }
    }
  }, [_vm._v("Col")]), _vm._v(" "), _c('Col', {
    attrs: {
      "xsm": 0,
      "sm": 4,
      "md": 6,
      "lg": 8,
      "xlg": {
        span: 6,
        offset: 3
      }
    }
  }, [_vm._v("Col")])], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 645 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('h1', [_vm._v("Input")]), _vm._v(" "), _c('blockquote', [_c('p', [_vm._v("输入栏")])]), _vm._v(" "), _c('h2', [_vm._v("代码示例")]), _vm._v(" "), _c('p', [_c('test')], 1), _vm._v(" "), _c('h2', [_vm._v("API")]), _vm._v(" "), _vm._m(0), _vm._v(" "), _vm._m(1)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('table', [_c('thead', [_c('tr', [_c('th', [_vm._v("参数")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "text-align": "left"
    }
  }, [_vm._v("说明")]), _vm._v(" "), _c('th', [_vm._v("类型")]), _vm._v(" "), _c('th', [_vm._v("默认值")])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_vm._v("value")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "text-align": "left"
    }
  }, [_vm._v("输入框的值，请使用"), _c('code', [_vm._v("v-model")]), _vm._v("获取及设置")]), _vm._v(" "), _c('td', [_vm._v("-")]), _vm._v(" "), _c('td', [_vm._v("-")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("size")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "text-align": "left"
    }
  }, [_vm._v("输入框尺寸，可选值 "), _c('code', [_vm._v("sm")]), _vm._v("/"), _c('code', [_vm._v("md")]), _vm._v("/"), _c('code', [_vm._v("lg")])]), _vm._v(" "), _c('td', [_c('code', [_vm._v("String")])]), _vm._v(" "), _c('td', [_c('code', [_vm._v("md")])])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("color")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "text-align": "left"
    }
  }, [_vm._v("输入框聚焦时的颜色, 支持两种格式"), _c('code', [_vm._v("#f00")]), _vm._v("/"), _c('code', [_vm._v("rgb(255,255,255)")])]), _vm._v(" "), _c('td', [_c('code', [_vm._v("String")])]), _vm._v(" "), _c('td', [_vm._v("-")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("label")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "text-align": "left"
    }
  }, [_vm._v("标题")]), _vm._v(" "), _c('td', [_c('code', [_vm._v("String")])]), _vm._v(" "), _c('td', [_vm._v("-")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("placeholder")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "text-align": "left"
    }
  }, [_vm._v("占位文本/提示文本")]), _vm._v(" "), _c('td', [_c('code', [_vm._v("String")])]), _vm._v(" "), _c('td', [_vm._v("-")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("type")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "text-align": "left"
    }
  }, [_vm._v("输入类型")]), _vm._v(" "), _c('td', [_c('code', [_vm._v("String")])]), _vm._v(" "), _c('td', [_c('code', [_vm._v("text")])])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("verify")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "text-align": "left"
    }
  }, [_vm._v("验证内容，可选值 "), _c('code', [_vm._v("phone")]), _vm._v("/"), _c('code', [_vm._v("password")]), _vm._v("/"), _c('code', [_vm._v("email")]), _vm._v("/"), _c('code', [_vm._v("empty")])]), _vm._v(" "), _c('td', [_c('code', [_vm._v("String")])]), _vm._v(" "), _c('td', [_vm._v("-")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("reg")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "text-align": "left"
    }
  }, [_vm._v("自定义验证正则")]), _vm._v(" "), _c('td', [_c('code', [_vm._v("String")]), _vm._v("/"), _c('code', [_vm._v("RegExp")])]), _vm._v(" "), _c('td', [_vm._v("-")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("tip")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "text-align": "left"
    }
  }, [_vm._v("验证错误提示")]), _vm._v(" "), _c('td', [_c('code', [_vm._v("String")])]), _vm._v(" "), _c('td', [_vm._v("-")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("disabled")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "text-align": "left"
    }
  }, [_vm._v("是否禁用")]), _vm._v(" "), _c('td', [_c('code', [_vm._v("Boolean")])]), _vm._v(" "), _c('td', [_c('code', [_vm._v("false")])])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("format")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "text-align": "left"
    }
  }, [_vm._v("是否格式化内容，将全角符号转化为半角, "), _c('code', [_vm._v("，")]), _vm._v(" => "), _c('code', [_vm._v(",")])]), _vm._v(" "), _c('td', [_c('code', [_vm._v("Boolean")])]), _vm._v(" "), _c('td', [_c('code', [_vm._v("false")])])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("readonly")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "text-align": "left"
    }
  }, [_vm._v("只读")]), _vm._v(" "), _c('td', [_c('code', [_vm._v("Boolean")])]), _vm._v(" "), _c('td', [_c('code', [_vm._v("false")])])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("with_border")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "text-align": "left"
    }
  }, [_vm._v("是否带边框")]), _vm._v(" "), _c('td', [_c('code', [_vm._v("Boolean")])]), _vm._v(" "), _c('td', [_c('code', [_vm._v("true")])])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("rows")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "text-align": "left"
    }
  }, [_c('code', [_vm._v("textarea")]), _vm._v("类型有效，指定默认行数")]), _vm._v(" "), _c('td', [_c('code', [_vm._v("Number")])]), _vm._v(" "), _c('td', [_c('code', [_vm._v("3")])])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("autosize")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "text-align": "left"
    }
  }, [_c('code', [_vm._v("textarea")]), _vm._v("类型有效，内容撑开高度")]), _vm._v(" "), _c('td', [_c('code', [_vm._v("Boolean")])]), _vm._v(" "), _c('td', [_c('code', [_vm._v("false")])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('table', [_c('thead', [_c('tr', [_c('th', [_vm._v("事件")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "text-align": "left"
    }
  }, [_vm._v("说明")]), _vm._v(" "), _c('th', [_vm._v("类型")]), _vm._v(" "), _c('th', [_vm._v("使用")]), _vm._v(" "), _c('th', [_vm._v("结果")])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_vm._v("form-verify")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "text-align": "left"
    }
  }, [_vm._v("验证当前选择器是否选中")]), _vm._v(" "), _c('td', [_vm._v("触发事件")]), _vm._v(" "), _c('td', [_c('code', [_vm._v("component.$emit('form-verify')")]), _vm._v("/"), _c('code', [_vm._v("this.$root.$emit('form-verify')")])]), _vm._v(" "), _c('td', [_vm._v("-")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("error")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "text-align": "left"
    }
  }, [_vm._v("手动触发错误提示（需要手动清除提示，否则一直存在）")]), _vm._v(" "), _c('td', [_vm._v("触发事件")]), _vm._v(" "), _c('td', [_c('code', [_vm._v("component.$emit('error', '错误提示')")])]), _vm._v(" "), _c('td', [_vm._v("-")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("correct")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "text-align": "left"
    }
  }, [_vm._v("手动触发正确提示")]), _vm._v(" "), _c('td', [_vm._v("触发事件")]), _vm._v(" "), _c('td', [_c('code', [_vm._v("component.$emit('correct')")])]), _vm._v(" "), _c('td', [_vm._v("-")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("clear")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "text-align": "left"
    }
  }, [_vm._v("手动清除提示")]), _vm._v(" "), _c('td', [_vm._v("触发事件")]), _vm._v(" "), _c('td', [_c('code', [_vm._v("component.$emit('clear')")])]), _vm._v(" "), _c('td', [_vm._v("-")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("verify")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "text-align": "left"
    }
  }, [_vm._v("返回验证结果")]), _vm._v(" "), _c('td', [_vm._v("监听事件")]), _vm._v(" "), _c('td', [_c('code', [_vm._v("@verify=\"result = argument[0]\"")])]), _vm._v(" "), _c('td', [_c('code', [_vm._v("true")]), _vm._v("/"), _c('code', [_vm._v("false")])])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("enter")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "text-align": "left"
    }
  }, [_vm._v("用户按下Enter键时触发")]), _vm._v(" "), _c('td', [_vm._v("监听事件")]), _vm._v(" "), _c('td', [_c('code', [_vm._v("@enter=\"dosomething\"")])]), _vm._v(" "), _c('td', [_vm._v("-")])])])])
}]}

/***/ }),
/* 646 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('h1', [_vm._v("Radio")]), _vm._v(" "), _c('blockquote', [_c('p', [_vm._v("单选框")])]), _vm._v(" "), _c('h2', [_vm._v("代码示例")]), _vm._v(" "), _c('p', [_c('test')], 1), _vm._v(" "), _c('h2', [_vm._v("API")]), _vm._v(" "), _vm._m(0)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('table', [_c('thead', [_c('tr', [_c('th', [_vm._v("参数")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "text-align": "left"
    }
  }, [_vm._v("说明")]), _vm._v(" "), _c('th', [_vm._v("类型")]), _vm._v(" "), _c('th', [_vm._v("默认值")])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_vm._v("checked")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "text-align": "left"
    }
  }, [_vm._v("单选框当前选中的数据，请使用"), _c('code', [_vm._v("v-model")]), _vm._v("获取及设置")]), _vm._v(" "), _c('td', [_vm._v("-")]), _vm._v(" "), _c('td', [_vm._v("-")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("value")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "text-align": "left"
    }
  }, [_vm._v("单选框值")]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [_c('code', [_vm._v("slot内容")])])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("size")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "text-align": "left"
    }
  }, [_vm._v("单选框尺寸，可选值 "), _c('code', [_vm._v("sm")]), _vm._v("/"), _c('code', [_vm._v("md")]), _vm._v("/"), _c('code', [_vm._v("lg")])]), _vm._v(" "), _c('td', [_c('code', [_vm._v("String")])]), _vm._v(" "), _c('td', [_c('code', [_vm._v("md")])])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("color")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "text-align": "left"
    }
  }, [_vm._v("单选框颜色")]), _vm._v(" "), _c('td', [_c('code', [_vm._v("String")])]), _vm._v(" "), _c('td', [_c('code', [_vm._v("#f02f45")])])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("reselect")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "text-align": "left"
    }
  }, [_vm._v("是否可重选")]), _vm._v(" "), _c('td', [_c('code', [_vm._v("Boolean")])]), _vm._v(" "), _c('td', [_c('code', [_vm._v("false")])])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("disabled")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "text-align": "left"
    }
  }, [_vm._v("是否禁用")]), _vm._v(" "), _c('td', [_c('code', [_vm._v("Boolean")])]), _vm._v(" "), _c('td', [_c('code', [_vm._v("false")])])])])])
}]}

/***/ }),
/* 647 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('h1', [_vm._v("Swipe")]), _vm._v(" "), _c('blockquote', [_c('p', [_vm._v("走马灯")])]), _vm._v(" "), _c('h2', [_vm._v("代码示例")]), _vm._v(" "), _c('p', [_c('test')], 1), _vm._v(" "), _c('h2', [_vm._v("API")]), _vm._v(" "), _vm._m(0), _vm._v(" "), _vm._m(1)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('table', [_c('thead', [_c('tr', [_c('th', [_vm._v("参数")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "text-align": "left"
    }
  }, [_vm._v("说明")]), _vm._v(" "), _c('th', [_vm._v("类型")]), _vm._v(" "), _c('th', [_vm._v("默认值")])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_vm._v("value")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "text-align": "left"
    }
  }, [_vm._v("Swipe的当前下标，请使用"), _c('code', [_vm._v("v-model")]), _vm._v("获取及设置")]), _vm._v(" "), _c('td', [_vm._v("-")]), _vm._v(" "), _c('td', [_vm._v("-")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("preview")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "text-align": "left"
    }
  }, [_vm._v("预览展示的滑块数目")]), _vm._v(" "), _c('td', [_c('code', [_vm._v("Number")])]), _vm._v(" "), _c('td', [_vm._v("1")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("between")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "text-align": "left"
    }
  }, [_vm._v("每个滑块之间的间距")]), _vm._v(" "), _c('td', [_c('code', [_vm._v("Number")])]), _vm._v(" "), _c('td', [_vm._v("0")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("autoplay")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "text-align": "left"
    }
  }, [_vm._v("自动滑动, 默认5000毫秒间隔，可自定义时长")]), _vm._v(" "), _c('td', [_c('code', [_vm._v("Boolean")]), _vm._v("/"), _c('code', [_vm._v("Number")])]), _vm._v(" "), _c('td', [_vm._v("false")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("trigger")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "text-align": "left"
    }
  }, [_vm._v("index的触发时机, 可选值"), _c('code', [_vm._v("change")]), _vm._v("/"), _c('code', [_vm._v("progress")])]), _vm._v(" "), _c('td', [_c('code', [_vm._v("String")])]), _vm._v(" "), _c('td', [_vm._v("change")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("arrow")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "text-align": "left"
    }
  }, [_vm._v("箭头, 可选值"), _c('code', [_vm._v("true")]), _vm._v("/"), _c('code', [_vm._v("false")]), _vm._v("/"), _c('code', [_vm._v("'hover'")])]), _vm._v(" "), _c('td', [_c('code', [_vm._v("String, Boolean")])]), _vm._v(" "), _c('td', [_vm._v("false")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("outer_arrow")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "text-align": "left"
    }
  }, [_vm._v("是否显示外部箭头, 可选值"), _c('code', [_vm._v("true")]), _vm._v("/"), _c('code', [_vm._v("false")])]), _vm._v(" "), _c('td', [_c('code', [_vm._v("Boolean")])]), _vm._v(" "), _c('td', [_vm._v("false")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("index")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "text-align": "left"
    }
  }, [_vm._v("显示下标, 可选值"), _c('code', [_vm._v("true")]), _vm._v("/"), _c('code', [_vm._v("false")])]), _vm._v(" "), _c('td', [_c('code', [_vm._v("Boolean")])]), _vm._v(" "), _c('td', [_vm._v("false")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("index_trigger")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "text-align": "left"
    }
  }, [_vm._v("下标触发滑动的方式, 可选值"), _c('code', [_vm._v("click")]), _vm._v("/"), _c('code', [_vm._v("hover")]), _vm._v("/"), _c('code', [_vm._v("false")])]), _vm._v(" "), _c('td', [_c('code', [_vm._v("String")]), _vm._v("/"), _c('code', [_vm._v("Boolean")])]), _vm._v(" "), _c('td', [_vm._v("click")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("arrow_offset")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "text-align": "left"
    }
  }, [_vm._v("箭头y轴偏差")]), _vm._v(" "), _c('td', [_c('code', [_vm._v("Number")])]), _vm._v(" "), _c('td', [_vm._v("-")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("index_x_offset")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "text-align": "left"
    }
  }, [_vm._v("下标x轴偏差")]), _vm._v(" "), _c('td', [_c('code', [_vm._v("Number")])]), _vm._v(" "), _c('td', [_vm._v("-")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("index_y_offset")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "text-align": "left"
    }
  }, [_vm._v("下标y轴偏差")]), _vm._v(" "), _c('td', [_c('code', [_vm._v("Number")])]), _vm._v(" "), _c('td', [_vm._v("-")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("sliding_num")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "text-align": "left"
    }
  }, [_vm._v("同时滑动的滑块个数")]), _vm._v(" "), _c('td', [_c('code', [_vm._v("Number")])]), _vm._v(" "), _c('td', [_vm._v("1")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("loop")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "text-align": "left"
    }
  }, [_vm._v("无限循环滑动")]), _vm._v(" "), _c('td', [_c('code', [_vm._v("Boolean")])]), _vm._v(" "), _c('td', [_vm._v("true")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("free")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "text-align": "left"
    }
  }, [_vm._v("滑块自由滑动")]), _vm._v(" "), _c('td', [_c('code', [_vm._v("Boolean")])]), _vm._v(" "), _c('td', [_vm._v("false")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("coverflow")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "text-align": "left"
    }
  }, [_vm._v("coverflow过渡效果")]), _vm._v(" "), _c('td', [_c('code', [_vm._v("Boolean")])]), _vm._v(" "), _c('td', [_vm._v("false")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("update_by")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "text-align": "left"
    }
  }, [_vm._v("指定更新数据源，Swipe会监听它，用于更新Swipe状态")]), _vm._v(" "), _c('td', [_vm._v("-")]), _vm._v(" "), _c('td', [_vm._v("-")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('table', [_c('thead', [_c('tr', [_c('th', [_vm._v("事件")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "text-align": "left"
    }
  }, [_vm._v("说明")]), _vm._v(" "), _c('th', [_vm._v("类型")]), _vm._v(" "), _c('th', [_vm._v("使用")]), _vm._v(" "), _c('th', [_vm._v("结果")])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_vm._v("slide-to")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "text-align": "left"
    }
  }, [_vm._v("滑动到指定index")]), _vm._v(" "), _c('td', [_vm._v("触发事件")]), _vm._v(" "), _c('td', [_c('code', [_vm._v("component.$emit('slide-to', 0)")])]), _vm._v(" "), _c('td', [_vm._v("-")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("slide-next")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "text-align": "left"
    }
  }, [_vm._v("滑动到后一个")]), _vm._v(" "), _c('td', [_vm._v("触发事件")]), _vm._v(" "), _c('td', [_c('code', [_vm._v("component.$emit('slide-next')")])]), _vm._v(" "), _c('td', [_vm._v("-")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("slide-prev")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "text-align": "left"
    }
  }, [_vm._v("滑动到前一个")]), _vm._v(" "), _c('td', [_vm._v("触发事件")]), _vm._v(" "), _c('td', [_c('code', [_vm._v("component.$emit('slide-prev')")])]), _vm._v(" "), _c('td', [_vm._v("-")])])])])
}]}

/***/ }),
/* 648 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('h1', [_vm._v("Tab")]), _vm._v(" "), _c('blockquote', [_c('p', [_vm._v("标签栏")])]), _vm._v(" "), _c('h2', [_vm._v("代码示例")]), _vm._v(" "), _c('p', [_c('test')], 1), _vm._v(" "), _c('h2', [_vm._v("API")]), _vm._v(" "), _vm._m(0), _vm._v(" "), _vm._m(1)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('table', [_c('thead', [_c('tr', [_c('th', [_vm._v("参数")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "text-align": "left"
    }
  }, [_vm._v("说明")]), _vm._v(" "), _c('th', [_vm._v("类型")]), _vm._v(" "), _c('th', [_vm._v("默认值")])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_vm._v("value")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "text-align": "left"
    }
  }, [_vm._v("当前索引值，请使用v-model获取及设置")]), _vm._v(" "), _c('td', [_c('code', [_vm._v("Number")])]), _vm._v(" "), _c('td', [_c('code', [_vm._v("0")])])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("data")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "text-align": "left"
    }
  }, [_vm._v("标签栏数据["), _c('code', [_vm._v("String")]), _vm._v(" / "), _c('code', [_vm._v("Object { name:标签名, icon:前置图标, suffix_icon:后置图标 }")]), _vm._v("]")]), _vm._v(" "), _c('td', [_c('code', [_vm._v("Array")])]), _vm._v(" "), _c('td', [_vm._v("-")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("trigger")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "text-align": "left"
    }
  }, [_vm._v("标签切换事件触发类型, 可选值"), _c('code', [_vm._v("click/hover")])]), _vm._v(" "), _c('td', [_c('code', [_vm._v("String")])]), _vm._v(" "), _c('td', [_c('code', [_vm._v("click")])])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("type")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "text-align": "left"
    }
  }, [_vm._v("标签类型，可选值"), _c('code', [_vm._v("padding/no_padding/fix_width/fix_width:String")])]), _vm._v(" "), _c('td', [_c('code', [_vm._v("String")])]), _vm._v(" "), _c('td', [_c('code', [_vm._v("padding")])])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("width")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "text-align": "left"
    }
  }, [_vm._v("容器宽度")]), _vm._v(" "), _c('td', [_c('code', [_vm._v("String/Number")])]), _vm._v(" "), _c('td', [_vm._v("-")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("height")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "text-align": "left"
    }
  }, [_vm._v("标签高度，可选值为 "), _c('code', [_vm._v("Number / \"auto\"")])]), _vm._v(" "), _c('td', [_c('code', [_vm._v("String/Number")])]), _vm._v(" "), _c('td', [_c('code', [_vm._v("40")])])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("font_size")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "text-align": "left"
    }
  }, [_vm._v("字体大小")]), _vm._v(" "), _c('td', [_c('code', [_vm._v("Number")])]), _vm._v(" "), _c('td', [_c('code', [_vm._v("14")])])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("gap")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "text-align": "left"
    }
  }, [_vm._v("标签之间的间隔")]), _vm._v(" "), _c('td', [_c('code', [_vm._v("Number")])]), _vm._v(" "), _c('td', [_vm._v("-")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("theme")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "text-align": "left"
    }
  }, [_vm._v("标签主题，可选值"), _c('code', [_vm._v("- /card/ticket")])]), _vm._v(" "), _c('td', [_c('code', [_vm._v("String")])]), _vm._v(" "), _c('td', [_vm._v("-")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("active-style")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "text-align": "left"
    }
  }, [_vm._v("选中时标签样式")]), _vm._v(" "), _c('td', [_c('code', [_vm._v("Object")])]), _vm._v(" "), _c('td', [_vm._v("-")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('table', [_c('thead', [_c('tr', [_c('th', [_vm._v("事件")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "text-align": "left"
    }
  }, [_vm._v("说明")]), _vm._v(" "), _c('th', [_vm._v("参数")]), _vm._v(" "), _c('th', [_vm._v("默认值")])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_vm._v("change")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "text-align": "left"
    }
  }, [_vm._v("标签切换时，回调方法")]), _vm._v(" "), _c('td', [_c('code', [_vm._v("[index <Number:索引>, title <Any:选中标签名>]")])]), _vm._v(" "), _c('td', [_vm._v("-")])])])])
}]}

/***/ }),
/* 649 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('h1', [_vm._v("SmoothScroll")]), _vm._v(" "), _c('blockquote', [_c('p', [_vm._v("平滑滚动")])]), _vm._v(" "), _c('h2', [_vm._v("代码示例")]), _vm._v(" "), _c('p', [_c('test')], 1), _vm._v(" "), _c('h2', [_vm._v("API")]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('h2', [_vm._v("Params")]), _vm._v(" "), _vm._m(1)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('code', [_vm._v("this.$smoothScroll(target, time, offset)")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('table', [_c('thead', [_c('tr', [_c('th', [_vm._v("参数")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "text-align": "left"
    }
  }, [_vm._v("说明")]), _vm._v(" "), _c('th', [_vm._v("类型")]), _vm._v(" "), _c('th', [_vm._v("默认值")])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_vm._v("target")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "text-align": "left"
    }
  }, [_vm._v("目标位置，可选值"), _c('code', [_vm._v("Number/Element")])]), _vm._v(" "), _c('td', [_c('code', [_vm._v("Number/Object")])]), _vm._v(" "), _c('td', [_c('code', [_vm._v("0")])])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("time")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "text-align": "left"
    }
  }, [_vm._v("滚动动画时间")]), _vm._v(" "), _c('td', [_c('code', [_vm._v("Number")])]), _vm._v(" "), _c('td', [_c('code', [_vm._v("500")])])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("offset")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "text-align": "left"
    }
  }, [_vm._v("偏移值，一般用于target为"), _c('code', [_vm._v("Element")]), _vm._v("时")]), _vm._v(" "), _c('td', [_c('code', [_vm._v("Number")])]), _vm._v(" "), _c('td', [_c('code', [_vm._v("0")])])])])])
}]}

/***/ }),
/* 650 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('Row', {
    staticClass: "demo-container",
    attrs: {
      "gutter": 20
    }
  }, [_c('vCol', {
    attrs: {
      "span": "24"
    }
  }, [_vm._t("default")], 2), _vm._v(" "), _c('vCol', {
    ref: "left",
    attrs: {
      "span": "12"
    }
  }, [_vm._t("left")], 2), _vm._v(" "), _c('vCol', {
    attrs: {
      "rref": "right",
      "span": "12"
    }
  }, [_vm._t("right")], 2)], 1)
},staticRenderFns: []}

/***/ }),
/* 651 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('h1', [_vm._v("BackTop")]), _vm._v(" "), _c('blockquote', [_c('p', [_vm._v("回到顶部")])]), _vm._v(" "), _c('h2', [_vm._v("代码示例")]), _vm._v(" "), _c('p', [_c('test')], 1), _vm._v(" "), _c('h2', [_vm._v("Slot")]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('h2', [_vm._v("API")]), _vm._v(" "), _vm._m(1)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('table', [_c('thead', [_c('tr', [_c('th', [_vm._v("名字")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "text-align": "left"
    }
  }, [_vm._v("说明")])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_vm._v("default")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "text-align": "left"
    }
  }, [_c('code', [_vm._v("BackTop")]), _vm._v("组件内容")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('table', [_c('thead', [_c('tr', [_c('th', [_vm._v("参数")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "text-align": "left"
    }
  }, [_vm._v("说明")]), _vm._v(" "), _c('th', [_vm._v("类型")]), _vm._v(" "), _c('th', [_vm._v("默认值")])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_vm._v("height")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "text-align": "left"
    }
  }, [_vm._v("页面滚动高度达到该值时才显示")]), _vm._v(" "), _c('td', [_c('code', [_vm._v("Number")])]), _vm._v(" "), _c('td', [_c('code', [_vm._v("200")])])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("right")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "text-align": "left"
    }
  }, [_vm._v("组件距离右边的距离")]), _vm._v(" "), _c('td', [_c('code', [_vm._v("Number")])]), _vm._v(" "), _c('td', [_c('code', [_vm._v("30")])])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("bottom")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "text-align": "left"
    }
  }, [_vm._v("组件距离底部的距离")]), _vm._v(" "), _c('td', [_c('code', [_vm._v("Number")])]), _vm._v(" "), _c('td', [_c('code', [_vm._v("30")])])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("time")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "text-align": "left"
    }
  }, [_vm._v("滚动的持续时间")]), _vm._v(" "), _c('td', [_c('code', [_vm._v("Number")])]), _vm._v(" "), _c('td', [_c('code', [_vm._v("500")])])])])])
}]}

/***/ }),
/* 652 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('h1', [_vm._v("Popover")]), _vm._v(" "), _c('blockquote', [_c('p', [_vm._v("弹出框")])]), _vm._v(" "), _c('h2', [_vm._v("代码示例")]), _vm._v(" "), _c('p', [_c('test')], 1), _vm._v(" "), _c('h2', [_vm._v("API")]), _vm._v(" "), _vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _vm._m(2), _vm._v(" "), _c('h2', [_vm._v("Slot")]), _vm._v(" "), _vm._m(3)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('table', [_c('thead', [_c('tr', [_c('th', [_vm._v("参数")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "text-align": "left"
    }
  }, [_vm._v("说明")]), _vm._v(" "), _c('th', [_vm._v("类型")]), _vm._v(" "), _c('th', [_vm._v("默认值")])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_vm._v("placement")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "text-align": "left"
    }
  }, [_vm._v("弹出框出现的位置，可选值"), _c('code', [_vm._v("top-left/top/top-right bottom-left/bottom/bottom-right left-top/left/left-bottom right-top/right/right-bottom")])]), _vm._v(" "), _c('td', [_c('code', [_vm._v("String")])]), _vm._v(" "), _c('td', [_c('code', [_vm._v("top")])])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("auto_reverse")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "text-align": "left"
    }
  }, [_vm._v("当弹出框超出页面可视区域时，是否自动反方向")]), _vm._v(" "), _c('td', [_c('code', [_vm._v("Boolean")])]), _vm._v(" "), _c('td', [_c('code', [_vm._v("true")])])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("offset")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "text-align": "left"
    }
  }, [_vm._v("弹出框出现位置的偏移值")]), _vm._v(" "), _c('td', [_c('code', [_vm._v("Number")])]), _vm._v(" "), _c('td', [_c('code', [_vm._v("10")])])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("trigger")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "text-align": "left"
    }
  }, [_vm._v("触发方式，可选值"), _c('code', [_vm._v("click/hover/focus/manual")])]), _vm._v(" "), _c('td', [_c('code', [_vm._v("String")])]), _vm._v(" "), _c('td', [_c('code', [_vm._v("click")])])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("show_arrow")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "text-align": "left"
    }
  }, [_vm._v("是否显示箭头")]), _vm._v(" "), _c('td', [_c('code', [_vm._v("Boolean")])]), _vm._v(" "), _c('td', [_c('code', [_vm._v("true")])])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("border_color")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "text-align": "left"
    }
  }, [_vm._v("边框颜色，当为"), _c('code', [_vm._v("false")]), _vm._v("时不显示边框")]), _vm._v(" "), _c('td', [_c('code', [_vm._v("Boolean/String")])]), _vm._v(" "), _c('td', [_c('code', [_vm._v("#ccc")])])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("border_radius")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "text-align": "left"
    }
  }, [_vm._v("边框圆角")]), _vm._v(" "), _c('td', [_c('code', [_vm._v("Number")])]), _vm._v(" "), _c('td', [_c('code', [_vm._v("3")])])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("use_shadow")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "text-align": "left"
    }
  }, [_vm._v("是否有边框阴影")]), _vm._v(" "), _c('td', [_c('code', [_vm._v("Boolean")])]), _vm._v(" "), _c('td', [_c('code', [_vm._v("true")])])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("width")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "text-align": "left"
    }
  }, [_vm._v("弹出框宽度，默认"), _c('code', [_vm._v("最小宽度150px")])]), _vm._v(" "), _c('td', [_c('code', [_vm._v("Number")])]), _vm._v(" "), _c('td', [_vm._v("-")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("z_index")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "text-align": "left"
    }
  }, [_vm._v("组件的堆叠层级，默认"), _c('code', [_vm._v("199")])]), _vm._v(" "), _c('td', [_c('code', [_vm._v("Number")])]), _vm._v(" "), _c('td', [_vm._v("-")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('table', [_c('thead', [_c('tr', [_c('th', [_vm._v("事件")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "text-align": "left"
    }
  }, [_vm._v("说明")]), _vm._v(" "), _c('th', [_vm._v("回调参数")])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_vm._v("show")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "text-align": "left"
    }
  }, [_vm._v("显示时触发")]), _vm._v(" "), _c('td', [_vm._v("-")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("hide")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "text-align": "left"
    }
  }, [_vm._v("关闭时触发")]), _vm._v(" "), _c('td', [_vm._v("-")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('table', [_c('thead', [_c('tr', [_c('th', [_vm._v("方法")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "text-align": "left"
    }
  }, [_vm._v("说明")])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_vm._v("open")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "text-align": "left"
    }
  }, [_vm._v("打开弹出框")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("close")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "text-align": "left"
    }
  }, [_vm._v("关闭弹出框")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("toggle")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "text-align": "left"
    }
  }, [_vm._v("切换弹出框状态")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('table', [_c('thead', [_c('tr', [_c('th', [_vm._v("名字")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "text-align": "left"
    }
  }, [_vm._v("说明")])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_vm._v("default")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "text-align": "left"
    }
  }, [_vm._v("弹出框的内容")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("reference")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "text-align": "left"
    }
  }, [_vm._v("触发弹出框显示的元素")])])])])
}]}

/***/ }),
/* 653 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('h1', [_vm._v("Hiui-PC")]), _vm._v(" "), _c('blockquote', [_c('p', [_vm._v("移动端组件库")])]), _vm._v(" "), _c('h2', [_vm._v("开发环境")]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('h2', [_vm._v("生产环境（demo）")]), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('h2', [_vm._v("生产环境（library）")]), _vm._v(" "), _vm._m(2), _vm._v(" "), _c('h2', [_vm._v("使用")]), _vm._v(" "), _vm._m(3), _vm._v(" "), _c('h3', [_vm._v("全部引入")]), _vm._v(" "), _vm._m(4), _vm._v(" "), _c('h3', [_vm._v("单个组件引入")]), _vm._v(" "), _c('blockquote', [_c('p', [_vm._v("需要安装 stylus-loader / stylus 依赖")])]), _vm._v(" "), _vm._m(5), _vm._v(" "), _vm._m(6), _vm._v(" "), _vm._m(7), _vm._v(" "), _c('p', [_vm._v("使用")]), _vm._v(" "), _vm._m(8)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('pre', [_c('code', {
    staticClass: "language-bash"
  }, [_vm._v("$ npm run dev\n")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('pre', [_c('code', {
    staticClass: "language-bash"
  }, [_vm._v("$ npm run build\n")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('pre', [_c('code', {
    staticClass: "language-bash"
  }, [_vm._v("$ npm run package\n")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('pre', [_c('code', {
    staticClass: "language-bash"
  }, [_vm._v("$ npm install hiui-pc --save\n")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('pre', [_c('code', {
    staticClass: "language-js"
  }, [_c('span', {
    staticClass: "hljs-keyword"
  }, [_vm._v("import")]), _vm._v(" hiuipc "), _c('span', {
    staticClass: "hljs-keyword"
  }, [_vm._v("from")]), _vm._v(" "), _c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("'hiui-pc'")]), _vm._v("\n"), _c('span', {
    staticClass: "hljs-keyword"
  }, [_vm._v("import")]), _vm._v(" "), _c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("'hiui-pc/dist/hiuipc.css'")]), _vm._v("\n\nVue.use(hiuipc)\n")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('pre', [_c('code', {
    staticClass: "language-html"
  }, [_c('span', {
    staticClass: "hljs-tag"
  }, [_vm._v("<"), _c('span', {
    staticClass: "hljs-name"
  }, [_vm._v("template")]), _vm._v(">")]), _vm._v("\n  "), _c('span', {
    staticClass: "hljs-tag"
  }, [_vm._v("<"), _c('span', {
    staticClass: "hljs-name"
  }, [_vm._v("Btn")]), _vm._v(" "), _c('span', {
    staticClass: "hljs-attr"
  }, [_vm._v("size")]), _vm._v("="), _c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("\"lg\"")]), _vm._v(">")]), _vm._v("Hiui-PC"), _c('span', {
    staticClass: "hljs-tag"
  }, [_vm._v("</"), _c('span', {
    staticClass: "hljs-name"
  }, [_vm._v("Btn")]), _vm._v(">")]), _vm._v("\n"), _c('span', {
    staticClass: "hljs-tag"
  }, [_vm._v("</"), _c('span', {
    staticClass: "hljs-name"
  }, [_vm._v("template")]), _vm._v(">")]), _vm._v("\n\n"), _c('span', {
    staticClass: "hljs-tag"
  }, [_vm._v("<"), _c('span', {
    staticClass: "hljs-name"
  }, [_vm._v("script")]), _vm._v(">")]), _c('span', {
    staticClass: "javascript"
  }, [_vm._v("\n  "), _c('span', {
    staticClass: "hljs-keyword"
  }, [_vm._v("import")]), _vm._v(" Btn "), _c('span', {
    staticClass: "hljs-keyword"
  }, [_vm._v("from")]), _vm._v(" "), _c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("'hiui-pc/src/components/Btn'")]), _vm._v("\n\n  "), _c('span', {
    staticClass: "hljs-keyword"
  }, [_vm._v("export")]), _vm._v(" "), _c('span', {
    staticClass: "hljs-keyword"
  }, [_vm._v("default")]), _vm._v(" {\n    "), _c('span', {
    staticClass: "hljs-attr"
  }, [_vm._v("components")]), _vm._v(": {\n      Btn\n    }\n  }\n")]), _c('span', {
    staticClass: "hljs-tag"
  }, [_vm._v("</"), _c('span', {
    staticClass: "hljs-name"
  }, [_vm._v("script")]), _vm._v(">")]), _vm._v("\n")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h4', [_vm._v("使用 "), _c('code', [_vm._v("webpack")]), _vm._v(" 配置模块别名 "), _c('code', [_vm._v("alias")]), _vm._v(" 单个引入")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('pre', [_c('code', {
    staticClass: "language-js"
  }, [_c('span', {
    staticClass: "hljs-built_in"
  }, [_vm._v("module")]), _vm._v(".exports = {\n  "), _c('span', {
    staticClass: "hljs-comment"
  }, [_vm._v("// ...")]), _vm._v("\n  resolve: {\n    "), _c('span', {
    staticClass: "hljs-attr"
  }, [_vm._v("alias")]), _vm._v(": {\n      "), _c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("'hiui'")]), _vm._v(": "), _c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("'hiui-pc/src/components'")]), _vm._v("\n    }\n  }\n}\n")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('pre', [_c('code', {
    staticClass: "language-js"
  }, [_c('span', {
    staticClass: "hljs-keyword"
  }, [_vm._v("import")]), _vm._v(" Btn "), _c('span', {
    staticClass: "hljs-keyword"
  }, [_vm._v("from")]), _vm._v(" "), _c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("'hiui/Btn'")]), _vm._v("\n")])])
}]}

/***/ }),
/* 654 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('h1', [_vm._v("Modal")]), _vm._v(" "), _c('blockquote', [_c('p', [_vm._v("弹出层")])]), _vm._v(" "), _c('h2', [_vm._v("代码示例")]), _vm._v(" "), _c('p', [_c('test')], 1), _vm._v(" "), _c('h2', [_vm._v("API")]), _vm._v(" "), _vm._m(0)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('table', [_c('thead', [_c('tr', [_c('th', [_vm._v("参数")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "text-align": "left"
    }
  }, [_vm._v("说明")]), _vm._v(" "), _c('th', [_vm._v("类型")]), _vm._v(" "), _c('th', [_vm._v("默认值")])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_vm._v("show")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "text-align": "left"
    }
  }, [_vm._v("控制弹出层显示，请使用"), _c('code', [_vm._v("v-model")]), _vm._v("获取及设置")]), _vm._v(" "), _c('td', [_c('code', [_vm._v("Boolean")])]), _vm._v(" "), _c('td', [_vm._v("-")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("type")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "text-align": "left"
    }
  }, [_vm._v("弹出层类型，可选值"), _c('code', [_vm._v("center/top/bottom/left/right")])]), _vm._v(" "), _c('td', [_c('code', [_vm._v("String")])]), _vm._v(" "), _c('td', [_c('code', [_vm._v("center")])])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("use_close")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "text-align": "left"
    }
  }, [_vm._v("是否显示关闭按钮")]), _vm._v(" "), _c('td', [_c('code', [_vm._v("Boolean")])]), _vm._v(" "), _c('td', [_c('code', [_vm._v("true")])])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("use_mask")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "text-align": "left"
    }
  }, [_vm._v("是否显示遮罩层")]), _vm._v(" "), _c('td', [_c('code', [_vm._v("Boolean")])]), _vm._v(" "), _c('td', [_c('code', [_vm._v("false")])])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("mask_close")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "text-align": "left"
    }
  }, [_vm._v("点击遮罩层是否关闭弹出层")]), _vm._v(" "), _c('td', [_c('code', [_vm._v("Boolean")])]), _vm._v(" "), _c('td', [_c('code', [_vm._v("true")])])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("render_type")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "text-align": "left"
    }
  }, [_vm._v("组件渲染类型，可选值"), _c('code', [_vm._v("show/if")])]), _vm._v(" "), _c('td', [_c('code', [_vm._v("String")])]), _vm._v(" "), _c('td', [_c('code', [_vm._v("show")])])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("use_shadow")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "text-align": "left"
    }
  }, [_vm._v("是否使用阴影")]), _vm._v(" "), _c('td', [_c('code', [_vm._v("Boolean")])]), _vm._v(" "), _c('td', [_c('code', [_vm._v("true")])])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("background_color")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "text-align": "left"
    }
  }, [_vm._v("弹出层背景色")]), _vm._v(" "), _c('td', [_c('code', [_vm._v("String")])]), _vm._v(" "), _c('td', [_c('code', [_vm._v("#fff")])])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("overflow")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "text-align": "left"
    }
  }, [_vm._v("弹出层的overflow")]), _vm._v(" "), _c('td', [_c('code', [_vm._v("String")])]), _vm._v(" "), _c('td', [_c('code', [_vm._v("visible")])])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("z_index")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "text-align": "left"
    }
  }, [_vm._v("组件的堆叠层级")]), _vm._v(" "), _c('td', [_c('code', [_vm._v("String/Number")])]), _vm._v(" "), _c('td', [_c('code', [_vm._v("999")])])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("border_radius")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "text-align": "left"
    }
  }, [_vm._v("弹出层圆角")]), _vm._v(" "), _c('td', [_c('code', [_vm._v("String")])]), _vm._v(" "), _c('td', [_c('code', [_vm._v("0")])])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("prevent_scroll")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "text-align": "left"
    }
  }, [_vm._v("是否禁止页面滚动")]), _vm._v(" "), _c('td', [_c('code', [_vm._v("Boolean")])]), _vm._v(" "), _c('td', [_c('code', [_vm._v("true")])])])])])
}]}

/***/ }),
/* 655 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('h1', [_vm._v("Bar")]), _vm._v(" "), _c('blockquote', [_c('p', [_vm._v("栏")])]), _vm._v(" "), _c('h2', [_vm._v("代码示例")]), _vm._v(" "), _c('p', [_c('test')], 1), _vm._v(" "), _c('h2', [_vm._v("API")]), _vm._v(" "), _vm._m(0)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('table', [_c('thead', [_c('tr', [_c('th', [_vm._v("参数")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "text-align": "left"
    }
  }, [_vm._v("说明")]), _vm._v(" "), _c('th', [_vm._v("类型")]), _vm._v(" "), _c('th', [_vm._v("默认值")])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_vm._v("size")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "text-align": "left"
    }
  }, [_vm._v("容器高度（使用outer标准），可选值 "), _c('code', [_vm._v("sm")]), _vm._v("/"), _c('code', [_vm._v("md")]), _vm._v("/"), _c('code', [_vm._v("lg")])]), _vm._v(" "), _c('td', [_c('code', [_vm._v("String")])]), _vm._v(" "), _c('td', [_c('code', [_vm._v("md")])])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("use_padding")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "text-align": "left"
    }
  }, [_vm._v("是否包含内边距（outer - inner）")]), _vm._v(" "), _c('td', [_c('code', [_vm._v("Boolean")])]), _vm._v(" "), _c('td', [_c('code', [_vm._v("false")])])])])])
}]}

/***/ }),
/* 656 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('h1', [_vm._v("Grid")]), _vm._v(" "), _c('blockquote', [_c('p', [_vm._v("栅格")])]), _vm._v(" "), _c('h2', [_vm._v("概念")]), _vm._v(" "), _c('blockquote', [_c('p', [_vm._v("24 栅格系统")])]), _vm._v(" "), _c('Row', {
    staticClass: "grid-concept-demo",
    attrs: {
      "gutter": 1
    }
  }, [_c('Col', {
    attrs: {
      "span": 6
    }
  }, [_vm._v(" col-6 ")]), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 6
    }
  }, [_vm._v(" col-6 ")]), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 6
    }
  }, [_vm._v(" col-6 ")]), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 6
    }
  }, [_vm._v(" col-6 ")])], 1), _vm._v(" "), _c('Row', {
    staticClass: "grid-concept-demo",
    attrs: {
      "gutter": 1
    }
  }, [_c('Col', {
    attrs: {
      "span": 8
    }
  }, [_vm._v(" col-8 ")]), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 8
    }
  }, [_vm._v(" col-8 ")])], 1), _vm._v(" "), _c('Row', {
    staticClass: "grid-concept-demo",
    attrs: {
      "gutter": 1
    }
  }, [_c('Col', {
    attrs: {
      "span": 6,
      "offset": 6
    }
  }, [_vm._v(" col-6 offset-6 ")]), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 6,
      "offset": 6
    }
  }, [_vm._v(" col-6 offset-6 ")])], 1), _vm._v(" "), _c('h2', [_vm._v("代码示例")]), _vm._v(" "), _c('test'), _vm._v(" "), _c('h2', [_vm._v("API")]), _vm._v(" "), _c('h3', [_vm._v("Row")]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('h3', [_vm._v("Col")]), _vm._v(" "), _vm._m(1)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('table', [_c('thead', [_c('tr', [_c('th', [_vm._v("参数")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "text-align": "left"
    }
  }, [_vm._v("说明")]), _vm._v(" "), _c('th', [_vm._v("类型")]), _vm._v(" "), _c('th', [_vm._v("默认值")])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_vm._v("gutter")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "text-align": "left"
    }
  }, [_vm._v("栅格间隔")]), _vm._v(" "), _c('td', [_c('code', [_vm._v("Number")])]), _vm._v(" "), _c('td', [_vm._v("0")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('table', [_c('thead', [_c('tr', [_c('th', [_vm._v("参数")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "text-align": "left"
    }
  }, [_vm._v("说明")]), _vm._v(" "), _c('th', [_vm._v("类型")]), _vm._v(" "), _c('th', [_vm._v("默认值")])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_vm._v("span")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "text-align": "left"
    }
  }, [_vm._v("栅格格数，为"), _c('code', [_vm._v("0")]), _vm._v("时为"), _c('code', [_vm._v("display: none")])]), _vm._v(" "), _c('td', [_c('code', [_vm._v("Number|String")])]), _vm._v(" "), _c('td', [_vm._v("-")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("offset")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "text-align": "left"
    }
  }, [_vm._v("栅格往右偏移个数")]), _vm._v(" "), _c('td', [_c('code', [_vm._v("Number|String")])]), _vm._v(" "), _c('td', [_vm._v("0")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("push")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "text-align": "left"
    }
  }, [_vm._v("栅格往右移动个数，原占位不变")]), _vm._v(" "), _c('td', [_c('code', [_vm._v("Number|String")])]), _vm._v(" "), _c('td', [_vm._v("0")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("pull")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "text-align": "left"
    }
  }, [_vm._v("栅格往左移动个数，原占位不变")]), _vm._v(" "), _c('td', [_c('code', [_vm._v("Number|String")])]), _vm._v(" "), _c('td', [_vm._v("0")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("xsm")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "text-align": "left"
    }
  }, [_c('code', [_vm._v("<768px")]), _vm._v(" 响应式栅格，可为栅格格数 或 一个包含多个属性的对象")]), _vm._v(" "), _c('td', [_c('code', [_vm._v("Number|String|Object")])]), _vm._v(" "), _c('td', [_vm._v("-")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("sm")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "text-align": "left"
    }
  }, [_c('code', [_vm._v(">=768px")]), _vm._v(" 响应式栅格，可为栅格格数 或 一个包含多个属性的对象")]), _vm._v(" "), _c('td', [_c('code', [_vm._v("Number|String|Object")])]), _vm._v(" "), _c('td', [_vm._v("-")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("md")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "text-align": "left"
    }
  }, [_c('code', [_vm._v(">=992px")]), _vm._v(" 响应式栅格，可为栅格格数 或 一个包含多个属性的对象")]), _vm._v(" "), _c('td', [_c('code', [_vm._v("Number|String|Object")])]), _vm._v(" "), _c('td', [_vm._v("-")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("lg")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "text-align": "left"
    }
  }, [_c('code', [_vm._v(">=1200px")]), _vm._v(" 响应式栅格，可为栅格格数 或 一个包含多个属性的对象")]), _vm._v(" "), _c('td', [_c('code', [_vm._v("Number|String|Object")])]), _vm._v(" "), _c('td', [_vm._v("-")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("xlg")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "text-align": "left"
    }
  }, [_c('code', [_vm._v(">=1600px")]), _vm._v(" 响应式栅格，可为栅格格数 或 一个包含多个属性的对象")]), _vm._v(" "), _c('td', [_c('code', [_vm._v("Number|String|Object")])]), _vm._v(" "), _c('td', [_vm._v("-")])])])])
}]}

/***/ }),
/* 657 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('h1', [_vm._v("Calendar")]), _vm._v(" "), _c('blockquote', [_c('p', [_vm._v("日历")])]), _vm._v(" "), _c('h2', [_vm._v("代码示例")]), _vm._v(" "), _c('p', [_c('test')], 1), _vm._v(" "), _c('h2', [_vm._v("API")]), _vm._v(" "), _vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _vm._m(2), _vm._v(" "), _c('h2', [_vm._v("Slot")]), _vm._v(" "), _vm._m(3), _vm._v(" "), _vm._m(4)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('table', [_c('thead', [_c('tr', [_c('th', [_vm._v("参数")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "text-align": "left"
    }
  }, [_vm._v("说明")]), _vm._v(" "), _c('th', [_vm._v("类型")]), _vm._v(" "), _c('th', [_vm._v("默认值")])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_vm._v("date")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "text-align": "left"
    }
  }, [_vm._v("日历当前选中的日期，请使用"), _c('code', [_vm._v("v-model")]), _vm._v("获取及设置")]), _vm._v(" "), _c('td', [_c('code', [_vm._v("Date")])]), _vm._v(" "), _c('td', [_vm._v("-")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("daterange")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "text-align": "left"
    }
  }, [_vm._v("是否开启范围模式")]), _vm._v(" "), _c('td', [_c('code', [_vm._v("Boolean")])]), _vm._v(" "), _c('td', [_c('code', [_vm._v("false")])])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("begin_date")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "text-align": "left"
    }
  }, [_vm._v("日历起始日期，"), _c('code', [_vm._v("daterange = true")]), _vm._v("时有效，请设置"), _c('code', [_vm._v(".sync")])]), _vm._v(" "), _c('td', [_c('code', [_vm._v("Date")])]), _vm._v(" "), _c('td', [_vm._v("-")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("end_date")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "text-align": "left"
    }
  }, [_vm._v("日历结束日期，"), _c('code', [_vm._v("daterange = true")]), _vm._v("时有效，请设置"), _c('code', [_vm._v(".sync")])]), _vm._v(" "), _c('td', [_c('code', [_vm._v("Date")])]), _vm._v(" "), _c('td', [_vm._v("-")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("type")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "text-align": "left"
    }
  }, [_vm._v("日历类型，可选值"), _c('code', [_vm._v("day")]), _vm._v("/"), _c('code', [_vm._v("month")]), _vm._v("/"), _c('code', [_vm._v("year")])]), _vm._v(" "), _c('td', [_c('code', [_vm._v("String")])]), _vm._v(" "), _c('td', [_c('code', [_vm._v("day")])])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("filter")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "text-align": "left"
    }
  }, [_vm._v("过滤方法，具体看下方*")]), _vm._v(" "), _c('td', [_c('code', [_vm._v("Function")])]), _vm._v(" "), _c('td', [_vm._v("-")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("one_calendar")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "text-align": "left"
    }
  }, [_vm._v("是否单个日历显示，"), _c('code', [_vm._v("daterange = true")]), _vm._v("时有效，默认两个日历")]), _vm._v(" "), _c('td', [_c('code', [_vm._v("Boolean")])]), _vm._v(" "), _c('td', [_c('code', [_vm._v("false")])])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("is_inline")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "text-align": "left"
    }
  }, [_vm._v("是否行内显示")]), _vm._v(" "), _c('td', [_c('code', [_vm._v("Boolean")])]), _vm._v(" "), _c('td', [_c('code', [_vm._v("false")])])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("format")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "text-align": "left"
    }
  }, [_vm._v("格式化展示的值, 默认"), _c('code', [_vm._v("yyyy-MM-dd")])]), _vm._v(" "), _c('td', [_c('code', [_vm._v("String")])]), _vm._v(" "), _c('td', [_vm._v("-")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('table', [_c('thead', [_c('tr', [_c('th', [_vm._v("事件")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "text-align": "left"
    }
  }, [_vm._v("说明")]), _vm._v(" "), _c('th', [_vm._v("回调参数")])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_vm._v("change_date")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "text-align": "left"
    }
  }, [_vm._v("当日期改变时的回调")]), _vm._v(" "), _c('td', [_c('code', [_vm._v("[ date <Date:单选日期>]")]), _vm._v("/"), _c('code', [_vm._v("[ begin_date <Date:日期>, end_date <Date:结束日期>]")])])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("change_mode")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "text-align": "left"
    }
  }, [_vm._v("当模式改变时的回调")]), _vm._v(" "), _c('td', [_c('code', [_vm._v("[ mode <String:模式>]")])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('pre', [_c('code', {
    staticClass: "language-js"
  }, [_c('span', {
    staticClass: "hljs-function"
  }, [_c('span', {
    staticClass: "hljs-keyword"
  }, [_vm._v("function")]), _vm._v(" "), _c('span', {
    staticClass: "hljs-title"
  }, [_vm._v("filter")]), _vm._v(" ("), _c('span', {
    staticClass: "hljs-params"
  }, [_vm._v("date")]), _vm._v(") ")]), _vm._v("{\n  "), _c('span', {
    staticClass: "hljs-comment"
  }, [_vm._v("// 返回 true 则可用，返回 false 则禁用")]), _vm._v("\n  "), _c('span', {
    staticClass: "hljs-keyword"
  }, [_vm._v("return")]), _vm._v(" "), _c('span', {
    staticClass: "hljs-built_in"
  }, [_vm._v("Boolean")]), _vm._v("\n}\n")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('table', [_c('thead', [_c('tr', [_c('th', [_vm._v("名字")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "text-align": "left"
    }
  }, [_vm._v("说明")])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_vm._v("day")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "text-align": "left"
    }
  }, [_vm._v("日期")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("month")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "text-align": "left"
    }
  }, [_vm._v("月份")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("year")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "text-align": "left"
    }
  }, [_vm._v("年份")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("display")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "text-align": "left"
    }
  }, [_vm._v("展示")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('a', {
    attrs: {
      "href": "https://vuefe.cn/v2/guide/components.html#%E4%BD%9C%E7%94%A8%E5%9F%9F%E6%8F%92%E6%A7%BD"
    }
  }, [_vm._v("#")]), _vm._v(" 使用 具有特殊属性 "), _c('code', [_vm._v("scope")]), _vm._v(" 的 "), _c('code', [_vm._v("<template>")]), _vm._v(" 元素做插槽时，可在作用域中获取 "), _c('code', [_vm._v("day")]), _vm._v("/"), _c('code', [_vm._v("month")]), _vm._v("/"), _c('code', [_vm._v("year")]), _vm._v("数据, "), _c('code', [_vm._v("nextMonth")]), _vm._v("/"), _c('code', [_vm._v("prevMonth")]), _vm._v("/"), _c('code', [_vm._v("nextYear")]), _vm._v("/"), _c('code', [_vm._v("prevYear")]), _vm._v("/.")])
}]}

/***/ }),
/* 658 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('h1', [_vm._v("Tabs")]), _vm._v(" "), _c('blockquote', [_c('p', [_vm._v("标签页")])]), _vm._v(" "), _c('h2', [_vm._v("代码示例")]), _vm._v(" "), _c('p', [_c('test')], 1), _vm._v(" "), _c('h2', [_vm._v("API")]), _vm._v(" "), _c('h3', [_vm._v("Tabs")]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('h3', [_vm._v("TabPane")]), _vm._v(" "), _vm._m(1)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('table', [_c('thead', [_c('tr', [_c('th', [_vm._v("参数")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "text-align": "left"
    }
  }, [_vm._v("说明")]), _vm._v(" "), _c('th', [_vm._v("类型")]), _vm._v(" "), _c('th', [_vm._v("默认值")])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_vm._v("type")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "text-align": "left"
    }
  }, [_vm._v("标签类型，可选值"), _c('code', [_vm._v("padding/no_padding/fix_width/fix_width:String")])]), _vm._v(" "), _c('td', [_c('code', [_vm._v("String")])]), _vm._v(" "), _c('td', [_c('code', [_vm._v("padding")])])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("active-style")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "text-align": "left"
    }
  }, [_vm._v("选中时标签样式")]), _vm._v(" "), _c('td', [_c('code', [_vm._v("Object")])]), _vm._v(" "), _c('td', [_vm._v("-")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("shouldChange")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "text-align": "left"
    }
  }, [_vm._v("标签切换前调用，返回false时则不切换标签[@params: name, vm]")]), _vm._v(" "), _c('td', [_c('code', [_vm._v("Function")])]), _vm._v(" "), _c('td', [_vm._v("-")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('table', [_c('thead', [_c('tr', [_c('th', [_vm._v("参数")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "text-align": "left"
    }
  }, [_vm._v("说明")]), _vm._v(" "), _c('th', [_vm._v("类型")]), _vm._v(" "), _c('th', [_vm._v("默认值")])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_vm._v("name")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "text-align": "left"
    }
  }, [_vm._v("标签Value，用于识别当前面板，默认为索引值")]), _vm._v(" "), _c('td', [_c('code', [_vm._v("String")])]), _vm._v(" "), _c('td', [_vm._v("-")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("icon")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "text-align": "left"
    }
  }, [_vm._v("前置图标")]), _vm._v(" "), _c('td', [_c('code', [_vm._v("String")])]), _vm._v(" "), _c('td', [_vm._v("-")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("disabled")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "text-align": "left"
    }
  }, [_vm._v("是否禁用标签")]), _vm._v(" "), _c('td', [_c('code', [_vm._v("Boolean")])]), _vm._v(" "), _c('td', [_c('code', [_vm._v("false")])])])])])
}]}

/***/ }),
/* 659 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('h1', [_vm._v("Toast")]), _vm._v(" "), _c('blockquote', [_c('p', [_vm._v("提示")])]), _vm._v(" "), _c('h2', [_vm._v("代码示例")]), _vm._v(" "), _c('p', [_c('test')], 1), _vm._v(" "), _c('h2', [_vm._v("API")]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('h2', [_vm._v("Options")]), _vm._v(" "), _vm._m(1)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('pre', [_c('code', {
    staticClass: "language-js"
  }, [_c('span', {
    staticClass: "hljs-keyword"
  }, [_vm._v("let")]), _vm._v(" vm = "), _c('span', {
    staticClass: "hljs-keyword"
  }, [_vm._v("this")]), _vm._v(".$toast(content, type)\n"), _c('span', {
    staticClass: "hljs-keyword"
  }, [_vm._v("let")]), _vm._v(" vm = "), _c('span', {
    staticClass: "hljs-keyword"
  }, [_vm._v("this")]), _vm._v(".$toast(content, options)\n")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('table', [_c('thead', [_c('tr', [_c('th', [_vm._v("参数")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "text-align": "left"
    }
  }, [_vm._v("说明")]), _vm._v(" "), _c('th', [_vm._v("类型")]), _vm._v(" "), _c('th', [_vm._v("默认值")])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_vm._v("content")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "text-align": "left"
    }
  }, [_vm._v("提示文本")]), _vm._v(" "), _c('td', [_c('code', [_vm._v("String")])]), _vm._v(" "), _c('td', [_vm._v("-")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("type")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "text-align": "left"
    }
  }, [_vm._v("主题，可选值"), _c('code', [_vm._v("default/primary/success/warning/error")])]), _vm._v(" "), _c('td', [_c('code', [_vm._v("String")])]), _vm._v(" "), _c('td', [_vm._v("-")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("time")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "text-align": "left"
    }
  }, [_vm._v("自动关闭的延时，单位毫秒（为"), _c('code', [_vm._v("0")]), _vm._v("时则不自动消失）")]), _vm._v(" "), _c('td', [_c('code', [_vm._v("Number")])]), _vm._v(" "), _c('td', [_c('code', [_vm._v("2000")])])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("callback")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "text-align": "left"
    }
  }, [_vm._v("消失后回调")]), _vm._v(" "), _c('td', [_c('code', [_vm._v("Function")])]), _vm._v(" "), _c('td', [_vm._v("-")])])])])
}]}

/***/ }),
/* 660 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "page"
  }, [_c('v-header'), _vm._v(" "), _c('main', {
    staticClass: "main"
  }, [_c('section', {
    staticClass: "left-content"
  }, [_c('v-nav')], 1), _vm._v(" "), _c('section', {
    staticClass: "right-content"
  }, [_c('div', {
    staticClass: "markdown-body"
  }, [_c('router-view')], 1)])])], 1)
},staticRenderFns: []}

/***/ }),
/* 661 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('demo', {
    staticClass: "modal-demo",
    attrs: {
      "title": "Modal"
    }
  }, [_c('demo-item', {
    attrs: {
      "name": "type",
      "description": "类型",
      "code": _vm.code
    },
    slot: "left"
  }, [_c('Btn', {
    on: {
      "click": function($event) {
        _vm.show = true
      }
    }
  }, [_vm._v("Center Modal")]), _vm._v(" "), _c('Modal', {
    model: {
      value: (_vm.show),
      callback: function($$v) {
        _vm.show = $$v
      },
      expression: "show"
    }
  }, [_c('h1', [_vm._v("Title")]), _vm._v(" "), _c('p', [_vm._v("This is a test txt.")])]), _vm._v(" "), _c('Btn', {
    on: {
      "click": function($event) {
        _vm.top_show = true
      }
    }
  }, [_vm._v("Top Modal")]), _vm._v(" "), _c('Modal', {
    attrs: {
      "type": 'top'
    },
    model: {
      value: (_vm.top_show),
      callback: function($$v) {
        _vm.top_show = $$v
      },
      expression: "top_show"
    }
  }, [_c('h1', [_vm._v("Title")]), _vm._v(" "), _c('p', [_vm._v("This is a test txt.")])]), _vm._v(" "), _c('Btn', {
    on: {
      "click": function($event) {
        _vm.bottom_show = true
      }
    }
  }, [_vm._v("Bottom Modal")]), _vm._v(" "), _c('Modal', {
    attrs: {
      "type": 'bottom'
    },
    model: {
      value: (_vm.bottom_show),
      callback: function($$v) {
        _vm.bottom_show = $$v
      },
      expression: "bottom_show"
    }
  }, [_c('h1', [_vm._v("Title")]), _vm._v(" "), _c('p', [_vm._v("This is a test txt.")])]), _vm._v(" "), _c('Btn', {
    on: {
      "click": function($event) {
        _vm.left_show = true
      }
    }
  }, [_vm._v("Left Modal")]), _vm._v(" "), _c('Modal', {
    attrs: {
      "type": 'left'
    },
    model: {
      value: (_vm.left_show),
      callback: function($$v) {
        _vm.left_show = $$v
      },
      expression: "left_show"
    }
  }, [_c('h1', [_vm._v("Title")]), _vm._v(" "), _c('p', [_vm._v("This is a test txt.")])]), _vm._v(" "), _c('Btn', {
    on: {
      "click": function($event) {
        _vm.right_show = true
      }
    }
  }, [_vm._v("Right Modal")]), _vm._v(" "), _c('Modal', {
    attrs: {
      "type": 'right'
    },
    model: {
      value: (_vm.right_show),
      callback: function($$v) {
        _vm.right_show = $$v
      },
      expression: "right_show"
    }
  }, [_c('h1', [_vm._v("Title")]), _vm._v(" "), _c('p', [_vm._v("This is a test txt.")])])], 1), _vm._v(" "), _c('demo-item', {
    attrs: {
      "name": "mask_close",
      "description": "点击遮罩层不关闭",
      "code": _vm.mask_close_code
    },
    slot: "right"
  }, [_c('Btn', {
    on: {
      "click": function($event) {
        _vm.mask_cloe_show = true
      }
    }
  }, [_vm._v("Modal")]), _vm._v(" "), _c('Modal', {
    attrs: {
      "mask_close": false
    },
    model: {
      value: (_vm.mask_cloe_show),
      callback: function($$v) {
        _vm.mask_cloe_show = $$v
      },
      expression: "mask_cloe_show"
    }
  }, [_c('h1', [_vm._v("Title")]), _vm._v(" "), _c('p', [_vm._v("This is a test txt.")])])], 1), _vm._v(" "), _c('demo-item', {
    attrs: {
      "name": "mask_close",
      "description": "不显示遮罩层",
      "code": _vm.mask_show_code
    },
    slot: "right"
  }, [_c('Btn', {
    on: {
      "click": function($event) {
        _vm.mask_show = true
      }
    }
  }, [_vm._v("Modal")]), _vm._v(" "), _c('Modal', {
    attrs: {
      "use_mask": false
    },
    model: {
      value: (_vm.mask_show),
      callback: function($$v) {
        _vm.mask_show = $$v
      },
      expression: "mask_show"
    }
  }, [_c('h1', [_vm._v("Title")]), _vm._v(" "), _c('p', [_vm._v("This is a test txt.")])])], 1), _vm._v(" "), _c('demo-item', {
    attrs: {
      "name": "prevent_scroll",
      "description": "不禁止滚动",
      "code": _vm.prevent_code
    },
    slot: "left"
  }, [_c('Btn', {
    on: {
      "click": function($event) {
        _vm.prevent_show = true
      }
    }
  }, [_vm._v("Modal")]), _vm._v(" "), _c('Modal', {
    attrs: {
      "prevent_scroll": false
    },
    model: {
      value: (_vm.prevent_show),
      callback: function($$v) {
        _vm.prevent_show = $$v
      },
      expression: "prevent_show"
    }
  }, [_c('h1', [_vm._v("Title")]), _vm._v(" "), _c('p', [_vm._v("This is a test txt.")])])], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 662 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('demo', {
    staticClass: "price-demo",
    attrs: {
      "title": "Price"
    }
  }, [_c('demo-item', {
    attrs: {
      "name": "fontSize",
      "description": "字号大小",
      "code": _vm.code
    },
    slot: "left"
  }, [_c('Price', [_vm._v("24")]), _vm._v(" "), _c('Price', {
    attrs: {
      "font_size": 36
    }
  }, [_vm._v("36")]), _vm._v(" "), _c('Price', {
    attrs: {
      "font_size": 48
    }
  }, [_vm._v("48")])], 1), _vm._v(" "), _c('demo-item', {
    attrs: {
      "name": "color",
      "description": "颜色",
      "code": _vm.color_code
    },
    slot: "right"
  }, [_c('Price', [_vm._v("99")]), _vm._v(" "), _c('Price', {
    attrs: {
      "color": '#00a0e9'
    }
  }, [_vm._v("998")]), _vm._v(" "), _c('Price', {
    attrs: {
      "color": 'rgba(99, 99, 99, 1)'
    }
  }, [_vm._v("9998")])], 1), _vm._v(" "), _c('demo-item', {
    attrs: {
      "name": "super",
      "description": "价格符号对其文本上标",
      "code": _vm.super_code
    },
    slot: "left"
  }, [_c('Price', {
    attrs: {
      "super": true
    }
  }, [_vm._v("24")]), _vm._v(" "), _c('Price', {
    attrs: {
      "super": true,
      "font_size": 36
    }
  }, [_vm._v("36")]), _vm._v(" "), _c('Price', {
    attrs: {
      "super": true,
      "font_size": 48
    }
  }, [_vm._v("48")])], 1), _vm._v(" "), _c('demo-item', {
    attrs: {
      "name": "delete",
      "description": "删除样式",
      "code": _vm.delete_code
    },
    slot: "right"
  }, [_c('Price', {
    attrs: {
      "delete": true
    }
  }, [_vm._v("24")]), _vm._v(" "), _c('Price', {
    attrs: {
      "delete": true,
      "font_size": 36
    }
  }, [_vm._v("36")]), _vm._v(" "), _c('Price', {
    attrs: {
      "delete": true,
      "font_size": 48
    }
  }, [_vm._v("48")])], 1), _vm._v(" "), _c('demo-item', {
    attrs: {
      "name": "suffix",
      "description": "后缀文本",
      "code": _vm.suffix_code
    },
    slot: "right"
  }, [_c('Price', {
    attrs: {
      "suffix": "起"
    }
  }, [_vm._v("24")]), _vm._v(" "), _c('Price', {
    attrs: {
      "suffix": "起",
      "font_size": 36
    }
  }, [_vm._v("36")]), _vm._v(" "), _c('Price', {
    attrs: {
      "suffix": "起",
      "font_size": 48
    }
  }, [_vm._v("48")])], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 663 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: _vm.component_class
  }, [(_vm.type === 'textarea') ? [_c('textarea', {
    style: (_vm.textarea_style),
    attrs: {
      "rows": _vm.rows,
      "placeholder": _vm.placeholder,
      "disabled": _vm.disabled,
      "readonly": _vm.readonly
    },
    domProps: {
      "value": _vm.value
    },
    on: {
      "focus": function($event) {
        _vm.$emit('focus')
      },
      "blur": function($event) {
        _vm.$emit('blur')
      },
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13)) { return null; }
        _vm.$emit('enter')
      },
      "input": function($event) {
        _vm.$emit('input', $event.target.value)
      },
      "change": function($event) {
        _vm.$emit('input', _vm.reformStr($event.target.value)), _vm.$emit('change', _vm.reformStr($event.target.value))
      }
    }
  }), _vm._v(" "), _c('textarea', {
    ref: 'hidden_textarea',
    staticClass: "hidden-textarea",
    attrs: {
      "rows": _vm.rows
    },
    domProps: {
      "value": _vm.value
    }
  })] : _c('input', {
    attrs: {
      "type": _vm.type,
      "placeholder": _vm.placeholder,
      "disabled": _vm.disabled,
      "readonly": _vm.readonly
    },
    domProps: {
      "value": _vm.value
    },
    on: {
      "focus": function($event) {
        _vm.$emit('focus')
      },
      "blur": function($event) {
        _vm.$emit('blur')
      },
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13)) { return null; }
        _vm.$emit('enter')
      },
      "input": function($event) {
        _vm.$emit('input', $event.target.value)
      },
      "change": function($event) {
        _vm.$emit('input', _vm.reformStr($event.target.value)), _vm.$emit('change', _vm.reformStr($event.target.value))
      }
    }
  })], 2)
},staticRenderFns: []}

/***/ }),
/* 664 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('demo', {
    staticClass: "icon-demo",
    attrs: {
      "title": "Icon"
    }
  }, [_c('demo-item', {
    attrs: {
      "name": "default",
      "description": "默认",
      "code": _vm.size_code
    },
    slot: "left"
  }, [_c('Btn', {
    on: {
      "click": function($event) {
        _vm.$toast(_vm.nowDate)
      }
    }
  }, [_vm._v("Toast")])], 1), _vm._v(" "), _c('demo-item', {
    staticClass: "type-btn-group",
    attrs: {
      "name": "type",
      "description": "主题",
      "code": _vm.type_code
    },
    slot: "right"
  }, [_c('Btn', {
    on: {
      "click": function($event) {
        _vm.$toast(_vm.nowDate, 'default')
      }
    }
  }, [_vm._v("Default")]), _vm._v(" "), _c('Btn', {
    on: {
      "click": function($event) {
        _vm.$toast(_vm.nowDate, 'primary')
      }
    }
  }, [_vm._v("Primary")]), _vm._v(" "), _c('Btn', {
    on: {
      "click": function($event) {
        _vm.$toast(_vm.nowDate, 'success')
      }
    }
  }, [_vm._v("Success")]), _vm._v(" "), _c('Btn', {
    on: {
      "click": function($event) {
        _vm.$toast(_vm.nowDate, 'warning')
      }
    }
  }, [_vm._v("Warning")]), _vm._v(" "), _c('Btn', {
    on: {
      "click": function($event) {
        _vm.$toast(_vm.nowDate, 'error')
      }
    }
  }, [_vm._v("Error")])], 1), _vm._v(" "), _c('demo-item', {
    attrs: {
      "name": "time",
      "description": "自动关闭的延时，单位毫秒",
      "code": _vm.time_code
    },
    slot: "left"
  }, [_c('Btn', {
    on: {
      "click": function($event) {
        _vm.$toast('一秒后消失', {
          time: 1000
        })
      }
    }
  }, [_vm._v("延迟一秒")]), _vm._v(" "), _c('Btn', {
    on: {
      "click": _vm.control
    }
  }, [_vm._v("手动控制")])], 1), _vm._v(" "), _c('demo-item', {
    attrs: {
      "name": "callback",
      "description": "消失后的回调",
      "code": _vm.callback_code
    },
    slot: "right"
  }, [_c('Btn', {
    on: {
      "click": function($event) {
        _vm.$toast(_vm.nowDate, {
          callback: function () { return _vm.$toast('Callback！'); }
        })
      }
    }
  }, [_vm._v("回调函数")])], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 665 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('demo', {
    staticClass: "tab-demo",
    attrs: {
      "title": "Tab"
    }
  }, [_c('demo-item', {
    attrs: {
      "name": "default",
      "description": "默认",
      "code": _vm.code
    },
    slot: "left"
  }, [_c('Tab', {
    attrs: {
      "data": ['标签一', '标签二', '标签三']
    },
    model: {
      value: (_vm.default_index),
      callback: function($$v) {
        _vm.default_index = $$v
      },
      expression: "default_index"
    }
  })], 1), _vm._v(" "), _c('demo-item', {
    attrs: {
      "name": "type",
      "description": "类型",
      "code": _vm.type_code
    },
    slot: "right"
  }, [_c('Tab', {
    attrs: {
      "data": ['标签一', '标签二', '标签三'],
      "type": 'no_padding'
    },
    model: {
      value: (_vm.type_index),
      callback: function($$v) {
        _vm.type_index = $$v
      },
      expression: "type_index"
    }
  }), _vm._v(" "), _c('Tab', {
    attrs: {
      "data": ['标签一', '标签二', '标签三'],
      "type": 'fix_width'
    },
    model: {
      value: (_vm.type_index),
      callback: function($$v) {
        _vm.type_index = $$v
      },
      expression: "type_index"
    }
  }), _vm._v(" "), _c('Tab', {
    attrs: {
      "data": ['标签一', '标签二', '标签三'],
      "type": 'fix_width:25%'
    },
    model: {
      value: (_vm.type_index),
      callback: function($$v) {
        _vm.type_index = $$v
      },
      expression: "type_index"
    }
  })], 1), _vm._v(" "), _c('demo-item', {
    attrs: {
      "name": "theme",
      "description": "主题",
      "code": _vm.theme_code
    },
    slot: "left"
  }, [_c('Tab', {
    attrs: {
      "data": ['标签一', '标签二', '标签三']
    },
    model: {
      value: (_vm.theme_index),
      callback: function($$v) {
        _vm.theme_index = $$v
      },
      expression: "theme_index"
    }
  }), _vm._v(" "), _c('Tab', {
    attrs: {
      "data": ['标签一', '标签二', '标签三'],
      "theme": 'card'
    },
    model: {
      value: (_vm.theme_index),
      callback: function($$v) {
        _vm.theme_index = $$v
      },
      expression: "theme_index"
    }
  }), _vm._v(" "), _c('Tab', {
    attrs: {
      "data": ['标签一', '标签二', '标签三'],
      "theme": 'ticket',
      "type": 'fix_width'
    },
    model: {
      value: (_vm.theme_index),
      callback: function($$v) {
        _vm.theme_index = $$v
      },
      expression: "theme_index"
    }
  })], 1), _vm._v(" "), _c('demo-item', {
    attrs: {
      "name": "trigger",
      "description": "触发类型",
      "code": _vm.trigger_code
    },
    slot: "right"
  }, [_c('Tab', {
    attrs: {
      "data": ['标签一', '标签二', '标签三'],
      "trigger": 'hover'
    },
    model: {
      value: (_vm.trigger_index),
      callback: function($$v) {
        _vm.trigger_index = $$v
      },
      expression: "trigger_index"
    }
  })], 1), _vm._v(" "), _c('demo-item', {
    attrs: {
      "name": "icon",
      "description": "图标",
      "code": _vm.icon_code
    },
    slot: "left"
  }, [_c('Tab', {
    attrs: {
      "data": ['Home', 'Cart', 'User']
    },
    model: {
      value: (_vm.icon_index),
      callback: function($$v) {
        _vm.icon_index = $$v
      },
      expression: "icon_index"
    }
  }), _vm._v(" "), _c('Tab', {
    attrs: {
      "data": [{
        name: 'Home',
        icon: 'home'
      }, {
        name: 'Cart',
        icon: 'shoppingcart'
      }, {
        name: 'User',
        icon: 'user'
      }]
    },
    model: {
      value: (_vm.icon_index),
      callback: function($$v) {
        _vm.icon_index = $$v
      },
      expression: "icon_index"
    }
  }), _vm._v(" "), _c('Tab', {
    attrs: {
      "data": [{
        name: 'Home',
        suffix_icon: 'home'
      }, {
        name: 'Cart',
        suffix_icon: 'shoppingcart'
      }, {
        name: 'User',
        suffix_icon: 'user'
      }]
    },
    model: {
      value: (_vm.icon_index),
      callback: function($$v) {
        _vm.icon_index = $$v
      },
      expression: "icon_index"
    }
  })], 1), _vm._v(" "), _c('demo-item', {
    attrs: {
      "name": "activeStyle",
      "description": "选中样式",
      "code": _vm.style_code
    },
    slot: "right"
  }, [_c('Tab', {
    attrs: {
      "data": ['标签一', '标签二', '标签三'],
      "active-style": {
        color: '#f02f45',
        borderBottomColor: '#f02f45'
      }
    },
    model: {
      value: (_vm.style_index),
      callback: function($$v) {
        _vm.style_index = $$v
      },
      expression: "style_index"
    }
  })], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 666 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('demo', {
    staticClass: "spinner-demo",
    attrs: {
      "title": "Spinner"
    }
  }, [_c('demo-item', {
    attrs: {
      "name": "color",
      "description": "颜色",
      "code": _vm.color_code
    },
    slot: "left"
  }, [_c('Spinner', {
    attrs: {
      "color": 'pink'
    }
  }), _vm._v(" "), _c('Spinner', {
    attrs: {
      "color": '#87db83'
    }
  }), _vm._v(" "), _c('Spinner', {
    attrs: {
      "color": 'rgba(255, 66, 66, 1)'
    }
  })], 1), _vm._v(" "), _c('demo-item', {
    attrs: {
      "name": "size",
      "description": "尺寸",
      "code": _vm.size_code
    },
    slot: "right"
  }, [_c('Spinner'), _vm._v(" "), _c('Spinner', {
    attrs: {
      "size": 36
    }
  }), _vm._v(" "), _c('Spinner', {
    attrs: {
      "size": 48
    }
  }), _vm._v(" "), _c('Spinner', {
    attrs: {
      "size": 60
    }
  })], 1), _vm._v(" "), _c('demo-item', {
    attrs: {
      "name": "wrap",
      "description": "覆盖整个容器, 基于最近的定位父级`relative`",
      "code": _vm.wrap_code
    },
    slot: "left"
  }, [_c('article', {
    staticClass: "article"
  }, [_c('h3', [_vm._v("Article Title")]), _vm._v(" "), _c('p', [_vm._v("This is a test text")]), _vm._v(" "), _c('Spinner', {
    attrs: {
      "wrap": true
    }
  }, [_vm._v("\n        Loading...\n      ")])], 1)])], 1)
},staticRenderFns: []}

/***/ }),
/* 667 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('demo', {
    staticClass: "popover-demo",
    attrs: {
      "title": "Popover"
    }
  }, [_c('demo-item', {
    attrs: {
      "name": "placement",
      "description": "位置",
      "code": _vm.code
    },
    slot: "left"
  }, [_c('div', {
    staticClass: "wrap"
  }, [_c('div', {
    staticClass: "top"
  }, [_c('Popover', {
    attrs: {
      "placement": 'top-left'
    }
  }, [_c('div', {
    staticClass: "test"
  }, [_vm._v("\n            Popover "), _c('br'), _vm._v("\n            This is a test txt.\n          ")]), _vm._v(" "), _c('Btn', {
    slot: "reference"
  }, [_vm._v("上左")])], 1), _vm._v(" "), _c('Popover', {
    attrs: {
      "placement": 'top'
    }
  }, [_c('div', {
    staticClass: "test"
  }, [_vm._v("\n            Popover "), _c('br'), _vm._v("\n            This is a test txt.\n          ")]), _vm._v(" "), _c('Btn', {
    slot: "reference"
  }, [_vm._v("上中")])], 1), _vm._v(" "), _c('Popover', {
    attrs: {
      "placement": 'top-right'
    }
  }, [_c('div', {
    staticClass: "test"
  }, [_vm._v("\n            Popover "), _c('br'), _vm._v("\n            This is a test txt.\n          ")]), _vm._v(" "), _c('Btn', {
    slot: "reference"
  }, [_vm._v("上右")])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "center"
  }, [_c('div', {
    staticClass: "left"
  }, [_c('Popover', {
    attrs: {
      "placement": 'left-top'
    }
  }, [_c('div', {
    staticClass: "test"
  }, [_vm._v("\n              Popover "), _c('br'), _vm._v("\n              This is a test txt.\n            ")]), _vm._v(" "), _c('Btn', {
    slot: "reference"
  }, [_vm._v("左上")])], 1), _vm._v(" "), _c('Popover', {
    attrs: {
      "placement": 'left'
    }
  }, [_c('div', {
    staticClass: "test"
  }, [_vm._v("\n              Popover "), _c('br'), _vm._v("\n              This is a test txt.\n            ")]), _vm._v(" "), _c('Btn', {
    slot: "reference"
  }, [_vm._v("左中")])], 1), _vm._v(" "), _c('Popover', {
    attrs: {
      "placement": 'left-bottom'
    }
  }, [_c('div', {
    staticClass: "test"
  }, [_vm._v("\n              Popover "), _c('br'), _vm._v("\n              This is a test txt.\n            ")]), _vm._v(" "), _c('Btn', {
    slot: "reference"
  }, [_vm._v("左下")])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "right"
  }, [_c('Popover', {
    attrs: {
      "placement": 'right-top'
    }
  }, [_c('div', {
    staticClass: "test"
  }, [_vm._v("\n              Popover "), _c('br'), _vm._v("\n              This is a test txt.\n            ")]), _vm._v(" "), _c('Btn', {
    slot: "reference"
  }, [_vm._v("右上")])], 1), _vm._v(" "), _c('Popover', {
    attrs: {
      "placement": 'right'
    }
  }, [_c('div', {
    staticClass: "test"
  }, [_vm._v("\n              Popover "), _c('br'), _vm._v("\n              This is a test txt.\n            ")]), _vm._v(" "), _c('Btn', {
    slot: "reference"
  }, [_vm._v("右中")])], 1), _vm._v(" "), _c('Popover', {
    attrs: {
      "placement": 'right-bottom'
    }
  }, [_c('div', {
    staticClass: "test"
  }, [_vm._v("\n              Popover "), _c('br'), _vm._v("\n              This is a test txt.\n            ")]), _vm._v(" "), _c('Btn', {
    slot: "reference"
  }, [_vm._v("右下")])], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "bottom"
  }, [_c('Popover', {
    attrs: {
      "placement": 'bottom-left'
    }
  }, [_c('div', {
    staticClass: "test"
  }, [_vm._v("\n            Popover "), _c('br'), _vm._v("\n            This is a test txt.\n          ")]), _vm._v(" "), _c('Btn', {
    slot: "reference"
  }, [_vm._v("下左")])], 1), _vm._v(" "), _c('Popover', {
    attrs: {
      "placement": 'bottom'
    }
  }, [_c('div', {
    staticClass: "test"
  }, [_vm._v("\n            Popover "), _c('br'), _vm._v("\n            This is a test txt.\n          ")]), _vm._v(" "), _c('Btn', {
    slot: "reference"
  }, [_vm._v("下中")])], 1), _vm._v(" "), _c('Popover', {
    attrs: {
      "placement": 'bottom-right'
    }
  }, [_c('div', {
    staticClass: "test"
  }, [_vm._v("\n            Popover "), _c('br'), _vm._v("\n            This is a test txt.\n          ")]), _vm._v(" "), _c('Btn', {
    slot: "reference"
  }, [_vm._v("下右")])], 1)], 1)])]), _vm._v(" "), _c('demo-item', {
    attrs: {
      "name": "trigger",
      "description": "触发类型",
      "code": _vm.trigger_code
    },
    slot: "right"
  }, [_c('Popover', [_c('div', {
    staticClass: "test"
  }, [_vm._v("\n        Popover "), _c('br'), _vm._v("\n        This is a test txt.\n      ")]), _vm._v(" "), _c('Btn', {
    slot: "reference"
  }, [_vm._v("Click")])], 1), _vm._v(" "), _c('Popover', {
    attrs: {
      "trigger": "hover"
    }
  }, [_c('div', {
    staticClass: "test"
  }, [_vm._v("\n        Popover "), _c('br'), _vm._v("\n        This is a test txt.\n      ")]), _vm._v(" "), _c('Btn', {
    slot: "reference"
  }, [_vm._v("Hover")])], 1), _vm._v(" "), _c('Popover', {
    attrs: {
      "trigger": "focus"
    }
  }, [_c('div', {
    staticClass: "test"
  }, [_vm._v("\n        Popover "), _c('br'), _vm._v("\n        This is a test txt.\n      ")]), _vm._v(" "), _c('Btn', {
    slot: "reference"
  }, [_vm._v("Focus")])], 1), _vm._v(" "), _c('Popover', {
    ref: "manual_popover",
    attrs: {
      "trigger": "manual"
    }
  }, [_c('div', {
    staticClass: "test"
  }, [_vm._v("\n        Popover "), _c('br'), _vm._v("\n        This is a test txt.\n      ")]), _vm._v(" "), _c('Btn', {
    on: {
      "click": function($event) {
        _vm.$refs.manual_popover.toggle()
      }
    },
    slot: "reference"
  }, [_vm._v("Manual")])], 1)], 1), _vm._v(" "), _c('demo-item', {
    attrs: {
      "name": "directive",
      "description": "通过指令触发, `Popover` 必须在 触发元素之前",
      "code": _vm.directive_code
    },
    slot: "right"
  }, [_c('Popover', {
    ref: "popover"
  }, [_c('div', {
    staticClass: "test"
  }, [_vm._v("\n        Popover "), _c('br'), _vm._v("\n        This is a test txt.\n      ")])]), _vm._v(" "), _c('Btn', {
    directives: [{
      name: "popover",
      rawName: "v-popover:popover",
      arg: "popover"
    }]
  }, [_vm._v("Click")])], 1), _vm._v(" "), _c('demo-item', {
    attrs: {
      "name": "event",
      "description": "回调事件",
      "code": _vm.event_code
    },
    slot: "right"
  }, [_c('Popover', {
    ref: "popover",
    on: {
      "show": function($event) {
        _vm.$toast('Show')
      },
      "hide": function($event) {
        _vm.$toast('hide')
      }
    }
  }, [_c('div', {
    staticClass: "test"
  }, [_vm._v("\n        Popover "), _c('br'), _vm._v("\n        This is a test txt.\n      ")]), _vm._v(" "), _c('Btn', {
    slot: "reference"
  }, [_vm._v("Click")])], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 668 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    class: _vm.component_class
  }, [_c('i', {
    staticClass: "radio-icon"
  }, [_c('transition', {
    attrs: {
      "name": "bounce"
    }
  }, [_c('i', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.is_active),
      expression: "is_active"
    }],
    staticClass: "active-sign",
    style: (_vm.active_style)
  })])], 1), _vm._v(" "), _c('input', {
    staticClass: "hidden-input",
    attrs: {
      "id": _vm._uid,
      "type": "radio"
    },
    domProps: {
      "value": _vm.cur_value
    },
    on: {
      "click": function($event) {
        !_vm.disabled && _vm.triggerHandler(_vm.cur_value)
      }
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "radio-label",
    attrs: {
      "for": _vm._uid
    }
  }, [_vm._t("default")], 2)])
},staticRenderFns: []}

/***/ }),
/* 669 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: _vm.component_class,
    on: {
      "mouseenter": function($event) {
        _vm.is_hover = true
      },
      "mouseleave": function($event) {
        _vm.is_hover = false
      }
    }
  }, [_c('div', {
    ref: "swiper_container",
    staticClass: "swiper-container"
  }, [_c('div', {
    staticClass: "swiper-wrapper"
  }, [_vm._t("default")], 2), _vm._v(" "), (_vm.index) ? _c('SwipeIndex', {
    attrs: {
      "swiper": _vm.swiper,
      "slides_len": _vm.slides_len,
      "index_trigger": _vm.index_trigger,
      "index_x_offset": _vm.index_x_offset,
      "index_y_offset": _vm.index_y_offset
    },
    on: {
      "active": function($event) {
        _vm.slideTo(arguments[0]), _vm.swiper.startAutoplay()
      }
    }
  }) : _vm._e()], 1), _vm._v(" "), (_vm.arrow && _vm.swiper) ? _c('SwipeArrow', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.arrow !== 'hover' || _vm.is_hover),
      expression: "arrow !== 'hover' || is_hover"
    }],
    attrs: {
      "swiper": _vm.swiper,
      "outer_arrow": _vm.outer_arrow,
      "loop": _vm.loop,
      "preview": _vm.preview,
      "arrow_offset": _vm.arrow_offset,
      "slides_len": _vm.slides_len
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 670 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('demo', {
    attrs: {
      "title": "Btn"
    }
  }, [_c('demo-item', {
    attrs: {
      "name": "size",
      "description": "按钮大小",
      "code": _vm.size_code
    },
    slot: "left"
  }, [_c('div', {
    staticClass: "btn-group"
  }, [_c('Btn', {
    attrs: {
      "size": 'sm'
    }
  }, [_vm._v("小尺寸")]), _vm._v(" "), _c('Btn', {
    attrs: {
      "size": 'md'
    }
  }, [_vm._v("中尺寸")]), _vm._v(" "), _c('Btn', {
    attrs: {
      "size": 'lg'
    }
  }, [_vm._v("大尺寸")])], 1)]), _vm._v(" "), _c('demo-item', {
    attrs: {
      "name": "icon",
      "description": "前后置图标",
      "code": _vm.icon_code
    },
    slot: "right"
  }, [_c('div', {
    staticClass: "btn-group"
  }, [_c('Btn', {
    attrs: {
      "prefix": 'arrowleft'
    }
  }, [_vm._v("Left")]), _vm._v(" "), _c('Btn', {
    attrs: {
      "prefix": 'arrowright'
    }
  }, [_vm._v("Right")]), _vm._v(" "), _c('Btn', {
    attrs: {
      "suffix": 'arrowup'
    }
  }, [_vm._v("Up")]), _vm._v(" "), _c('Btn', {
    attrs: {
      "suffix": 'arrowdown'
    }
  }, [_vm._v("Down")])], 1)]), _vm._v(" "), _c('demo-item', {
    attrs: {
      "name": "status",
      "description": "按钮状态",
      "code": _vm.status_code
    },
    slot: "left"
  }, [_c('div', {
    staticClass: "btn-group"
  }, [_c('Btn', {
    attrs: {
      "disabled": true
    }
  }, [_vm._v("Disabled")]), _vm._v(" "), _c('Btn', {
    attrs: {
      "is_loading": true,
      "loading_text": "Loading.."
    }
  }, [_vm._v("Btn")])], 1)]), _vm._v(" "), _c('demo-item', {
    attrs: {
      "name": "style",
      "description": "自定义样式",
      "code": _vm.style_code
    },
    slot: "right"
  }, [_c('div', {
    staticClass: "btn-group"
  }, [_c('Btn', {
    class: 'solid-btn',
    attrs: {
      "prefix": 'rollback'
    }
  }, [_vm._v("Back")]), _vm._v(" "), _c('Btn', {
    class: 'star-btn',
    attrs: {
      "prefix": 'star'
    }
  }, [_vm._v("Star")]), _vm._v(" "), _c('Btn', {
    class: 'cir-btn',
    attrs: {
      "prefix": 'search'
    }
  }), _vm._v(" "), _c('Btn', {
    class: 'fixed-width-btn',
    attrs: {
      "suffix": 'shoppingcart',
      "size": 'lg'
    }
  }, [_vm._v("购买")])], 1)])], 1)
},staticRenderFns: []}

/***/ }),
/* 671 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('h1', [_vm._v("Components")]), _vm._v(" "), _c('blockquote', [_c('p', [_vm._v("组件")])]), _vm._v(" "), _c('h2', [_vm._v("Step.1 添加组件")]), _vm._v(" "), _c('p', [_vm._v("添加组件")]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('p', [_vm._v("添加方法组件")]), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('h2', [_vm._v("Step.2 修改组件")]), _vm._v(" "), _vm._m(2), _vm._v(" "), _vm._m(3), _vm._v(" "), _c('h2', [_vm._v("Step.3 修改组件预览（Demo）")]), _vm._v(" "), _vm._m(4), _vm._v(" "), _c('p', [_vm._v("该文件为组件文档的代码示例")])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('pre', [_c('code', {
    staticClass: "language-base"
  }, [_vm._v("node add ComponentName --cn 组件中文名 --type [base, data-in, data-out]\n\n//  例如添加 Input 组件\nnode add Input --cn 输入栏 --type data-in\n")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('pre', [_c('code', {
    staticClass: "language-base"
  }, [_vm._v("node add ComponentName method --cn 组件中文名 --type [base, data-in, data-out]\n\n//  例如添加 Toast 组件\nnode add Toast method --cn 提示 --type data-out\n")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("在"), _c('code', [_vm._v("/src/components/")]), _vm._v("目录下找到生成的组件文件夹")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('pre', [_c('code', [_vm._v("Component\n  | - style/          样式\n  | - components/     子组件（未生成）\n  | - index.md        组件markdown文档\n  | - Component.vue   Vue文件\n  | - index.js        入口文件\n")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("在"), _c('code', [_vm._v("/pages/demo/")]), _vm._v("目录下找到生成的component.vue文件")])
}]}

/***/ }),
/* 672 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    class: _vm.component_class,
    style: (_vm.custom_style),
    on: {
      "mouseenter": function($event) {
        _vm.is_hover = true
      },
      "mouseleave": function($event) {
        _vm.is_hover = false
      }
    }
  }, [_c('div', {
    staticClass: "wrapper"
  }, [_c('InputLabel', {
    attrs: {
      "label": _vm.label
    }
  }), _vm._v(" "), _c('InputField', {
    attrs: {
      "type": _vm.type,
      "placeholder": _vm.placeholder,
      "disabled": _vm.disabled,
      "readonly": _vm.readonly,
      "format": _vm.format,
      "reg": _vm.reg,
      "verify": _vm.verify,
      "value": _vm.value != null ? _vm.value : _vm.val,
      "autosize": _vm.autosize,
      "rows": _vm.rows,
      "no_padding": !_vm.with_border
    },
    on: {
      "focus": _vm.focusHandler,
      "blur": function($event) {
        _vm.blurHandler(_vm.is_edited)
      },
      "enter": _vm.enterHandler,
      "input": _vm.inputHandler,
      "change": function($event) {
        _vm.$emit('change', arguments[0])
      },
      "verify": _vm.verifyHandler
    }
  }), _vm._v(" "), _c('InputTip', {
    attrs: {
      "tip": _vm.err_tip,
      "position": _vm.type === 'textarea' ? 'top' : 'middle',
      "verify": _vm.verify,
      "is_error": _vm.is_error,
      "is_correct": _vm.is_correct
    }
  })], 1)])
},staticRenderFns: []}

/***/ }),
/* 673 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('demo', {
    staticClass: "switch-demo",
    attrs: {
      "title": "Switch"
    }
  }, [_c('demo-item', {
    attrs: {
      "name": "size",
      "description": "尺寸",
      "code": _vm.code
    },
    slot: "left"
  }, [_c('vSwitch', {
    attrs: {
      "size": 'sm'
    },
    model: {
      value: (_vm.val),
      callback: function($$v) {
        _vm.val = $$v
      },
      expression: "val"
    }
  }), _vm._v(" "), _c('vSwitch', {
    attrs: {
      "size": 'md'
    },
    model: {
      value: (_vm.val),
      callback: function($$v) {
        _vm.val = $$v
      },
      expression: "val"
    }
  }), _vm._v(" "), _c('vSwitch', {
    attrs: {
      "size": 'lg'
    },
    model: {
      value: (_vm.val),
      callback: function($$v) {
        _vm.val = $$v
      },
      expression: "val"
    }
  })], 1), _vm._v(" "), _c('demo-item', {
    attrs: {
      "name": "style",
      "description": "自定义样式",
      "code": _vm.color_code
    },
    slot: "right"
  }, [_c('vSwitch', {
    class: 'green',
    model: {
      value: (_vm.val),
      callback: function($$v) {
        _vm.val = $$v
      },
      expression: "val"
    }
  })], 1), _vm._v(" "), _c('demo-item', {
    attrs: {
      "name": "status",
      "description": "状态",
      "code": _vm.status_code
    },
    slot: "left"
  }, [_c('vSwitch', {
    model: {
      value: (_vm.val),
      callback: function($$v) {
        _vm.val = $$v
      },
      expression: "val"
    }
  }), _vm._v(" "), _c('vSwitch', {
    attrs: {
      "disabled": ""
    },
    model: {
      value: (_vm.val),
      callback: function($$v) {
        _vm.val = $$v
      },
      expression: "val"
    }
  })], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 674 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h3', [_vm._v(_vm._s(_vm.data[_vm.type].name))]), _vm._v(" "), _c('div', {
    class: (_vm.type + "-group color-group pure-g")
  }, _vm._l((_vm.data[_vm.type].colors), function(name, key, i) {
    return _c('div', {
      key: i,
      class: ['color-item-wrap', ("pure-u-" + (24 / _vm.data[_vm.type].colors.length) + "-24")]
    }, [_c('div', {
      staticClass: "color-item"
    }, [_c('div', {
      staticClass: "color-name"
    }, [_vm._v(_vm._s(name))])])])
  }))])
},staticRenderFns: []}

/***/ }),
/* 675 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('demo', {
    staticClass: "loadmore-demo",
    attrs: {
      "title": "Loadmore"
    }
  }, [_c('demo-item', {
    attrs: {
      "name": "default",
      "description": "默认",
      "code": _vm.code
    }
  }, [_c('Btn', {
    staticClass: "show-btn",
    on: {
      "click": function($event) {
        _vm.setShow(0)
      }
    }
  }, [_vm._v("Show")]), _vm._v(" "), (_vm.show[0]) ? _c('Loadmore', {
    attrs: {
      "done": _vm.cur >= _vm.total
    },
    on: {
      "load-method": _vm.getNextPage
    }
  }, _vm._l((_vm.list), function(item) {
    return _c('div', {
      staticClass: "block"
    }, [_vm._v("\n        List." + _vm._s(item) + "\n      ")])
  })) : _vm._e()], 1), _vm._v(" "), _c('demo-item', {
    attrs: {
      "name": "erroe",
      "description": "错误处理",
      "code": _vm.code
    }
  }, [_c('Btn', {
    staticClass: "show-btn",
    on: {
      "click": function($event) {
        _vm.setShow(2)
      }
    }
  }, [_vm._v("Show")]), _vm._v(" "), (_vm.show[2]) ? _c('Loadmore', {
    attrs: {
      "done": _vm.cur >= _vm.total
    },
    on: {
      "load-method": _vm.getNextPage
    }
  }, _vm._l((_vm.list), function(item) {
    return _c('div', {
      staticClass: "block"
    }, [_vm._v("\n        List." + _vm._s(item) + "\n      ")])
  })) : _vm._e()], 1), _vm._v(" "), _c('demo-item', {
    attrs: {
      "name": "slot",
      "description": "自定义Slot内容",
      "code": _vm.slot_code
    }
  }, [_c('Btn', {
    staticClass: "show-btn",
    on: {
      "click": function($event) {
        _vm.setShow(1)
      }
    }
  }, [_vm._v("Show")]), _vm._v(" "), (_vm.show[1]) ? _c('Loadmore', {
    attrs: {
      "done": _vm.cur >= _vm.total
    },
    on: {
      "load-method": _vm.getNextPage
    },
    scopedSlots: _vm._u([
      ["loadmore", function(props) {
        return [_c('Btn', {
          staticClass: "blue-btn",
          on: {
            "click": props.loadmore
          }
        }, [_vm._v("点击加载更多")])]
      }],
      ["error", function(props) {
        return [_c('Btn', {
          staticClass: "error-btn",
          on: {
            "click": props.loadmore
          }
        }, [_vm._v("出错啦，重新加载")])]
      }]
    ])
  }, [_vm._l((_vm.list), function(item) {
    return _c('div', {
      staticClass: "block"
    }, [_vm._v("\n        List." + _vm._s(item) + "\n      ")])
  }), _vm._v(" "), _c('template', {
    slot: "loading"
  }, [_c('Icon', {
    staticClass: "float-icon",
    attrs: {
      "name": "heart",
      "color": "rgb(255, 66, 66)"
    }
  }), _vm._v("\n        Loading more...\n      ")], 1)], 2) : _vm._e()], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 676 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: _vm.component_class
  }, [_vm._t("default")], 2)
},staticRenderFns: []}

/***/ }),
/* 677 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: _vm.component_class
  }, [_c('transition', {
    attrs: {
      "name": "float-up"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.is_correct || _vm.is_error),
      expression: "is_correct || is_error"
    }],
    staticClass: "tip-wrapper"
  }, [(_vm.is_correct) ? _c('span', {
    staticClass: "correct-sign"
  }, [_c('Icon', {
    staticClass: "icon",
    attrs: {
      "name": "check",
      "size": 12,
      "color": "#4fae9b"
    }
  })], 1) : (_vm.is_error) ? _c('p', {
    staticClass: "tip"
  }, [_vm._v(" * " + _vm._s(_vm.self_tip))]) : _vm._e()])])], 1)
},staticRenderFns: []}

/***/ }),
/* 678 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('demo', {
    staticClass: "select-demo",
    attrs: {
      "title": "Select"
    }
  }, [_c('demo-item', {
    attrs: {
      "name": "size",
      "description": "大小",
      "code": _vm.code
    },
    slot: "left"
  }, [_c('Select', {
    attrs: {
      "data": [2, 3, 4],
      "size": 'sm'
    },
    model: {
      value: (_vm.test),
      callback: function($$v) {
        _vm.test = $$v
      },
      expression: "test"
    }
  }), _vm._v(" "), _c('Select', {
    attrs: {
      "data": [2, 3, 4],
      "size": 'md'
    },
    model: {
      value: (_vm.test),
      callback: function($$v) {
        _vm.test = $$v
      },
      expression: "test"
    }
  }), _vm._v(" "), _c('Select', {
    attrs: {
      "data": [2, 3, 4],
      "size": 'lg'
    },
    model: {
      value: (_vm.test),
      callback: function($$v) {
        _vm.test = $$v
      },
      expression: "test"
    }
  })], 1), _vm._v(" "), _c('demo-item', {
    attrs: {
      "name": "labelFloat",
      "description": "标题浮动",
      "code": _vm.float_code
    },
    slot: "right"
  }, [_c('Select', {
    attrs: {
      "data": [2, 3, 4],
      "float": true,
      "label": '我是标题'
    },
    model: {
      value: (_vm.float_test),
      callback: function($$v) {
        _vm.float_test = $$v
      },
      expression: "float_test"
    }
  }), _vm._v(" "), _c('Select', {
    attrs: {
      "data": [2, 3, 4],
      "float": true
    },
    model: {
      value: (_vm.float_test),
      callback: function($$v) {
        _vm.float_test = $$v
      },
      expression: "float_test"
    }
  }), _vm._v(" "), _c('Select', {
    attrs: {
      "data": [2, 3, 4]
    },
    model: {
      value: (_vm.float_test),
      callback: function($$v) {
        _vm.float_test = $$v
      },
      expression: "float_test"
    }
  })], 1), _vm._v(" "), _c('demo-item', {
    attrs: {
      "name": "status",
      "description": "状态",
      "code": _vm.disabled_code
    },
    slot: "left"
  }, [_c('Select', {
    attrs: {
      "data": [2, 3, 4],
      "disabled": true
    }
  }), _vm._v(" "), _c('Select', {
    attrs: {
      "data": [2, 3, 4]
    },
    model: {
      value: (_vm.disabled_test),
      callback: function($$v) {
        _vm.disabled_test = $$v
      },
      expression: "disabled_test"
    }
  })], 1), _vm._v(" "), _c('demo-item', {
    attrs: {
      "name": "color",
      "description": "颜色",
      "code": _vm.color_code
    },
    slot: "right"
  }, [_c('Select', {
    attrs: {
      "data": [2, 3, 4]
    },
    model: {
      value: (_vm.color_test),
      callback: function($$v) {
        _vm.color_test = $$v
      },
      expression: "color_test"
    }
  }), _vm._v(" "), _c('Select', {
    attrs: {
      "data": [2, 3, 4],
      "color": '#4fae9B'
    },
    model: {
      value: (_vm.color_test),
      callback: function($$v) {
        _vm.color_test = $$v
      },
      expression: "color_test"
    }
  }), _vm._v(" "), _c('Select', {
    attrs: {
      "data": [2, 3, 4],
      "color": 'rgb(0, 160, 233)'
    },
    model: {
      value: (_vm.color_test),
      callback: function($$v) {
        _vm.color_test = $$v
      },
      expression: "color_test"
    }
  })], 1), _vm._v(" "), _c('demo-item', {
    attrs: {
      "name": "custom",
      "description": "自定义行为",
      "code": _vm.custom_code
    },
    slot: "left"
  }, [_c('p', {
    staticClass: "tip"
  }, [_vm._v("选择器1 无触发close事件")]), _vm._v(" "), _c('Select', {
    model: {
      value: (_vm.custom_test),
      callback: function($$v) {
        _vm.custom_test = $$v
      },
      expression: "custom_test"
    }
  }, _vm._l((4), function(n) {
    return _c('p', {
      staticClass: "custom-option",
      on: {
        "click": function($event) {
          _vm.custom_test = "自定义选项" + n
        }
      }
    }, [_vm._v("自定义选项 " + _vm._s(n))])
  })), _vm._v(" "), _c('p', {
    staticClass: "tip"
  }, [_vm._v("选择器2 触发close事件")]), _vm._v(" "), _c('Select', {
    ref: 'select',
    model: {
      value: (_vm.custom_test),
      callback: function($$v) {
        _vm.custom_test = $$v
      },
      expression: "custom_test"
    }
  }, _vm._l((4), function(n) {
    return _c('p', {
      staticClass: "custom-option",
      on: {
        "click": function($event) {
          _vm.custom_test = "自定义选项" + n, _vm.$refs.select.$emit('close')
        }
      }
    }, [_vm._v("自定义选项 " + _vm._s(n))])
  })), _vm._v(" "), _c('br'), _vm._v(" "), _c('Btn', {
    nativeOn: {
      "click": function($event) {
        _vm.$refs.select.$emit('form-verify')
      }
    }
  }, [_vm._v("验证选择器1")]), _vm._v(" "), _c('Btn', {
    nativeOn: {
      "click": function($event) {
        _vm.$root.$emit('form-verify')
      }
    }
  }, [_vm._v("验证所有选择器")])], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 679 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: _vm.component_class,
    style: (_vm.tab_style)
  }, _vm._l((_vm.tab_data), function(item, i) {
    return _c('div', {
      key: i,
      class: [_vm.item_class, {
        active: _vm.value === i
      }],
      style: ([_vm.item_style, _vm.value === i ? _vm.activeStyle : {}]),
      on: {
        "click": function($event) {
          _vm.handleClick(i, item.name)
        },
        "mouseenter": function($event) {
          _vm.handleMouseEnter(i, item.name)
        }
      }
    }, [(item.icon) ? _c('Icon', {
      staticClass: "hiui-icon-prefix",
      attrs: {
        "name": item.icon
      }
    }) : _vm._e(), _vm._v("\n       " + _vm._s(item.name) + "\n       "), (item.suffix_icon) ? _c('Icon', {
      staticClass: "hiui-icon-suffix",
      attrs: {
        "name": item.suffix_icon
      }
    }) : _vm._e()], 1)
  }))
},staticRenderFns: []}

/***/ }),
/* 680 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "hiui-modal-fade"
    },
    on: {
      "after-leave": _vm.afterLeave
    }
  }, [(_vm.isExist) ? _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.modal_show),
      expression: "modal_show"
    }],
    class: _vm.component_class,
    style: (_vm.component_style)
  }, [(_vm.use_mask) ? _c('div', {
    staticClass: "hiui-modal-mask",
    on: {
      "click": function($event) {
        _vm.closeModal('mask')
      }
    }
  }) : _vm._e(), _vm._v(" "), _c('transition', {
    attrs: {
      "name": _vm.transitionName[_vm.type]
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.modal_show),
      expression: "modal_show"
    }],
    class: _vm.container_class
  }, [(_vm.use_close) ? _c('Icon', {
    class: _vm.icon_class,
    attrs: {
      "name": "close",
      "role": "button"
    },
    nativeOn: {
      "click": function($event) {
        _vm.closeModal()
      }
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    class: _vm.body_class,
    style: (_vm.body_style)
  }, [_vm._t("default")], 2)], 1)])], 1) : _vm._e()])
},staticRenderFns: []}

/***/ }),
/* 681 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    class: _vm.component_class
  }, [_c('span', {
    staticClass: "box"
  }, [_c('transition', {
    attrs: {
      "name": "bounce"
    }
  }, [_c('i', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.is_active),
      expression: "is_active"
    }],
    staticClass: "item",
    style: ({
      backgroundColor: _vm.color
    })
  })])], 1), _vm._v(" "), _c('input', {
    staticClass: "hidden-input",
    attrs: {
      "id": _vm._uid,
      "type": "checkbox"
    },
    domProps: {
      "value": _vm.cur_value
    },
    on: {
      "click": function($event) {
        _vm.triggerHandler(_vm.cur_value)
      }
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "checkbox-label",
    attrs: {
      "for": _vm._uid
    }
  }, [_vm._t("default")], 2)])
},staticRenderFns: []}

/***/ }),
/* 682 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: _vm.component_class,
    style: (_vm.styles)
  }, [_vm._t("default")], 2)
},staticRenderFns: []}

/***/ }),
/* 683 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('demo', {
    staticClass: "input-demo",
    attrs: {
      "title": "Input"
    }
  }, [_c('demo-item', {
    attrs: {
      "name": "size",
      "description": "大小",
      "code": _vm.code
    },
    slot: "left"
  }, [_c('Input', {
    attrs: {
      "size": 'sm'
    },
    model: {
      value: (_vm.size_test),
      callback: function($$v) {
        _vm.size_test = $$v
      },
      expression: "size_test"
    }
  }), _vm._v(" "), _c('Input', {
    attrs: {
      "size": 'md'
    },
    model: {
      value: (_vm.size_test),
      callback: function($$v) {
        _vm.size_test = $$v
      },
      expression: "size_test"
    }
  }), _vm._v(" "), _c('Input', {
    attrs: {
      "size": 'lg'
    },
    model: {
      value: (_vm.size_test),
      callback: function($$v) {
        _vm.size_test = $$v
      },
      expression: "size_test"
    }
  }), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.size_test))])], 1), _vm._v(" "), _c('demo-item', {
    attrs: {
      "name": "labelFloat",
      "description": "标题浮动",
      "code": _vm.label_code
    },
    slot: "right"
  }, [_c('Input', {
    attrs: {
      "label": '我是浮动标题'
    },
    model: {
      value: (_vm.label_test),
      callback: function($$v) {
        _vm.label_test = $$v
      },
      expression: "label_test"
    }
  }), _vm._v(" "), _c('Input', {
    attrs: {
      "placeholder": '我是提示'
    },
    model: {
      value: (_vm.label_test),
      callback: function($$v) {
        _vm.label_test = $$v
      },
      expression: "label_test"
    }
  })], 1), _vm._v(" "), _c('demo-item', {
    attrs: {
      "name": "status",
      "description": "状态",
      "code": _vm.disabled_code
    },
    slot: "left"
  }, [_c('Input', {
    attrs: {
      "placeholder": '正常使用'
    },
    model: {
      value: (_vm.status_test),
      callback: function($$v) {
        _vm.status_test = $$v
      },
      expression: "status_test"
    }
  }), _vm._v(" "), _c('Input', {
    attrs: {
      "placeholder": '我被禁用了',
      "disabled": true
    }
  })], 1), _vm._v(" "), _c('demo-item', {
    attrs: {
      "name": "color",
      "description": "颜色",
      "code": _vm.color_code
    },
    slot: "right"
  }, [_c('Input', {
    attrs: {
      "placeholder": '默认'
    },
    model: {
      value: (_vm.color_test),
      callback: function($$v) {
        _vm.color_test = $$v
      },
      expression: "color_test"
    }
  }), _vm._v(" "), _c('Input', {
    attrs: {
      "placeholder": '绿色',
      "color": "#4fae9B"
    },
    model: {
      value: (_vm.color_test),
      callback: function($$v) {
        _vm.color_test = $$v
      },
      expression: "color_test"
    }
  }), _vm._v(" "), _c('Input', {
    attrs: {
      "placeholder": '蓝色',
      "color": "rgb(0, 160, 233)"
    },
    model: {
      value: (_vm.color_test),
      callback: function($$v) {
        _vm.color_test = $$v
      },
      expression: "color_test"
    }
  })], 1), _vm._v(" "), _c('demo-item', {
    attrs: {
      "name": "verify",
      "description": "验证",
      "code": _vm.verify_code
    },
    slot: "left"
  }, [_c('Input', {
    attrs: {
      "placeholder": '验证手机号(数字7~14位)',
      "verify": "phone"
    },
    on: {
      "verify": function($event) {
        _vm.verify_result = arguments[0]
      }
    }
  }), _vm._v(" "), _c('p', [_vm._v("手机号验证结果: " + _vm._s(_vm.verify_result))]), _vm._v(" "), _c('Input', {
    attrs: {
      "placeholder": '验证手机号/邮箱',
      "verify": ['phone', 'email']
    },
    on: {
      "verify": function($event) {
        _vm.verify3_result = arguments[0]
      }
    }
  }), _vm._v(" "), _c('p', [_vm._v("手机号/邮箱验证果: " + _vm._s(_vm.verify3_result))]), _vm._v(" "), _c('Input', {
    attrs: {
      "placeholder": '输入 哈哈',
      "reg": /哈哈/,
      "tip": "不开心"
    },
    on: {
      "verify": function($event) {
        _vm.verify1_result = arguments[0]
      }
    }
  }), _vm._v(" "), _c('p', [_vm._v("自定义验证1结果：" + _vm._s(_vm.verify1_result))]), _vm._v(" "), _c('Input', {
    ref: 'verify_input',
    attrs: {
      "placeholder": '自定义验证2'
    },
    on: {
      "verify": function($event) {
        _vm.verify2_result = arguments[0]
      }
    }
  }), _vm._v(" "), _c('p', [_c('Btn', {
    on: {
      "click": function($event) {
        _vm.$refs.verify_input.$emit(_vm.verify2_result ? 'error' : 'correct', '自定义的错误信息啊')
      }
    }
  }, [_vm._v(_vm._s(_vm.verify2_result ? '报错' : '正确'))]), _vm._v(" "), _c('Btn', {
    on: {
      "click": function($event) {
        _vm.$refs.verify_input.$emit('clear')
      }
    }
  }, [_vm._v("清除(验证结果还原为false)")])], 1), _vm._v(" "), _c('p', [_vm._v("自定义验证1结果：" + _vm._s(_vm.verify2_result))])], 1), _vm._v(" "), _c('demo-item', {
    attrs: {
      "name": "textarea",
      "description": "文本域",
      "code": _vm.textarea_code
    },
    slot: "right"
  }, [_c('Input', {
    model: {
      value: (_vm.textarea_test),
      callback: function($$v) {
        _vm.textarea_test = $$v
      },
      expression: "textarea_test"
    }
  }), _vm._v(" "), _c('Input', {
    attrs: {
      "placeholder": '默认3行高',
      "type": "textarea"
    },
    model: {
      value: (_vm.textarea_test),
      callback: function($$v) {
        _vm.textarea_test = $$v
      },
      expression: "textarea_test"
    }
  }), _vm._v(" "), _c('Input', {
    attrs: {
      "type": "textarea",
      "placeholder": '内容撑开高度',
      "autosize": true
    },
    model: {
      value: (_vm.textarea_test),
      callback: function($$v) {
        _vm.textarea_test = $$v
      },
      expression: "textarea_test"
    }
  })], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 684 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('h1', [_vm._v("色彩")]), _vm._v(" "), _c('blockquote', [_c('p', [_vm._v("基础色 和 主题色")])]), _vm._v(" "), _c('h2', [_vm._v("基础色")]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('p', [_c('color'), _vm._v(" "), _c('color', {
    attrs: {
      "type": "red"
    }
  }), _vm._v(" "), _c('color', {
    attrs: {
      "type": "green"
    }
  }), _vm._v(" "), _c('color', {
    attrs: {
      "type": "yellow"
    }
  }), _vm._v(" "), _c('color', {
    attrs: {
      "type": "neutrals"
    }
  })], 1), _vm._v(" "), _c('h2', [_vm._v("主题色")]), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('p', [_c('color', {
    attrs: {
      "type": "vi"
    }
  })], 1)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("基础色在 "), _c('code', [_vm._v("/src/style/themes/colors/ui.styl")]), _vm._v(" 文件中修改")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("主题色在 "), _c('code', [_vm._v("/src/style/themes/colors/vi.styl")]), _vm._v(" 文件中修改")])
}]}

/***/ }),
/* 685 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('demo', {
    staticClass: "icon-demo",
    attrs: {
      "title": "Icon"
    }
  }, [_c('demo-item', {
    attrs: {
      "name": "default",
      "description": "默认",
      "code": _vm.size_code,
      "lang": "html"
    }
  }, [_c('Btn', {
    on: {
      "click": function($event) {
        _vm.$loading.start()
      }
    }
  }, [_vm._v("Start")]), _vm._v(" "), _c('Btn', {
    on: {
      "click": function($event) {
        _vm.$loading.success()
      }
    }
  }, [_vm._v("Success")]), _vm._v(" "), _c('Btn', {
    on: {
      "click": function($event) {
        _vm.$loading.error()
      }
    }
  }, [_vm._v("Error")])], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 686 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.is_show),
      expression: "is_show"
    }],
    staticClass: "calendar",
    class: _vm.component_class
  }, [(_vm.is_single_month) ? _c('h2', {
    staticClass: "title pure-g"
  }, [_c('div', {
    staticClass: "pure-u-1-8"
  }, [_c('a', {
    class: {
      'opacity-hidden': _vm.is_disable_prev
    },
    on: {
      "click": function($event) {
        !_vm.is_disable_prev && _vm.preMonth()
      }
    }
  }, [_c('Icon', {
    attrs: {
      "size": 16,
      "name": "left"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "info pure-u-3-4"
  }, [_c('span', {
    staticClass: "year",
    class: {
      active: _vm.is_select_year
    },
    on: {
      "click": function($event) {
        _vm.is_select_year = !_vm.is_select_year, _vm.is_select_month = false, _vm.scrollToTheYear()
      }
    }
  }, [_vm._v("\n        " + _vm._s(_vm.cur_year) + " 年\n        "), (!_vm.is_select_year) ? _c('Icon', {
    attrs: {
      "name": "down",
      "size": 16
    }
  }) : _c('Icon', {
    attrs: {
      "name": "up",
      "size": 16
    }
  })], 1), _vm._v(" "), _c('span', {
    staticClass: "month",
    class: {
      active: _vm.is_select_month
    },
    on: {
      "click": function($event) {
        _vm.is_select_month = !_vm.is_select_month, _vm.is_select_year = false
      }
    }
  }, [_vm._v("\n        " + _vm._s(_vm.cur_month + 1) + " 月\n        "), (!_vm.is_select_month) ? _c('Icon', {
    attrs: {
      "name": "down",
      "size": 16
    }
  }) : _c('Icon', {
    attrs: {
      "name": "up",
      "size": 16
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "pure-u-1-8"
  }, [_c('a', {
    class: {
      'opacity-hidden': _vm.is_disable_next
    },
    on: {
      "click": function($event) {
        !_vm.is_disable_next && _vm.nextMonth()
      }
    }
  }, [_c('Icon', {
    attrs: {
      "size": 16,
      "name": "right"
    }
  })], 1)])]) : _vm._e(), _vm._v(" "), _c('section', {
    staticClass: "day-title"
  }, [_c('table', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.is_select_year && !_vm.is_select_month),
      expression: "!is_select_year && !is_select_month"
    }]
  }, [_c('tbody', [_c('tr', _vm._l((_vm.week_days), function(day, index) {
    return _c('td', {
      class: {
        'color-red': index === 0 || index === _vm.week_days.length - 1
      }
    }, [_c('div', {
      staticClass: "item"
    }, [_vm._v(_vm._s(day))])])
  }))])])]), _vm._v(" "), _vm._l((_vm.total_days), function(item, index) {
    return _c('section', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (!_vm.is_select_year && !_vm.is_select_month),
        expression: "!is_select_year && !is_select_month"
      }],
      key: index,
      staticClass: "month"
    }, [(!_vm.is_single_month) ? _c('h3', [_vm._v(_vm._s(item.year) + " 年 " + _vm._s(item.month) + " 月")]) : _vm._e(), _vm._v(" "), _c('table', [_c('tbody', _vm._l((item.arr), function(day, k1, index) {
      return _c('tr', {
        key: index
      }, _vm._l((day), function(child, k2, index) {
        return _c('td', {
          key: index
        }, [_c('div', {
          staticClass: "item",
          class: {
            'selected': child.select,
              'weekend': child.weekend,
              'nodisplay': child.nodisplay,
              'disable': child.disable,
              'range-begin': child.range_begin,
              'range-end': child.range_end
          },
          on: {
            "mousedown": function($event) {
              !child.nodisplay && !child.disable && _vm.select(k1, k2, _vm.cur_year, item.month, $event)
            }
          }
        }, [_c('em', [_vm._v(_vm._s(child.day))])])])
      }))
    }))])])
  }), _vm._v(" "), _c('section', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.is_select_year),
      expression: "is_select_year"
    }],
    ref: "select_year",
    staticClass: "select-year select"
  }, [_c('table', [_c('tbody', _vm._l((_vm.select_year_data), function(year_tr, index) {
    return _c('tr', _vm._l((year_tr), function(year) {
      return _c('td', [_c('div', {
        staticClass: "item",
        class: {
          disable: !year.enable
        },
        on: {
          "click": function($event) {
            year.enable && _vm.selectYear(year.value)
          }
        }
      }, [_vm._v("\n            " + _vm._s(year.value) + "\n          ")])])
    }))
  }))])]), _vm._v(" "), _c('section', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.is_select_month),
      expression: "is_select_month"
    }],
    staticClass: "select-month select"
  }, [_c('table', [_c('tbody', _vm._l((_vm.select_month_data), function(month_tr) {
    return _c('tr', _vm._l((month_tr), function(month) {
      return _c('td', [_c('div', {
        staticClass: "item",
        class: {
          disable: !month.enable
        },
        on: {
          "click": function($event) {
            month.enable && _vm.selectMonth(month.value)
          }
        }
      }, [_vm._v("\n            " + _vm._s(month.value) + "\n          ")])])
    }))
  }))])]), _vm._v(" "), _vm._m(0)], 2)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "can-select-tips pure-g"
  }, [_c('div', {
    staticClass: "pure-u-1-2 left"
  }, [_c('span', {
    staticClass: "can-select-block block"
  }, [_vm._v("1")]), _vm._v("\n      可选日期\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "pure-u-1-2 right"
  }, [_c('span', {
    staticClass: "cant-select-block block"
  }, [_vm._v("1")]), _vm._v("\n      不可选日期\n    ")])])
}]}

/***/ }),
/* 687 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "demo-code"
  }, [_c('pre', {
    staticClass: "demo-code-pre"
  }, [_c('code', {
    ref: "code",
    class: _vm.lang
  }, [_vm._v(_vm._s(_vm.code.trim()))])])])
},staticRenderFns: []}

/***/ }),
/* 688 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('demo', {
    staticClass: "swipe-demo",
    attrs: {
      "title": "Swipe"
    }
  }, [_c('demo-item', {
    attrs: {
      "name": "default",
      "description": "默认",
      "code": _vm.code
    },
    slot: "left"
  }, [_c('Swipe', _vm._l((5), function(n, index) {
    return _c('SwipeSlide', {
      key: index
    }, [_c('div', {
      staticClass: "content"
    }, [_vm._v(" " + _vm._s(index) + " ")])])
  })), _vm._v(" "), _c('Swipe', {
    attrs: {
      "loop": false
    }
  }, _vm._l((5), function(n, index) {
    return _c('SwipeSlide', {
      key: index
    }, [_c('div', {
      staticClass: "content"
    }, [_vm._v(" " + _vm._s(index) + " ")])])
  }))], 1), _vm._v(" "), _c('demo-item', {
    attrs: {
      "name": "index",
      "description": "下标",
      "code": _vm.index_code
    },
    slot: "left"
  }, [_c('p', [_vm._v("当前下标是 " + _vm._s(_vm.index))]), _vm._v(" "), _c('Swipe', {
    model: {
      value: (_vm.index),
      callback: function($$v) {
        _vm.index = $$v
      },
      expression: "index"
    }
  }, _vm._l((5), function(n, index) {
    return _c('SwipeSlide', {
      key: index
    }, [_c('div', {
      staticClass: "content"
    }, [_vm._v(" " + _vm._s(index) + " ")])])
  })), _vm._v(" "), _c('br'), _vm._v(" "), _c('p', [_vm._v("当前下标是 " + _vm._s(_vm.trigger_index))]), _vm._v(" "), _c('Swipe', {
    attrs: {
      "trigger": 'progress'
    },
    model: {
      value: (_vm.trigger_index),
      callback: function($$v) {
        _vm.trigger_index = $$v
      },
      expression: "trigger_index"
    }
  }, _vm._l((5), function(n, index) {
    return _c('SwipeSlide', {
      key: index
    }, [_c('div', {
      staticClass: "content"
    }, [_vm._v(" " + _vm._s(index) + " "), _c('p', [_vm._v("滑动过程中改变index")])])])
  })), _vm._v(" "), _c('Swipe', {
    attrs: {
      "index": true
    }
  }, _vm._l((5), function(n, index) {
    return _c('SwipeSlide', {
      key: index
    }, [_c('div', {
      staticClass: "content"
    }, [_vm._v(" " + _vm._s(index) + " "), _c('p', [_vm._v("显示index")])])])
  })), _vm._v(" "), _c('Swipe', {
    attrs: {
      "index": true,
      "index_trigger": 'hover'
    }
  }, _vm._l((5), function(n, index) {
    return _c('SwipeSlide', {
      key: index
    }, [_c('div', {
      staticClass: "content"
    }, [_vm._v(" " + _vm._s(index) + " "), _c('p', [_vm._v("index hover触发滑动")])])])
  })), _vm._v(" "), _c('Swipe', {
    attrs: {
      "index": true,
      "index_x_offset": 15,
      "index_y_offset": -10
    }
  }, _vm._l((5), function(n, index) {
    return _c('SwipeSlide', {
      key: index
    }, [_c('div', {
      staticClass: "content"
    }, [_vm._v(" " + _vm._s(index) + " "), _c('p', [_vm._v("调整下标偏差")])])])
  }))], 1), _vm._v(" "), _c('demo-item', {
    attrs: {
      "name": "arrow",
      "description": "箭头",
      "code": _vm.arrow_code
    },
    slot: "right"
  }, [_c('Swipe', _vm._l((5), function(n, index) {
    return _c('SwipeSlide', {
      key: index
    }, [_c('div', {
      staticClass: "content"
    }, [_vm._v(" " + _vm._s(index) + " "), _c('p', [_vm._v("默认hover显示左右箭头")])])])
  })), _vm._v(" "), _c('Swipe', {
    attrs: {
      "arrow": true
    }
  }, _vm._l((5), function(n, index) {
    return _c('SwipeSlide', {
      key: index
    }, [_c('div', {
      staticClass: "content"
    }, [_vm._v(" " + _vm._s(index) + " "), _c('p', [_vm._v("总是显示箭头")])])])
  })), _vm._v(" "), _c('Swipe', {
    attrs: {
      "arrow": false
    }
  }, _vm._l((5), function(n, index) {
    return _c('SwipeSlide', {
      key: index
    }, [_c('div', {
      staticClass: "content"
    }, [_vm._v(" " + _vm._s(index) + " "), _c('p', [_vm._v("无箭头")])])])
  })), _vm._v(" "), _c('Swipe', {
    attrs: {
      "arrow": true,
      "outer_arrow": true
    }
  }, _vm._l((5), function(n, index) {
    return _c('SwipeSlide', {
      key: index
    }, [_c('div', {
      staticClass: "content"
    }, [_vm._v(" " + _vm._s(index) + " "), _c('p', [_vm._v("外部箭头")])])])
  })), _vm._v(" "), _c('Swipe', {
    attrs: {
      "arrow": true,
      "outer_arrow": true,
      "arrow_offset": -15
    }
  }, _vm._l((5), function(n, index) {
    return _c('SwipeSlide', {
      key: index
    }, [_c('div', {
      staticClass: "content"
    }, [_vm._v(" " + _vm._s(index) + " "), _c('p', [_vm._v("调整箭头偏差")])])])
  }))], 1), _vm._v(" "), _c('demo-item', {
    attrs: {
      "name": "custom slide",
      "description": "自定义滑动",
      "code": _vm.sliding_code
    },
    slot: "left"
  }, [_c('p', [_vm._v("同时展示多个Slide")]), _vm._v(" "), _c('Swipe', {
    attrs: {
      "preview": 2,
      "between": 12
    }
  }, _vm._l((5), function(n, index) {
    return _c('SwipeSlide', {
      key: index
    }, [_c('div', {
      staticClass: "content"
    }, [_vm._v(" " + _vm._s(index) + " ")])])
  })), _vm._v(" "), _c('Swipe', {
    attrs: {
      "preview": 3,
      "between": 12
    }
  }, _vm._l((5), function(n, index) {
    return _c('SwipeSlide', {
      key: index
    }, [_c('div', {
      staticClass: "content"
    }, [_vm._v(" " + _vm._s(index) + " ")])])
  })), _vm._v(" "), _c('p', [_vm._v("多个Slide同时滑动")]), _vm._v(" "), _c('Swipe', {
    attrs: {
      "preview": 2,
      "between": 12,
      "sliding_num": 2
    }
  }, _vm._l((6), function(n, index) {
    return _c('SwipeSlide', {
      key: index
    }, [_c('div', {
      staticClass: "content"
    }, [_vm._v(" " + _vm._s(index) + " ")])])
  }))], 1), _vm._v(" "), _c('demo-item', {
    attrs: {
      "name": "coverflow",
      "description": "coverflow过渡",
      "code": _vm.coverflow_code
    },
    slot: "right"
  }, [_c('Swipe', {
    attrs: {
      "coverflow": true
    }
  }, _vm._l((5), function(n, index) {
    return _c('SwipeSlide', {
      key: index
    }, [_c('div', {
      staticClass: "content"
    }, [_vm._v(" " + _vm._s(index) + " ")])])
  })), _vm._v(" "), _c('Swipe', {
    attrs: {
      "coverflow": true,
      "preview": 2
    }
  }, _vm._l((5), function(n, index) {
    return _c('SwipeSlide', {
      key: index
    }, [_c('div', {
      staticClass: "content"
    }, [_vm._v(" " + _vm._s(index) + " ")])])
  })), _vm._v(" "), _c('Swipe', {
    attrs: {
      "coverflow": true,
      "preview": 3
    }
  }, _vm._l((5), function(n, index) {
    return _c('SwipeSlide', {
      key: index
    }, [_c('div', {
      staticClass: "content"
    }, [_vm._v(" " + _vm._s(index) + " ")])])
  }))], 1), _vm._v(" "), _c('demo-item', {
    attrs: {
      "name": "free",
      "description": "自由滑动",
      "code": _vm.free_code
    },
    slot: "right"
  }, [_c('Swipe', _vm._l((5), function(n, index) {
    return _c('SwipeSlide', {
      key: index
    }, [_c('div', {
      staticClass: "content"
    }, [_vm._v(" " + _vm._s(index) + " ")])])
  })), _vm._v(" "), _c('Swipe', {
    attrs: {
      "free": true
    }
  }, _vm._l((5), function(n, index) {
    return _c('SwipeSlide', {
      key: index
    }, [_c('div', {
      staticClass: "content"
    }, [_vm._v(" " + _vm._s(index) + " ")])])
  }))], 1), _vm._v(" "), _c('demo-item', {
    attrs: {
      "name": "event",
      "description": "事件",
      "code": _vm.event_code
    },
    slot: "right"
  }, [_c('Swipe', {
    ref: "swiper"
  }, _vm._l((5), function(n, index) {
    return _c('SwipeSlide', {
      key: index
    }, [_c('div', {
      staticClass: "content"
    }, [_vm._v(" " + _vm._s(index) + " ")])])
  })), _vm._v(" "), _c('Btn', {
    nativeOn: {
      "click": function($event) {
        _vm.$refs.swiper.$emit('slide-prev')
      }
    }
  }, [_vm._v("前一个")]), _vm._v(" "), _c('Btn', {
    nativeOn: {
      "click": function($event) {
        _vm.$refs.swiper.$emit('slide-next')
      }
    }
  }, [_vm._v("后一个")]), _vm._v(" "), _c('Btn', {
    nativeOn: {
      "click": function($event) {
        _vm.$refs.swiper.$emit('slide-to', 1)
      }
    }
  }, [_vm._v("到第二个")])], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 689 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('demo', {
    staticClass: "bar-demo",
    attrs: {
      "title": "Icon"
    }
  }, [_c('demo-item', {
    attrs: {
      "name": "default",
      "description": "默认",
      "code": _vm.no_padding_code
    }
  }, [_c('Bar', [_vm._v("\n      I'm Bar.\n    ")])], 1), _vm._v(" "), _c('demo-item', {
    attrs: {
      "name": "use_padding",
      "description": "包含padding",
      "code": _vm.have_padding_code
    }
  }, [_c('Bar', {
    attrs: {
      "use_padding": true
    }
  }, [_c('Btn', [_vm._v("Button")]), _vm._v(" "), _c('Btn', [_vm._v("Button")]), _vm._v(" "), _c('Btn', [_vm._v("Button")])], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 690 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "swipe-index",
    style: (_vm.swipe_offset_style)
  }, _vm._l((_vm.slides_len), function(item, i) {
    return _c('span', {
      staticClass: "index",
      class: {
        active: i === _vm.swiper.realIndex
      },
      on: {
        "click": function($event) {
          _vm.index_trigger === 'click' && _vm.$emit('active', i)
        },
        "mouseenter": function($event) {
          _vm.index_trigger === 'hover' && _vm.$emit('active', i)
        }
      }
    })
  }))
},staticRenderFns: []}

/***/ }),
/* 691 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: _vm.component_class,
    style: (_vm.styles)
  }, [_vm._t("default")], 2)
},staticRenderFns: []}

/***/ }),
/* 692 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: _vm.component_class,
    style: (_vm.custom_style),
    on: {
      "click": function($event) {
        _vm.$emit('click')
      }
    }
  }, [_vm._t("default")], 2)
},staticRenderFns: []}

/***/ }),
/* 693 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "swipe-arrow"
  }, _vm._l((['left', 'right']), function(direction, index) {
    return _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (!_vm.arrow_disabled_status[direction]),
        expression: "!arrow_disabled_status[direction]"
      }],
      staticClass: "swipe-button",
      class: [direction, {
        outer: _vm.outer_arrow
      }],
      style: ({
        'margin-top': -_vm.arrow_offset + 'px'
      })
    }, [(_vm.outer_arrow) ? _c('span', {
      staticClass: "arrow outer",
      class: direction,
      on: {
        "click": function($event) {
          (direction === 'left' ? _vm.swiper.slidePrev() : _vm.swiper.slideNext()), _vm.swiper.startAutoplay()
        },
        "mouseenter": function($event) {
          _vm.$set(_vm.hover, index, true)
        },
        "mouseleave": function($event) {
          _vm.$set(_vm.hover, index, false)
        }
      }
    }, [_c('Icon', {
      staticClass: "icon",
      attrs: {
        "name": direction,
        "size": 24,
        "color": _vm.hover[index] ? '#323232' : '#999'
      }
    })], 1) : _c('span', {
      staticClass: "arrow inner",
      class: direction,
      on: {
        "click": function($event) {
          (direction === 'left' ? _vm.swiper.slidePrev() : _vm.swiper.slideNext()), _vm.swiper.startAutoplay()
        }
      }
    }, [_c('Icon', {
      staticClass: "icon",
      attrs: {
        "name": ("arrow" + direction),
        "size": 16,
        "color": "#fff"
      }
    })], 1)])
  }))
},staticRenderFns: []}

/***/ }),
/* 694 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "clickothers",
      rawName: "v-clickothers",
      value: (_vm.clickOthers),
      expression: "clickOthers"
    }],
    class: _vm.component_class,
    style: (_vm.custom_style.self)
  }, [_c('div', {
    staticClass: "handler",
    on: {
      "click": _vm.clickHandler,
      "mouseenter": function($event) {
        _vm.hoverHandler(true)
      },
      "mouseleave": function($event) {
        _vm.hoverHandler(false)
      }
    }
  }, [_c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.float || !_vm.show_val),
      expression: "float || !show_val"
    }],
    staticClass: "label",
    class: {
      float: _vm.show_val && _vm.float
    }
  }, [_vm._v(_vm._s(_vm.label || (_vm.show_val ? '已选择' : '请选择')) + " ")]), _vm._v(" "), _c('p', {
    staticClass: "selected",
    class: {
      float: _vm.show_val && _vm.float
    }
  }, [_vm._v(_vm._s(_vm.show_val))]), _vm._v(" "), _c('span', {
    staticClass: "arrow",
    style: (_vm.custom_style.arrow)
  })]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "select-slide-down"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.is_active),
      expression: "is_active"
    }],
    staticClass: "body"
  }, [_vm._t("default", _vm._l((_vm.data), function(item, index) {
    return _c('SelectItem', {
      key: index,
      attrs: {
        "color": _vm.color,
        "active": _vm.value_by ? _vm.value === item[_vm.value_by] : item === _vm.value
      },
      on: {
        "click": function($event) {
          _vm.itemClick(item, index)
        }
      }
    }, [_vm._v("\n          " + _vm._s(item[_vm.show_by] || item) + "\n        ")])
  }))], 2)]), _vm._v(" "), _c('input', {
    ref: "tab_hack",
    staticClass: "tab-hack",
    attrs: {
      "type": "text"
    },
    on: {
      "focus": function($event) {
        _vm.is_active = true
      },
      "blur": function($event) {
        _vm.is_active = false
      }
    }
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.disabled),
      expression: "disabled"
    }],
    staticClass: "disabled-mask"
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 695 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    class: _vm.component_class
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.checked),
      expression: "checked"
    }],
    attrs: {
      "type": "checkbox",
      "disabled": _vm.disabled
    },
    domProps: {
      "checked": Array.isArray(_vm.checked) ? _vm._i(_vm.checked, null) > -1 : (_vm.checked)
    },
    on: {
      "__c": function($event) {
        var $$a = _vm.checked,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$c) {
            $$i < 0 && (_vm.checked = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.checked = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.checked = $$c
        }
      }
    }
  })])
},staticRenderFns: []}

/***/ }),
/* 696 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.show) ? _c('transition', {
    attrs: {
      "name": "fade"
    },
    on: {
      "after-leave": _vm.destroy
    }
  }, [_c('div', {
    class: _vm.component_class,
    style: (_vm.component_style)
  }, [(_vm.status === 'loading') ? _c('Icon', {
    attrs: {
      "name": "loading",
      "rotate": true
    }
  }) : _vm._e()], 1)]) : _vm._e()
},staticRenderFns: []}

/***/ }),
/* 697 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    class: _vm.component_class,
    attrs: {
      "disabled": _vm.disabled
    },
    on: {
      "click": _vm.handleClick
    }
  }, [(_vm.is_loading) ? _c('Icon', {
    attrs: {
      "name": "loading",
      "rotate": true
    }
  }) : _vm._e(), _vm._v(" "), (!_vm.is_loading && _vm.prefix) ? _c('Icon', {
    attrs: {
      "name": _vm.prefix
    }
  }) : _vm._e(), _vm._v(" "), (_vm.loading_text) ? _c('span', [_vm._v("\n    " + _vm._s(_vm.loading_text) + "\n  ")]) : _c('span', [_vm._t("default")], 2), _vm._v(" "), (!_vm.is_loading && _vm.suffix) ? _c('Icon', {
    attrs: {
      "name": _vm.suffix
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 698 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(546);

/***/ }),
/* 699 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(551);

/***/ }),
/* 700 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(540);

/***/ }),
/* 701 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(553);

/***/ }),
/* 702 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(558);

/***/ }),
/* 703 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(552);

/***/ }),
/* 704 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(556);

/***/ }),
/* 705 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(541);

/***/ }),
/* 706 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(559);

/***/ }),
/* 707 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(560);

/***/ }),
/* 708 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(550);

/***/ }),
/* 709 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(547);

/***/ }),
/* 710 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(562);

/***/ }),
/* 711 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(542);

/***/ }),
/* 712 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(561);

/***/ }),
/* 713 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(545);

/***/ }),
/* 714 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(557);

/***/ }),
/* 715 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(543);

/***/ }),
/* 716 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(548);

/***/ }),
/* 717 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(544);

/***/ }),
/* 718 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(554);

/***/ }),
/* 719 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(555);

/***/ }),
/* 720 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(538);

/***/ }),
/* 721 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(539);

/***/ }),
/* 722 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(549);

/***/ }),
/* 723 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(563);

/***/ }),
/* 724 */,
/* 725 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(237);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(726)("68858081", content, true);
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../css-loader/index.js?minimize!../../vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-501ee0f0\",\"scoped\":false,\"hasInlineConfig\":false}!../../vue-loader/lib/selector.js?type=styles&index=0!./index-23.vue", function() {
     var newContent = require("!!../../css-loader/index.js?minimize!../../vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-501ee0f0\",\"scoped\":false,\"hasInlineConfig\":false}!../../vue-loader/lib/selector.js?type=styles&index=0!./index-23.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 726 */,
/* 727 */,
/* 728 */,
/* 729 */
/***/ (function(module, exports) {

module.exports = {
	"name": "hiui-pc",
	"version": "1.3.7",
	"description": "UI components for wantu.cn",
	"homepage": "https://hi-fe.github.io/hiui-pc/",
	"main": "./dist/hiuipc.js",
	"scripts": {
		"dev": "node build/dev-server.js",
		"build": "node build/build.js",
		"package": "node build/package.js",
		"lint": "eslint --ext .js,.vue src"
	},
	"dependencies": {
		"github-markdown-css": "^2.6.0",
		"highlight.js": "^9.10.0",
		"markdown-it": "^8.3.1",
		"purecss": "^0.6.0",
		"swiper": "^3.4.2",
		"vue": "^2.2.2",
		"vue-clipboards": "^0.2.6",
		"vue-router": "^2.2.0"
	},
	"devDependencies": {
		"autoprefixer": "^6.7.2",
		"babel-core": "^6.22.1",
		"babel-eslint": "^7.1.1",
		"babel-loader": "^6.2.10",
		"babel-plugin-transform-runtime": "^6.22.0",
		"babel-preset-env": "^1.2.1",
		"babel-preset-stage-2": "^6.22.0",
		"babel-register": "^6.22.0",
		"chalk": "^1.1.3",
		"connect-history-api-fallback": "^1.3.0",
		"copy-webpack-plugin": "^4.0.1",
		"css-loader": "^0.26.1",
		"eslint": "^3.14.1",
		"eslint-config-standard": "^6.2.1",
		"eslint-friendly-formatter": "^2.0.7",
		"eslint-loader": "^1.6.1",
		"eslint-plugin-html": "^2.0.0",
		"eslint-plugin-promise": "^3.4.0",
		"eslint-plugin-standard": "^2.0.1",
		"eventsource-polyfill": "^0.9.6",
		"express": "^4.14.1",
		"extract-text-webpack-plugin": "^2.0.0",
		"file-loader": "^0.10.0",
		"friendly-errors-webpack-plugin": "^1.1.3",
		"function-bind": "^1.1.0",
		"html-webpack-plugin": "^2.28.0",
		"http-proxy-middleware": "^0.17.3",
		"minimist": "^1.2.0",
		"opn": "^4.0.2",
		"optimize-css-assets-webpack-plugin": "^1.3.0",
		"ora": "^1.1.0",
		"rimraf": "^2.6.0",
		"semver": "^5.3.0",
		"style-loader": "^0.17.0",
		"stylus": "^0.54.5",
		"stylus-loader": "^3.0.1",
		"url-loader": "^0.5.7",
		"vue-loader": "^11.1.4",
		"vue-markdown-loader": "^0.6.2",
		"vue-style-loader": "^2.0.0",
		"vue-template-compiler": "^2.2.4",
		"webpack": "^2.2.1",
		"webpack-bundle-analyzer": "^2.2.1",
		"webpack-dev-middleware": "^1.10.0",
		"webpack-hot-middleware": "^2.16.1",
		"webpack-merge": "^2.6.1"
	},
	"engines": {
		"node": ">= 4.0.0",
		"npm": ">= 3.0.0"
	},
	"browserslist": [
		"> 1%",
		"last 2 versions",
		"not ie <= 8"
	]
};

/***/ })
],[108]);


// WEBPACK FOOTER //
// static/js/app.48412c270ba287609500.js